export default [
  {
    "countryId": 1,
    "countryCode": "AF",
    "countryName": "Afghanistan",
    "regions": [
      {
        "regionId": 17,
        "regionCode": null,
        "regionName": "Badakhshan"
      },
      {
        "regionId": 18,
        "regionCode": null,
        "regionName": "Badgis"
      },
      {
        "regionId": 19,
        "regionCode": null,
        "regionName": "Baglan"
      },
      {
        "regionId": 20,
        "regionCode": null,
        "regionName": "Balkh"
      },
      {
        "regionId": 21,
        "regionCode": null,
        "regionName": "Bamiyan"
      },
      {
        "regionId": 22,
        "regionCode": null,
        "regionName": "Farah"
      },
      {
        "regionId": 23,
        "regionCode": null,
        "regionName": "Faryab"
      },
      {
        "regionId": 24,
        "regionCode": null,
        "regionName": "Gawr"
      },
      {
        "regionId": 25,
        "regionCode": null,
        "regionName": "Gazni"
      },
      {
        "regionId": 26,
        "regionCode": null,
        "regionName": "Herat"
      },
      {
        "regionId": 27,
        "regionCode": null,
        "regionName": "Hilmand"
      },
      {
        "regionId": 28,
        "regionCode": null,
        "regionName": "Jawzjan"
      },
      {
        "regionId": 29,
        "regionCode": null,
        "regionName": "Kabul"
      },
      {
        "regionId": 30,
        "regionCode": null,
        "regionName": "Kapisa"
      },
      {
        "regionId": 31,
        "regionCode": null,
        "regionName": "Khawst"
      },
      {
        "regionId": 32,
        "regionCode": null,
        "regionName": "Kunar"
      },
      {
        "regionId": 33,
        "regionCode": null,
        "regionName": "Lagman"
      },
      {
        "regionId": 34,
        "regionCode": null,
        "regionName": "Lawghar"
      },
      {
        "regionId": 35,
        "regionCode": null,
        "regionName": "Nangarhar"
      },
      {
        "regionId": 36,
        "regionCode": null,
        "regionName": "Nimruz"
      },
      {
        "regionId": 37,
        "regionCode": null,
        "regionName": "Nuristan"
      },
      {
        "regionId": 38,
        "regionCode": null,
        "regionName": "Paktika"
      },
      {
        "regionId": 39,
        "regionCode": null,
        "regionName": "Paktiya"
      },
      {
        "regionId": 40,
        "regionCode": null,
        "regionName": "Parwan"
      },
      {
        "regionId": 41,
        "regionCode": null,
        "regionName": "Qandahar"
      },
      {
        "regionId": 42,
        "regionCode": null,
        "regionName": "Qunduz"
      },
      {
        "regionId": 43,
        "regionCode": null,
        "regionName": "Samangan"
      },
      {
        "regionId": 44,
        "regionCode": null,
        "regionName": "Sar-e Pul"
      },
      {
        "regionId": 45,
        "regionCode": null,
        "regionName": "Takhar"
      },
      {
        "regionId": 46,
        "regionCode": null,
        "regionName": "Uruzgan"
      },
      {
        "regionId": 47,
        "regionCode": null,
        "regionName": "Wardag"
      },
      {
        "regionId": 48,
        "regionCode": null,
        "regionName": "Zabul"
      }
    ]
  },
  {
    "countryId": 2,
    "countryCode": "AX",
    "countryName": "Aland",
    "regions": []
  },
  {
    "countryId": 3,
    "countryCode": "AL",
    "countryName": "Albania",
    "regions": [
      {
        "regionId": 57,
        "regionCode": null,
        "regionName": "Berat"
      },
      {
        "regionId": 58,
        "regionCode": null,
        "regionName": "Bulqize"
      },
      {
        "regionId": 59,
        "regionCode": null,
        "regionName": "Delvine"
      },
      {
        "regionId": 60,
        "regionCode": null,
        "regionName": "Devoll"
      },
      {
        "regionId": 61,
        "regionCode": null,
        "regionName": "Dibre"
      },
      {
        "regionId": 62,
        "regionCode": null,
        "regionName": "Durres"
      },
      {
        "regionId": 63,
        "regionCode": null,
        "regionName": "Elbasan"
      },
      {
        "regionId": 64,
        "regionCode": null,
        "regionName": "Fier"
      },
      {
        "regionId": 65,
        "regionCode": null,
        "regionName": "Gjirokaster"
      },
      {
        "regionId": 66,
        "regionCode": null,
        "regionName": "Gramsh"
      },
      {
        "regionId": 67,
        "regionCode": null,
        "regionName": "Has"
      },
      {
        "regionId": 68,
        "regionCode": null,
        "regionName": "Kavaje"
      },
      {
        "regionId": 69,
        "regionCode": null,
        "regionName": "Kolonje"
      },
      {
        "regionId": 70,
        "regionCode": null,
        "regionName": "Korce"
      },
      {
        "regionId": 71,
        "regionCode": null,
        "regionName": "Kruje"
      },
      {
        "regionId": 72,
        "regionCode": null,
        "regionName": "Kucove"
      },
      {
        "regionId": 73,
        "regionCode": null,
        "regionName": "Kukes"
      },
      {
        "regionId": 74,
        "regionCode": null,
        "regionName": "Kurbin"
      },
      {
        "regionId": 75,
        "regionCode": null,
        "regionName": "Lezhe"
      },
      {
        "regionId": 76,
        "regionCode": null,
        "regionName": "Librazhd"
      },
      {
        "regionId": 77,
        "regionCode": null,
        "regionName": "Lushnje"
      },
      {
        "regionId": 78,
        "regionCode": null,
        "regionName": "Mallakaster"
      },
      {
        "regionId": 79,
        "regionCode": null,
        "regionName": "Malsi e Madhe"
      },
      {
        "regionId": 80,
        "regionCode": null,
        "regionName": "Mat"
      },
      {
        "regionId": 81,
        "regionCode": null,
        "regionName": "Mirdite"
      },
      {
        "regionId": 82,
        "regionCode": null,
        "regionName": "Peqin"
      },
      {
        "regionId": 83,
        "regionCode": null,
        "regionName": "Permet"
      },
      {
        "regionId": 84,
        "regionCode": null,
        "regionName": "Pogradec"
      },
      {
        "regionId": 85,
        "regionCode": null,
        "regionName": "Puke"
      },
      {
        "regionId": 86,
        "regionCode": null,
        "regionName": "Sarande"
      },
      {
        "regionId": 87,
        "regionCode": null,
        "regionName": "Shkoder"
      },
      {
        "regionId": 88,
        "regionCode": null,
        "regionName": "Skrapar"
      },
      {
        "regionId": 89,
        "regionCode": null,
        "regionName": "Tepelene"
      },
      {
        "regionId": 90,
        "regionCode": null,
        "regionName": "Tirane"
      },
      {
        "regionId": 91,
        "regionCode": null,
        "regionName": "Tropoje"
      },
      {
        "regionId": 92,
        "regionCode": null,
        "regionName": "Vlore"
      }
    ]
  },
  {
    "countryId": 4,
    "countryCode": "DZ",
    "countryName": "Algeria",
    "regions": [
      {
        "regionId": 931,
        "regionCode": null,
        "regionName": "Adrar"
      },
      {
        "regionId": 932,
        "regionCode": null,
        "regionName": "al-Aghwat"
      },
      {
        "regionId": 933,
        "regionCode": null,
        "regionName": "al-Bayadh"
      },
      {
        "regionId": 934,
        "regionCode": null,
        "regionName": "Algiers"
      },
      {
        "regionId": 935,
        "regionCode": null,
        "regionName": "al-Jaza'ir"
      },
      {
        "regionId": 936,
        "regionCode": null,
        "regionName": "al-Wad"
      },
      {
        "regionId": 937,
        "regionCode": null,
        "regionName": "Annabah"
      },
      {
        "regionId": 938,
        "regionCode": null,
        "regionName": "ash-Shalif"
      },
      {
        "regionId": 939,
        "regionCode": null,
        "regionName": "at-Tarif"
      },
      {
        "regionId": 940,
        "regionCode": null,
        "regionName": "'Ayn Daflah"
      },
      {
        "regionId": 941,
        "regionCode": null,
        "regionName": "'Ayn Tamushanat"
      },
      {
        "regionId": 942,
        "regionCode": null,
        "regionName": "Bashshar"
      },
      {
        "regionId": 943,
        "regionCode": null,
        "regionName": "Batnah"
      },
      {
        "regionId": 944,
        "regionCode": null,
        "regionName": "Bijayah"
      },
      {
        "regionId": 945,
        "regionCode": null,
        "regionName": "Biskrah"
      },
      {
        "regionId": 946,
        "regionCode": null,
        "regionName": "Blidah"
      },
      {
        "regionId": 947,
        "regionCode": null,
        "regionName": "Buirah"
      },
      {
        "regionId": 948,
        "regionCode": null,
        "regionName": "Bumardas"
      },
      {
        "regionId": 949,
        "regionCode": null,
        "regionName": "Burj Bu Arririj"
      },
      {
        "regionId": 950,
        "regionCode": null,
        "regionName": "Ghalizan"
      },
      {
        "regionId": 951,
        "regionCode": null,
        "regionName": "Ghardayah"
      },
      {
        "regionId": 952,
        "regionCode": null,
        "regionName": "Ilizi"
      },
      {
        "regionId": 953,
        "regionCode": null,
        "regionName": "Jijili"
      },
      {
        "regionId": 954,
        "regionCode": null,
        "regionName": "Jilfah"
      },
      {
        "regionId": 955,
        "regionCode": null,
        "regionName": "Khanshalah"
      },
      {
        "regionId": 956,
        "regionCode": null,
        "regionName": "Masilah"
      },
      {
        "regionId": 957,
        "regionCode": null,
        "regionName": "Midyah"
      },
      {
        "regionId": 958,
        "regionCode": null,
        "regionName": "Milah"
      },
      {
        "regionId": 959,
        "regionCode": null,
        "regionName": "Muaskar"
      },
      {
        "regionId": 960,
        "regionCode": null,
        "regionName": "Mustaghanam"
      },
      {
        "regionId": 961,
        "regionCode": null,
        "regionName": "Naama"
      },
      {
        "regionId": 962,
        "regionCode": null,
        "regionName": "Oran"
      },
      {
        "regionId": 963,
        "regionCode": null,
        "regionName": "Ouargla"
      },
      {
        "regionId": 964,
        "regionCode": null,
        "regionName": "Qalmah"
      },
      {
        "regionId": 965,
        "regionCode": null,
        "regionName": "Qustantinah"
      },
      {
        "regionId": 966,
        "regionCode": null,
        "regionName": "Sakikdah"
      },
      {
        "regionId": 967,
        "regionCode": null,
        "regionName": "Satif"
      },
      {
        "regionId": 968,
        "regionCode": null,
        "regionName": "Sayda'"
      },
      {
        "regionId": 969,
        "regionCode": null,
        "regionName": "Sidi ban-al-'Abbas"
      },
      {
        "regionId": 970,
        "regionCode": null,
        "regionName": "Suq Ahras"
      },
      {
        "regionId": 971,
        "regionCode": null,
        "regionName": "Tamanghasat"
      },
      {
        "regionId": 972,
        "regionCode": null,
        "regionName": "Tibazah"
      },
      {
        "regionId": 973,
        "regionCode": null,
        "regionName": "Tibissah"
      },
      {
        "regionId": 974,
        "regionCode": null,
        "regionName": "Tilimsan"
      },
      {
        "regionId": 975,
        "regionCode": null,
        "regionName": "Tinduf"
      },
      {
        "regionId": 976,
        "regionCode": null,
        "regionName": "Tisamsilt"
      },
      {
        "regionId": 977,
        "regionCode": null,
        "regionName": "Tiyarat"
      },
      {
        "regionId": 978,
        "regionCode": null,
        "regionName": "Tizi Wazu"
      },
      {
        "regionId": 979,
        "regionCode": null,
        "regionName": "Umm-al-Bawaghi"
      },
      {
        "regionId": 980,
        "regionCode": null,
        "regionName": "Wahran"
      },
      {
        "regionId": 981,
        "regionCode": null,
        "regionName": "Warqla"
      },
      {
        "regionId": 982,
        "regionCode": null,
        "regionName": "Wilaya d Alger"
      },
      {
        "regionId": 983,
        "regionCode": null,
        "regionName": "Wilaya de Bejaia"
      },
      {
        "regionId": 984,
        "regionCode": null,
        "regionName": "Wilaya de Constantine"
      }
    ]
  },
  {
    "countryId": 5,
    "countryCode": "AS",
    "countryName": "American Samoa",
    "regions": [
      {
        "regionId": 159,
        "regionCode": null,
        "regionName": "Eastern"
      },
      {
        "regionId": 160,
        "regionCode": null,
        "regionName": "Manu'a"
      },
      {
        "regionId": 161,
        "regionCode": null,
        "regionName": "Swains Island"
      },
      {
        "regionId": 162,
        "regionCode": null,
        "regionName": "Western"
      }
    ]
  },
  {
    "countryId": 6,
    "countryCode": "AD",
    "countryName": "Andorra",
    "regions": [
      {
        "regionId": 1,
        "regionCode": "07",
        "regionName": "Andorra la Vella"
      },
      {
        "regionId": 2,
        "regionCode": "02",
        "regionName": "Canillo"
      },
      {
        "regionId": 3,
        "regionCode": "03",
        "regionName": "Encamp"
      },
      {
        "regionId": 4,
        "regionCode": "04",
        "regionName": "La Massana"
      },
      {
        "regionId": 5,
        "regionCode": null,
        "regionName": "Les Escaldes"
      },
      {
        "regionId": 6,
        "regionCode": "05",
        "regionName": "Ordino"
      },
      {
        "regionId": 7,
        "regionCode": "06",
        "regionName": "Sant Julia de Loria"
      }
    ]
  },
  {
    "countryId": 7,
    "countryCode": "AO",
    "countryName": "Angola",
    "regions": [
      {
        "regionId": 110,
        "regionCode": null,
        "regionName": "Bengo"
      },
      {
        "regionId": 111,
        "regionCode": null,
        "regionName": "Benguela"
      },
      {
        "regionId": 112,
        "regionCode": null,
        "regionName": "Bie"
      },
      {
        "regionId": 113,
        "regionCode": null,
        "regionName": "Cabinda"
      },
      {
        "regionId": 114,
        "regionCode": null,
        "regionName": "Cunene"
      },
      {
        "regionId": 115,
        "regionCode": null,
        "regionName": "Huambo"
      },
      {
        "regionId": 116,
        "regionCode": null,
        "regionName": "Huila"
      },
      {
        "regionId": 117,
        "regionCode": null,
        "regionName": "Kuando-Kubango"
      },
      {
        "regionId": 118,
        "regionCode": null,
        "regionName": "Kwanza Norte"
      },
      {
        "regionId": 119,
        "regionCode": null,
        "regionName": "Kwanza Sul"
      },
      {
        "regionId": 120,
        "regionCode": null,
        "regionName": "Luanda"
      },
      {
        "regionId": 121,
        "regionCode": null,
        "regionName": "Lunda Norte"
      },
      {
        "regionId": 122,
        "regionCode": null,
        "regionName": "Lunda Sul"
      },
      {
        "regionId": 123,
        "regionCode": null,
        "regionName": "Malanje"
      },
      {
        "regionId": 124,
        "regionCode": null,
        "regionName": "Moxico"
      },
      {
        "regionId": 125,
        "regionCode": null,
        "regionName": "Namibe"
      },
      {
        "regionId": 126,
        "regionCode": null,
        "regionName": "Uige"
      },
      {
        "regionId": 127,
        "regionCode": null,
        "regionName": "Zaire"
      }
    ]
  },
  {
    "countryId": 8,
    "countryCode": "AI",
    "countryName": "Anguilla",
    "regions": [
      {
        "regionId": 56,
        "regionCode": null,
        "regionName": "Other Provinces"
      }
    ]
  },
  {
    "countryId": 9,
    "countryCode": "AQ",
    "countryName": "Antarctica",
    "regions": [
      {
        "regionId": 128,
        "regionCode": null,
        "regionName": "Sector claimed by Argentina/Ch"
      },
      {
        "regionId": 129,
        "regionCode": null,
        "regionName": "Sector claimed by Argentina/UK"
      },
      {
        "regionId": 130,
        "regionCode": null,
        "regionName": "Sector claimed by Australia"
      },
      {
        "regionId": 131,
        "regionCode": null,
        "regionName": "Sector claimed by France"
      },
      {
        "regionId": 132,
        "regionCode": null,
        "regionName": "Sector claimed by New Zealand"
      },
      {
        "regionId": 133,
        "regionCode": null,
        "regionName": "Sector claimed by Norway"
      },
      {
        "regionId": 134,
        "regionCode": null,
        "regionName": "Unclaimed Sector"
      }
    ]
  },
  {
    "countryId": 10,
    "countryCode": "AG",
    "countryName": "Antigua",
    "regions": [
      {
        "regionId": 49,
        "regionCode": null,
        "regionName": "Barbuda"
      },
      {
        "regionId": 50,
        "regionCode": null,
        "regionName": "Saint George"
      },
      {
        "regionId": 51,
        "regionCode": null,
        "regionName": "Saint John"
      },
      {
        "regionId": 52,
        "regionCode": null,
        "regionName": "Saint Mary"
      },
      {
        "regionId": 53,
        "regionCode": null,
        "regionName": "Saint Paul"
      },
      {
        "regionId": 54,
        "regionCode": null,
        "regionName": "Saint Peter"
      },
      {
        "regionId": 55,
        "regionCode": null,
        "regionName": "Saint Philip"
      }
    ]
  },
  {
    "countryId": 11,
    "countryCode": "AR",
    "countryName": "Argentina",
    "regions": [
      {
        "regionId": 135,
        "regionCode": "01",
        "regionName": "Buenos Aires"
      },
      {
        "regionId": 136,
        "regionCode": "02",
        "regionName": "Catamarca"
      },
      {
        "regionId": 137,
        "regionCode": "16",
        "regionName": "Chaco"
      },
      {
        "regionId": 138,
        "regionCode": "17",
        "regionName": "Chubut"
      },
      {
        "regionId": 139,
        "regionCode": "X",
        "regionName": "Cordoba"
      },
      {
        "regionId": 140,
        "regionCode": "04",
        "regionName": "Corrientes"
      },
      {
        "regionId": 141,
        "regionCode": null,
        "regionName": "Distrito Federal"
      },
      {
        "regionId": 142,
        "regionCode": "05",
        "regionName": "Entre Rios"
      },
      {
        "regionId": 143,
        "regionCode": "18",
        "regionName": "Formosa"
      },
      {
        "regionId": 144,
        "regionCode": "06",
        "regionName": "Jujuy"
      },
      {
        "regionId": 145,
        "regionCode": "21",
        "regionName": "La Pampa"
      },
      {
        "regionId": 146,
        "regionCode": "08",
        "regionName": "La Rioja"
      },
      {
        "regionId": 147,
        "regionCode": "07",
        "regionName": "Mendoza"
      },
      {
        "regionId": 148,
        "regionCode": "19",
        "regionName": "Misiones"
      },
      {
        "regionId": 149,
        "regionCode": "20",
        "regionName": "Neuquen"
      },
      {
        "regionId": 150,
        "regionCode": "22",
        "regionName": "Rio Negro"
      },
      {
        "regionId": 151,
        "regionCode": "09",
        "regionName": "Salta"
      },
      {
        "regionId": 152,
        "regionCode": "10",
        "regionName": "San Juan"
      },
      {
        "regionId": 153,
        "regionCode": "11",
        "regionName": "San Luis"
      },
      {
        "regionId": 154,
        "regionCode": "23",
        "regionName": "Santa Cruz"
      },
      {
        "regionId": 155,
        "regionCode": "S",
        "regionName": "Santa Fe"
      },
      {
        "regionId": 156,
        "regionCode": "13",
        "regionName": "Santiago del Estero"
      },
      {
        "regionId": 157,
        "regionCode": "V",
        "regionName": "Tierra del Fuego"
      },
      {
        "regionId": 158,
        "regionCode": "T",
        "regionName": "Tucuman"
      }
    ]
  },
  {
    "countryId": 12,
    "countryCode": "AM",
    "countryName": "Armenia",
    "regions": [
      {
        "regionId": 93,
        "regionCode": "AG",
        "regionName": "Aragatsotn"
      },
      {
        "regionId": 94,
        "regionCode": "AR",
        "regionName": "Ararat"
      },
      {
        "regionId": 95,
        "regionCode": "AV",
        "regionName": "Armavir"
      },
      {
        "regionId": 96,
        "regionCode": "GR",
        "regionName": "Gegharkunik"
      },
      {
        "regionId": 97,
        "regionCode": null,
        "regionName": "Kotaik"
      },
      {
        "regionId": 98,
        "regionCode": "LO",
        "regionName": "Lori"
      },
      {
        "regionId": 99,
        "regionCode": "SH",
        "regionName": "Shirak"
      },
      {
        "regionId": 100,
        "regionCode": null,
        "regionName": "Stepanakert"
      },
      {
        "regionId": 101,
        "regionCode": "SU",
        "regionName": "Syunik"
      },
      {
        "regionId": 102,
        "regionCode": "TV",
        "regionName": "Tavush"
      },
      {
        "regionId": 103,
        "regionCode": "VD",
        "regionName": "Vayots Dzor"
      },
      {
        "regionId": 104,
        "regionCode": "ER",
        "regionName": "Yerevan"
      }
    ]
  },
  {
    "countryId": 13,
    "countryCode": "AW",
    "countryName": "Aruba",
    "regions": [
      {
        "regionId": 213,
        "regionCode": null,
        "regionName": "Aruba"
      }
    ]
  },
  {
    "countryId": 14,
    "countryCode": "AC",
    "countryName": "Ascension",
    "regions": []
  },
  {
    "countryId": 15,
    "countryCode": "AU",
    "countryName": "Australia",
    "regions": [
      {
        "regionId": 182,
        "regionCode": "ACT",
        "regionName": "Australian Capital Territory"
      },
      {
        "regionId": 202,
        "regionCode": "NSW",
        "regionName": "New South Wales"
      },
      {
        "regionId": 203,
        "regionCode": "NT",
        "regionName": "Northern Territory"
      },
      {
        "regionId": 205,
        "regionCode": "QLD",
        "regionName": "Queensland"
      },
      {
        "regionId": 206,
        "regionCode": "SA",
        "regionName": "South Australia"
      },
      {
        "regionId": 207,
        "regionCode": "TAS",
        "regionName": "Tasmania"
      },
      {
        "regionId": 209,
        "regionCode": "VIC",
        "regionName": "Victoria"
      },
      {
        "regionId": 211,
        "regionCode": "WA",
        "regionName": "Western Australia"
      }
    ]
  },
  {
    "countryId": 16,
    "countryCode": "AT",
    "countryName": "Austria",
    "regions": [
      {
        "regionId": 163,
        "regionCode": null,
        "regionName": "Bundesland Salzburg"
      },
      {
        "regionId": 164,
        "regionCode": null,
        "regionName": "Bundesland Steiermark"
      },
      {
        "regionId": 165,
        "regionCode": null,
        "regionName": "Bundesland Tirol"
      },
      {
        "regionId": 166,
        "regionCode": "B",
        "regionName": "Burgenland"
      },
      {
        "regionId": 167,
        "regionCode": "K",
        "regionName": "Carinthia"
      },
      {
        "regionId": 168,
        "regionCode": null,
        "regionName": "Karnten"
      },
      {
        "regionId": 169,
        "regionCode": null,
        "regionName": "Liezen"
      },
      {
        "regionId": 170,
        "regionCode": "NÖ",
        "regionName": "Lower Austria"
      },
      {
        "regionId": 171,
        "regionCode": null,
        "regionName": "Niederosterreich"
      },
      {
        "regionId": 172,
        "regionCode": null,
        "regionName": "Oberosterreich"
      },
      {
        "regionId": 173,
        "regionCode": "S",
        "regionName": "Salzburg"
      },
      {
        "regionId": 174,
        "regionCode": null,
        "regionName": "Schleswig-Holstein"
      },
      {
        "regionId": 175,
        "regionCode": null,
        "regionName": "Steiermark"
      },
      {
        "regionId": 176,
        "regionCode": "ST",
        "regionName": "Styria"
      },
      {
        "regionId": 177,
        "regionCode": null,
        "regionName": "Tirol"
      },
      {
        "regionId": 178,
        "regionCode": "OÖ",
        "regionName": "Upper Austria"
      },
      {
        "regionId": 179,
        "regionCode": "V",
        "regionName": "Vorarlberg"
      },
      {
        "regionId": 180,
        "regionCode": null,
        "regionName": "Wien"
      }
    ]
  },
  {
    "countryId": 17,
    "countryCode": "AZ",
    "countryName": "Azerbaijan",
    "regions": [
      {
        "regionId": 214,
        "regionCode": null,
        "regionName": "Abseron"
      },
      {
        "regionId": 215,
        "regionCode": null,
        "regionName": "Baki Sahari"
      },
      {
        "regionId": 216,
        "regionCode": null,
        "regionName": "Ganca"
      },
      {
        "regionId": 217,
        "regionCode": null,
        "regionName": "Ganja"
      },
      {
        "regionId": 218,
        "regionCode": null,
        "regionName": "Kalbacar"
      },
      {
        "regionId": 219,
        "regionCode": null,
        "regionName": "Lankaran"
      },
      {
        "regionId": 220,
        "regionCode": null,
        "regionName": "Mil-Qarabax"
      },
      {
        "regionId": 221,
        "regionCode": null,
        "regionName": "Mugan-Salyan"
      },
      {
        "regionId": 222,
        "regionCode": null,
        "regionName": "Nagorni-Qarabax"
      },
      {
        "regionId": 223,
        "regionCode": null,
        "regionName": "Naxcivan"
      },
      {
        "regionId": 224,
        "regionCode": null,
        "regionName": "Priaraks"
      },
      {
        "regionId": 225,
        "regionCode": null,
        "regionName": "Qazax"
      },
      {
        "regionId": 226,
        "regionCode": null,
        "regionName": "Saki"
      },
      {
        "regionId": 227,
        "regionCode": null,
        "regionName": "Sirvan"
      },
      {
        "regionId": 228,
        "regionCode": null,
        "regionName": "Xacmaz"
      }
    ]
  },
  {
    "countryId": 18,
    "countryCode": "BS",
    "countryName": "Bahamas",
    "regions": [
      {
        "regionId": 473,
        "regionCode": null,
        "regionName": "Abaco"
      },
      {
        "regionId": 474,
        "regionCode": null,
        "regionName": "Acklins Island"
      },
      {
        "regionId": 475,
        "regionCode": null,
        "regionName": "Andros"
      },
      {
        "regionId": 476,
        "regionCode": "BY",
        "regionName": "Berry Islands"
      },
      {
        "regionId": 477,
        "regionCode": null,
        "regionName": "Biminis"
      },
      {
        "regionId": 478,
        "regionCode": "CI",
        "regionName": "Cat Island"
      },
      {
        "regionId": 479,
        "regionCode": null,
        "regionName": "Crooked Island"
      },
      {
        "regionId": 480,
        "regionCode": null,
        "regionName": "Eleuthera"
      },
      {
        "regionId": 481,
        "regionCode": "EX",
        "regionName": "Exuma and Cays"
      },
      {
        "regionId": 482,
        "regionCode": null,
        "regionName": "Grand Bahama"
      },
      {
        "regionId": 483,
        "regionCode": null,
        "regionName": "Inagua Islands"
      },
      {
        "regionId": 484,
        "regionCode": "LI",
        "regionName": "Long Island"
      },
      {
        "regionId": 485,
        "regionCode": "MG",
        "regionName": "Mayaguana"
      },
      {
        "regionId": 486,
        "regionCode": null,
        "regionName": "New Providence"
      },
      {
        "regionId": 487,
        "regionCode": "RI",
        "regionName": "Ragged Island"
      },
      {
        "regionId": 488,
        "regionCode": "RC",
        "regionName": "Rum Cay"
      },
      {
        "regionId": 489,
        "regionCode": "SS",
        "regionName": "San Salvador"
      }
    ]
  },
  {
    "countryId": 19,
    "countryCode": "BH",
    "countryName": "Bahrain",
    "regions": [
      {
        "regionId": 393,
        "regionCode": null,
        "regionName": "al-Manamah"
      },
      {
        "regionId": 394,
        "regionCode": null,
        "regionName": "al-Muharraq"
      },
      {
        "regionId": 395,
        "regionCode": null,
        "regionName": "ar-Rifa'a"
      },
      {
        "regionId": 396,
        "regionCode": null,
        "regionName": "Badiyah"
      },
      {
        "regionId": 397,
        "regionCode": null,
        "regionName": "Hidd"
      },
      {
        "regionId": 398,
        "regionCode": null,
        "regionName": "'Isa"
      },
      {
        "regionId": 399,
        "regionCode": null,
        "regionName": "Jidd Hafs"
      },
      {
        "regionId": 400,
        "regionCode": null,
        "regionName": "Mahama"
      },
      {
        "regionId": 401,
        "regionCode": null,
        "regionName": "Manama"
      },
      {
        "regionId": 402,
        "regionCode": null,
        "regionName": "Sitrah"
      }
    ]
  },
  {
    "countryId": 20,
    "countryCode": "BD",
    "countryName": "Bangladesh",
    "regions": [
      {
        "regionId": 242,
        "regionCode": null,
        "regionName": "Bagar Hat"
      },
      {
        "regionId": 243,
        "regionCode": null,
        "regionName": "Bandarban"
      },
      {
        "regionId": 244,
        "regionCode": null,
        "regionName": "Barguna"
      },
      {
        "regionId": 245,
        "regionCode": null,
        "regionName": "Barisal"
      },
      {
        "regionId": 246,
        "regionCode": null,
        "regionName": "Bhola"
      },
      {
        "regionId": 247,
        "regionCode": null,
        "regionName": "Bogora"
      },
      {
        "regionId": 248,
        "regionCode": null,
        "regionName": "Brahman Bariya"
      },
      {
        "regionId": 249,
        "regionCode": null,
        "regionName": "Chandpur"
      },
      {
        "regionId": 250,
        "regionCode": null,
        "regionName": "Chattagam"
      },
      {
        "regionId": 251,
        "regionCode": null,
        "regionName": "Chittagong Division"
      },
      {
        "regionId": 252,
        "regionCode": null,
        "regionName": "Chuadanga"
      },
      {
        "regionId": 253,
        "regionCode": null,
        "regionName": "Dhaka"
      },
      {
        "regionId": 254,
        "regionCode": null,
        "regionName": "Dinajpur"
      },
      {
        "regionId": 255,
        "regionCode": null,
        "regionName": "Faridpur"
      },
      {
        "regionId": 256,
        "regionCode": null,
        "regionName": "Feni"
      },
      {
        "regionId": 257,
        "regionCode": null,
        "regionName": "Gaybanda"
      },
      {
        "regionId": 258,
        "regionCode": null,
        "regionName": "Gazipur"
      },
      {
        "regionId": 259,
        "regionCode": null,
        "regionName": "Gopalganj"
      },
      {
        "regionId": 260,
        "regionCode": null,
        "regionName": "Habiganj"
      },
      {
        "regionId": 261,
        "regionCode": null,
        "regionName": "Jaipur Hat"
      },
      {
        "regionId": 262,
        "regionCode": null,
        "regionName": "Jamalpur"
      },
      {
        "regionId": 263,
        "regionCode": null,
        "regionName": "Jessor"
      },
      {
        "regionId": 264,
        "regionCode": null,
        "regionName": "Jhalakati"
      },
      {
        "regionId": 265,
        "regionCode": null,
        "regionName": "Jhanaydah"
      },
      {
        "regionId": 266,
        "regionCode": null,
        "regionName": "Khagrachhari"
      },
      {
        "regionId": 267,
        "regionCode": null,
        "regionName": "Khulna"
      },
      {
        "regionId": 268,
        "regionCode": null,
        "regionName": "Kishorganj"
      },
      {
        "regionId": 269,
        "regionCode": null,
        "regionName": "Koks Bazar"
      },
      {
        "regionId": 270,
        "regionCode": null,
        "regionName": "Komilla"
      },
      {
        "regionId": 271,
        "regionCode": null,
        "regionName": "Kurigram"
      },
      {
        "regionId": 272,
        "regionCode": null,
        "regionName": "Kushtiya"
      },
      {
        "regionId": 273,
        "regionCode": null,
        "regionName": "Lakshmipur"
      },
      {
        "regionId": 274,
        "regionCode": null,
        "regionName": "Lalmanir Hat"
      },
      {
        "regionId": 275,
        "regionCode": null,
        "regionName": "Madaripur"
      },
      {
        "regionId": 276,
        "regionCode": null,
        "regionName": "Magura"
      },
      {
        "regionId": 277,
        "regionCode": null,
        "regionName": "Maimansingh"
      },
      {
        "regionId": 278,
        "regionCode": null,
        "regionName": "Manikganj"
      },
      {
        "regionId": 279,
        "regionCode": null,
        "regionName": "Maulvi Bazar"
      },
      {
        "regionId": 280,
        "regionCode": null,
        "regionName": "Meherpur"
      },
      {
        "regionId": 281,
        "regionCode": null,
        "regionName": "Munshiganj"
      },
      {
        "regionId": 282,
        "regionCode": null,
        "regionName": "Naral"
      },
      {
        "regionId": 283,
        "regionCode": null,
        "regionName": "Narayanganj"
      },
      {
        "regionId": 284,
        "regionCode": null,
        "regionName": "Narsingdi"
      },
      {
        "regionId": 285,
        "regionCode": null,
        "regionName": "Nator"
      },
      {
        "regionId": 286,
        "regionCode": null,
        "regionName": "Naugaon"
      },
      {
        "regionId": 287,
        "regionCode": null,
        "regionName": "Nawabganj"
      },
      {
        "regionId": 288,
        "regionCode": null,
        "regionName": "Netrakona"
      },
      {
        "regionId": 289,
        "regionCode": null,
        "regionName": "Nilphamari"
      },
      {
        "regionId": 290,
        "regionCode": null,
        "regionName": "Noakhali"
      },
      {
        "regionId": 291,
        "regionCode": null,
        "regionName": "Pabna"
      },
      {
        "regionId": 292,
        "regionCode": null,
        "regionName": "Panchagarh"
      },
      {
        "regionId": 293,
        "regionCode": null,
        "regionName": "Patuakhali"
      },
      {
        "regionId": 294,
        "regionCode": null,
        "regionName": "Pirojpur"
      },
      {
        "regionId": 295,
        "regionCode": null,
        "regionName": "Rajbari"
      },
      {
        "regionId": 296,
        "regionCode": null,
        "regionName": "Rajshahi"
      },
      {
        "regionId": 297,
        "regionCode": null,
        "regionName": "Rangamati"
      },
      {
        "regionId": 298,
        "regionCode": null,
        "regionName": "Rangpur"
      },
      {
        "regionId": 299,
        "regionCode": null,
        "regionName": "Satkhira"
      },
      {
        "regionId": 300,
        "regionCode": null,
        "regionName": "Shariatpur"
      },
      {
        "regionId": 301,
        "regionCode": null,
        "regionName": "Sherpur"
      },
      {
        "regionId": 302,
        "regionCode": null,
        "regionName": "Silhat"
      },
      {
        "regionId": 303,
        "regionCode": null,
        "regionName": "Sirajganj"
      },
      {
        "regionId": 304,
        "regionCode": null,
        "regionName": "Sunamganj"
      },
      {
        "regionId": 305,
        "regionCode": null,
        "regionName": "Tangayal"
      },
      {
        "regionId": 306,
        "regionCode": null,
        "regionName": "Thakurgaon"
      }
    ]
  },
  {
    "countryId": 21,
    "countryCode": "BB",
    "countryName": "Barbados",
    "regions": [
      {
        "regionId": 231,
        "regionCode": null,
        "regionName": "Christ Church"
      },
      {
        "regionId": 232,
        "regionCode": null,
        "regionName": "Saint Andrew"
      },
      {
        "regionId": 233,
        "regionCode": null,
        "regionName": "Saint George"
      },
      {
        "regionId": 234,
        "regionCode": null,
        "regionName": "Saint James"
      },
      {
        "regionId": 235,
        "regionCode": null,
        "regionName": "Saint John"
      },
      {
        "regionId": 236,
        "regionCode": null,
        "regionName": "Saint Joseph"
      },
      {
        "regionId": 237,
        "regionCode": null,
        "regionName": "Saint Lucy"
      },
      {
        "regionId": 238,
        "regionCode": null,
        "regionName": "Saint Michael"
      },
      {
        "regionId": 239,
        "regionCode": null,
        "regionName": "Saint Peter"
      },
      {
        "regionId": 240,
        "regionCode": null,
        "regionName": "Saint Philip"
      },
      {
        "regionId": 241,
        "regionCode": null,
        "regionName": "Saint Thomas"
      }
    ]
  },
  {
    "countryId": 22,
    "countryCode": "BY",
    "countryName": "Belarus",
    "regions": [
      {
        "regionId": 532,
        "regionCode": null,
        "regionName": "Brest"
      },
      {
        "regionId": 533,
        "regionCode": null,
        "regionName": "Homjel'"
      },
      {
        "regionId": 534,
        "regionCode": null,
        "regionName": "Hrodna"
      },
      {
        "regionId": 535,
        "regionCode": null,
        "regionName": "Mahiljow"
      },
      {
        "regionId": 536,
        "regionCode": null,
        "regionName": "Mahilyowskaya Voblasts"
      },
      {
        "regionId": 537,
        "regionCode": null,
        "regionName": "Minsk"
      },
      {
        "regionId": 538,
        "regionCode": null,
        "regionName": "Minskaja Voblasts'"
      },
      {
        "regionId": 539,
        "regionCode": null,
        "regionName": "Petrik"
      },
      {
        "regionId": 540,
        "regionCode": null,
        "regionName": "Vicebsk"
      }
    ]
  },
  {
    "countryId": 23,
    "countryCode": "BE",
    "countryName": "Belgium",
    "regions": [
      {
        "regionId": 307,
        "regionCode": null,
        "regionName": "Antwerpen"
      },
      {
        "regionId": 308,
        "regionCode": null,
        "regionName": "Berchem"
      },
      {
        "regionId": 309,
        "regionCode": null,
        "regionName": "Brabant"
      },
      {
        "regionId": 310,
        "regionCode": null,
        "regionName": "Brabant Wallon"
      },
      {
        "regionId": 311,
        "regionCode": null,
        "regionName": "Brussel"
      },
      {
        "regionId": 312,
        "regionCode": null,
        "regionName": "East Flanders"
      },
      {
        "regionId": 313,
        "regionCode": "03",
        "regionName": "Hainaut"
      },
      {
        "regionId": 314,
        "regionCode": "04",
        "regionName": "Liege"
      },
      {
        "regionId": 315,
        "regionCode": "05",
        "regionName": "Limburg"
      },
      {
        "regionId": 316,
        "regionCode": "06",
        "regionName": "Luxembourg"
      },
      {
        "regionId": 317,
        "regionCode": "07",
        "regionName": "Namur"
      },
      {
        "regionId": 318,
        "regionCode": null,
        "regionName": "Ontario"
      },
      {
        "regionId": 319,
        "regionCode": "08",
        "regionName": "Oost-Vlaanderen"
      },
      {
        "regionId": 320,
        "regionCode": null,
        "regionName": "Provincie Brabant"
      },
      {
        "regionId": 321,
        "regionCode": null,
        "regionName": "Vlaams-Brabant"
      },
      {
        "regionId": 322,
        "regionCode": null,
        "regionName": "Wallonne"
      },
      {
        "regionId": 323,
        "regionCode": "09",
        "regionName": "West-Vlaanderen"
      }
    ]
  },
  {
    "countryId": 24,
    "countryCode": "BZ",
    "countryName": "Belize",
    "regions": [
      {
        "regionId": 541,
        "regionCode": "BZ",
        "regionName": "Belize"
      },
      {
        "regionId": 542,
        "regionCode": "CY",
        "regionName": "Cayo"
      },
      {
        "regionId": 543,
        "regionCode": "CZ",
        "regionName": "Corozal"
      },
      {
        "regionId": 544,
        "regionCode": "OW",
        "regionName": "Orange Walk"
      },
      {
        "regionId": 545,
        "regionCode": "SC",
        "regionName": "Stann Creek"
      },
      {
        "regionId": 546,
        "regionCode": "TO",
        "regionName": "Toledo"
      }
    ]
  },
  {
    "countryId": 25,
    "countryCode": "BJ",
    "countryName": "Benin",
    "regions": [
      {
        "regionId": 418,
        "regionCode": null,
        "regionName": "Alibori"
      },
      {
        "regionId": 419,
        "regionCode": null,
        "regionName": "Atacora"
      },
      {
        "regionId": 420,
        "regionCode": null,
        "regionName": "Atlantique"
      },
      {
        "regionId": 421,
        "regionCode": null,
        "regionName": "Borgou"
      },
      {
        "regionId": 422,
        "regionCode": null,
        "regionName": "Collines"
      },
      {
        "regionId": 423,
        "regionCode": null,
        "regionName": "Couffo"
      },
      {
        "regionId": 424,
        "regionCode": null,
        "regionName": "Donga"
      },
      {
        "regionId": 425,
        "regionCode": null,
        "regionName": "Littoral"
      },
      {
        "regionId": 426,
        "regionCode": null,
        "regionName": "Mono"
      },
      {
        "regionId": 427,
        "regionCode": null,
        "regionName": "Oueme"
      },
      {
        "regionId": 428,
        "regionCode": null,
        "regionName": "Plateau"
      },
      {
        "regionId": 429,
        "regionCode": null,
        "regionName": "Zou"
      }
    ]
  },
  {
    "countryId": 26,
    "countryCode": "BM",
    "countryName": "Bermuda",
    "regions": [
      {
        "regionId": 430,
        "regionCode": "HA",
        "regionName": "Hamilton"
      },
      {
        "regionId": 431,
        "regionCode": "SC",
        "regionName": "Saint George"
      },
      {
        "regionId": 4068,
        "regionCode": "DE",
        "regionName": "Devonshire"
      },
      {
        "regionId": 4069,
        "regionCode": "PA",
        "regionName": "Paget"
      },
      {
        "regionId": 4070,
        "regionCode": "PE",
        "regionName": "Pembroke"
      },
      {
        "regionId": 4071,
        "regionCode": "SA",
        "regionName": "Sandys"
      },
      {
        "regionId": 4072,
        "regionCode": "SM",
        "regionName": "Smith's"
      },
      {
        "regionId": 4073,
        "regionCode": "SO",
        "regionName": "Southampton"
      },
      {
        "regionId": 4074,
        "regionCode": "WA",
        "regionName": "Warwick"
      }
    ]
  },
  {
    "countryId": 27,
    "countryCode": "BT",
    "countryName": "Bhutan",
    "regions": [
      {
        "regionId": 490,
        "regionCode": null,
        "regionName": "Bumthang"
      },
      {
        "regionId": 491,
        "regionCode": null,
        "regionName": "Chhukha"
      },
      {
        "regionId": 492,
        "regionCode": null,
        "regionName": "Chirang"
      },
      {
        "regionId": 493,
        "regionCode": null,
        "regionName": "Daga"
      },
      {
        "regionId": 494,
        "regionCode": null,
        "regionName": "Geylegphug"
      },
      {
        "regionId": 495,
        "regionCode": null,
        "regionName": "Ha"
      },
      {
        "regionId": 496,
        "regionCode": null,
        "regionName": "Lhuntshi"
      },
      {
        "regionId": 497,
        "regionCode": null,
        "regionName": "Mongar"
      },
      {
        "regionId": 498,
        "regionCode": null,
        "regionName": "Pemagatsel"
      },
      {
        "regionId": 499,
        "regionCode": null,
        "regionName": "Punakha"
      },
      {
        "regionId": 500,
        "regionCode": null,
        "regionName": "Rinpung"
      },
      {
        "regionId": 501,
        "regionCode": null,
        "regionName": "Samchi"
      },
      {
        "regionId": 502,
        "regionCode": null,
        "regionName": "Samdrup Jongkhar"
      },
      {
        "regionId": 503,
        "regionCode": null,
        "regionName": "Shemgang"
      },
      {
        "regionId": 504,
        "regionCode": null,
        "regionName": "Tashigang"
      },
      {
        "regionId": 505,
        "regionCode": null,
        "regionName": "Timphu"
      },
      {
        "regionId": 506,
        "regionCode": null,
        "regionName": "Tongsa"
      },
      {
        "regionId": 507,
        "regionCode": null,
        "regionName": "Wangdiphodrang"
      }
    ]
  },
  {
    "countryId": 28,
    "countryCode": "BO",
    "countryName": "Bolivia",
    "regions": [
      {
        "regionId": 436,
        "regionCode": null,
        "regionName": "Beni"
      },
      {
        "regionId": 437,
        "regionCode": null,
        "regionName": "Chuquisaca"
      },
      {
        "regionId": 438,
        "regionCode": null,
        "regionName": "Cochabamba"
      },
      {
        "regionId": 439,
        "regionCode": null,
        "regionName": "La Paz"
      },
      {
        "regionId": 440,
        "regionCode": null,
        "regionName": "Oruro"
      },
      {
        "regionId": 441,
        "regionCode": null,
        "regionName": "Pando"
      },
      {
        "regionId": 442,
        "regionCode": null,
        "regionName": "Potosi"
      },
      {
        "regionId": 443,
        "regionCode": null,
        "regionName": "Santa Cruz"
      },
      {
        "regionId": 444,
        "regionCode": null,
        "regionName": "Tarija"
      }
    ]
  },
  {
    "countryId": 29,
    "countryCode": "BA",
    "countryName": "Bosnia and Herzegovina",
    "regions": [
      {
        "regionId": 229,
        "regionCode": null,
        "regionName": "Federacija Bosna i Hercegovina"
      },
      {
        "regionId": 230,
        "regionCode": null,
        "regionName": "Republika Srpska"
      }
    ]
  },
  {
    "countryId": 30,
    "countryCode": "BW",
    "countryName": "Botswana",
    "regions": [
      {
        "regionId": 509,
        "regionCode": null,
        "regionName": "Central Bobonong"
      },
      {
        "regionId": 510,
        "regionCode": null,
        "regionName": "Central Boteti"
      },
      {
        "regionId": 511,
        "regionCode": null,
        "regionName": "Central Mahalapye"
      },
      {
        "regionId": 512,
        "regionCode": null,
        "regionName": "Central Serowe-Palapye"
      },
      {
        "regionId": 513,
        "regionCode": null,
        "regionName": "Central Tutume"
      },
      {
        "regionId": 514,
        "regionCode": null,
        "regionName": "Chobe"
      },
      {
        "regionId": 515,
        "regionCode": null,
        "regionName": "Francistown"
      },
      {
        "regionId": 516,
        "regionCode": null,
        "regionName": "Gaborone"
      },
      {
        "regionId": 517,
        "regionCode": null,
        "regionName": "Ghanzi"
      },
      {
        "regionId": 518,
        "regionCode": null,
        "regionName": "Jwaneng"
      },
      {
        "regionId": 519,
        "regionCode": null,
        "regionName": "Kgalagadi North"
      },
      {
        "regionId": 520,
        "regionCode": null,
        "regionName": "Kgalagadi South"
      },
      {
        "regionId": 521,
        "regionCode": null,
        "regionName": "Kgatleng"
      },
      {
        "regionId": 522,
        "regionCode": null,
        "regionName": "Kweneng"
      },
      {
        "regionId": 523,
        "regionCode": null,
        "regionName": "Lobatse"
      },
      {
        "regionId": 524,
        "regionCode": null,
        "regionName": "Ngamiland"
      },
      {
        "regionId": 525,
        "regionCode": null,
        "regionName": "Ngwaketse"
      },
      {
        "regionId": 526,
        "regionCode": null,
        "regionName": "North East"
      },
      {
        "regionId": 527,
        "regionCode": null,
        "regionName": "Okavango"
      },
      {
        "regionId": 528,
        "regionCode": null,
        "regionName": "Orapa"
      },
      {
        "regionId": 529,
        "regionCode": null,
        "regionName": "Selibe Phikwe"
      },
      {
        "regionId": 530,
        "regionCode": null,
        "regionName": "South East"
      },
      {
        "regionId": 531,
        "regionCode": null,
        "regionName": "Sowa"
      }
    ]
  },
  {
    "countryId": 31,
    "countryCode": "BV",
    "countryName": "Bouvet Island",
    "regions": [
      {
        "regionId": 508,
        "regionCode": null,
        "regionName": "Bouvet Island"
      }
    ]
  },
  {
    "countryId": 32,
    "countryCode": "BR",
    "countryName": "Brazil",
    "regions": [
      {
        "regionId": 445,
        "regionCode": "AC",
        "regionName": "Acre"
      },
      {
        "regionId": 446,
        "regionCode": "AL",
        "regionName": "Alagoas"
      },
      {
        "regionId": 447,
        "regionCode": "AP",
        "regionName": "Amapa"
      },
      {
        "regionId": 448,
        "regionCode": "AM",
        "regionName": "Amazonas"
      },
      {
        "regionId": 449,
        "regionCode": "BA",
        "regionName": "Bahia"
      },
      {
        "regionId": 450,
        "regionCode": "CE",
        "regionName": "Ceara"
      },
      {
        "regionId": 451,
        "regionCode": "DF",
        "regionName": "Distrito Federal"
      },
      {
        "regionId": 452,
        "regionCode": "ES",
        "regionName": "Espirito Santo"
      },
      {
        "regionId": 454,
        "regionCode": "GO",
        "regionName": "Goias"
      },
      {
        "regionId": 455,
        "regionCode": "MA",
        "regionName": "Maranhao"
      },
      {
        "regionId": 456,
        "regionCode": "MT",
        "regionName": "Mato Grosso"
      },
      {
        "regionId": 457,
        "regionCode": "MS",
        "regionName": "Mato Grosso do Sul"
      },
      {
        "regionId": 458,
        "regionCode": "MG",
        "regionName": "Minas Gerais"
      },
      {
        "regionId": 459,
        "regionCode": "PA",
        "regionName": "Para"
      },
      {
        "regionId": 460,
        "regionCode": "PB",
        "regionName": "Paraiba"
      },
      {
        "regionId": 461,
        "regionCode": "PR",
        "regionName": "Parana"
      },
      {
        "regionId": 462,
        "regionCode": "PE",
        "regionName": "Pernambuco"
      },
      {
        "regionId": 463,
        "regionCode": "PI",
        "regionName": "Piaui"
      },
      {
        "regionId": 464,
        "regionCode": "RJ",
        "regionName": "Rio de Janeiro"
      },
      {
        "regionId": 465,
        "regionCode": "RN",
        "regionName": "Rio Grande do Norte"
      },
      {
        "regionId": 466,
        "regionCode": "RS",
        "regionName": "Rio Grande do Sul"
      },
      {
        "regionId": 467,
        "regionCode": "RO",
        "regionName": "Rondonia"
      },
      {
        "regionId": 468,
        "regionCode": "RR",
        "regionName": "Roraima"
      },
      {
        "regionId": 469,
        "regionCode": "SC",
        "regionName": "Santa Catarina"
      },
      {
        "regionId": 470,
        "regionCode": "SP",
        "regionName": "Sao Paulo"
      },
      {
        "regionId": 471,
        "regionCode": "SE",
        "regionName": "Sergipe"
      },
      {
        "regionId": 472,
        "regionCode": "TO",
        "regionName": "Tocantins"
      }
    ]
  },
  {
    "countryId": 33,
    "countryCode": "VG",
    "countryName": "British Virgin Islands",
    "regions": [
      {
        "regionId": 3912,
        "regionCode": null,
        "regionName": "Anegada"
      },
      {
        "regionId": 3913,
        "regionCode": null,
        "regionName": "Jost van Dyke"
      },
      {
        "regionId": 3914,
        "regionCode": null,
        "regionName": "Tortola"
      }
    ]
  },
  {
    "countryId": 34,
    "countryCode": "BN",
    "countryName": "Brunei",
    "regions": [
      {
        "regionId": 432,
        "regionCode": null,
        "regionName": "Belait"
      },
      {
        "regionId": 433,
        "regionCode": null,
        "regionName": "Brunei-Muara"
      },
      {
        "regionId": 434,
        "regionCode": null,
        "regionName": "Temburong"
      },
      {
        "regionId": 435,
        "regionCode": null,
        "regionName": "Tutong"
      }
    ]
  },
  {
    "countryId": 35,
    "countryCode": "BG",
    "countryName": "Bulgaria",
    "regions": [
      {
        "regionId": 363,
        "regionCode": null,
        "regionName": "Blagoevgrad"
      },
      {
        "regionId": 364,
        "regionCode": "01",
        "regionName": "Burgas"
      },
      {
        "regionId": 365,
        "regionCode": null,
        "regionName": "Dobrich"
      },
      {
        "regionId": 366,
        "regionCode": null,
        "regionName": "Gabrovo"
      },
      {
        "regionId": 367,
        "regionCode": null,
        "regionName": "Haskovo"
      },
      {
        "regionId": 368,
        "regionCode": null,
        "regionName": "Jambol"
      },
      {
        "regionId": 369,
        "regionCode": null,
        "regionName": "Kardzhali"
      },
      {
        "regionId": 370,
        "regionCode": null,
        "regionName": "Kjustendil"
      },
      {
        "regionId": 371,
        "regionCode": "04",
        "regionName": "Lovech"
      },
      {
        "regionId": 372,
        "regionCode": "05",
        "regionName": "Montana"
      },
      {
        "regionId": 373,
        "regionCode": null,
        "regionName": "Oblast Sofiya-Grad"
      },
      {
        "regionId": 374,
        "regionCode": null,
        "regionName": "Pazardzhik"
      },
      {
        "regionId": 375,
        "regionCode": null,
        "regionName": "Pernik"
      },
      {
        "regionId": 376,
        "regionCode": null,
        "regionName": "Pleven"
      },
      {
        "regionId": 377,
        "regionCode": "06",
        "regionName": "Plovdiv"
      },
      {
        "regionId": 378,
        "regionCode": null,
        "regionName": "Razgrad"
      },
      {
        "regionId": 379,
        "regionCode": "07",
        "regionName": "Ruse"
      },
      {
        "regionId": 380,
        "regionCode": null,
        "regionName": "Shumen"
      },
      {
        "regionId": 381,
        "regionCode": null,
        "regionName": "Silistra"
      },
      {
        "regionId": 382,
        "regionCode": null,
        "regionName": "Sliven"
      },
      {
        "regionId": 383,
        "regionCode": null,
        "regionName": "Smoljan"
      },
      {
        "regionId": 384,
        "regionCode": null,
        "regionName": "Sofija grad"
      },
      {
        "regionId": 385,
        "regionCode": null,
        "regionName": "Sofijska oblast"
      },
      {
        "regionId": 386,
        "regionCode": null,
        "regionName": "Stara Zagora"
      },
      {
        "regionId": 387,
        "regionCode": null,
        "regionName": "Targovishte"
      },
      {
        "regionId": 388,
        "regionCode": "09",
        "regionName": "Varna"
      },
      {
        "regionId": 389,
        "regionCode": null,
        "regionName": "Veliko Tarnovo"
      },
      {
        "regionId": 390,
        "regionCode": null,
        "regionName": "Vidin"
      },
      {
        "regionId": 391,
        "regionCode": null,
        "regionName": "Vraca"
      },
      {
        "regionId": 392,
        "regionCode": null,
        "regionName": "Yablaniza"
      }
    ]
  },
  {
    "countryId": 36,
    "countryCode": "BF",
    "countryName": "Burkina Faso",
    "regions": [
      {
        "regionId": 324,
        "regionCode": null,
        "regionName": "Bale"
      },
      {
        "regionId": 325,
        "regionCode": null,
        "regionName": "Bam"
      },
      {
        "regionId": 326,
        "regionCode": null,
        "regionName": "Bazega"
      },
      {
        "regionId": 327,
        "regionCode": null,
        "regionName": "Bougouriba"
      },
      {
        "regionId": 328,
        "regionCode": null,
        "regionName": "Boulgou"
      },
      {
        "regionId": 329,
        "regionCode": null,
        "regionName": "Boulkiemde"
      },
      {
        "regionId": 330,
        "regionCode": null,
        "regionName": "Comoe"
      },
      {
        "regionId": 331,
        "regionCode": null,
        "regionName": "Ganzourgou"
      },
      {
        "regionId": 332,
        "regionCode": null,
        "regionName": "Gnagna"
      },
      {
        "regionId": 333,
        "regionCode": null,
        "regionName": "Gourma"
      },
      {
        "regionId": 334,
        "regionCode": null,
        "regionName": "Houet"
      },
      {
        "regionId": 335,
        "regionCode": null,
        "regionName": "Ioba"
      },
      {
        "regionId": 336,
        "regionCode": null,
        "regionName": "Kadiogo"
      },
      {
        "regionId": 337,
        "regionCode": null,
        "regionName": "Kenedougou"
      },
      {
        "regionId": 338,
        "regionCode": null,
        "regionName": "Komandjari"
      },
      {
        "regionId": 339,
        "regionCode": null,
        "regionName": "Kompienga"
      },
      {
        "regionId": 340,
        "regionCode": null,
        "regionName": "Kossi"
      },
      {
        "regionId": 341,
        "regionCode": null,
        "regionName": "Kouritenga"
      },
      {
        "regionId": 342,
        "regionCode": null,
        "regionName": "Kourweogo"
      },
      {
        "regionId": 343,
        "regionCode": null,
        "regionName": "Leraba"
      },
      {
        "regionId": 344,
        "regionCode": null,
        "regionName": "Mouhoun"
      },
      {
        "regionId": 345,
        "regionCode": null,
        "regionName": "Nahouri"
      },
      {
        "regionId": 346,
        "regionCode": null,
        "regionName": "Namentenga"
      },
      {
        "regionId": 347,
        "regionCode": null,
        "regionName": "Noumbiel"
      },
      {
        "regionId": 348,
        "regionCode": null,
        "regionName": "Oubritenga"
      },
      {
        "regionId": 349,
        "regionCode": null,
        "regionName": "Oudalan"
      },
      {
        "regionId": 350,
        "regionCode": null,
        "regionName": "Passore"
      },
      {
        "regionId": 351,
        "regionCode": null,
        "regionName": "Poni"
      },
      {
        "regionId": 352,
        "regionCode": null,
        "regionName": "Sanguie"
      },
      {
        "regionId": 353,
        "regionCode": null,
        "regionName": "Sanmatenga"
      },
      {
        "regionId": 354,
        "regionCode": null,
        "regionName": "Seno"
      },
      {
        "regionId": 355,
        "regionCode": null,
        "regionName": "Sissili"
      },
      {
        "regionId": 356,
        "regionCode": null,
        "regionName": "Soum"
      },
      {
        "regionId": 357,
        "regionCode": null,
        "regionName": "Sourou"
      },
      {
        "regionId": 358,
        "regionCode": null,
        "regionName": "Tapoa"
      },
      {
        "regionId": 359,
        "regionCode": null,
        "regionName": "Tuy"
      },
      {
        "regionId": 360,
        "regionCode": null,
        "regionName": "Yatenga"
      },
      {
        "regionId": 361,
        "regionCode": null,
        "regionName": "Zondoma"
      },
      {
        "regionId": 362,
        "regionCode": null,
        "regionName": "Zoundweogo"
      }
    ]
  },
  {
    "countryId": 37,
    "countryCode": "BI",
    "countryName": "Burundi",
    "regions": [
      {
        "regionId": 403,
        "regionCode": null,
        "regionName": "Bubanza"
      },
      {
        "regionId": 404,
        "regionCode": null,
        "regionName": "Bujumbura"
      },
      {
        "regionId": 405,
        "regionCode": null,
        "regionName": "Bururi"
      },
      {
        "regionId": 406,
        "regionCode": null,
        "regionName": "Cankuzo"
      },
      {
        "regionId": 407,
        "regionCode": null,
        "regionName": "Cibitoke"
      },
      {
        "regionId": 408,
        "regionCode": null,
        "regionName": "Gitega"
      },
      {
        "regionId": 409,
        "regionCode": null,
        "regionName": "Karuzi"
      },
      {
        "regionId": 410,
        "regionCode": null,
        "regionName": "Kayanza"
      },
      {
        "regionId": 411,
        "regionCode": null,
        "regionName": "Kirundo"
      },
      {
        "regionId": 412,
        "regionCode": null,
        "regionName": "Makamba"
      },
      {
        "regionId": 413,
        "regionCode": null,
        "regionName": "Muramvya"
      },
      {
        "regionId": 414,
        "regionCode": null,
        "regionName": "Muyinga"
      },
      {
        "regionId": 415,
        "regionCode": null,
        "regionName": "Ngozi"
      },
      {
        "regionId": 416,
        "regionCode": null,
        "regionName": "Rutana"
      },
      {
        "regionId": 417,
        "regionCode": null,
        "regionName": "Ruyigi"
      }
    ]
  },
  {
    "countryId": 38,
    "countryCode": "KH",
    "countryName": "Cambodia",
    "regions": [
      {
        "regionId": 2116,
        "regionCode": null,
        "regionName": "Banteay Mean Chey"
      },
      {
        "regionId": 2117,
        "regionCode": null,
        "regionName": "Bat Dambang"
      },
      {
        "regionId": 2118,
        "regionCode": null,
        "regionName": "Kampong Cham"
      },
      {
        "regionId": 2119,
        "regionCode": null,
        "regionName": "Kampong Chhnang"
      },
      {
        "regionId": 2120,
        "regionCode": null,
        "regionName": "Kampong Spoeu"
      },
      {
        "regionId": 2121,
        "regionCode": null,
        "regionName": "Kampong Thum"
      },
      {
        "regionId": 2122,
        "regionCode": null,
        "regionName": "Kampot"
      },
      {
        "regionId": 2123,
        "regionCode": null,
        "regionName": "Kandal"
      },
      {
        "regionId": 2124,
        "regionCode": null,
        "regionName": "Kaoh Kong"
      },
      {
        "regionId": 2125,
        "regionCode": null,
        "regionName": "Kracheh"
      },
      {
        "regionId": 2126,
        "regionCode": null,
        "regionName": "Krong Kaeb"
      },
      {
        "regionId": 2127,
        "regionCode": null,
        "regionName": "Krong Pailin"
      },
      {
        "regionId": 2128,
        "regionCode": null,
        "regionName": "Krong Preah Sihanouk"
      },
      {
        "regionId": 2129,
        "regionCode": null,
        "regionName": "Mondol Kiri"
      },
      {
        "regionId": 2130,
        "regionCode": null,
        "regionName": "Otdar Mean Chey"
      },
      {
        "regionId": 2131,
        "regionCode": null,
        "regionName": "Phnum Penh"
      },
      {
        "regionId": 2132,
        "regionCode": null,
        "regionName": "Pousat"
      },
      {
        "regionId": 2133,
        "regionCode": null,
        "regionName": "Preah Vihear"
      },
      {
        "regionId": 2134,
        "regionCode": null,
        "regionName": "Prey Veaeng"
      },
      {
        "regionId": 2135,
        "regionCode": null,
        "regionName": "Rotanak Kiri"
      },
      {
        "regionId": 2136,
        "regionCode": null,
        "regionName": "Siem Reab"
      },
      {
        "regionId": 2137,
        "regionCode": null,
        "regionName": "Stueng Traeng"
      },
      {
        "regionId": 2138,
        "regionCode": null,
        "regionName": "Svay Rieng"
      },
      {
        "regionId": 2139,
        "regionCode": null,
        "regionName": "Takaev"
      }
    ]
  },
  {
    "countryId": 39,
    "countryCode": "CM",
    "countryName": "Cameroon",
    "regions": [
      {
        "regionId": 675,
        "regionCode": null,
        "regionName": "Adamaoua"
      },
      {
        "regionId": 676,
        "regionCode": null,
        "regionName": "Centre"
      },
      {
        "regionId": 677,
        "regionCode": null,
        "regionName": "Est"
      },
      {
        "regionId": 678,
        "regionCode": null,
        "regionName": "Littoral"
      },
      {
        "regionId": 679,
        "regionCode": null,
        "regionName": "Nord"
      },
      {
        "regionId": 680,
        "regionCode": null,
        "regionName": "Nord Extreme"
      },
      {
        "regionId": 681,
        "regionCode": null,
        "regionName": "Nordouest"
      },
      {
        "regionId": 682,
        "regionCode": null,
        "regionName": "Ouest"
      },
      {
        "regionId": 683,
        "regionCode": null,
        "regionName": "Sud"
      },
      {
        "regionId": 684,
        "regionCode": null,
        "regionName": "Sudouest"
      }
    ]
  },
  {
    "countryId": 40,
    "countryCode": "CA",
    "countryName": "Canada",
    "regions": [
      {
        "regionId": 547,
        "regionCode": "AB",
        "regionName": "Alberta"
      },
      {
        "regionId": 548,
        "regionCode": "BC",
        "regionName": "British Columbia"
      },
      {
        "regionId": 549,
        "regionCode": "MB",
        "regionName": "Manitoba"
      },
      {
        "regionId": 550,
        "regionCode": "NB",
        "regionName": "New Brunswick"
      },
      {
        "regionId": 551,
        "regionCode": "NL",
        "regionName": "Newfoundland and Labrador"
      },
      {
        "regionId": 552,
        "regionCode": "NT",
        "regionName": "Northwest Territories"
      },
      {
        "regionId": 553,
        "regionCode": "NS",
        "regionName": "Nova Scotia"
      },
      {
        "regionId": 554,
        "regionCode": "NU",
        "regionName": "Nunavut"
      },
      {
        "regionId": 555,
        "regionCode": "ON",
        "regionName": "Ontario"
      },
      {
        "regionId": 556,
        "regionCode": "PE",
        "regionName": "Prince Edward Island"
      },
      {
        "regionId": 557,
        "regionCode": "QC",
        "regionName": "Quebec"
      },
      {
        "regionId": 558,
        "regionCode": "SK",
        "regionName": "Saskatchewan"
      },
      {
        "regionId": 559,
        "regionCode": "YT",
        "regionName": "Yukon"
      }
    ]
  },
  {
    "countryId": 41,
    "countryCode": "KY",
    "countryName": "Cayman Islands",
    "regions": [
      {
        "regionId": 2236,
        "regionCode": null,
        "regionName": "Grand Cayman"
      }
    ]
  },
  {
    "countryId": 42,
    "countryCode": "CF",
    "countryName": "Central African Republic",
    "regions": [
      {
        "regionId": 571,
        "regionCode": null,
        "regionName": "Bamingui-Bangoran"
      },
      {
        "regionId": 572,
        "regionCode": null,
        "regionName": "Bangui"
      },
      {
        "regionId": 573,
        "regionCode": null,
        "regionName": "Basse-Kotto"
      },
      {
        "regionId": 574,
        "regionCode": null,
        "regionName": "Haute-Kotto"
      },
      {
        "regionId": 575,
        "regionCode": null,
        "regionName": "Haut-Mbomou"
      },
      {
        "regionId": 576,
        "regionCode": null,
        "regionName": "Kemo"
      },
      {
        "regionId": 577,
        "regionCode": null,
        "regionName": "Lobaye"
      },
      {
        "regionId": 578,
        "regionCode": null,
        "regionName": "Mambere-Kadei"
      },
      {
        "regionId": 579,
        "regionCode": null,
        "regionName": "Mbomou"
      },
      {
        "regionId": 580,
        "regionCode": null,
        "regionName": "Nana-Gribizi"
      },
      {
        "regionId": 581,
        "regionCode": null,
        "regionName": "Nana-Mambere"
      },
      {
        "regionId": 582,
        "regionCode": null,
        "regionName": "Ombella Mpoko"
      },
      {
        "regionId": 583,
        "regionCode": null,
        "regionName": "Ouaka"
      },
      {
        "regionId": 584,
        "regionCode": null,
        "regionName": "Ouham"
      },
      {
        "regionId": 585,
        "regionCode": null,
        "regionName": "Ouham-Pende"
      },
      {
        "regionId": 586,
        "regionCode": null,
        "regionName": "Sangha-Mbaere"
      },
      {
        "regionId": 587,
        "regionCode": null,
        "regionName": "Vakaga"
      }
    ]
  },
  {
    "countryId": 43,
    "countryCode": "TD",
    "countryName": "Chad",
    "regions": [
      {
        "regionId": 3466,
        "regionCode": null,
        "regionName": "Batha"
      },
      {
        "regionId": 3467,
        "regionCode": null,
        "regionName": "Biltine"
      },
      {
        "regionId": 3468,
        "regionCode": null,
        "regionName": "Bourkou-Ennedi-Tibesti"
      },
      {
        "regionId": 3469,
        "regionCode": null,
        "regionName": "Chari-Baguirmi"
      },
      {
        "regionId": 3470,
        "regionCode": null,
        "regionName": "Guera"
      },
      {
        "regionId": 3471,
        "regionCode": null,
        "regionName": "Kanem"
      },
      {
        "regionId": 3472,
        "regionCode": null,
        "regionName": "Lac"
      },
      {
        "regionId": 3473,
        "regionCode": null,
        "regionName": "Logone Occidental"
      },
      {
        "regionId": 3474,
        "regionCode": null,
        "regionName": "Logone Oriental"
      },
      {
        "regionId": 3475,
        "regionCode": null,
        "regionName": "Mayo-Kebbi"
      },
      {
        "regionId": 3476,
        "regionCode": null,
        "regionName": "Moyen-Chari"
      },
      {
        "regionId": 3477,
        "regionCode": null,
        "regionName": "Ouaddai"
      },
      {
        "regionId": 3478,
        "regionCode": null,
        "regionName": "Salamat"
      },
      {
        "regionId": 3479,
        "regionCode": null,
        "regionName": "Tandjile"
      }
    ]
  },
  {
    "countryId": 44,
    "countryCode": "CL",
    "countryName": "Chile",
    "regions": [
      {
        "regionId": 661,
        "regionCode": null,
        "regionName": "Aisen"
      },
      {
        "regionId": 662,
        "regionCode": "AN",
        "regionName": "Antofagasta"
      },
      {
        "regionId": 663,
        "regionCode": "AR",
        "regionName": "Araucania"
      },
      {
        "regionId": 664,
        "regionCode": "AT",
        "regionName": "Atacama"
      },
      {
        "regionId": 665,
        "regionCode": null,
        "regionName": "Bio Bio"
      },
      {
        "regionId": 666,
        "regionCode": "CO",
        "regionName": "Coquimbo"
      },
      {
        "regionId": 667,
        "regionCode": null,
        "regionName": "Libertador General Bernardo O'"
      },
      {
        "regionId": 668,
        "regionCode": "LL",
        "regionName": "Los Lagos"
      },
      {
        "regionId": 669,
        "regionCode": null,
        "regionName": "Magellanes"
      },
      {
        "regionId": 670,
        "regionCode": "ML",
        "regionName": "Maule"
      },
      {
        "regionId": 671,
        "regionCode": null,
        "regionName": "Metropolitana"
      },
      {
        "regionId": 672,
        "regionCode": "RM",
        "regionName": "Metropolitana de Santiago"
      },
      {
        "regionId": 673,
        "regionCode": "TA",
        "regionName": "Tarapaca"
      },
      {
        "regionId": 674,
        "regionCode": "VS",
        "regionName": "Valparaiso"
      }
    ]
  },
  {
    "countryId": 45,
    "countryCode": "CN",
    "countryName": "China",
    "regions": [
      {
        "regionId": 685,
        "regionCode": "110",
        "regionName": "Anhui"
      },
      {
        "regionId": 686,
        "regionCode": null,
        "regionName": "Anhui Province"
      },
      {
        "regionId": 687,
        "regionCode": "34",
        "regionName": "Anhui Sheng"
      },
      {
        "regionId": 688,
        "regionCode": null,
        "regionName": "Aomen"
      },
      {
        "regionId": 689,
        "regionCode": "010",
        "regionName": "Beijing"
      },
      {
        "regionId": 690,
        "regionCode": "11",
        "regionName": "Beijing Shi"
      },
      {
        "regionId": 691,
        "regionCode": null,
        "regionName": "Chongqing"
      },
      {
        "regionId": 692,
        "regionCode": "150",
        "regionName": "Fujian"
      },
      {
        "regionId": 693,
        "regionCode": "35",
        "regionName": "Fujian Sheng"
      },
      {
        "regionId": 694,
        "regionCode": "260",
        "regionName": "Gansu"
      },
      {
        "regionId": 695,
        "regionCode": "190",
        "regionName": "Guangdong"
      },
      {
        "regionId": 696,
        "regionCode": "44",
        "regionName": "Guangdong Sheng"
      },
      {
        "regionId": 697,
        "regionCode": "210",
        "regionName": "Guangxi"
      },
      {
        "regionId": 698,
        "regionCode": "220",
        "regionName": "Guizhou"
      },
      {
        "regionId": 699,
        "regionCode": "200",
        "regionName": "Hainan"
      },
      {
        "regionId": 700,
        "regionCode": "060",
        "regionName": "Hebei"
      },
      {
        "regionId": 701,
        "regionCode": "090",
        "regionName": "Heilongjiang"
      },
      {
        "regionId": 702,
        "regionCode": "180",
        "regionName": "Henan"
      },
      {
        "regionId": 703,
        "regionCode": "170",
        "regionName": "Hubei"
      },
      {
        "regionId": 704,
        "regionCode": "160",
        "regionName": "Hunan"
      },
      {
        "regionId": 705,
        "regionCode": "100",
        "regionName": "Jiangsu"
      },
      {
        "regionId": 706,
        "regionCode": "32",
        "regionName": "Jiangsu Sheng"
      },
      {
        "regionId": 707,
        "regionCode": "140",
        "regionName": "Jiangxi"
      },
      {
        "regionId": 708,
        "regionCode": "080",
        "regionName": "Jilin"
      },
      {
        "regionId": 709,
        "regionCode": "070",
        "regionName": "Liaoning"
      },
      {
        "regionId": 710,
        "regionCode": "21",
        "regionName": "Liaoning Sheng"
      },
      {
        "regionId": 711,
        "regionCode": null,
        "regionName": "Nei Monggol"
      },
      {
        "regionId": 712,
        "regionCode": null,
        "regionName": "Ningxia Hui"
      },
      {
        "regionId": 713,
        "regionCode": "280",
        "regionName": "Qinghai"
      },
      {
        "regionId": 714,
        "regionCode": "250",
        "regionName": "Shaanxi"
      },
      {
        "regionId": 715,
        "regionCode": "120",
        "regionName": "Shandong"
      },
      {
        "regionId": 716,
        "regionCode": "37",
        "regionName": "Shandong Sheng"
      },
      {
        "regionId": 717,
        "regionCode": "020",
        "regionName": "Shanghai"
      },
      {
        "regionId": 718,
        "regionCode": "050",
        "regionName": "Shanxi"
      },
      {
        "regionId": 719,
        "regionCode": "230",
        "regionName": "Sichuan"
      },
      {
        "regionId": 720,
        "regionCode": "030",
        "regionName": "Tianjin"
      },
      {
        "regionId": 721,
        "regionCode": null,
        "regionName": "Xianggang"
      },
      {
        "regionId": 722,
        "regionCode": "290",
        "regionName": "Xinjiang"
      },
      {
        "regionId": 723,
        "regionCode": "300",
        "regionName": "Xizang"
      },
      {
        "regionId": 724,
        "regionCode": "240",
        "regionName": "Yunnan"
      },
      {
        "regionId": 725,
        "regionCode": "130",
        "regionName": "Zhejiang"
      },
      {
        "regionId": 726,
        "regionCode": "33",
        "regionName": "Zhejiang Sheng"
      }
    ]
  },
  {
    "countryId": 46,
    "countryCode": "CX",
    "countryName": "Christmas Island",
    "regions": [
      {
        "regionId": 783,
        "regionCode": null,
        "regionName": "Christmas Island"
      }
    ]
  },
  {
    "countryId": 47,
    "countryCode": "CO",
    "countryName": "Colombia",
    "regions": [
      {
        "regionId": 727,
        "regionCode": "91",
        "regionName": "Amazonas"
      },
      {
        "regionId": 728,
        "regionCode": "05",
        "regionName": "Antioquia"
      },
      {
        "regionId": 729,
        "regionCode": "81",
        "regionName": "Arauca"
      },
      {
        "regionId": 730,
        "regionCode": "08",
        "regionName": "Atlantico"
      },
      {
        "regionId": 731,
        "regionCode": "11",
        "regionName": "Bogota"
      },
      {
        "regionId": 732,
        "regionCode": "13",
        "regionName": "Bolivar"
      },
      {
        "regionId": 733,
        "regionCode": "15",
        "regionName": "Boyaca"
      },
      {
        "regionId": 734,
        "regionCode": "17",
        "regionName": "Caldas"
      },
      {
        "regionId": 735,
        "regionCode": "18",
        "regionName": "Caqueta"
      },
      {
        "regionId": 736,
        "regionCode": "85",
        "regionName": "Casanare"
      },
      {
        "regionId": 737,
        "regionCode": "19",
        "regionName": "Cauca"
      },
      {
        "regionId": 738,
        "regionCode": "20",
        "regionName": "Cesar"
      },
      {
        "regionId": 739,
        "regionCode": "27",
        "regionName": "Choco"
      },
      {
        "regionId": 740,
        "regionCode": "23",
        "regionName": "Cordoba"
      },
      {
        "regionId": 741,
        "regionCode": "25",
        "regionName": "Cundinamarca"
      },
      {
        "regionId": 742,
        "regionCode": "94",
        "regionName": "Guainia"
      },
      {
        "regionId": 743,
        "regionCode": "95",
        "regionName": "Guaviare"
      },
      {
        "regionId": 744,
        "regionCode": "41",
        "regionName": "Huila"
      },
      {
        "regionId": 745,
        "regionCode": "44",
        "regionName": "La Guajira"
      },
      {
        "regionId": 746,
        "regionCode": "47",
        "regionName": "Magdalena"
      },
      {
        "regionId": 747,
        "regionCode": "50",
        "regionName": "Meta"
      },
      {
        "regionId": 748,
        "regionCode": null,
        "regionName": "Narino"
      },
      {
        "regionId": 749,
        "regionCode": null,
        "regionName": "Norte de Santander"
      },
      {
        "regionId": 750,
        "regionCode": "86",
        "regionName": "Putumayo"
      },
      {
        "regionId": 751,
        "regionCode": "63",
        "regionName": "Quindio"
      },
      {
        "regionId": 752,
        "regionCode": "66",
        "regionName": "Risaralda"
      },
      {
        "regionId": 753,
        "regionCode": null,
        "regionName": "San Andres y Providencia"
      },
      {
        "regionId": 754,
        "regionCode": "68",
        "regionName": "Santander"
      },
      {
        "regionId": 755,
        "regionCode": "70",
        "regionName": "Sucre"
      },
      {
        "regionId": 756,
        "regionCode": "73",
        "regionName": "Tolima"
      },
      {
        "regionId": 757,
        "regionCode": null,
        "regionName": "Valle del Cauca"
      },
      {
        "regionId": 758,
        "regionCode": "97",
        "regionName": "Vaupes"
      },
      {
        "regionId": 759,
        "regionCode": "99",
        "regionName": "Vichada"
      }
    ]
  },
  {
    "countryId": 48,
    "countryCode": "KM",
    "countryName": "Comoros",
    "regions": [
      {
        "regionId": 2163,
        "regionCode": null,
        "regionName": "Mwali"
      },
      {
        "regionId": 2164,
        "regionCode": null,
        "regionName": "Njazidja"
      },
      {
        "regionId": 2165,
        "regionCode": null,
        "regionName": "Nzwani"
      }
    ]
  },
  {
    "countryId": 49,
    "countryCode": "CD",
    "countryName": "Congo, Democratic Republic of the",
    "regions": [
      {
        "regionId": 560,
        "regionCode": null,
        "regionName": "Bandundu"
      },
      {
        "regionId": 561,
        "regionCode": null,
        "regionName": "Bas-Congo"
      },
      {
        "regionId": 562,
        "regionCode": null,
        "regionName": "Equateur"
      },
      {
        "regionId": 563,
        "regionCode": null,
        "regionName": "Haut-Congo"
      },
      {
        "regionId": 564,
        "regionCode": null,
        "regionName": "Kasai-Occidental"
      },
      {
        "regionId": 565,
        "regionCode": null,
        "regionName": "Kasai-Oriental"
      },
      {
        "regionId": 566,
        "regionCode": null,
        "regionName": "Katanga"
      },
      {
        "regionId": 567,
        "regionCode": null,
        "regionName": "Kinshasa"
      },
      {
        "regionId": 568,
        "regionCode": null,
        "regionName": "Maniema"
      },
      {
        "regionId": 569,
        "regionCode": null,
        "regionName": "Nord-Kivu"
      },
      {
        "regionId": 570,
        "regionCode": null,
        "regionName": "Sud-Kivu"
      }
    ]
  },
  {
    "countryId": 50,
    "countryCode": "CG",
    "countryName": "Congo, Republic of the",
    "regions": [
      {
        "regionId": 588,
        "regionCode": null,
        "regionName": "Bouenza"
      },
      {
        "regionId": 589,
        "regionCode": null,
        "regionName": "Brazzaville"
      },
      {
        "regionId": 590,
        "regionCode": null,
        "regionName": "Cuvette"
      },
      {
        "regionId": 591,
        "regionCode": null,
        "regionName": "Kouilou"
      },
      {
        "regionId": 592,
        "regionCode": null,
        "regionName": "Lekoumou"
      },
      {
        "regionId": 593,
        "regionCode": null,
        "regionName": "Likouala"
      },
      {
        "regionId": 594,
        "regionCode": null,
        "regionName": "Niari"
      },
      {
        "regionId": 595,
        "regionCode": null,
        "regionName": "Plateaux"
      },
      {
        "regionId": 596,
        "regionCode": null,
        "regionName": "Pool"
      },
      {
        "regionId": 597,
        "regionCode": null,
        "regionName": "Sangha"
      }
    ]
  },
  {
    "countryId": 51,
    "countryCode": "CK",
    "countryName": "Cook Islands",
    "regions": [
      {
        "regionId": 650,
        "regionCode": null,
        "regionName": "Aitutaki"
      },
      {
        "regionId": 651,
        "regionCode": null,
        "regionName": "Atiu"
      },
      {
        "regionId": 652,
        "regionCode": null,
        "regionName": "Mangaia"
      },
      {
        "regionId": 653,
        "regionCode": null,
        "regionName": "Manihiki"
      },
      {
        "regionId": 654,
        "regionCode": null,
        "regionName": "Mauke"
      },
      {
        "regionId": 655,
        "regionCode": null,
        "regionName": "Mitiaro"
      },
      {
        "regionId": 656,
        "regionCode": null,
        "regionName": "Nassau"
      },
      {
        "regionId": 657,
        "regionCode": null,
        "regionName": "Pukapuka"
      },
      {
        "regionId": 658,
        "regionCode": null,
        "regionName": "Rakahanga"
      },
      {
        "regionId": 659,
        "regionCode": null,
        "regionName": "Rarotonga"
      },
      {
        "regionId": 660,
        "regionCode": null,
        "regionName": "Tongareva"
      }
    ]
  },
  {
    "countryId": 52,
    "countryCode": "CR",
    "countryName": "Costa Rica",
    "regions": [
      {
        "regionId": 760,
        "regionCode": "A",
        "regionName": "Alajuela"
      },
      {
        "regionId": 761,
        "regionCode": "C",
        "regionName": "Cartago"
      },
      {
        "regionId": 762,
        "regionCode": "G",
        "regionName": "Guanacaste"
      },
      {
        "regionId": 763,
        "regionCode": "H",
        "regionName": "Heredia"
      },
      {
        "regionId": 764,
        "regionCode": "L",
        "regionName": "Limon"
      },
      {
        "regionId": 765,
        "regionCode": "P",
        "regionName": "Puntarenas"
      },
      {
        "regionId": 766,
        "regionCode": "SJ",
        "regionName": "San Jose"
      }
    ]
  },
  {
    "countryId": 53,
    "countryCode": "HR",
    "countryName": "Croatia",
    "regions": [
      {
        "regionId": 1686,
        "regionCode": "01",
        "regionName": "Bjelovar-Bilogora"
      },
      {
        "regionId": 1687,
        "regionCode": "03",
        "regionName": "Dubrovnik-Neretva"
      },
      {
        "regionId": 1688,
        "regionCode": null,
        "regionName": "Grad Zagreb"
      },
      {
        "regionId": 1689,
        "regionCode": "04",
        "regionName": "Istra"
      },
      {
        "regionId": 1690,
        "regionCode": "05",
        "regionName": "Karlovac"
      },
      {
        "regionId": 1691,
        "regionCode": null,
        "regionName": "Koprivnica-Krizhevci"
      },
      {
        "regionId": 1692,
        "regionCode": null,
        "regionName": "Krapina-Zagorje"
      },
      {
        "regionId": 1693,
        "regionCode": "07",
        "regionName": "Lika-Senj"
      },
      {
        "regionId": 1694,
        "regionCode": null,
        "regionName": "Medhimurje"
      },
      {
        "regionId": 1695,
        "regionCode": null,
        "regionName": "Medimurska Zupanija"
      },
      {
        "regionId": 1696,
        "regionCode": "09",
        "regionName": "Osijek-Baranja"
      },
      {
        "regionId": 1697,
        "regionCode": null,
        "regionName": "Osjecko-Baranjska Zupanija"
      },
      {
        "regionId": 1698,
        "regionCode": null,
        "regionName": "Pozhega-Slavonija"
      },
      {
        "regionId": 1699,
        "regionCode": null,
        "regionName": "Primorje-Gorski Kotar"
      },
      {
        "regionId": 1700,
        "regionCode": null,
        "regionName": "Shibenik-Knin"
      },
      {
        "regionId": 1701,
        "regionCode": "13",
        "regionName": "Sisak-Moslavina"
      },
      {
        "regionId": 1702,
        "regionCode": null,
        "regionName": "Slavonski Brod-Posavina"
      },
      {
        "regionId": 1703,
        "regionCode": null,
        "regionName": "Split-Dalmacija"
      },
      {
        "regionId": 1704,
        "regionCode": null,
        "regionName": "Varazhdin"
      },
      {
        "regionId": 1705,
        "regionCode": "18",
        "regionName": "Virovitica-Podravina"
      },
      {
        "regionId": 1706,
        "regionCode": "19",
        "regionName": "Vukovar-Srijem"
      },
      {
        "regionId": 1707,
        "regionCode": null,
        "regionName": "Zadar"
      },
      {
        "regionId": 1708,
        "regionCode": "21",
        "regionName": "Zagreb"
      }
    ]
  },
  {
    "countryId": 54,
    "countryCode": "CU",
    "countryName": "Cuba",
    "regions": [
      {
        "regionId": 767,
        "regionCode": "09",
        "regionName": "Camaguey"
      },
      {
        "regionId": 768,
        "regionCode": "08",
        "regionName": "Ciego de Avila"
      },
      {
        "regionId": 769,
        "regionCode": "06",
        "regionName": "Cienfuegos"
      },
      {
        "regionId": 770,
        "regionCode": null,
        "regionName": "Ciudad de la Habana"
      },
      {
        "regionId": 771,
        "regionCode": "12",
        "regionName": "Granma"
      },
      {
        "regionId": 772,
        "regionCode": "14",
        "regionName": "Guantanamo"
      },
      {
        "regionId": 773,
        "regionCode": null,
        "regionName": "Habana"
      },
      {
        "regionId": 774,
        "regionCode": "11",
        "regionName": "Holguin"
      },
      {
        "regionId": 775,
        "regionCode": "99",
        "regionName": "Isla de la Juventud"
      },
      {
        "regionId": 776,
        "regionCode": "03",
        "regionName": "La Habana"
      },
      {
        "regionId": 777,
        "regionCode": "10",
        "regionName": "Las Tunas"
      },
      {
        "regionId": 778,
        "regionCode": "04",
        "regionName": "Matanzas"
      },
      {
        "regionId": 779,
        "regionCode": "01",
        "regionName": "Pinar del Rio"
      },
      {
        "regionId": 780,
        "regionCode": "07",
        "regionName": "Sancti Spiritus"
      },
      {
        "regionId": 781,
        "regionCode": "13",
        "regionName": "Santiago de Cuba"
      },
      {
        "regionId": 782,
        "regionCode": "05",
        "regionName": "Villa Clara"
      }
    ]
  },
  {
    "countryId": 55,
    "countryCode": "CY",
    "countryName": "Cyprus",
    "regions": [
      {
        "regionId": 784,
        "regionCode": null,
        "regionName": "Government controlled area"
      },
      {
        "regionId": 785,
        "regionCode": null,
        "regionName": "Limassol"
      },
      {
        "regionId": 786,
        "regionCode": null,
        "regionName": "Nicosia District"
      },
      {
        "regionId": 787,
        "regionCode": null,
        "regionName": "Paphos"
      },
      {
        "regionId": 788,
        "regionCode": null,
        "regionName": "Turkish controlled area"
      }
    ]
  },
  {
    "countryId": 56,
    "countryCode": "CZ",
    "countryName": "Czech Republic",
    "regions": [
      {
        "regionId": 789,
        "regionCode": null,
        "regionName": "Central Bohemian"
      },
      {
        "regionId": 790,
        "regionCode": null,
        "regionName": "Frycovice"
      },
      {
        "regionId": 791,
        "regionCode": null,
        "regionName": "Jihocesky Kraj"
      },
      {
        "regionId": 792,
        "regionCode": null,
        "regionName": "Jihochesky"
      },
      {
        "regionId": 793,
        "regionCode": "02",
        "regionName": "Jihomoravsky"
      },
      {
        "regionId": 794,
        "regionCode": null,
        "regionName": "Karlovarsky"
      },
      {
        "regionId": 795,
        "regionCode": null,
        "regionName": "Klecany"
      },
      {
        "regionId": 796,
        "regionCode": null,
        "regionName": "Kralovehradecky"
      },
      {
        "regionId": 797,
        "regionCode": null,
        "regionName": "Liberecky"
      },
      {
        "regionId": 798,
        "regionCode": null,
        "regionName": "Lipov"
      },
      {
        "regionId": 799,
        "regionCode": null,
        "regionName": "Moravskoslezsky"
      },
      {
        "regionId": 800,
        "regionCode": null,
        "regionName": "Olomoucky"
      },
      {
        "regionId": 801,
        "regionCode": null,
        "regionName": "Olomoucky Kraj"
      },
      {
        "regionId": 802,
        "regionCode": null,
        "regionName": "Pardubicky"
      },
      {
        "regionId": 803,
        "regionCode": null,
        "regionName": "Plzensky"
      },
      {
        "regionId": 804,
        "regionCode": "03",
        "regionName": "Praha"
      },
      {
        "regionId": 805,
        "regionCode": null,
        "regionName": "Rajhrad"
      },
      {
        "regionId": 806,
        "regionCode": null,
        "regionName": "Smirice"
      },
      {
        "regionId": 807,
        "regionCode": null,
        "regionName": "South Moravian"
      },
      {
        "regionId": 808,
        "regionCode": null,
        "regionName": "Straz nad Nisou"
      },
      {
        "regionId": 809,
        "regionCode": null,
        "regionName": "Stredochesky"
      },
      {
        "regionId": 810,
        "regionCode": null,
        "regionName": "Unicov"
      },
      {
        "regionId": 811,
        "regionCode": null,
        "regionName": "Ustecky"
      },
      {
        "regionId": 812,
        "regionCode": null,
        "regionName": "Valletta"
      },
      {
        "regionId": 813,
        "regionCode": null,
        "regionName": "Velesin"
      },
      {
        "regionId": 814,
        "regionCode": null,
        "regionName": "Vysochina"
      },
      {
        "regionId": 815,
        "regionCode": null,
        "regionName": "Zlinsky"
      }
    ]
  },
  {
    "countryId": 57,
    "countryCode": "DK",
    "countryName": "Denmark",
    "regions": [
      {
        "regionId": 868,
        "regionCode": null,
        "regionName": "Arhus"
      },
      {
        "regionId": 869,
        "regionCode": null,
        "regionName": "Bornholm"
      },
      {
        "regionId": 870,
        "regionCode": null,
        "regionName": "Frederiksborg"
      },
      {
        "regionId": 871,
        "regionCode": null,
        "regionName": "Fyn"
      },
      {
        "regionId": 872,
        "regionCode": null,
        "regionName": "Hovedstaden"
      },
      {
        "regionId": 873,
        "regionCode": null,
        "regionName": "Kobenhavn"
      },
      {
        "regionId": 874,
        "regionCode": null,
        "regionName": "Kobenhavns Amt"
      },
      {
        "regionId": 875,
        "regionCode": null,
        "regionName": "Kobenhavns Kommune"
      },
      {
        "regionId": 876,
        "regionCode": null,
        "regionName": "Nordjylland"
      },
      {
        "regionId": 877,
        "regionCode": null,
        "regionName": "Ribe"
      },
      {
        "regionId": 878,
        "regionCode": null,
        "regionName": "Ringkobing"
      },
      {
        "regionId": 879,
        "regionCode": null,
        "regionName": "Roervig"
      },
      {
        "regionId": 880,
        "regionCode": null,
        "regionName": "Roskilde"
      },
      {
        "regionId": 881,
        "regionCode": null,
        "regionName": "Roslev"
      },
      {
        "regionId": 882,
        "regionCode": null,
        "regionName": "Sjaelland"
      },
      {
        "regionId": 883,
        "regionCode": null,
        "regionName": "Soeborg"
      },
      {
        "regionId": 884,
        "regionCode": null,
        "regionName": "Sonderjylland"
      },
      {
        "regionId": 885,
        "regionCode": null,
        "regionName": "Storstrom"
      },
      {
        "regionId": 886,
        "regionCode": null,
        "regionName": "Syddanmark"
      },
      {
        "regionId": 887,
        "regionCode": null,
        "regionName": "Toelloese"
      },
      {
        "regionId": 888,
        "regionCode": null,
        "regionName": "Vejle"
      },
      {
        "regionId": 889,
        "regionCode": null,
        "regionName": "Vestsjalland"
      },
      {
        "regionId": 890,
        "regionCode": null,
        "regionName": "Viborg"
      }
    ]
  },
  {
    "countryId": 58,
    "countryCode": "DJ",
    "countryName": "Djibouti",
    "regions": [
      {
        "regionId": 863,
        "regionCode": null,
        "regionName": "'Ali Sabih"
      },
      {
        "regionId": 864,
        "regionCode": null,
        "regionName": "Dikhil"
      },
      {
        "regionId": 865,
        "regionCode": null,
        "regionName": "Jibuti"
      },
      {
        "regionId": 866,
        "regionCode": null,
        "regionName": "Tajurah"
      },
      {
        "regionId": 867,
        "regionCode": null,
        "regionName": "Ubuk"
      }
    ]
  },
  {
    "countryId": 59,
    "countryCode": "DM",
    "countryName": "Dominica",
    "regions": [
      {
        "regionId": 891,
        "regionCode": null,
        "regionName": "Saint Andrew"
      },
      {
        "regionId": 892,
        "regionCode": null,
        "regionName": "Saint David"
      },
      {
        "regionId": 893,
        "regionCode": null,
        "regionName": "Saint George"
      },
      {
        "regionId": 894,
        "regionCode": null,
        "regionName": "Saint John"
      },
      {
        "regionId": 895,
        "regionCode": null,
        "regionName": "Saint Joseph"
      },
      {
        "regionId": 896,
        "regionCode": null,
        "regionName": "Saint Luke"
      },
      {
        "regionId": 897,
        "regionCode": null,
        "regionName": "Saint Mark"
      },
      {
        "regionId": 898,
        "regionCode": null,
        "regionName": "Saint Patrick"
      },
      {
        "regionId": 899,
        "regionCode": null,
        "regionName": "Saint Paul"
      },
      {
        "regionId": 900,
        "regionCode": null,
        "regionName": "Saint Peter"
      }
    ]
  },
  {
    "countryId": 60,
    "countryCode": "DO",
    "countryName": "Dominican Republic",
    "regions": [
      {
        "regionId": 4003,
        "regionCode": "06",
        "regionName": "Duarte"
      },
      {
        "regionId": 4004,
        "regionCode": "14",
        "regionName": "María Trinidad Sánchez"
      },
      {
        "regionId": 4005,
        "regionCode": "19",
        "regionName": "Hermanas Mirabal"
      },
      {
        "regionId": 4006,
        "regionCode": "20",
        "regionName": "Samaná"
      },
      {
        "regionId": 4007,
        "regionCode": "05",
        "regionName": "Dajabón"
      },
      {
        "regionId": 4008,
        "regionCode": "15",
        "regionName": "Monte Cristi"
      },
      {
        "regionId": 4009,
        "regionCode": "12",
        "regionName": "La Romana"
      },
      {
        "regionId": 4010,
        "regionCode": "02",
        "regionName": "Azua"
      },
      {
        "regionId": 4011,
        "regionCode": "17",
        "regionName": "Peravia"
      },
      {
        "regionId": 4012,
        "regionCode": "21",
        "regionName": "San Cristóbal"
      },
      {
        "regionId": 4013,
        "regionCode": "31",
        "regionName": "San José de Ocoa"
      },
      {
        "regionId": 4014,
        "regionCode": "08",
        "regionName": "El Seibo"
      },
      {
        "regionId": 4015,
        "regionCode": "11",
        "regionName": "La Altagracia"
      },
      {
        "regionId": 4016,
        "regionCode": "10",
        "regionName": "Independencia"
      },
      {
        "regionId": 4017,
        "regionCode": "16",
        "regionName": "Pedernales"
      },
      {
        "regionId": 4018,
        "regionCode": "23",
        "regionName": "San Pedro de Macorís"
      },
      {
        "regionId": 4019,
        "regionCode": "29",
        "regionName": "Monte Plata"
      },
      {
        "regionId": 4020,
        "regionCode": "30",
        "regionName": "Hato Mayor"
      },
      {
        "regionId": 4021,
        "regionCode": "32",
        "regionName": "Santo Domingo"
      },
      {
        "regionId": 4022,
        "regionCode": "24",
        "regionName": "Sánchez Ramírez"
      },
      {
        "regionId": 4023,
        "regionCode": "28",
        "regionName": "Monseñor Nouel"
      },
      {
        "regionId": 4024,
        "regionCode": "07",
        "regionName": "Elías Piña"
      },
      {
        "regionId": 4025,
        "regionCode": "22",
        "regionName": "San Juan"
      },
      {
        "regionId": 4026,
        "regionCode": "03",
        "regionName": "Baoruco"
      },
      {
        "regionId": 4027,
        "regionCode": "04",
        "regionName": "Barahona"
      },
      {
        "regionId": 4028,
        "regionCode": "26",
        "regionName": "Santiago Rodríguez"
      },
      {
        "regionId": 4029,
        "regionCode": "27",
        "regionName": "Valverde"
      },
      {
        "regionId": 4030,
        "regionCode": "09",
        "regionName": "Espaillat"
      },
      {
        "regionId": 4031,
        "regionCode": "18",
        "regionName": "Puerto Plata"
      },
      {
        "regionId": 4032,
        "regionCode": "25",
        "regionName": "Santiago"
      },
      {
        "regionId": 4033,
        "regionCode": "13",
        "regionName": "La Vega"
      }
    ]
  },
  {
    "countryId": 61,
    "countryCode": "EC",
    "countryName": "Ecuador",
    "regions": [
      {
        "regionId": 985,
        "regionCode": null,
        "regionName": "Azuay"
      },
      {
        "regionId": 986,
        "regionCode": null,
        "regionName": "Bolivar"
      },
      {
        "regionId": 987,
        "regionCode": null,
        "regionName": "Canar"
      },
      {
        "regionId": 988,
        "regionCode": null,
        "regionName": "Carchi"
      },
      {
        "regionId": 989,
        "regionCode": null,
        "regionName": "Chimborazo"
      },
      {
        "regionId": 990,
        "regionCode": null,
        "regionName": "Cotopaxi"
      },
      {
        "regionId": 991,
        "regionCode": null,
        "regionName": "El Oro"
      },
      {
        "regionId": 992,
        "regionCode": null,
        "regionName": "Esmeraldas"
      },
      {
        "regionId": 993,
        "regionCode": null,
        "regionName": "Galapagos"
      },
      {
        "regionId": 994,
        "regionCode": null,
        "regionName": "Guayas"
      },
      {
        "regionId": 995,
        "regionCode": null,
        "regionName": "Imbabura"
      },
      {
        "regionId": 996,
        "regionCode": null,
        "regionName": "Loja"
      },
      {
        "regionId": 997,
        "regionCode": null,
        "regionName": "Los Rios"
      },
      {
        "regionId": 998,
        "regionCode": null,
        "regionName": "Manabi"
      },
      {
        "regionId": 999,
        "regionCode": null,
        "regionName": "Morona Santiago"
      },
      {
        "regionId": 1000,
        "regionCode": null,
        "regionName": "Napo"
      },
      {
        "regionId": 1001,
        "regionCode": null,
        "regionName": "Orellana"
      },
      {
        "regionId": 1002,
        "regionCode": null,
        "regionName": "Pastaza"
      },
      {
        "regionId": 1003,
        "regionCode": null,
        "regionName": "Pichincha"
      },
      {
        "regionId": 1004,
        "regionCode": null,
        "regionName": "Sucumbios"
      },
      {
        "regionId": 1005,
        "regionCode": null,
        "regionName": "Tungurahua"
      },
      {
        "regionId": 1006,
        "regionCode": null,
        "regionName": "Zamora Chinchipe"
      }
    ]
  },
  {
    "countryId": 62,
    "countryCode": "EG",
    "countryName": "Egypt",
    "regions": [
      {
        "regionId": 1022,
        "regionCode": null,
        "regionName": "ad-Daqahliyah"
      },
      {
        "regionId": 1023,
        "regionCode": null,
        "regionName": "al-Bahr-al-Ahmar"
      },
      {
        "regionId": 1024,
        "regionCode": null,
        "regionName": "al-Buhayrah"
      },
      {
        "regionId": 1025,
        "regionCode": null,
        "regionName": "al-Fayyum"
      },
      {
        "regionId": 1026,
        "regionCode": null,
        "regionName": "al-Gharbiyah"
      },
      {
        "regionId": 1027,
        "regionCode": null,
        "regionName": "al-Iskandariyah"
      },
      {
        "regionId": 1028,
        "regionCode": null,
        "regionName": "al-Ismailiyah"
      },
      {
        "regionId": 1029,
        "regionCode": null,
        "regionName": "al-Jizah"
      },
      {
        "regionId": 1030,
        "regionCode": null,
        "regionName": "al-Minufiyah"
      },
      {
        "regionId": 1031,
        "regionCode": null,
        "regionName": "al-Minya"
      },
      {
        "regionId": 1032,
        "regionCode": null,
        "regionName": "al-Qahira"
      },
      {
        "regionId": 1033,
        "regionCode": null,
        "regionName": "al-Qalyubiyah"
      },
      {
        "regionId": 1034,
        "regionCode": null,
        "regionName": "al-Uqsur"
      },
      {
        "regionId": 1035,
        "regionCode": null,
        "regionName": "al-Wadi al-Jadid"
      },
      {
        "regionId": 1036,
        "regionCode": null,
        "regionName": "ash-Sharqiyah"
      },
      {
        "regionId": 1037,
        "regionCode": null,
        "regionName": "as-Suways"
      },
      {
        "regionId": 1038,
        "regionCode": null,
        "regionName": "Aswan"
      },
      {
        "regionId": 1039,
        "regionCode": null,
        "regionName": "Asyut"
      },
      {
        "regionId": 1040,
        "regionCode": null,
        "regionName": "Bani Suwayf"
      },
      {
        "regionId": 1041,
        "regionCode": null,
        "regionName": "Bur Sa'id"
      },
      {
        "regionId": 1042,
        "regionCode": null,
        "regionName": "Cairo"
      },
      {
        "regionId": 1043,
        "regionCode": null,
        "regionName": "Dumyat"
      },
      {
        "regionId": 1044,
        "regionCode": null,
        "regionName": "Kafr-ash-Shaykh"
      },
      {
        "regionId": 1045,
        "regionCode": null,
        "regionName": "Matruh"
      },
      {
        "regionId": 1046,
        "regionCode": null,
        "regionName": "Muhafazat ad Daqahliyah"
      },
      {
        "regionId": 1047,
        "regionCode": null,
        "regionName": "Muhafazat al Fayyum"
      },
      {
        "regionId": 1048,
        "regionCode": null,
        "regionName": "Muhafazat al Gharbiyah"
      },
      {
        "regionId": 1049,
        "regionCode": null,
        "regionName": "Muhafazat al Iskandariyah"
      },
      {
        "regionId": 1050,
        "regionCode": null,
        "regionName": "Muhafazat al Qahirah"
      },
      {
        "regionId": 1051,
        "regionCode": null,
        "regionName": "Qina"
      },
      {
        "regionId": 1052,
        "regionCode": null,
        "regionName": "Sawhaj"
      },
      {
        "regionId": 1053,
        "regionCode": null,
        "regionName": "Sina al-Janubiyah"
      },
      {
        "regionId": 1054,
        "regionCode": null,
        "regionName": "Sina ash-Shamaliyah"
      }
    ]
  },
  {
    "countryId": 63,
    "countryCode": "SV",
    "countryName": "El Salvador",
    "regions": [
      {
        "regionId": 3431,
        "regionCode": "AH",
        "regionName": "Ahuachapan"
      },
      {
        "regionId": 3432,
        "regionCode": "CA",
        "regionName": "Cabanas"
      },
      {
        "regionId": 3433,
        "regionCode": "CH",
        "regionName": "Chalatenango"
      },
      {
        "regionId": 3434,
        "regionCode": "CU",
        "regionName": "Cuscatlan"
      },
      {
        "regionId": 3435,
        "regionCode": "LI",
        "regionName": "La Libertad"
      },
      {
        "regionId": 3436,
        "regionCode": "PA",
        "regionName": "La Paz"
      },
      {
        "regionId": 3437,
        "regionCode": "UN",
        "regionName": "La Union"
      },
      {
        "regionId": 3438,
        "regionCode": "MO",
        "regionName": "Morazan"
      },
      {
        "regionId": 3439,
        "regionCode": "SM",
        "regionName": "San Miguel"
      },
      {
        "regionId": 3440,
        "regionCode": "SS",
        "regionName": "San Salvador"
      },
      {
        "regionId": 3441,
        "regionCode": "SV",
        "regionName": "San Vicente"
      },
      {
        "regionId": 3442,
        "regionCode": "SA",
        "regionName": "Santa Ana"
      },
      {
        "regionId": 3443,
        "regionCode": "SO",
        "regionName": "Sonsonate"
      },
      {
        "regionId": 3444,
        "regionCode": "US",
        "regionName": "Usulutan"
      }
    ]
  },
  {
    "countryId": 64,
    "countryCode": "GQ",
    "countryName": "Equatorial Guinea",
    "regions": [
      {
        "regionId": 1541,
        "regionCode": null,
        "regionName": "Annobon"
      },
      {
        "regionId": 1542,
        "regionCode": null,
        "regionName": "Bioko Norte"
      },
      {
        "regionId": 1543,
        "regionCode": null,
        "regionName": "Bioko Sur"
      },
      {
        "regionId": 1544,
        "regionCode": null,
        "regionName": "Centro Sur"
      },
      {
        "regionId": 1545,
        "regionCode": null,
        "regionName": "Kie-Ntem"
      },
      {
        "regionId": 1546,
        "regionCode": null,
        "regionName": "Litoral"
      },
      {
        "regionId": 1547,
        "regionCode": null,
        "regionName": "Wele-Nzas"
      }
    ]
  },
  {
    "countryId": 65,
    "countryCode": "ER",
    "countryName": "Eritrea",
    "regions": [
      {
        "regionId": 1059,
        "regionCode": null,
        "regionName": "Anseba"
      },
      {
        "regionId": 1060,
        "regionCode": null,
        "regionName": "Debub"
      },
      {
        "regionId": 1061,
        "regionCode": null,
        "regionName": "Debub-Keih-Bahri"
      },
      {
        "regionId": 1062,
        "regionCode": null,
        "regionName": "Gash-Barka"
      },
      {
        "regionId": 1063,
        "regionCode": null,
        "regionName": "Maekel"
      },
      {
        "regionId": 1064,
        "regionCode": null,
        "regionName": "Semien-Keih-Bahri"
      }
    ]
  },
  {
    "countryId": 66,
    "countryCode": "EE",
    "countryName": "Estonia",
    "regions": [
      {
        "regionId": 1007,
        "regionCode": null,
        "regionName": "Harju"
      },
      {
        "regionId": 1008,
        "regionCode": null,
        "regionName": "Hiiu"
      },
      {
        "regionId": 1009,
        "regionCode": null,
        "regionName": "Ida-Viru"
      },
      {
        "regionId": 1010,
        "regionCode": null,
        "regionName": "Jarva"
      },
      {
        "regionId": 1011,
        "regionCode": null,
        "regionName": "Jogeva"
      },
      {
        "regionId": 1012,
        "regionCode": null,
        "regionName": "Laane"
      },
      {
        "regionId": 1013,
        "regionCode": null,
        "regionName": "Laane-Viru"
      },
      {
        "regionId": 1014,
        "regionCode": null,
        "regionName": "Parnu"
      },
      {
        "regionId": 1015,
        "regionCode": null,
        "regionName": "Polva"
      },
      {
        "regionId": 1016,
        "regionCode": null,
        "regionName": "Rapla"
      },
      {
        "regionId": 1017,
        "regionCode": null,
        "regionName": "Saare"
      },
      {
        "regionId": 1018,
        "regionCode": null,
        "regionName": "Tartu"
      },
      {
        "regionId": 1019,
        "regionCode": null,
        "regionName": "Valga"
      },
      {
        "regionId": 1020,
        "regionCode": null,
        "regionName": "Viljandi"
      },
      {
        "regionId": 1021,
        "regionCode": null,
        "regionName": "Voru"
      }
    ]
  },
  {
    "countryId": 67,
    "countryCode": "ET",
    "countryName": "Ethiopia",
    "regions": [
      {
        "regionId": 1131,
        "regionCode": null,
        "regionName": "Addis Abeba"
      },
      {
        "regionId": 1132,
        "regionCode": null,
        "regionName": "Afar"
      },
      {
        "regionId": 1133,
        "regionCode": null,
        "regionName": "Amhara"
      },
      {
        "regionId": 1134,
        "regionCode": null,
        "regionName": "Benishangul"
      },
      {
        "regionId": 1135,
        "regionCode": null,
        "regionName": "Diredawa"
      },
      {
        "regionId": 1136,
        "regionCode": null,
        "regionName": "Gambella"
      },
      {
        "regionId": 1137,
        "regionCode": null,
        "regionName": "Harar"
      },
      {
        "regionId": 1138,
        "regionCode": null,
        "regionName": "Jigjiga"
      },
      {
        "regionId": 1139,
        "regionCode": null,
        "regionName": "Mekele"
      },
      {
        "regionId": 1140,
        "regionCode": null,
        "regionName": "Oromia"
      },
      {
        "regionId": 1141,
        "regionCode": null,
        "regionName": "Somali"
      },
      {
        "regionId": 1142,
        "regionCode": null,
        "regionName": "Southern"
      },
      {
        "regionId": 1143,
        "regionCode": null,
        "regionName": "Tigray"
      }
    ]
  },
  {
    "countryId": 68,
    "countryCode": "FK",
    "countryName": "Falkland Islands (Islas Malvinas)",
    "regions": [
      {
        "regionId": 1179,
        "regionCode": null,
        "regionName": "Falkland Islands"
      },
      {
        "regionId": 1180,
        "regionCode": null,
        "regionName": "South Georgia"
      }
    ]
  },
  {
    "countryId": 69,
    "countryCode": "FO",
    "countryName": "Faroe Islands",
    "regions": [
      {
        "regionId": 1185,
        "regionCode": null,
        "regionName": "Klaksvik"
      },
      {
        "regionId": 1186,
        "regionCode": null,
        "regionName": "Nor ara Eysturoy"
      },
      {
        "regionId": 1187,
        "regionCode": null,
        "regionName": "Nor oy"
      },
      {
        "regionId": 1188,
        "regionCode": null,
        "regionName": "Sandoy"
      },
      {
        "regionId": 1189,
        "regionCode": null,
        "regionName": "Streymoy"
      },
      {
        "regionId": 1190,
        "regionCode": null,
        "regionName": "Su uroy"
      },
      {
        "regionId": 1191,
        "regionCode": null,
        "regionName": "Sy ra Eysturoy"
      },
      {
        "regionId": 1192,
        "regionCode": null,
        "regionName": "Torshavn"
      },
      {
        "regionId": 1193,
        "regionCode": null,
        "regionName": "Vaga"
      }
    ]
  },
  {
    "countryId": 70,
    "countryCode": "FJ",
    "countryName": "Fiji",
    "regions": [
      {
        "regionId": 1174,
        "regionCode": null,
        "regionName": "Central"
      },
      {
        "regionId": 1175,
        "regionCode": null,
        "regionName": "Eastern"
      },
      {
        "regionId": 1176,
        "regionCode": null,
        "regionName": "Northern"
      },
      {
        "regionId": 1177,
        "regionCode": null,
        "regionName": "South Pacific"
      },
      {
        "regionId": 1178,
        "regionCode": null,
        "regionName": "Western"
      }
    ]
  },
  {
    "countryId": 71,
    "countryCode": "FI",
    "countryName": "Finland",
    "regions": [
      {
        "regionId": 1144,
        "regionCode": "001",
        "regionName": "Ahvenanmaa"
      },
      {
        "regionId": 1145,
        "regionCode": null,
        "regionName": "Etela-Karjala"
      },
      {
        "regionId": 1146,
        "regionCode": null,
        "regionName": "Etela-Pohjanmaa"
      },
      {
        "regionId": 1147,
        "regionCode": null,
        "regionName": "Etela-Savo"
      },
      {
        "regionId": 1148,
        "regionCode": null,
        "regionName": "Etela-Suomen Laani"
      },
      {
        "regionId": 1149,
        "regionCode": null,
        "regionName": "Ita-Suomen Laani"
      },
      {
        "regionId": 1150,
        "regionCode": null,
        "regionName": "Ita-Uusimaa"
      },
      {
        "regionId": 1151,
        "regionCode": null,
        "regionName": "Kainuu"
      },
      {
        "regionId": 1152,
        "regionCode": null,
        "regionName": "Kanta-Hame"
      },
      {
        "regionId": 1153,
        "regionCode": null,
        "regionName": "Keski-Pohjanmaa"
      },
      {
        "regionId": 1154,
        "regionCode": null,
        "regionName": "Keski-Suomi"
      },
      {
        "regionId": 1155,
        "regionCode": null,
        "regionName": "Kymenlaakso"
      },
      {
        "regionId": 1156,
        "regionCode": null,
        "regionName": "Lansi-Suomen Laani"
      },
      {
        "regionId": 1157,
        "regionCode": "004",
        "regionName": "Lappi"
      },
      {
        "regionId": 1158,
        "regionCode": null,
        "regionName": "Northern Savonia"
      },
      {
        "regionId": 1159,
        "regionCode": null,
        "regionName": "Ostrobothnia"
      },
      {
        "regionId": 1160,
        "regionCode": null,
        "regionName": "Oulun Laani"
      },
      {
        "regionId": 1161,
        "regionCode": null,
        "regionName": "Paijat-Hame"
      },
      {
        "regionId": 1162,
        "regionCode": null,
        "regionName": "Pirkanmaa"
      },
      {
        "regionId": 1163,
        "regionCode": null,
        "regionName": "Pohjanmaa"
      },
      {
        "regionId": 1164,
        "regionCode": null,
        "regionName": "Pohjois-Karjala"
      },
      {
        "regionId": 1165,
        "regionCode": null,
        "regionName": "Pohjois-Pohjanmaa"
      },
      {
        "regionId": 1166,
        "regionCode": null,
        "regionName": "Pohjois-Savo"
      },
      {
        "regionId": 1167,
        "regionCode": null,
        "regionName": "Saarijarvi"
      },
      {
        "regionId": 1168,
        "regionCode": null,
        "regionName": "Satakunta"
      },
      {
        "regionId": 1169,
        "regionCode": null,
        "regionName": "Southern Savonia"
      },
      {
        "regionId": 1170,
        "regionCode": null,
        "regionName": "Tavastia Proper"
      },
      {
        "regionId": 1171,
        "regionCode": null,
        "regionName": "Uleaborgs Lan"
      },
      {
        "regionId": 1172,
        "regionCode": null,
        "regionName": "Uusimaa"
      },
      {
        "regionId": 1173,
        "regionCode": null,
        "regionName": "Varsinais-Suomi"
      }
    ]
  },
  {
    "countryId": 72,
    "countryCode": "FR",
    "countryName": "France",
    "regions": [
      {
        "regionId": 1194,
        "regionCode": "01",
        "regionName": "Ain"
      },
      {
        "regionId": 1195,
        "regionCode": "02",
        "regionName": "Aisne"
      },
      {
        "regionId": 1196,
        "regionCode": null,
        "regionName": "Albi Le Sequestre"
      },
      {
        "regionId": 1197,
        "regionCode": "03",
        "regionName": "Allier"
      },
      {
        "regionId": 1198,
        "regionCode": null,
        "regionName": "Alpes-Cote dAzur"
      },
      {
        "regionId": 1199,
        "regionCode": null,
        "regionName": "Alpes-de-Haute-Provence"
      },
      {
        "regionId": 1200,
        "regionCode": "06",
        "regionName": "Alpes-Maritimes"
      },
      {
        "regionId": 1201,
        "regionCode": null,
        "regionName": "Alsace"
      },
      {
        "regionId": 1202,
        "regionCode": null,
        "regionName": "Aquitaine"
      },
      {
        "regionId": 1203,
        "regionCode": null,
        "regionName": "Ardeche"
      },
      {
        "regionId": 1204,
        "regionCode": "08",
        "regionName": "Ardennes"
      },
      {
        "regionId": 1205,
        "regionCode": null,
        "regionName": "Ariege"
      },
      {
        "regionId": 1206,
        "regionCode": "10",
        "regionName": "Aube"
      },
      {
        "regionId": 1207,
        "regionCode": "11",
        "regionName": "Aude"
      },
      {
        "regionId": 1208,
        "regionCode": null,
        "regionName": "Auvergne"
      },
      {
        "regionId": 1209,
        "regionCode": "12",
        "regionName": "Aveyron"
      },
      {
        "regionId": 1210,
        "regionCode": "67",
        "regionName": "Bas-Rhin"
      },
      {
        "regionId": 1211,
        "regionCode": null,
        "regionName": "Basse-Normandie"
      },
      {
        "regionId": 1212,
        "regionCode": null,
        "regionName": "Bouches-du-Rhone"
      },
      {
        "regionId": 1213,
        "regionCode": null,
        "regionName": "Bourgogne"
      },
      {
        "regionId": 1214,
        "regionCode": null,
        "regionName": "Bretagne"
      },
      {
        "regionId": 1215,
        "regionCode": null,
        "regionName": "Brittany"
      },
      {
        "regionId": 1216,
        "regionCode": null,
        "regionName": "Burgundy"
      },
      {
        "regionId": 1217,
        "regionCode": "14",
        "regionName": "Calvados"
      },
      {
        "regionId": 1218,
        "regionCode": "15",
        "regionName": "Cantal"
      },
      {
        "regionId": 1219,
        "regionCode": null,
        "regionName": "Cedex"
      },
      {
        "regionId": 1220,
        "regionCode": null,
        "regionName": "Centre"
      },
      {
        "regionId": 1221,
        "regionCode": "16",
        "regionName": "Charente"
      },
      {
        "regionId": 1222,
        "regionCode": "17",
        "regionName": "Charente-Maritime"
      },
      {
        "regionId": 1223,
        "regionCode": "18",
        "regionName": "Cher"
      },
      {
        "regionId": 1224,
        "regionCode": null,
        "regionName": "Correze"
      },
      {
        "regionId": 1225,
        "regionCode": "2A",
        "regionName": "Corse-du-Sud"
      },
      {
        "regionId": 1226,
        "regionCode": null,
        "regionName": "Cote-d'Or"
      },
      {
        "regionId": 1227,
        "regionCode": null,
        "regionName": "Cotes-d'Armor"
      },
      {
        "regionId": 1228,
        "regionCode": "23",
        "regionName": "Creuse"
      },
      {
        "regionId": 1229,
        "regionCode": null,
        "regionName": "Crolles"
      },
      {
        "regionId": 1230,
        "regionCode": null,
        "regionName": "Deux-Sevres"
      },
      {
        "regionId": 1231,
        "regionCode": "24",
        "regionName": "Dordogne"
      },
      {
        "regionId": 1232,
        "regionCode": "25",
        "regionName": "Doubs"
      },
      {
        "regionId": 1233,
        "regionCode": null,
        "regionName": "Drome"
      },
      {
        "regionId": 1234,
        "regionCode": "91",
        "regionName": "Essonne"
      },
      {
        "regionId": 1235,
        "regionCode": "27",
        "regionName": "Eure"
      },
      {
        "regionId": 1236,
        "regionCode": "28",
        "regionName": "Eure-et-Loir"
      },
      {
        "regionId": 1237,
        "regionCode": null,
        "regionName": "Feucherolles"
      },
      {
        "regionId": 1238,
        "regionCode": null,
        "regionName": "Finistere"
      },
      {
        "regionId": 1239,
        "regionCode": null,
        "regionName": "Franche-Comte"
      },
      {
        "regionId": 1240,
        "regionCode": "30",
        "regionName": "Gard"
      },
      {
        "regionId": 1241,
        "regionCode": "32",
        "regionName": "Gers"
      },
      {
        "regionId": 1242,
        "regionCode": "33",
        "regionName": "Gironde"
      },
      {
        "regionId": 1243,
        "regionCode": null,
        "regionName": "Haute-Corse"
      },
      {
        "regionId": 1244,
        "regionCode": null,
        "regionName": "Haute-Garonne"
      },
      {
        "regionId": 1245,
        "regionCode": null,
        "regionName": "Haute-Loire"
      },
      {
        "regionId": 1246,
        "regionCode": null,
        "regionName": "Haute-Marne"
      },
      {
        "regionId": 1247,
        "regionCode": null,
        "regionName": "Hautes-Alpes"
      },
      {
        "regionId": 1248,
        "regionCode": null,
        "regionName": "Haute-Saone"
      },
      {
        "regionId": 1249,
        "regionCode": null,
        "regionName": "Haute-Savoie"
      },
      {
        "regionId": 1250,
        "regionCode": null,
        "regionName": "Hautes-Pyrenees"
      },
      {
        "regionId": 1251,
        "regionCode": null,
        "regionName": "Haute-Vienne"
      },
      {
        "regionId": 1252,
        "regionCode": "68",
        "regionName": "Haut-Rhin"
      },
      {
        "regionId": 1253,
        "regionCode": "92",
        "regionName": "Hauts-de-Seine"
      },
      {
        "regionId": 1254,
        "regionCode": null,
        "regionName": "Herault"
      },
      {
        "regionId": 1255,
        "regionCode": null,
        "regionName": "Ile-de-France"
      },
      {
        "regionId": 1256,
        "regionCode": "35",
        "regionName": "Ille-et-Vilaine"
      },
      {
        "regionId": 1257,
        "regionCode": "36",
        "regionName": "Indre"
      },
      {
        "regionId": 1258,
        "regionCode": "37",
        "regionName": "Indre-et-Loire"
      },
      {
        "regionId": 1259,
        "regionCode": null,
        "regionName": "Isere"
      },
      {
        "regionId": 1260,
        "regionCode": "39",
        "regionName": "Jura"
      },
      {
        "regionId": 1261,
        "regionCode": null,
        "regionName": "Klagenfurt"
      },
      {
        "regionId": 1262,
        "regionCode": "40",
        "regionName": "Landes"
      },
      {
        "regionId": 1263,
        "regionCode": null,
        "regionName": "Languedoc-Roussillon"
      },
      {
        "regionId": 1264,
        "regionCode": null,
        "regionName": "Larcay"
      },
      {
        "regionId": 1265,
        "regionCode": null,
        "regionName": "Le Castellet"
      },
      {
        "regionId": 1266,
        "regionCode": null,
        "regionName": "Le Creusot"
      },
      {
        "regionId": 1267,
        "regionCode": null,
        "regionName": "Limousin"
      },
      {
        "regionId": 1268,
        "regionCode": "42",
        "regionName": "Loire"
      },
      {
        "regionId": 1269,
        "regionCode": "44",
        "regionName": "Loire-Atlantique"
      },
      {
        "regionId": 1270,
        "regionCode": "45",
        "regionName": "Loiret"
      },
      {
        "regionId": 1271,
        "regionCode": "41",
        "regionName": "Loir-et-Cher"
      },
      {
        "regionId": 1272,
        "regionCode": null,
        "regionName": "Lorraine"
      },
      {
        "regionId": 1273,
        "regionCode": "46",
        "regionName": "Lot"
      },
      {
        "regionId": 1274,
        "regionCode": "47",
        "regionName": "Lot-et-Garonne"
      },
      {
        "regionId": 1275,
        "regionCode": null,
        "regionName": "Lower Normandy"
      },
      {
        "regionId": 1276,
        "regionCode": null,
        "regionName": "Lozere"
      },
      {
        "regionId": 1277,
        "regionCode": "49",
        "regionName": "Maine-et-Loire"
      },
      {
        "regionId": 1278,
        "regionCode": "50",
        "regionName": "Manche"
      },
      {
        "regionId": 1279,
        "regionCode": "51",
        "regionName": "Marne"
      },
      {
        "regionId": 1280,
        "regionCode": "53",
        "regionName": "Mayenne"
      },
      {
        "regionId": 1281,
        "regionCode": "54",
        "regionName": "Meurthe-et-Moselle"
      },
      {
        "regionId": 1282,
        "regionCode": "55",
        "regionName": "Meuse"
      },
      {
        "regionId": 1283,
        "regionCode": null,
        "regionName": "Midi-Pyrenees"
      },
      {
        "regionId": 1284,
        "regionCode": "56",
        "regionName": "Morbihan"
      },
      {
        "regionId": 1285,
        "regionCode": "57",
        "regionName": "Moselle"
      },
      {
        "regionId": 1286,
        "regionCode": null,
        "regionName": "Nievre"
      },
      {
        "regionId": 1287,
        "regionCode": "59",
        "regionName": "Nord"
      },
      {
        "regionId": 1288,
        "regionCode": null,
        "regionName": "Nord-Pas-de-Calais"
      },
      {
        "regionId": 1289,
        "regionCode": "60",
        "regionName": "Oise"
      },
      {
        "regionId": 1290,
        "regionCode": "61",
        "regionName": "Orne"
      },
      {
        "regionId": 1291,
        "regionCode": "75",
        "regionName": "Paris"
      },
      {
        "regionId": 1292,
        "regionCode": "62",
        "regionName": "Pas-de-Calais"
      },
      {
        "regionId": 1293,
        "regionCode": null,
        "regionName": "Pays de la Loire"
      },
      {
        "regionId": 1294,
        "regionCode": null,
        "regionName": "Pays-de-la-Loire"
      },
      {
        "regionId": 1295,
        "regionCode": null,
        "regionName": "Picardy"
      },
      {
        "regionId": 1296,
        "regionCode": null,
        "regionName": "Puy-de-Dome"
      },
      {
        "regionId": 1297,
        "regionCode": null,
        "regionName": "Pyrenees-Atlantiques"
      },
      {
        "regionId": 1298,
        "regionCode": null,
        "regionName": "Pyrenees-Orientales"
      },
      {
        "regionId": 1299,
        "regionCode": null,
        "regionName": "Quelmes"
      },
      {
        "regionId": 1300,
        "regionCode": null,
        "regionName": "Rhone"
      },
      {
        "regionId": 1301,
        "regionCode": null,
        "regionName": "Rhone-Alpes"
      },
      {
        "regionId": 1302,
        "regionCode": null,
        "regionName": "Saint Ouen"
      },
      {
        "regionId": 1303,
        "regionCode": null,
        "regionName": "Saint Viatre"
      },
      {
        "regionId": 1304,
        "regionCode": null,
        "regionName": "Saone-et-Loire"
      },
      {
        "regionId": 1305,
        "regionCode": "72",
        "regionName": "Sarthe"
      },
      {
        "regionId": 1306,
        "regionCode": "73",
        "regionName": "Savoie"
      },
      {
        "regionId": 1307,
        "regionCode": "77",
        "regionName": "Seine-et-Marne"
      },
      {
        "regionId": 1308,
        "regionCode": "76",
        "regionName": "Seine-Maritime"
      },
      {
        "regionId": 1309,
        "regionCode": "93",
        "regionName": "Seine-Saint-Denis"
      },
      {
        "regionId": 1310,
        "regionCode": "80",
        "regionName": "Somme"
      },
      {
        "regionId": 1311,
        "regionCode": null,
        "regionName": "Sophia Antipolis"
      },
      {
        "regionId": 1312,
        "regionCode": null,
        "regionName": "Souvans"
      },
      {
        "regionId": 1313,
        "regionCode": "81",
        "regionName": "Tarn"
      },
      {
        "regionId": 1314,
        "regionCode": "82",
        "regionName": "Tarn-et-Garonne"
      },
      {
        "regionId": 1315,
        "regionCode": null,
        "regionName": "Territoire de Belfort"
      },
      {
        "regionId": 1316,
        "regionCode": null,
        "regionName": "Treignac"
      },
      {
        "regionId": 1317,
        "regionCode": null,
        "regionName": "Upper Normandy"
      },
      {
        "regionId": 1318,
        "regionCode": "94",
        "regionName": "Val-de-Marne"
      },
      {
        "regionId": 1319,
        "regionCode": "95",
        "regionName": "Val-d'Oise"
      },
      {
        "regionId": 1320,
        "regionCode": "83",
        "regionName": "Var"
      },
      {
        "regionId": 1321,
        "regionCode": "84",
        "regionName": "Vaucluse"
      },
      {
        "regionId": 1322,
        "regionCode": null,
        "regionName": "Vellise"
      },
      {
        "regionId": 1323,
        "regionCode": null,
        "regionName": "Vendee"
      },
      {
        "regionId": 1324,
        "regionCode": "86",
        "regionName": "Vienne"
      },
      {
        "regionId": 1325,
        "regionCode": "88",
        "regionName": "Vosges"
      },
      {
        "regionId": 1326,
        "regionCode": "89",
        "regionName": "Yonne"
      },
      {
        "regionId": 1327,
        "regionCode": "78",
        "regionName": "Yvelines"
      }
    ]
  },
  {
    "countryId": 73,
    "countryCode": "GF",
    "countryName": "French Guiana",
    "regions": [
      {
        "regionId": 1469,
        "regionCode": null,
        "regionName": "Cayenne"
      },
      {
        "regionId": 1470,
        "regionCode": null,
        "regionName": "Saint-Laurent-du-Maroni"
      }
    ]
  },
  {
    "countryId": 74,
    "countryCode": "PF",
    "countryName": "French Polynesia",
    "regions": [
      {
        "regionId": 2930,
        "regionCode": null,
        "regionName": "Iles du Vent"
      },
      {
        "regionId": 2931,
        "regionCode": null,
        "regionName": "Iles sous le Vent"
      },
      {
        "regionId": 2932,
        "regionCode": null,
        "regionName": "Marquesas"
      },
      {
        "regionId": 2933,
        "regionCode": null,
        "regionName": "Tuamotu"
      },
      {
        "regionId": 2934,
        "regionCode": null,
        "regionName": "Tubuai"
      }
    ]
  },
  {
    "countryId": 75,
    "countryCode": "GA",
    "countryName": "Gabon",
    "regions": [
      {
        "regionId": 1328,
        "regionCode": null,
        "regionName": "Estuaire"
      },
      {
        "regionId": 1329,
        "regionCode": null,
        "regionName": "Haut-Ogooue"
      },
      {
        "regionId": 1330,
        "regionCode": null,
        "regionName": "Moyen-Ogooue"
      },
      {
        "regionId": 1331,
        "regionCode": null,
        "regionName": "Ngounie"
      },
      {
        "regionId": 1332,
        "regionCode": null,
        "regionName": "Nyanga"
      },
      {
        "regionId": 1333,
        "regionCode": null,
        "regionName": "Ogooue-Ivindo"
      },
      {
        "regionId": 1334,
        "regionCode": null,
        "regionName": "Ogooue-Lolo"
      },
      {
        "regionId": 1335,
        "regionCode": null,
        "regionName": "Ogooue-Maritime"
      },
      {
        "regionId": 1336,
        "regionCode": null,
        "regionName": "Woleu-Ntem"
      }
    ]
  },
  {
    "countryId": 76,
    "countryCode": "GM",
    "countryName": "Gambia",
    "regions": [
      {
        "regionId": 1501,
        "regionCode": null,
        "regionName": "Banjul"
      },
      {
        "regionId": 1502,
        "regionCode": null,
        "regionName": "Basse"
      },
      {
        "regionId": 1503,
        "regionCode": null,
        "regionName": "Brikama"
      },
      {
        "regionId": 1504,
        "regionCode": null,
        "regionName": "Janjanbureh"
      },
      {
        "regionId": 1505,
        "regionCode": null,
        "regionName": "Kanifing"
      },
      {
        "regionId": 1506,
        "regionCode": null,
        "regionName": "Kerewan"
      },
      {
        "regionId": 1507,
        "regionCode": null,
        "regionName": "Kuntaur"
      },
      {
        "regionId": 1508,
        "regionCode": null,
        "regionName": "Mansakonko"
      }
    ]
  },
  {
    "countryId": 77,
    "countryCode": "GE",
    "countryName": "Georgia",
    "regions": [
      {
        "regionId": 1457,
        "regionCode": null,
        "regionName": "Abhasia"
      },
      {
        "regionId": 1458,
        "regionCode": null,
        "regionName": "Ajaria"
      },
      {
        "regionId": 1459,
        "regionCode": null,
        "regionName": "Guria"
      },
      {
        "regionId": 1460,
        "regionCode": null,
        "regionName": "Imereti"
      },
      {
        "regionId": 1461,
        "regionCode": null,
        "regionName": "Kaheti"
      },
      {
        "regionId": 1462,
        "regionCode": null,
        "regionName": "Kvemo Kartli"
      },
      {
        "regionId": 1463,
        "regionCode": null,
        "regionName": "Mcheta-Mtianeti"
      },
      {
        "regionId": 1464,
        "regionCode": null,
        "regionName": "Racha"
      },
      {
        "regionId": 1465,
        "regionCode": null,
        "regionName": "Samagrelo-Zemo Svaneti"
      },
      {
        "regionId": 1466,
        "regionCode": null,
        "regionName": "Samche-Zhavaheti"
      },
      {
        "regionId": 1467,
        "regionCode": null,
        "regionName": "Shida Kartli"
      },
      {
        "regionId": 1468,
        "regionCode": null,
        "regionName": "Tbilisi"
      }
    ]
  },
  {
    "countryId": 78,
    "countryCode": "DE",
    "countryName": "Germany",
    "regions": [
      {
        "regionId": 816,
        "regionCode": null,
        "regionName": "Auvergne"
      },
      {
        "regionId": 817,
        "regionCode": "08",
        "regionName": "Baden-Wurttemberg"
      },
      {
        "regionId": 818,
        "regionCode": "09",
        "regionName": "Bavaria"
      },
      {
        "regionId": 819,
        "regionCode": null,
        "regionName": "Bayern"
      },
      {
        "regionId": 820,
        "regionCode": null,
        "regionName": "Beilstein Wurtt"
      },
      {
        "regionId": 821,
        "regionCode": "11",
        "regionName": "Berlin"
      },
      {
        "regionId": 822,
        "regionCode": "12",
        "regionName": "Brandenburg"
      },
      {
        "regionId": 823,
        "regionCode": "04",
        "regionName": "Bremen"
      },
      {
        "regionId": 824,
        "regionCode": null,
        "regionName": "Dreisbach"
      },
      {
        "regionId": 825,
        "regionCode": null,
        "regionName": "Freistaat Bayern"
      },
      {
        "regionId": 826,
        "regionCode": "02",
        "regionName": "Hamburg"
      },
      {
        "regionId": 827,
        "regionCode": null,
        "regionName": "Hannover"
      },
      {
        "regionId": 828,
        "regionCode": null,
        "regionName": "Heroldstatt"
      },
      {
        "regionId": 829,
        "regionCode": null,
        "regionName": "Hessen"
      },
      {
        "regionId": 830,
        "regionCode": null,
        "regionName": "Kortenberg"
      },
      {
        "regionId": 831,
        "regionCode": null,
        "regionName": "Laasdorf"
      },
      {
        "regionId": 832,
        "regionCode": null,
        "regionName": "Land Baden-Wurttemberg"
      },
      {
        "regionId": 833,
        "regionCode": null,
        "regionName": "Land Bayern"
      },
      {
        "regionId": 834,
        "regionCode": null,
        "regionName": "Land Brandenburg"
      },
      {
        "regionId": 835,
        "regionCode": null,
        "regionName": "Land Hessen"
      },
      {
        "regionId": 836,
        "regionCode": null,
        "regionName": "Land Mecklenburg-Vorpommern"
      },
      {
        "regionId": 837,
        "regionCode": null,
        "regionName": "Land Nordrhein-Westfalen"
      },
      {
        "regionId": 838,
        "regionCode": null,
        "regionName": "Land Rheinland-Pfalz"
      },
      {
        "regionId": 839,
        "regionCode": null,
        "regionName": "Land Sachsen"
      },
      {
        "regionId": 840,
        "regionCode": null,
        "regionName": "Land Sachsen-Anhalt"
      },
      {
        "regionId": 841,
        "regionCode": null,
        "regionName": "Land Thuringen"
      },
      {
        "regionId": 842,
        "regionCode": "03",
        "regionName": "Lower Saxony"
      },
      {
        "regionId": 843,
        "regionCode": null,
        "regionName": "Mecklenburg-Vorpommern"
      },
      {
        "regionId": 844,
        "regionCode": null,
        "regionName": "Mulfingen"
      },
      {
        "regionId": 845,
        "regionCode": null,
        "regionName": "Munich"
      },
      {
        "regionId": 846,
        "regionCode": null,
        "regionName": "Neubeuern"
      },
      {
        "regionId": 847,
        "regionCode": null,
        "regionName": "Niedersachsen"
      },
      {
        "regionId": 848,
        "regionCode": null,
        "regionName": "Noord-Holland"
      },
      {
        "regionId": 849,
        "regionCode": null,
        "regionName": "Nordrhein-Westfalen"
      },
      {
        "regionId": 850,
        "regionCode": null,
        "regionName": "North Rhine-Westphalia"
      },
      {
        "regionId": 851,
        "regionCode": null,
        "regionName": "Osterode"
      },
      {
        "regionId": 852,
        "regionCode": null,
        "regionName": "Rheinland-Pfalz"
      },
      {
        "regionId": 853,
        "regionCode": null,
        "regionName": "Rhineland-Palatinate"
      },
      {
        "regionId": 854,
        "regionCode": "10",
        "regionName": "Saarland"
      },
      {
        "regionId": 855,
        "regionCode": null,
        "regionName": "Sachsen"
      },
      {
        "regionId": 856,
        "regionCode": null,
        "regionName": "Sachsen-Anhalt"
      },
      {
        "regionId": 857,
        "regionCode": "14",
        "regionName": "Saxony"
      },
      {
        "regionId": 858,
        "regionCode": "01",
        "regionName": "Schleswig-Holstein"
      },
      {
        "regionId": 859,
        "regionCode": null,
        "regionName": "schlobborn"
      },
      {
        "regionId": 860,
        "regionCode": "16",
        "regionName": "Thuringia"
      },
      {
        "regionId": 861,
        "regionCode": null,
        "regionName": "Webling"
      },
      {
        "regionId": 862,
        "regionCode": null,
        "regionName": "Weinstrabe"
      }
    ]
  },
  {
    "countryId": 79,
    "countryCode": "GH",
    "countryName": "Ghana",
    "regions": [
      {
        "regionId": 1471,
        "regionCode": null,
        "regionName": "Ashanti"
      },
      {
        "regionId": 1472,
        "regionCode": null,
        "regionName": "Brong-Ahafo"
      },
      {
        "regionId": 1473,
        "regionCode": null,
        "regionName": "Central"
      },
      {
        "regionId": 1474,
        "regionCode": null,
        "regionName": "Eastern"
      },
      {
        "regionId": 1475,
        "regionCode": null,
        "regionName": "Greater Accra"
      },
      {
        "regionId": 1476,
        "regionCode": null,
        "regionName": "Northern"
      },
      {
        "regionId": 1477,
        "regionCode": null,
        "regionName": "Upper East"
      },
      {
        "regionId": 1478,
        "regionCode": null,
        "regionName": "Upper West"
      },
      {
        "regionId": 1479,
        "regionCode": null,
        "regionName": "Volta"
      },
      {
        "regionId": 1480,
        "regionCode": null,
        "regionName": "Western"
      }
    ]
  },
  {
    "countryId": 80,
    "countryCode": "GI",
    "countryName": "Gibraltar",
    "regions": [
      {
        "regionId": 1481,
        "regionCode": null,
        "regionName": "Gibraltar"
      }
    ]
  },
  {
    "countryId": 81,
    "countryCode": "GR",
    "countryName": "Greece",
    "regions": [
      {
        "regionId": 1548,
        "regionCode": null,
        "regionName": "Acharnes"
      },
      {
        "regionId": 1549,
        "regionCode": null,
        "regionName": "Ahaia"
      },
      {
        "regionId": 1550,
        "regionCode": null,
        "regionName": "Aitolia kai Akarnania"
      },
      {
        "regionId": 1551,
        "regionCode": "03",
        "regionName": "Argolis"
      },
      {
        "regionId": 1552,
        "regionCode": null,
        "regionName": "Arkadia"
      },
      {
        "regionId": 1553,
        "regionCode": "05",
        "regionName": "Arta"
      },
      {
        "regionId": 1554,
        "regionCode": null,
        "regionName": "Attica"
      },
      {
        "regionId": 1555,
        "regionCode": "06",
        "regionName": "Attiki"
      },
      {
        "regionId": 1556,
        "regionCode": null,
        "regionName": "Ayion Oros"
      },
      {
        "regionId": 1557,
        "regionCode": null,
        "regionName": "Crete"
      },
      {
        "regionId": 1558,
        "regionCode": null,
        "regionName": "Dodekanisos"
      },
      {
        "regionId": 1559,
        "regionCode": null,
        "regionName": "Drama"
      },
      {
        "regionId": 1560,
        "regionCode": null,
        "regionName": "Evia"
      },
      {
        "regionId": 1561,
        "regionCode": "09",
        "regionName": "Evritania"
      },
      {
        "regionId": 1562,
        "regionCode": "10",
        "regionName": "Evros"
      },
      {
        "regionId": 1563,
        "regionCode": "11",
        "regionName": "Evvoia"
      },
      {
        "regionId": 1564,
        "regionCode": "12",
        "regionName": "Florina"
      },
      {
        "regionId": 1565,
        "regionCode": "13",
        "regionName": "Fokis"
      },
      {
        "regionId": 1566,
        "regionCode": "14",
        "regionName": "Fthiotis"
      },
      {
        "regionId": 1567,
        "regionCode": "15",
        "regionName": "Grevena"
      },
      {
        "regionId": 1568,
        "regionCode": null,
        "regionName": "Halandri"
      },
      {
        "regionId": 1569,
        "regionCode": null,
        "regionName": "Halkidiki"
      },
      {
        "regionId": 1570,
        "regionCode": null,
        "regionName": "Hania"
      },
      {
        "regionId": 1571,
        "regionCode": null,
        "regionName": "Heraklion"
      },
      {
        "regionId": 1572,
        "regionCode": null,
        "regionName": "Hios"
      },
      {
        "regionId": 1573,
        "regionCode": "16",
        "regionName": "Ilia"
      },
      {
        "regionId": 1574,
        "regionCode": "17",
        "regionName": "Imathia"
      },
      {
        "regionId": 1575,
        "regionCode": "18",
        "regionName": "Ioannina"
      },
      {
        "regionId": 1576,
        "regionCode": "19",
        "regionName": "Iraklion"
      },
      {
        "regionId": 1577,
        "regionCode": null,
        "regionName": "Karditsa"
      },
      {
        "regionId": 1578,
        "regionCode": "21",
        "regionName": "Kastoria"
      },
      {
        "regionId": 1579,
        "regionCode": "22",
        "regionName": "Kavala"
      },
      {
        "regionId": 1580,
        "regionCode": "23",
        "regionName": "Kefallinia"
      },
      {
        "regionId": 1581,
        "regionCode": "24",
        "regionName": "Kerkira"
      },
      {
        "regionId": 1582,
        "regionCode": null,
        "regionName": "Kiklades"
      },
      {
        "regionId": 1583,
        "regionCode": "29",
        "regionName": "Kilkis"
      },
      {
        "regionId": 1584,
        "regionCode": "30",
        "regionName": "Korinthia"
      },
      {
        "regionId": 1585,
        "regionCode": "31",
        "regionName": "Kozani"
      },
      {
        "regionId": 1586,
        "regionCode": "32",
        "regionName": "Lakonia"
      },
      {
        "regionId": 1587,
        "regionCode": "33",
        "regionName": "Larisa"
      },
      {
        "regionId": 1588,
        "regionCode": "34",
        "regionName": "Lasithi"
      },
      {
        "regionId": 1589,
        "regionCode": "35",
        "regionName": "Lesvos"
      },
      {
        "regionId": 1590,
        "regionCode": "36",
        "regionName": "Levkas"
      },
      {
        "regionId": 1591,
        "regionCode": "37",
        "regionName": "Magnisia"
      },
      {
        "regionId": 1592,
        "regionCode": "38",
        "regionName": "Messinia"
      },
      {
        "regionId": 1593,
        "regionCode": null,
        "regionName": "Nomos Attikis"
      },
      {
        "regionId": 1594,
        "regionCode": null,
        "regionName": "Nomos Zakynthou"
      },
      {
        "regionId": 1595,
        "regionCode": "39",
        "regionName": "Pella"
      },
      {
        "regionId": 1596,
        "regionCode": "40",
        "regionName": "Pieria"
      },
      {
        "regionId": 1597,
        "regionCode": null,
        "regionName": "Piraios"
      },
      {
        "regionId": 1598,
        "regionCode": "42",
        "regionName": "Preveza"
      },
      {
        "regionId": 1599,
        "regionCode": "43",
        "regionName": "Rethimni"
      },
      {
        "regionId": 1600,
        "regionCode": null,
        "regionName": "Rodopi"
      },
      {
        "regionId": 1601,
        "regionCode": "45",
        "regionName": "Samos"
      },
      {
        "regionId": 1602,
        "regionCode": "46",
        "regionName": "Serrai"
      },
      {
        "regionId": 1603,
        "regionCode": "47",
        "regionName": "Thesprotia"
      },
      {
        "regionId": 1604,
        "regionCode": "48",
        "regionName": "Thessaloniki"
      },
      {
        "regionId": 1605,
        "regionCode": "49",
        "regionName": "Trikala"
      },
      {
        "regionId": 1606,
        "regionCode": "50",
        "regionName": "Voiotia"
      },
      {
        "regionId": 1607,
        "regionCode": null,
        "regionName": "West Greece"
      },
      {
        "regionId": 1608,
        "regionCode": "51",
        "regionName": "Xanthi"
      },
      {
        "regionId": 1609,
        "regionCode": "52",
        "regionName": "Zakinthos"
      }
    ]
  },
  {
    "countryId": 82,
    "countryCode": "GL",
    "countryName": "Greenland",
    "regions": [
      {
        "regionId": 1482,
        "regionCode": null,
        "regionName": "Aasiaat"
      },
      {
        "regionId": 1483,
        "regionCode": null,
        "regionName": "Ammassalik"
      },
      {
        "regionId": 1484,
        "regionCode": null,
        "regionName": "Illoqqortoormiut"
      },
      {
        "regionId": 1485,
        "regionCode": null,
        "regionName": "Ilulissat"
      },
      {
        "regionId": 1486,
        "regionCode": null,
        "regionName": "Ivittuut"
      },
      {
        "regionId": 1487,
        "regionCode": null,
        "regionName": "Kangaatsiaq"
      },
      {
        "regionId": 1488,
        "regionCode": null,
        "regionName": "Maniitsoq"
      },
      {
        "regionId": 1489,
        "regionCode": null,
        "regionName": "Nanortalik"
      },
      {
        "regionId": 1490,
        "regionCode": null,
        "regionName": "Narsaq"
      },
      {
        "regionId": 1491,
        "regionCode": null,
        "regionName": "Nuuk"
      },
      {
        "regionId": 1492,
        "regionCode": null,
        "regionName": "Paamiut"
      },
      {
        "regionId": 1493,
        "regionCode": null,
        "regionName": "Qaanaaq"
      },
      {
        "regionId": 1494,
        "regionCode": null,
        "regionName": "Qaqortoq"
      },
      {
        "regionId": 1495,
        "regionCode": null,
        "regionName": "Qasigiannguit"
      },
      {
        "regionId": 1496,
        "regionCode": null,
        "regionName": "Qeqertarsuaq"
      },
      {
        "regionId": 1497,
        "regionCode": null,
        "regionName": "Sisimiut"
      },
      {
        "regionId": 1498,
        "regionCode": null,
        "regionName": "Udenfor kommunal inddeling"
      },
      {
        "regionId": 1499,
        "regionCode": null,
        "regionName": "Upernavik"
      },
      {
        "regionId": 1500,
        "regionCode": null,
        "regionName": "Uummannaq"
      }
    ]
  },
  {
    "countryId": 83,
    "countryCode": "GD",
    "countryName": "Grenada",
    "regions": [
      {
        "regionId": 1450,
        "regionCode": null,
        "regionName": "Carriacou-Petite Martinique"
      },
      {
        "regionId": 1451,
        "regionCode": null,
        "regionName": "Saint Andrew"
      },
      {
        "regionId": 1452,
        "regionCode": null,
        "regionName": "Saint Davids"
      },
      {
        "regionId": 1453,
        "regionCode": null,
        "regionName": "Saint George's"
      },
      {
        "regionId": 1454,
        "regionCode": null,
        "regionName": "Saint John"
      },
      {
        "regionId": 1455,
        "regionCode": null,
        "regionName": "Saint Mark"
      },
      {
        "regionId": 1456,
        "regionCode": null,
        "regionName": "Saint Patrick"
      }
    ]
  },
  {
    "countryId": 84,
    "countryCode": "GU",
    "countryName": "Guam",
    "regions": [
      {
        "regionId": 1632,
        "regionCode": null,
        "regionName": "Agana Heights"
      },
      {
        "regionId": 1633,
        "regionCode": null,
        "regionName": "Agat"
      },
      {
        "regionId": 1634,
        "regionCode": null,
        "regionName": "Barrigada"
      },
      {
        "regionId": 1635,
        "regionCode": null,
        "regionName": "Chalan-Pago-Ordot"
      },
      {
        "regionId": 1636,
        "regionCode": null,
        "regionName": "Dededo"
      },
      {
        "regionId": 1637,
        "regionCode": null,
        "regionName": "Hagatna"
      },
      {
        "regionId": 1638,
        "regionCode": null,
        "regionName": "Inarajan"
      },
      {
        "regionId": 1639,
        "regionCode": null,
        "regionName": "Mangilao"
      },
      {
        "regionId": 1640,
        "regionCode": null,
        "regionName": "Merizo"
      },
      {
        "regionId": 1641,
        "regionCode": null,
        "regionName": "Mongmong-Toto-Maite"
      },
      {
        "regionId": 1642,
        "regionCode": null,
        "regionName": "Santa Rita"
      },
      {
        "regionId": 1643,
        "regionCode": null,
        "regionName": "Sinajana"
      },
      {
        "regionId": 1644,
        "regionCode": null,
        "regionName": "Talofofo"
      },
      {
        "regionId": 1645,
        "regionCode": null,
        "regionName": "Tamuning"
      },
      {
        "regionId": 1646,
        "regionCode": null,
        "regionName": "Yigo"
      },
      {
        "regionId": 1647,
        "regionCode": null,
        "regionName": "Yona"
      }
    ]
  },
  {
    "countryId": 85,
    "countryCode": "GT",
    "countryName": "Guatemala",
    "regions": [
      {
        "regionId": 1610,
        "regionCode": null,
        "regionName": "Alta Verapaz"
      },
      {
        "regionId": 1611,
        "regionCode": null,
        "regionName": "Baja Verapaz"
      },
      {
        "regionId": 1612,
        "regionCode": null,
        "regionName": "Chimaltenango"
      },
      {
        "regionId": 1613,
        "regionCode": null,
        "regionName": "Chiquimula"
      },
      {
        "regionId": 1614,
        "regionCode": null,
        "regionName": "El Progreso"
      },
      {
        "regionId": 1615,
        "regionCode": null,
        "regionName": "Escuintla"
      },
      {
        "regionId": 1616,
        "regionCode": null,
        "regionName": "Guatemala"
      },
      {
        "regionId": 1617,
        "regionCode": null,
        "regionName": "Huehuetenango"
      },
      {
        "regionId": 1618,
        "regionCode": null,
        "regionName": "Izabal"
      },
      {
        "regionId": 1619,
        "regionCode": null,
        "regionName": "Jalapa"
      },
      {
        "regionId": 1620,
        "regionCode": null,
        "regionName": "Jutiapa"
      },
      {
        "regionId": 1621,
        "regionCode": null,
        "regionName": "Peten"
      },
      {
        "regionId": 1622,
        "regionCode": null,
        "regionName": "Quezaltenango"
      },
      {
        "regionId": 1623,
        "regionCode": null,
        "regionName": "Quiche"
      },
      {
        "regionId": 1624,
        "regionCode": null,
        "regionName": "Retalhuleu"
      },
      {
        "regionId": 1625,
        "regionCode": null,
        "regionName": "Sacatepequez"
      },
      {
        "regionId": 1626,
        "regionCode": null,
        "regionName": "San Marcos"
      },
      {
        "regionId": 1627,
        "regionCode": null,
        "regionName": "Santa Rosa"
      },
      {
        "regionId": 1628,
        "regionCode": null,
        "regionName": "Solola"
      },
      {
        "regionId": 1629,
        "regionCode": null,
        "regionName": "Suchitepequez"
      },
      {
        "regionId": 1630,
        "regionCode": null,
        "regionName": "Totonicapan"
      },
      {
        "regionId": 1631,
        "regionCode": null,
        "regionName": "Zacapa"
      }
    ]
  },
  {
    "countryId": 86,
    "countryCode": "GG",
    "countryName": "Guernsey",
    "regions": []
  },
  {
    "countryId": 87,
    "countryCode": "GN",
    "countryName": "Guinea",
    "regions": [
      {
        "regionId": 1509,
        "regionCode": null,
        "regionName": "Beyla"
      },
      {
        "regionId": 1510,
        "regionCode": null,
        "regionName": "Boffa"
      },
      {
        "regionId": 1511,
        "regionCode": null,
        "regionName": "Boke"
      },
      {
        "regionId": 1512,
        "regionCode": null,
        "regionName": "Conakry"
      },
      {
        "regionId": 1513,
        "regionCode": null,
        "regionName": "Coyah"
      },
      {
        "regionId": 1514,
        "regionCode": null,
        "regionName": "Dabola"
      },
      {
        "regionId": 1515,
        "regionCode": null,
        "regionName": "Dalaba"
      },
      {
        "regionId": 1516,
        "regionCode": null,
        "regionName": "Dinguiraye"
      },
      {
        "regionId": 1517,
        "regionCode": null,
        "regionName": "Faranah"
      },
      {
        "regionId": 1518,
        "regionCode": null,
        "regionName": "Forecariah"
      },
      {
        "regionId": 1519,
        "regionCode": null,
        "regionName": "Fria"
      },
      {
        "regionId": 1520,
        "regionCode": null,
        "regionName": "Gaoual"
      },
      {
        "regionId": 1521,
        "regionCode": null,
        "regionName": "Gueckedou"
      },
      {
        "regionId": 1522,
        "regionCode": null,
        "regionName": "Kankan"
      },
      {
        "regionId": 1523,
        "regionCode": null,
        "regionName": "Kerouane"
      },
      {
        "regionId": 1524,
        "regionCode": null,
        "regionName": "Kindia"
      },
      {
        "regionId": 1525,
        "regionCode": null,
        "regionName": "Kissidougou"
      },
      {
        "regionId": 1526,
        "regionCode": null,
        "regionName": "Koubia"
      },
      {
        "regionId": 1527,
        "regionCode": null,
        "regionName": "Koundara"
      },
      {
        "regionId": 1528,
        "regionCode": null,
        "regionName": "Kouroussa"
      },
      {
        "regionId": 1529,
        "regionCode": null,
        "regionName": "Labe"
      },
      {
        "regionId": 1530,
        "regionCode": null,
        "regionName": "Lola"
      },
      {
        "regionId": 1531,
        "regionCode": null,
        "regionName": "Macenta"
      },
      {
        "regionId": 1532,
        "regionCode": null,
        "regionName": "Mali"
      },
      {
        "regionId": 1533,
        "regionCode": null,
        "regionName": "Mamou"
      },
      {
        "regionId": 1534,
        "regionCode": null,
        "regionName": "Mandiana"
      },
      {
        "regionId": 1535,
        "regionCode": null,
        "regionName": "Nzerekore"
      },
      {
        "regionId": 1536,
        "regionCode": null,
        "regionName": "Pita"
      },
      {
        "regionId": 1537,
        "regionCode": null,
        "regionName": "Siguiri"
      },
      {
        "regionId": 1538,
        "regionCode": null,
        "regionName": "Telimele"
      },
      {
        "regionId": 1539,
        "regionCode": null,
        "regionName": "Tougue"
      },
      {
        "regionId": 1540,
        "regionCode": null,
        "regionName": "Yomou"
      }
    ]
  },
  {
    "countryId": 88,
    "countryCode": "GW",
    "countryName": "Guinea-Bissau",
    "regions": [
      {
        "regionId": 1648,
        "regionCode": null,
        "regionName": "Bafata"
      },
      {
        "regionId": 1649,
        "regionCode": null,
        "regionName": "Bissau"
      },
      {
        "regionId": 1650,
        "regionCode": null,
        "regionName": "Bolama"
      },
      {
        "regionId": 1651,
        "regionCode": null,
        "regionName": "Cacheu"
      },
      {
        "regionId": 1652,
        "regionCode": null,
        "regionName": "Gabu"
      },
      {
        "regionId": 1653,
        "regionCode": null,
        "regionName": "Oio"
      },
      {
        "regionId": 1654,
        "regionCode": null,
        "regionName": "Quinara"
      },
      {
        "regionId": 1655,
        "regionCode": null,
        "regionName": "Tombali"
      }
    ]
  },
  {
    "countryId": 89,
    "countryCode": "GY",
    "countryName": "Guyana",
    "regions": [
      {
        "regionId": 1656,
        "regionCode": null,
        "regionName": "Barima-Waini"
      },
      {
        "regionId": 1657,
        "regionCode": null,
        "regionName": "Cuyuni-Mazaruni"
      },
      {
        "regionId": 1658,
        "regionCode": null,
        "regionName": "Demerara-Mahaica"
      },
      {
        "regionId": 1659,
        "regionCode": null,
        "regionName": "East Berbice-Corentyne"
      },
      {
        "regionId": 1660,
        "regionCode": null,
        "regionName": "Essequibo Islands-West Demerar"
      },
      {
        "regionId": 1661,
        "regionCode": null,
        "regionName": "Mahaica-Berbice"
      },
      {
        "regionId": 1662,
        "regionCode": null,
        "regionName": "Pomeroon-Supenaam"
      },
      {
        "regionId": 1663,
        "regionCode": null,
        "regionName": "Potaro-Siparuni"
      },
      {
        "regionId": 1664,
        "regionCode": null,
        "regionName": "Upper Demerara-Berbice"
      },
      {
        "regionId": 1665,
        "regionCode": null,
        "regionName": "Upper Takutu-Upper Essequibo"
      }
    ]
  },
  {
    "countryId": 90,
    "countryCode": "HT",
    "countryName": "Haiti",
    "regions": [
      {
        "regionId": 1709,
        "regionCode": null,
        "regionName": "Artibonite"
      },
      {
        "regionId": 1710,
        "regionCode": null,
        "regionName": "Centre"
      },
      {
        "regionId": 1711,
        "regionCode": null,
        "regionName": "Grand'Anse"
      },
      {
        "regionId": 1712,
        "regionCode": null,
        "regionName": "Nord"
      },
      {
        "regionId": 1713,
        "regionCode": null,
        "regionName": "Nord-Est"
      },
      {
        "regionId": 1714,
        "regionCode": null,
        "regionName": "Nord-Ouest"
      },
      {
        "regionId": 1715,
        "regionCode": null,
        "regionName": "Ouest"
      },
      {
        "regionId": 1716,
        "regionCode": null,
        "regionName": "Sud"
      },
      {
        "regionId": 1717,
        "regionCode": null,
        "regionName": "Sud-Est"
      }
    ]
  },
  {
    "countryId": 91,
    "countryCode": "HN",
    "countryName": "Honduras",
    "regions": [
      {
        "regionId": 1667,
        "regionCode": null,
        "regionName": "Atlantida"
      },
      {
        "regionId": 1668,
        "regionCode": "CH",
        "regionName": "Choluteca"
      },
      {
        "regionId": 1669,
        "regionCode": null,
        "regionName": "Colon"
      },
      {
        "regionId": 1670,
        "regionCode": "CM",
        "regionName": "Comayagua"
      },
      {
        "regionId": 1671,
        "regionCode": null,
        "regionName": "Copan"
      },
      {
        "regionId": 1672,
        "regionCode": null,
        "regionName": "Cortes"
      },
      {
        "regionId": 1673,
        "regionCode": null,
        "regionName": "Distrito Central"
      },
      {
        "regionId": 1674,
        "regionCode": null,
        "regionName": "El Paraiso"
      },
      {
        "regionId": 1675,
        "regionCode": null,
        "regionName": "Francisco Morazan"
      },
      {
        "regionId": 1676,
        "regionCode": "GD",
        "regionName": "Gracias a Dios"
      },
      {
        "regionId": 1677,
        "regionCode": null,
        "regionName": "Intibuca"
      },
      {
        "regionId": 1678,
        "regionCode": null,
        "regionName": "Islas de la Bahia"
      },
      {
        "regionId": 1679,
        "regionCode": "LP",
        "regionName": "La Paz"
      },
      {
        "regionId": 1680,
        "regionCode": "LE",
        "regionName": "Lempira"
      },
      {
        "regionId": 1681,
        "regionCode": "OC",
        "regionName": "Ocotepeque"
      },
      {
        "regionId": 1682,
        "regionCode": "OL",
        "regionName": "Olancho"
      },
      {
        "regionId": 1683,
        "regionCode": null,
        "regionName": "Santa Barbara"
      },
      {
        "regionId": 1684,
        "regionCode": "VA",
        "regionName": "Valle"
      },
      {
        "regionId": 1685,
        "regionCode": "YO",
        "regionName": "Yoro"
      }
    ]
  },
  {
    "countryId": 92,
    "countryCode": "HK",
    "countryName": "Hong Kong",
    "regions": [
      {
        "regionId": 1666,
        "regionCode": null,
        "regionName": "Hong Kong"
      }
    ]
  },
  {
    "countryId": 93,
    "countryCode": "HU",
    "countryName": "Hungary",
    "regions": [
      {
        "regionId": 1718,
        "regionCode": "01",
        "regionName": "Bács-Kiskun"
      },
      {
        "regionId": 1719,
        "regionCode": "02",
        "regionName": "Baranya"
      },
      {
        "regionId": 1720,
        "regionCode": "03",
        "regionName": "Békés"
      },
      {
        "regionId": 1721,
        "regionCode": "05",
        "regionName": "Borsod-Abaúj-Zemplén"
      },
      {
        "regionId": 1722,
        "regionCode": "06",
        "regionName": "Budapest"
      },
      {
        "regionId": 1723,
        "regionCode": "07",
        "regionName": "Csongrád"
      },
      {
        "regionId": 1724,
        "regionCode": "11",
        "regionName": "Fejér"
      },
      {
        "regionId": 1725,
        "regionCode": "13",
        "regionName": "Gyor-Moson-Sopron"
      },
      {
        "regionId": 1726,
        "regionCode": "14",
        "regionName": "Hajdú-Bihar"
      },
      {
        "regionId": 1727,
        "regionCode": "15",
        "regionName": "Heves"
      },
      {
        "regionId": 1728,
        "regionCode": "17",
        "regionName": "Jász-Nagykun-Szolnok"
      },
      {
        "regionId": 1729,
        "regionCode": "20",
        "regionName": "Komárom-Esztergom"
      },
      {
        "regionId": 1730,
        "regionCode": "23",
        "regionName": "Nógrád"
      },
      {
        "regionId": 1731,
        "regionCode": "26",
        "regionName": "Pest"
      },
      {
        "regionId": 1732,
        "regionCode": "27",
        "regionName": "Somogy"
      },
      {
        "regionId": 1733,
        "regionCode": null,
        "regionName": "Szabolcs-Szatmár-Bereg"
      },
      {
        "regionId": 1734,
        "regionCode": "35",
        "regionName": "Tolna"
      },
      {
        "regionId": 1735,
        "regionCode": "36",
        "regionName": "Vas"
      },
      {
        "regionId": 1736,
        "regionCode": "37",
        "regionName": "Veszprém"
      },
      {
        "regionId": 1737,
        "regionCode": "38",
        "regionName": "Zala"
      }
    ]
  },
  {
    "countryId": 94,
    "countryCode": "IS",
    "countryName": "Iceland",
    "regions": [
      {
        "regionId": 1915,
        "regionCode": null,
        "regionName": "Austurland"
      },
      {
        "regionId": 1916,
        "regionCode": null,
        "regionName": "Gullbringusysla"
      },
      {
        "regionId": 1917,
        "regionCode": null,
        "regionName": "Hofu borgarsva i"
      },
      {
        "regionId": 1918,
        "regionCode": null,
        "regionName": "Nor urland eystra"
      },
      {
        "regionId": 1919,
        "regionCode": null,
        "regionName": "Nor urland vestra"
      },
      {
        "regionId": 1920,
        "regionCode": null,
        "regionName": "Su urland"
      },
      {
        "regionId": 1921,
        "regionCode": null,
        "regionName": "Su urnes"
      },
      {
        "regionId": 1922,
        "regionCode": null,
        "regionName": "Vestfir ir"
      },
      {
        "regionId": 1923,
        "regionCode": null,
        "regionName": "Vesturland"
      }
    ]
  },
  {
    "countryId": 95,
    "countryCode": "IN",
    "countryName": "India",
    "regions": [
      {
        "regionId": 1825,
        "regionCode": "AN",
        "regionName": "Andaman and Nicobar Islands"
      },
      {
        "regionId": 1826,
        "regionCode": "AP",
        "regionName": "Andhra Pradesh"
      },
      {
        "regionId": 1827,
        "regionCode": "02",
        "regionName": "Arunachal Pradesh"
      },
      {
        "regionId": 1828,
        "regionCode": "03",
        "regionName": "Assam"
      },
      {
        "regionId": 1829,
        "regionCode": "04",
        "regionName": "Bihar"
      },
      {
        "regionId": 1830,
        "regionCode": "27",
        "regionName": "Chandigarh"
      },
      {
        "regionId": 1831,
        "regionCode": "CT",
        "regionName": "Chhattisgarh"
      },
      {
        "regionId": 1832,
        "regionCode": null,
        "regionName": "Dadra and Nagar Haveli"
      },
      {
        "regionId": 1833,
        "regionCode": null,
        "regionName": "Daman and Diu"
      },
      {
        "regionId": 1834,
        "regionCode": "30",
        "regionName": "Delhi"
      },
      {
        "regionId": 1835,
        "regionCode": "05",
        "regionName": "Goa"
      },
      {
        "regionId": 1836,
        "regionCode": "06",
        "regionName": "Gujarat"
      },
      {
        "regionId": 1837,
        "regionCode": "07",
        "regionName": "Haryana"
      },
      {
        "regionId": 1838,
        "regionCode": "08",
        "regionName": "Himachal Pradesh"
      },
      {
        "regionId": 1839,
        "regionCode": "JK",
        "regionName": "Jammu and Kashmir"
      },
      {
        "regionId": 1840,
        "regionCode": "JH",
        "regionName": "Jharkhand"
      },
      {
        "regionId": 1841,
        "regionCode": "10",
        "regionName": "Karnataka"
      },
      {
        "regionId": 1842,
        "regionCode": null,
        "regionName": "Kenmore"
      },
      {
        "regionId": 1843,
        "regionCode": "11",
        "regionName": "Kerala"
      },
      {
        "regionId": 1844,
        "regionCode": "31",
        "regionName": "Lakshadweep"
      },
      {
        "regionId": 1845,
        "regionCode": "12",
        "regionName": "Madhya Pradesh"
      },
      {
        "regionId": 1846,
        "regionCode": "13",
        "regionName": "Maharashtra"
      },
      {
        "regionId": 1847,
        "regionCode": "14",
        "regionName": "Manipur"
      },
      {
        "regionId": 1848,
        "regionCode": "ML",
        "regionName": "Meghalaya"
      },
      {
        "regionId": 1849,
        "regionCode": "16",
        "regionName": "Mizoram"
      },
      {
        "regionId": 1850,
        "regionCode": "17",
        "regionName": "Nagaland"
      },
      {
        "regionId": 1851,
        "regionCode": null,
        "regionName": "Narora"
      },
      {
        "regionId": 1852,
        "regionCode": null,
        "regionName": "Natwar"
      },
      {
        "regionId": 1853,
        "regionCode": "OR",
        "regionName": "Odisha"
      },
      {
        "regionId": 1854,
        "regionCode": null,
        "regionName": "Paschim Medinipur"
      },
      {
        "regionId": 1855,
        "regionCode": "32",
        "regionName": "Pondicherry"
      },
      {
        "regionId": 1856,
        "regionCode": "19",
        "regionName": "Punjab"
      },
      {
        "regionId": 1857,
        "regionCode": "20",
        "regionName": "Rajasthan"
      },
      {
        "regionId": 1858,
        "regionCode": "21",
        "regionName": "Sikkim"
      },
      {
        "regionId": 1859,
        "regionCode": "22",
        "regionName": "Tamil Nadu"
      },
      {
        "regionId": 1860,
        "regionCode": "TG",
        "regionName": "Telangana"
      },
      {
        "regionId": 1861,
        "regionCode": "23",
        "regionName": "Tripura"
      },
      {
        "regionId": 1862,
        "regionCode": "24",
        "regionName": "Uttar Pradesh"
      },
      {
        "regionId": 1863,
        "regionCode": "UT",
        "regionName": "Uttarakhand"
      },
      {
        "regionId": 1864,
        "regionCode": null,
        "regionName": "Vaishali"
      },
      {
        "regionId": 1865,
        "regionCode": "25",
        "regionName": "West Bengal"
      }
    ]
  },
  {
    "countryId": 96,
    "countryCode": "ID",
    "countryName": "Indonesia",
    "regions": [
      {
        "regionId": 1738,
        "regionCode": "AC",
        "regionName": "Aceh"
      },
      {
        "regionId": 1739,
        "regionCode": "BA",
        "regionName": "Bali"
      },
      {
        "regionId": 1740,
        "regionCode": null,
        "regionName": "Bangka-Belitung"
      },
      {
        "regionId": 1741,
        "regionCode": "BT",
        "regionName": "Banten"
      },
      {
        "regionId": 1742,
        "regionCode": "BE",
        "regionName": "Bengkulu"
      },
      {
        "regionId": 1743,
        "regionCode": null,
        "regionName": "Gandaria"
      },
      {
        "regionId": 1744,
        "regionCode": "GO",
        "regionName": "Gorontalo"
      },
      {
        "regionId": 1745,
        "regionCode": "JK",
        "regionName": "Jakarta"
      },
      {
        "regionId": 1746,
        "regionCode": "JA",
        "regionName": "Jambi"
      },
      {
        "regionId": 1747,
        "regionCode": "JB",
        "regionName": "Jawa Barat"
      },
      {
        "regionId": 1748,
        "regionCode": "JT",
        "regionName": "Jawa Tengah"
      },
      {
        "regionId": 1749,
        "regionCode": "JI",
        "regionName": "Jawa Timur"
      },
      {
        "regionId": 1750,
        "regionCode": "KB",
        "regionName": "Kalimantan Barat"
      },
      {
        "regionId": 1751,
        "regionCode": "KS",
        "regionName": "Kalimantan Selatan"
      },
      {
        "regionId": 1752,
        "regionCode": "KT",
        "regionName": "Kalimantan Tengah"
      },
      {
        "regionId": 1753,
        "regionCode": "KI",
        "regionName": "Kalimantan Timur"
      },
      {
        "regionId": 1754,
        "regionCode": null,
        "regionName": "Kendal"
      },
      {
        "regionId": 1755,
        "regionCode": "LA",
        "regionName": "Lampung"
      },
      {
        "regionId": 1756,
        "regionCode": "MA",
        "regionName": "Maluku"
      },
      {
        "regionId": 1757,
        "regionCode": "MU",
        "regionName": "Maluku Utara"
      },
      {
        "regionId": 1758,
        "regionCode": "23",
        "regionName": "Nusa Tenggara Barat"
      },
      {
        "regionId": 1759,
        "regionCode": "24",
        "regionName": "Nusa Tenggara Timur"
      },
      {
        "regionId": 1760,
        "regionCode": "PA",
        "regionName": "Papua"
      },
      {
        "regionId": 1761,
        "regionCode": "RI",
        "regionName": "Riau"
      },
      {
        "regionId": 1762,
        "regionCode": null,
        "regionName": "Riau Kepulauan"
      },
      {
        "regionId": 1763,
        "regionCode": null,
        "regionName": "Solo"
      },
      {
        "regionId": 1764,
        "regionCode": "SN",
        "regionName": "Sulawesi Selatan"
      },
      {
        "regionId": 1765,
        "regionCode": "ST",
        "regionName": "Sulawesi Tengah"
      },
      {
        "regionId": 1766,
        "regionCode": "SG",
        "regionName": "Sulawesi Tenggara"
      },
      {
        "regionId": 1767,
        "regionCode": "SA",
        "regionName": "Sulawesi Utara"
      },
      {
        "regionId": 1768,
        "regionCode": "SB",
        "regionName": "Sumatera Barat"
      },
      {
        "regionId": 1769,
        "regionCode": "SS",
        "regionName": "Sumatera Selatan"
      },
      {
        "regionId": 1770,
        "regionCode": "SU",
        "regionName": "Sumatera Utara"
      },
      {
        "regionId": 1771,
        "regionCode": null,
        "regionName": "Yogyakarta"
      }
    ]
  },
  {
    "countryId": 97,
    "countryCode": "IR",
    "countryName": "Iran",
    "regions": [
      {
        "regionId": 1886,
        "regionCode": null,
        "regionName": "Ardabil"
      },
      {
        "regionId": 1887,
        "regionCode": null,
        "regionName": "Azarbayjan-e Bakhtari"
      },
      {
        "regionId": 1888,
        "regionCode": null,
        "regionName": "Azarbayjan-e Khavari"
      },
      {
        "regionId": 1889,
        "regionCode": null,
        "regionName": "Bushehr"
      },
      {
        "regionId": 1890,
        "regionCode": null,
        "regionName": "Chahar Mahal-e Bakhtiari"
      },
      {
        "regionId": 1891,
        "regionCode": null,
        "regionName": "Esfahan"
      },
      {
        "regionId": 1892,
        "regionCode": null,
        "regionName": "Fars"
      },
      {
        "regionId": 1893,
        "regionCode": null,
        "regionName": "Gilan"
      },
      {
        "regionId": 1894,
        "regionCode": null,
        "regionName": "Golestan"
      },
      {
        "regionId": 1895,
        "regionCode": null,
        "regionName": "Hamadan"
      },
      {
        "regionId": 1896,
        "regionCode": null,
        "regionName": "Hormozgan"
      },
      {
        "regionId": 1897,
        "regionCode": null,
        "regionName": "Ilam"
      },
      {
        "regionId": 1898,
        "regionCode": null,
        "regionName": "Kerman"
      },
      {
        "regionId": 1899,
        "regionCode": null,
        "regionName": "Kermanshah"
      },
      {
        "regionId": 1900,
        "regionCode": null,
        "regionName": "Khorasan"
      },
      {
        "regionId": 1901,
        "regionCode": null,
        "regionName": "Khuzestan"
      },
      {
        "regionId": 1902,
        "regionCode": null,
        "regionName": "Kohgiluyeh-e Boyerahmad"
      },
      {
        "regionId": 1903,
        "regionCode": null,
        "regionName": "Kordestan"
      },
      {
        "regionId": 1904,
        "regionCode": null,
        "regionName": "Lorestan"
      },
      {
        "regionId": 1905,
        "regionCode": null,
        "regionName": "Markazi"
      },
      {
        "regionId": 1906,
        "regionCode": null,
        "regionName": "Mazandaran"
      },
      {
        "regionId": 1907,
        "regionCode": null,
        "regionName": "Ostan-e Esfahan"
      },
      {
        "regionId": 1908,
        "regionCode": null,
        "regionName": "Qazvin"
      },
      {
        "regionId": 1909,
        "regionCode": null,
        "regionName": "Qom"
      },
      {
        "regionId": 1910,
        "regionCode": null,
        "regionName": "Semnan"
      },
      {
        "regionId": 1911,
        "regionCode": null,
        "regionName": "Sistan-e Baluchestan"
      },
      {
        "regionId": 1912,
        "regionCode": null,
        "regionName": "Tehran"
      },
      {
        "regionId": 1913,
        "regionCode": null,
        "regionName": "Yazd"
      },
      {
        "regionId": 1914,
        "regionCode": null,
        "regionName": "Zanjan"
      }
    ]
  },
  {
    "countryId": 98,
    "countryCode": "IQ",
    "countryName": "Iraq",
    "regions": [
      {
        "regionId": 1866,
        "regionCode": null,
        "regionName": "al-Anbar"
      },
      {
        "regionId": 1867,
        "regionCode": null,
        "regionName": "al-Basrah"
      },
      {
        "regionId": 1868,
        "regionCode": null,
        "regionName": "al-Muthanna"
      },
      {
        "regionId": 1869,
        "regionCode": null,
        "regionName": "al-Qadisiyah"
      },
      {
        "regionId": 1870,
        "regionCode": null,
        "regionName": "an-Najaf"
      },
      {
        "regionId": 1871,
        "regionCode": null,
        "regionName": "as-Sulaymaniyah"
      },
      {
        "regionId": 1872,
        "regionCode": null,
        "regionName": "at-Ta'mim"
      },
      {
        "regionId": 1873,
        "regionCode": null,
        "regionName": "Babil"
      },
      {
        "regionId": 1874,
        "regionCode": null,
        "regionName": "Baghdad"
      },
      {
        "regionId": 1875,
        "regionCode": null,
        "regionName": "Dahuk"
      },
      {
        "regionId": 1876,
        "regionCode": null,
        "regionName": "Dhi Qar"
      },
      {
        "regionId": 1877,
        "regionCode": null,
        "regionName": "Diyala"
      },
      {
        "regionId": 1878,
        "regionCode": null,
        "regionName": "Erbil"
      },
      {
        "regionId": 1879,
        "regionCode": null,
        "regionName": "Irbil"
      },
      {
        "regionId": 1880,
        "regionCode": null,
        "regionName": "Karbala"
      },
      {
        "regionId": 1881,
        "regionCode": null,
        "regionName": "Kurdistan"
      },
      {
        "regionId": 1882,
        "regionCode": null,
        "regionName": "Maysan"
      },
      {
        "regionId": 1883,
        "regionCode": null,
        "regionName": "Ninawa"
      },
      {
        "regionId": 1884,
        "regionCode": null,
        "regionName": "Salah-ad-Din"
      },
      {
        "regionId": 1885,
        "regionCode": null,
        "regionName": "Wasit"
      }
    ]
  },
  {
    "countryId": 99,
    "countryCode": "IE",
    "countryName": "Ireland",
    "regions": [
      {
        "regionId": 1772,
        "regionCode": null,
        "regionName": "Armagh"
      },
      {
        "regionId": 1773,
        "regionCode": "CW",
        "regionName": "Carlow"
      },
      {
        "regionId": 1774,
        "regionCode": "CV",
        "regionName": "Cavan"
      },
      {
        "regionId": 1775,
        "regionCode": "CL",
        "regionName": "Clare"
      },
      {
        "regionId": 1776,
        "regionCode": "CK",
        "regionName": "Cork"
      },
      {
        "regionId": 1777,
        "regionCode": "DG",
        "regionName": "Donegal"
      },
      {
        "regionId": 1778,
        "regionCode": "DB",
        "regionName": "Dublin"
      },
      {
        "regionId": 1779,
        "regionCode": "GW",
        "regionName": "Galway"
      },
      {
        "regionId": 1780,
        "regionCode": "KY",
        "regionName": "Kerry"
      },
      {
        "regionId": 1781,
        "regionCode": "KD",
        "regionName": "Kildare"
      },
      {
        "regionId": 1782,
        "regionCode": "KK",
        "regionName": "Kilkenny"
      },
      {
        "regionId": 1783,
        "regionCode": "LS",
        "regionName": "Laois"
      },
      {
        "regionId": 1784,
        "regionCode": null,
        "regionName": "Leinster"
      },
      {
        "regionId": 1785,
        "regionCode": "LM",
        "regionName": "Leitrim"
      },
      {
        "regionId": 1786,
        "regionCode": "LI",
        "regionName": "Limerick"
      },
      {
        "regionId": 1787,
        "regionCode": null,
        "regionName": "Loch Garman"
      },
      {
        "regionId": 1788,
        "regionCode": "LF",
        "regionName": "Longford"
      },
      {
        "regionId": 1789,
        "regionCode": "LT",
        "regionName": "Louth"
      },
      {
        "regionId": 1790,
        "regionCode": "MY",
        "regionName": "Mayo"
      },
      {
        "regionId": 1791,
        "regionCode": "MT",
        "regionName": "Meath"
      },
      {
        "regionId": 1792,
        "regionCode": "MH",
        "regionName": "Monaghan"
      },
      {
        "regionId": 1793,
        "regionCode": "OF",
        "regionName": "Offaly"
      },
      {
        "regionId": 1794,
        "regionCode": null,
        "regionName": "Roscommon"
      },
      {
        "regionId": 1795,
        "regionCode": "SG",
        "regionName": "Sligo"
      },
      {
        "regionId": 1796,
        "regionCode": null,
        "regionName": "Tipperary North Riding"
      },
      {
        "regionId": 1797,
        "regionCode": null,
        "regionName": "Tipperary South Riding"
      },
      {
        "regionId": 1798,
        "regionCode": null,
        "regionName": "Ulster"
      },
      {
        "regionId": 1799,
        "regionCode": "WF",
        "regionName": "Waterford"
      },
      {
        "regionId": 1800,
        "regionCode": "WM",
        "regionName": "Westmeath"
      },
      {
        "regionId": 1801,
        "regionCode": "WX",
        "regionName": "Wexford"
      },
      {
        "regionId": 1802,
        "regionCode": "WK",
        "regionName": "Wicklow"
      },
      {
        "regionId": 4108,
        "regionCode": "TA",
        "regionName": "Tipperary"
      }
    ]
  },
  {
    "countryId": 100,
    "countryCode": "IM",
    "countryName": "Isle of Man",
    "regions": []
  },
  {
    "countryId": 101,
    "countryCode": "IL",
    "countryName": "Israel",
    "regions": [
      {
        "regionId": 1803,
        "regionCode": null,
        "regionName": "Beit Hanania"
      },
      {
        "regionId": 1804,
        "regionCode": null,
        "regionName": "Ben Gurion Airport"
      },
      {
        "regionId": 1805,
        "regionCode": null,
        "regionName": "Bethlehem"
      },
      {
        "regionId": 1806,
        "regionCode": null,
        "regionName": "Caesarea"
      },
      {
        "regionId": 1807,
        "regionCode": null,
        "regionName": "Centre"
      },
      {
        "regionId": 1808,
        "regionCode": null,
        "regionName": "Gaza"
      },
      {
        "regionId": 1809,
        "regionCode": null,
        "regionName": "Hadaron"
      },
      {
        "regionId": 1810,
        "regionCode": null,
        "regionName": "Haifa District"
      },
      {
        "regionId": 1811,
        "regionCode": null,
        "regionName": "Hamerkaz"
      },
      {
        "regionId": 1812,
        "regionCode": null,
        "regionName": "Hazafon"
      },
      {
        "regionId": 1813,
        "regionCode": null,
        "regionName": "Hebron"
      },
      {
        "regionId": 1814,
        "regionCode": null,
        "regionName": "Jaffa"
      },
      {
        "regionId": 1815,
        "regionCode": "03",
        "regionName": "Jerusalem"
      },
      {
        "regionId": 1816,
        "regionCode": null,
        "regionName": "Khefa"
      },
      {
        "regionId": 1817,
        "regionCode": null,
        "regionName": "Kiryat Yam"
      },
      {
        "regionId": 1818,
        "regionCode": null,
        "regionName": "Lower Galilee"
      },
      {
        "regionId": 1819,
        "regionCode": null,
        "regionName": "Qalqilya"
      },
      {
        "regionId": 1820,
        "regionCode": null,
        "regionName": "Talme Elazar"
      },
      {
        "regionId": 1821,
        "regionCode": "06",
        "regionName": "Tel Aviv"
      },
      {
        "regionId": 1822,
        "regionCode": null,
        "regionName": "Tsafon"
      },
      {
        "regionId": 1823,
        "regionCode": null,
        "regionName": "Umm El Fahem"
      },
      {
        "regionId": 1824,
        "regionCode": null,
        "regionName": "Yerushalayim"
      }
    ]
  },
  {
    "countryId": 102,
    "countryCode": "IT",
    "countryName": "Italy",
    "regions": [
      {
        "regionId": 1924,
        "regionCode": null,
        "regionName": "Abruzzi"
      },
      {
        "regionId": 1925,
        "regionCode": null,
        "regionName": "Abruzzo"
      },
      {
        "regionId": 1926,
        "regionCode": "AG",
        "regionName": "Agrigento"
      },
      {
        "regionId": 1927,
        "regionCode": "AL",
        "regionName": "Alessandria"
      },
      {
        "regionId": 1928,
        "regionCode": "AN",
        "regionName": "Ancona"
      },
      {
        "regionId": 1929,
        "regionCode": "AR",
        "regionName": "Arezzo"
      },
      {
        "regionId": 1930,
        "regionCode": "AP",
        "regionName": "Ascoli Piceno"
      },
      {
        "regionId": 1931,
        "regionCode": "AT",
        "regionName": "Asti"
      },
      {
        "regionId": 1932,
        "regionCode": "AV",
        "regionName": "Avellino"
      },
      {
        "regionId": 1933,
        "regionCode": "BA",
        "regionName": "Bari"
      },
      {
        "regionId": 1934,
        "regionCode": null,
        "regionName": "Basilicata"
      },
      {
        "regionId": 1935,
        "regionCode": "BL",
        "regionName": "Belluno"
      },
      {
        "regionId": 1936,
        "regionCode": "BN",
        "regionName": "Benevento"
      },
      {
        "regionId": 1937,
        "regionCode": "BG",
        "regionName": "Bergamo"
      },
      {
        "regionId": 1938,
        "regionCode": "BI",
        "regionName": "Biella"
      },
      {
        "regionId": 1939,
        "regionCode": "BO",
        "regionName": "Bologna"
      },
      {
        "regionId": 1940,
        "regionCode": "BZ",
        "regionName": "Bolzano"
      },
      {
        "regionId": 1941,
        "regionCode": "BS",
        "regionName": "Brescia"
      },
      {
        "regionId": 1942,
        "regionCode": "BR",
        "regionName": "Brindisi"
      },
      {
        "regionId": 1943,
        "regionCode": null,
        "regionName": "Calabria"
      },
      {
        "regionId": 1944,
        "regionCode": null,
        "regionName": "Campania"
      },
      {
        "regionId": 1945,
        "regionCode": null,
        "regionName": "Cartoceto"
      },
      {
        "regionId": 1946,
        "regionCode": "CE",
        "regionName": "Caserta"
      },
      {
        "regionId": 1947,
        "regionCode": "CT",
        "regionName": "Catania"
      },
      {
        "regionId": 1948,
        "regionCode": "CH",
        "regionName": "Chieti"
      },
      {
        "regionId": 1949,
        "regionCode": "CO",
        "regionName": "Como"
      },
      {
        "regionId": 1950,
        "regionCode": "CS",
        "regionName": "Cosenza"
      },
      {
        "regionId": 1951,
        "regionCode": "CR",
        "regionName": "Cremona"
      },
      {
        "regionId": 1952,
        "regionCode": "CN",
        "regionName": "Cuneo"
      },
      {
        "regionId": 1953,
        "regionCode": null,
        "regionName": "Emilia-Romagna"
      },
      {
        "regionId": 1954,
        "regionCode": "FE",
        "regionName": "Ferrara"
      },
      {
        "regionId": 1955,
        "regionCode": "FI",
        "regionName": "Firenze"
      },
      {
        "regionId": 1956,
        "regionCode": "FI",
        "regionName": "Florence"
      },
      {
        "regionId": 1957,
        "regionCode": "FC",
        "regionName": "Forli-Cesena"
      },
      {
        "regionId": 1958,
        "regionCode": null,
        "regionName": "Friuli-Venezia Giulia"
      },
      {
        "regionId": 1959,
        "regionCode": "FR",
        "regionName": "Frosinone"
      },
      {
        "regionId": 1960,
        "regionCode": null,
        "regionName": "Genoa"
      },
      {
        "regionId": 1961,
        "regionCode": "GO",
        "regionName": "Gorizia"
      },
      {
        "regionId": 1962,
        "regionCode": "AQ",
        "regionName": "L'Aquila"
      },
      {
        "regionId": 1963,
        "regionCode": null,
        "regionName": "Lazio"
      },
      {
        "regionId": 1964,
        "regionCode": "LE",
        "regionName": "Lecce"
      },
      {
        "regionId": 1965,
        "regionCode": "LC",
        "regionName": "Lecco"
      },
      {
        "regionId": 1966,
        "regionCode": null,
        "regionName": "Lecco Province"
      },
      {
        "regionId": 1967,
        "regionCode": null,
        "regionName": "Liguria"
      },
      {
        "regionId": 1968,
        "regionCode": "LO",
        "regionName": "Lodi"
      },
      {
        "regionId": 1969,
        "regionCode": null,
        "regionName": "Lombardia"
      },
      {
        "regionId": 1970,
        "regionCode": null,
        "regionName": "Lombardy"
      },
      {
        "regionId": 1971,
        "regionCode": "MC",
        "regionName": "Macerata"
      },
      {
        "regionId": 1972,
        "regionCode": "MN",
        "regionName": "Mantova"
      },
      {
        "regionId": 1973,
        "regionCode": null,
        "regionName": "Marche"
      },
      {
        "regionId": 1974,
        "regionCode": "ME",
        "regionName": "Messina"
      },
      {
        "regionId": 1975,
        "regionCode": "MI",
        "regionName": "Milan"
      },
      {
        "regionId": 1976,
        "regionCode": "MO",
        "regionName": "Modena"
      },
      {
        "regionId": 1977,
        "regionCode": null,
        "regionName": "Molise"
      },
      {
        "regionId": 1978,
        "regionCode": null,
        "regionName": "Molteno"
      },
      {
        "regionId": 1979,
        "regionCode": null,
        "regionName": "Montenegro"
      },
      {
        "regionId": 1980,
        "regionCode": null,
        "regionName": "Monza and Brianza"
      },
      {
        "regionId": 1981,
        "regionCode": "NA",
        "regionName": "Naples"
      },
      {
        "regionId": 1982,
        "regionCode": "NO",
        "regionName": "Novara"
      },
      {
        "regionId": 1983,
        "regionCode": "PD",
        "regionName": "Padova"
      },
      {
        "regionId": 1984,
        "regionCode": "PR",
        "regionName": "Parma"
      },
      {
        "regionId": 1985,
        "regionCode": "PV",
        "regionName": "Pavia"
      },
      {
        "regionId": 1986,
        "regionCode": "PG",
        "regionName": "Perugia"
      },
      {
        "regionId": 1987,
        "regionCode": "PU",
        "regionName": "Pesaro-Urbino"
      },
      {
        "regionId": 1988,
        "regionCode": "PC",
        "regionName": "Piacenza"
      },
      {
        "regionId": 1989,
        "regionCode": null,
        "regionName": "Piedmont"
      },
      {
        "regionId": 1990,
        "regionCode": null,
        "regionName": "Piemonte"
      },
      {
        "regionId": 1991,
        "regionCode": "PI",
        "regionName": "Pisa"
      },
      {
        "regionId": 1992,
        "regionCode": "PN",
        "regionName": "Pordenone"
      },
      {
        "regionId": 1993,
        "regionCode": "PZ",
        "regionName": "Potenza"
      },
      {
        "regionId": 1994,
        "regionCode": null,
        "regionName": "Puglia"
      },
      {
        "regionId": 1995,
        "regionCode": "RE",
        "regionName": "Reggio Emilia"
      },
      {
        "regionId": 1996,
        "regionCode": "RN",
        "regionName": "Rimini"
      },
      {
        "regionId": 1997,
        "regionCode": "RM",
        "regionName": "Roma"
      },
      {
        "regionId": 1998,
        "regionCode": "SA",
        "regionName": "Salerno"
      },
      {
        "regionId": 1999,
        "regionCode": null,
        "regionName": "Sardegna"
      },
      {
        "regionId": 2000,
        "regionCode": "SS",
        "regionName": "Sassari"
      },
      {
        "regionId": 2001,
        "regionCode": "SV",
        "regionName": "Savona"
      },
      {
        "regionId": 2002,
        "regionCode": null,
        "regionName": "Sicilia"
      },
      {
        "regionId": 2003,
        "regionCode": "SI",
        "regionName": "Siena"
      },
      {
        "regionId": 2004,
        "regionCode": "SO",
        "regionName": "Sondrio"
      },
      {
        "regionId": 2005,
        "regionCode": null,
        "regionName": "South Tyrol"
      },
      {
        "regionId": 2006,
        "regionCode": "TA",
        "regionName": "Taranto"
      },
      {
        "regionId": 2007,
        "regionCode": "TE",
        "regionName": "Teramo"
      },
      {
        "regionId": 2008,
        "regionCode": "TO",
        "regionName": "Torino"
      },
      {
        "regionId": 2009,
        "regionCode": null,
        "regionName": "Toscana"
      },
      {
        "regionId": 2010,
        "regionCode": "TP",
        "regionName": "Trapani"
      },
      {
        "regionId": 2011,
        "regionCode": null,
        "regionName": "Trentino-Alto Adige"
      },
      {
        "regionId": 2012,
        "regionCode": "TN",
        "regionName": "Trento"
      },
      {
        "regionId": 2013,
        "regionCode": "TV",
        "regionName": "Treviso"
      },
      {
        "regionId": 2014,
        "regionCode": "UD",
        "regionName": "Udine"
      },
      {
        "regionId": 2015,
        "regionCode": null,
        "regionName": "Umbria"
      },
      {
        "regionId": 2016,
        "regionCode": null,
        "regionName": "Valle d'Aosta"
      },
      {
        "regionId": 2017,
        "regionCode": "VA",
        "regionName": "Varese"
      },
      {
        "regionId": 2018,
        "regionCode": null,
        "regionName": "Veneto"
      },
      {
        "regionId": 2019,
        "regionCode": "VE",
        "regionName": "Venezia"
      },
      {
        "regionId": 2020,
        "regionCode": "VB",
        "regionName": "Verbano-Cusio-Ossola"
      },
      {
        "regionId": 2021,
        "regionCode": "VC",
        "regionName": "Vercelli"
      },
      {
        "regionId": 2022,
        "regionCode": "VR",
        "regionName": "Verona"
      },
      {
        "regionId": 2023,
        "regionCode": "VI",
        "regionName": "Vicenza"
      },
      {
        "regionId": 2024,
        "regionCode": "VT",
        "regionName": "Viterbo"
      }
    ]
  },
  {
    "countryId": 103,
    "countryCode": "CI",
    "countryName": "Ivory Coast",
    "regions": [
      {
        "regionId": 630,
        "regionCode": null,
        "regionName": "Abidjan"
      },
      {
        "regionId": 631,
        "regionCode": null,
        "regionName": "Agneby"
      },
      {
        "regionId": 632,
        "regionCode": null,
        "regionName": "Bafing"
      },
      {
        "regionId": 633,
        "regionCode": null,
        "regionName": "Denguele"
      },
      {
        "regionId": 634,
        "regionCode": null,
        "regionName": "Dix-huit Montagnes"
      },
      {
        "regionId": 635,
        "regionCode": null,
        "regionName": "Fromager"
      },
      {
        "regionId": 636,
        "regionCode": null,
        "regionName": "Haut-Sassandra"
      },
      {
        "regionId": 637,
        "regionCode": null,
        "regionName": "Lacs"
      },
      {
        "regionId": 638,
        "regionCode": null,
        "regionName": "Lagunes"
      },
      {
        "regionId": 639,
        "regionCode": null,
        "regionName": "Marahoue"
      },
      {
        "regionId": 640,
        "regionCode": null,
        "regionName": "Moyen-Cavally"
      },
      {
        "regionId": 641,
        "regionCode": null,
        "regionName": "Moyen-Comoe"
      },
      {
        "regionId": 642,
        "regionCode": null,
        "regionName": "N'zi-Comoe"
      },
      {
        "regionId": 643,
        "regionCode": null,
        "regionName": "Sassandra"
      },
      {
        "regionId": 644,
        "regionCode": null,
        "regionName": "Savanes"
      },
      {
        "regionId": 645,
        "regionCode": null,
        "regionName": "Sud-Bandama"
      },
      {
        "regionId": 646,
        "regionCode": null,
        "regionName": "Sud-Comoe"
      },
      {
        "regionId": 647,
        "regionCode": null,
        "regionName": "Vallee du Bandama"
      },
      {
        "regionId": 648,
        "regionCode": null,
        "regionName": "Worodougou"
      },
      {
        "regionId": 649,
        "regionCode": null,
        "regionName": "Zanzan"
      }
    ]
  },
  {
    "countryId": 104,
    "countryCode": "JM",
    "countryName": "Jamaica",
    "regions": [
      {
        "regionId": 2026,
        "regionCode": "13",
        "regionName": "Clarendon"
      },
      {
        "regionId": 2027,
        "regionCode": "09",
        "regionName": "Hanover"
      },
      {
        "regionId": 2028,
        "regionCode": "01",
        "regionName": "Kingston"
      },
      {
        "regionId": 2029,
        "regionCode": "12",
        "regionName": "Manchester"
      },
      {
        "regionId": 2030,
        "regionCode": "04",
        "regionName": "Portland"
      },
      {
        "regionId": 2031,
        "regionCode": "02",
        "regionName": "Saint Andrew"
      },
      {
        "regionId": 2032,
        "regionCode": "06",
        "regionName": "Saint Ann"
      },
      {
        "regionId": 2033,
        "regionCode": "14",
        "regionName": "Saint Catherine"
      },
      {
        "regionId": 2034,
        "regionCode": "11",
        "regionName": "Saint Elizabeth"
      },
      {
        "regionId": 2035,
        "regionCode": "08",
        "regionName": "Saint James"
      },
      {
        "regionId": 2036,
        "regionCode": "05",
        "regionName": "Saint Mary"
      },
      {
        "regionId": 2037,
        "regionCode": "03",
        "regionName": "Saint Thomas"
      },
      {
        "regionId": 2038,
        "regionCode": "07",
        "regionName": "Trelawny"
      },
      {
        "regionId": 2039,
        "regionCode": "10",
        "regionName": "Westmoreland"
      }
    ]
  },
  {
    "countryId": 105,
    "countryCode": "JP",
    "countryName": "Japan",
    "regions": [
      {
        "regionId": 2052,
        "regionCode": "23",
        "regionName": "Aichi"
      },
      {
        "regionId": 2053,
        "regionCode": "05",
        "regionName": "Akita"
      },
      {
        "regionId": 2054,
        "regionCode": "02",
        "regionName": "Aomori"
      },
      {
        "regionId": 2055,
        "regionCode": "12",
        "regionName": "Chiba"
      },
      {
        "regionId": 2056,
        "regionCode": "38",
        "regionName": "Ehime"
      },
      {
        "regionId": 2057,
        "regionCode": "18",
        "regionName": "Fukui"
      },
      {
        "regionId": 2058,
        "regionCode": "40",
        "regionName": "Fukuoka"
      },
      {
        "regionId": 2059,
        "regionCode": "07",
        "regionName": "Fukushima"
      },
      {
        "regionId": 2060,
        "regionCode": "21",
        "regionName": "Gifu"
      },
      {
        "regionId": 2061,
        "regionCode": null,
        "regionName": "Gumma"
      },
      {
        "regionId": 2062,
        "regionCode": "34",
        "regionName": "Hiroshima"
      },
      {
        "regionId": 2063,
        "regionCode": "01",
        "regionName": "Hokkaido"
      },
      {
        "regionId": 2064,
        "regionCode": "28",
        "regionName": "Hyogo"
      },
      {
        "regionId": 2065,
        "regionCode": "08",
        "regionName": "Ibaraki"
      },
      {
        "regionId": 2066,
        "regionCode": "17",
        "regionName": "Ishikawa"
      },
      {
        "regionId": 2067,
        "regionCode": "03",
        "regionName": "Iwate"
      },
      {
        "regionId": 2068,
        "regionCode": "37",
        "regionName": "Kagawa"
      },
      {
        "regionId": 2069,
        "regionCode": "46",
        "regionName": "Kagoshima"
      },
      {
        "regionId": 2070,
        "regionCode": "14",
        "regionName": "Kanagawa"
      },
      {
        "regionId": 2071,
        "regionCode": null,
        "regionName": "Kanto"
      },
      {
        "regionId": 2072,
        "regionCode": "39",
        "regionName": "Kochi"
      },
      {
        "regionId": 2073,
        "regionCode": "43",
        "regionName": "Kumamoto"
      },
      {
        "regionId": 2074,
        "regionCode": "26",
        "regionName": "Kyoto"
      },
      {
        "regionId": 2075,
        "regionCode": "24",
        "regionName": "Mie"
      },
      {
        "regionId": 2076,
        "regionCode": "04",
        "regionName": "Miyagi"
      },
      {
        "regionId": 2077,
        "regionCode": "45",
        "regionName": "Miyazaki"
      },
      {
        "regionId": 2078,
        "regionCode": "20",
        "regionName": "Nagano"
      },
      {
        "regionId": 2079,
        "regionCode": "42",
        "regionName": "Nagasaki"
      },
      {
        "regionId": 2080,
        "regionCode": "29",
        "regionName": "Nara"
      },
      {
        "regionId": 2081,
        "regionCode": "15",
        "regionName": "Niigata"
      },
      {
        "regionId": 2082,
        "regionCode": "44",
        "regionName": "Oita"
      },
      {
        "regionId": 2083,
        "regionCode": "33",
        "regionName": "Okayama"
      },
      {
        "regionId": 2084,
        "regionCode": "47",
        "regionName": "Okinawa"
      },
      {
        "regionId": 2085,
        "regionCode": "27",
        "regionName": "Osaka"
      },
      {
        "regionId": 2086,
        "regionCode": "41",
        "regionName": "Saga"
      },
      {
        "regionId": 2087,
        "regionCode": "11",
        "regionName": "Saitama"
      },
      {
        "regionId": 2088,
        "regionCode": "25",
        "regionName": "Shiga"
      },
      {
        "regionId": 2089,
        "regionCode": "32",
        "regionName": "Shimane"
      },
      {
        "regionId": 2090,
        "regionCode": "22",
        "regionName": "Shizuoka"
      },
      {
        "regionId": 2091,
        "regionCode": "09",
        "regionName": "Tochigi"
      },
      {
        "regionId": 2092,
        "regionCode": "36",
        "regionName": "Tokushima"
      },
      {
        "regionId": 2093,
        "regionCode": "13",
        "regionName": "Tokyo"
      },
      {
        "regionId": 2094,
        "regionCode": "31",
        "regionName": "Tottori"
      },
      {
        "regionId": 2095,
        "regionCode": "16",
        "regionName": "Toyama"
      },
      {
        "regionId": 2096,
        "regionCode": "30",
        "regionName": "Wakayama"
      },
      {
        "regionId": 2097,
        "regionCode": "06",
        "regionName": "Yamagata"
      },
      {
        "regionId": 2098,
        "regionCode": "35",
        "regionName": "Yamaguchi"
      },
      {
        "regionId": 2099,
        "regionCode": "19",
        "regionName": "Yamanashi"
      }
    ]
  },
  {
    "countryId": 106,
    "countryCode": "JE",
    "countryName": "Jersey",
    "regions": []
  },
  {
    "countryId": 107,
    "countryCode": "JO",
    "countryName": "Jordan",
    "regions": [
      {
        "regionId": 2040,
        "regionCode": null,
        "regionName": "'Ajlun"
      },
      {
        "regionId": 2041,
        "regionCode": null,
        "regionName": "al-'Aqabah"
      },
      {
        "regionId": 2042,
        "regionCode": null,
        "regionName": "al-Balqa'"
      },
      {
        "regionId": 2043,
        "regionCode": null,
        "regionName": "al-Karak"
      },
      {
        "regionId": 2044,
        "regionCode": null,
        "regionName": "al-Mafraq"
      },
      {
        "regionId": 2045,
        "regionCode": null,
        "regionName": "Amman"
      },
      {
        "regionId": 2046,
        "regionCode": null,
        "regionName": "at-Tafilah"
      },
      {
        "regionId": 2047,
        "regionCode": null,
        "regionName": "az-Zarqa'"
      },
      {
        "regionId": 2048,
        "regionCode": null,
        "regionName": "Irbid"
      },
      {
        "regionId": 2049,
        "regionCode": null,
        "regionName": "Jarash"
      },
      {
        "regionId": 2050,
        "regionCode": null,
        "regionName": "Ma'an"
      },
      {
        "regionId": 2051,
        "regionCode": null,
        "regionName": "Madaba"
      }
    ]
  },
  {
    "countryId": 108,
    "countryCode": "KZ",
    "countryName": "Kazakhstan",
    "regions": [
      {
        "regionId": 2237,
        "regionCode": null,
        "regionName": "Akmecet"
      },
      {
        "regionId": 2238,
        "regionCode": null,
        "regionName": "Akmola"
      },
      {
        "regionId": 2239,
        "regionCode": null,
        "regionName": "Aktobe"
      },
      {
        "regionId": 2240,
        "regionCode": null,
        "regionName": "Almati"
      },
      {
        "regionId": 2241,
        "regionCode": null,
        "regionName": "Atirau"
      },
      {
        "regionId": 2242,
        "regionCode": null,
        "regionName": "Batis Kazakstan"
      },
      {
        "regionId": 2243,
        "regionCode": null,
        "regionName": "Burlinsky Region"
      },
      {
        "regionId": 2244,
        "regionCode": null,
        "regionName": "Karagandi"
      },
      {
        "regionId": 2245,
        "regionCode": null,
        "regionName": "Kostanay"
      },
      {
        "regionId": 2246,
        "regionCode": null,
        "regionName": "Mankistau"
      },
      {
        "regionId": 2247,
        "regionCode": null,
        "regionName": "Ontustik Kazakstan"
      },
      {
        "regionId": 2248,
        "regionCode": null,
        "regionName": "Pavlodar"
      },
      {
        "regionId": 2249,
        "regionCode": null,
        "regionName": "Sigis Kazakstan"
      },
      {
        "regionId": 2250,
        "regionCode": null,
        "regionName": "Soltustik Kazakstan"
      },
      {
        "regionId": 2251,
        "regionCode": null,
        "regionName": "Taraz"
      }
    ]
  },
  {
    "countryId": 109,
    "countryCode": "KE",
    "countryName": "Kenya",
    "regions": [
      {
        "regionId": 2100,
        "regionCode": null,
        "regionName": "Central"
      },
      {
        "regionId": 2101,
        "regionCode": null,
        "regionName": "Coast"
      },
      {
        "regionId": 2102,
        "regionCode": null,
        "regionName": "Eastern"
      },
      {
        "regionId": 2103,
        "regionCode": null,
        "regionName": "Nairobi"
      },
      {
        "regionId": 2104,
        "regionCode": null,
        "regionName": "North Eastern"
      },
      {
        "regionId": 2105,
        "regionCode": null,
        "regionName": "Nyanza"
      },
      {
        "regionId": 2106,
        "regionCode": null,
        "regionName": "Rift Valley"
      },
      {
        "regionId": 2107,
        "regionCode": null,
        "regionName": "Western"
      }
    ]
  },
  {
    "countryId": 110,
    "countryCode": "KI",
    "countryName": "Kiribati",
    "regions": [
      {
        "regionId": 2140,
        "regionCode": null,
        "regionName": "Abaiang"
      },
      {
        "regionId": 2141,
        "regionCode": null,
        "regionName": "Abemana"
      },
      {
        "regionId": 2142,
        "regionCode": null,
        "regionName": "Aranuka"
      },
      {
        "regionId": 2143,
        "regionCode": null,
        "regionName": "Arorae"
      },
      {
        "regionId": 2144,
        "regionCode": null,
        "regionName": "Banaba"
      },
      {
        "regionId": 2145,
        "regionCode": null,
        "regionName": "Beru"
      },
      {
        "regionId": 2146,
        "regionCode": null,
        "regionName": "Butaritari"
      },
      {
        "regionId": 2147,
        "regionCode": null,
        "regionName": "Kiritimati"
      },
      {
        "regionId": 2148,
        "regionCode": null,
        "regionName": "Kuria"
      },
      {
        "regionId": 2149,
        "regionCode": null,
        "regionName": "Maiana"
      },
      {
        "regionId": 2150,
        "regionCode": null,
        "regionName": "Makin"
      },
      {
        "regionId": 2151,
        "regionCode": null,
        "regionName": "Marakei"
      },
      {
        "regionId": 2152,
        "regionCode": null,
        "regionName": "Nikunau"
      },
      {
        "regionId": 2153,
        "regionCode": null,
        "regionName": "Nonouti"
      },
      {
        "regionId": 2154,
        "regionCode": null,
        "regionName": "Onotoa"
      },
      {
        "regionId": 2155,
        "regionCode": null,
        "regionName": "Phoenix Islands"
      },
      {
        "regionId": 2156,
        "regionCode": null,
        "regionName": "Tabiteuea North"
      },
      {
        "regionId": 2157,
        "regionCode": null,
        "regionName": "Tabiteuea South"
      },
      {
        "regionId": 2158,
        "regionCode": null,
        "regionName": "Tabuaeran"
      },
      {
        "regionId": 2159,
        "regionCode": null,
        "regionName": "Tamana"
      },
      {
        "regionId": 2160,
        "regionCode": null,
        "regionName": "Tarawa North"
      },
      {
        "regionId": 2161,
        "regionCode": null,
        "regionName": "Tarawa South"
      },
      {
        "regionId": 2162,
        "regionCode": null,
        "regionName": "Teraina"
      }
    ]
  },
  {
    "countryId": 111,
    "countryCode": "KR",
    "countryName": "Korea, Republic of",
    "regions": [
      {
        "regionId": 2192,
        "regionCode": "26",
        "regionName": "Busan"
      },
      {
        "regionId": 2193,
        "regionCode": null,
        "regionName": "Cheju"
      },
      {
        "regionId": 2194,
        "regionCode": null,
        "regionName": "Chollabuk"
      },
      {
        "regionId": 2195,
        "regionCode": null,
        "regionName": "Chollanam"
      },
      {
        "regionId": 2196,
        "regionCode": null,
        "regionName": "Chungbuk"
      },
      {
        "regionId": 2197,
        "regionCode": null,
        "regionName": "Chungcheongbuk"
      },
      {
        "regionId": 2198,
        "regionCode": null,
        "regionName": "Chungcheongnam"
      },
      {
        "regionId": 2199,
        "regionCode": null,
        "regionName": "Chungnam"
      },
      {
        "regionId": 2200,
        "regionCode": "27",
        "regionName": "Daegu"
      },
      {
        "regionId": 2201,
        "regionCode": "42",
        "regionName": "Gangwon-do"
      },
      {
        "regionId": 2202,
        "regionCode": null,
        "regionName": "Goyang-si"
      },
      {
        "regionId": 2203,
        "regionCode": null,
        "regionName": "gwangyoksi"
      },
      {
        "regionId": 2204,
        "regionCode": "41",
        "regionName": "Gyeonggi-do"
      },
      {
        "regionId": 2205,
        "regionCode": null,
        "regionName": "Gyeongsang"
      },
      {
        "regionId": 2206,
        "regionCode": "48",
        "regionName": "Gyeongsangnam-do"
      },
      {
        "regionId": 2207,
        "regionCode": "28",
        "regionName": "Incheon"
      },
      {
        "regionId": 2208,
        "regionCode": null,
        "regionName": "Jeju-Si"
      },
      {
        "regionId": 2209,
        "regionCode": null,
        "regionName": "Jeonbuk"
      },
      {
        "regionId": 2210,
        "regionCode": null,
        "regionName": "Kangweon"
      },
      {
        "regionId": 2211,
        "regionCode": null,
        "regionName": "Kwangju"
      },
      {
        "regionId": 2212,
        "regionCode": null,
        "regionName": "Kyeonggi"
      },
      {
        "regionId": 2213,
        "regionCode": null,
        "regionName": "Kyeongsangbuk"
      },
      {
        "regionId": 2214,
        "regionCode": null,
        "regionName": "Kyeongsangnam"
      },
      {
        "regionId": 2215,
        "regionCode": "09",
        "regionName": "Kyonggi-do"
      },
      {
        "regionId": 2216,
        "regionCode": null,
        "regionName": "Kyungbuk-do"
      },
      {
        "regionId": 2217,
        "regionCode": null,
        "regionName": "Kyunggi-do"
      },
      {
        "regionId": 2218,
        "regionCode": null,
        "regionName": "Pusan"
      },
      {
        "regionId": 2219,
        "regionCode": "11",
        "regionName": "Seoul"
      },
      {
        "regionId": 2220,
        "regionCode": null,
        "regionName": "Sudogwon"
      },
      {
        "regionId": 2221,
        "regionCode": null,
        "regionName": "Taegu"
      },
      {
        "regionId": 2222,
        "regionCode": null,
        "regionName": "Taejeon"
      },
      {
        "regionId": 2223,
        "regionCode": null,
        "regionName": "Taejon-gwangyoksi"
      },
      {
        "regionId": 2224,
        "regionCode": "31",
        "regionName": "Ulsan"
      },
      {
        "regionId": 2225,
        "regionCode": null,
        "regionName": "Wonju"
      }
    ]
  },
  {
    "countryId": 112,
    "countryCode": "CS",
    "countryName": "Kosovo",
    "regions": []
  },
  {
    "countryId": 113,
    "countryCode": "KW",
    "countryName": "Kuwait",
    "regions": [
      {
        "regionId": 2226,
        "regionCode": null,
        "regionName": "Al Asimah"
      },
      {
        "regionId": 2227,
        "regionCode": null,
        "regionName": "al-Ahmadi"
      },
      {
        "regionId": 2228,
        "regionCode": null,
        "regionName": "al-Farwaniyah"
      },
      {
        "regionId": 2229,
        "regionCode": null,
        "regionName": "al-Jahra"
      },
      {
        "regionId": 2230,
        "regionCode": null,
        "regionName": "al-Kuwayt"
      },
      {
        "regionId": 2231,
        "regionCode": null,
        "regionName": "Hawalli"
      },
      {
        "regionId": 2232,
        "regionCode": null,
        "regionName": "Mishref"
      },
      {
        "regionId": 2233,
        "regionCode": null,
        "regionName": "Qadesiya"
      },
      {
        "regionId": 2234,
        "regionCode": null,
        "regionName": "Safat"
      },
      {
        "regionId": 2235,
        "regionCode": null,
        "regionName": "Salmiya"
      }
    ]
  },
  {
    "countryId": 114,
    "countryCode": "KG",
    "countryName": "Kyrgyzstan",
    "regions": [
      {
        "regionId": 2108,
        "regionCode": null,
        "regionName": "Batken"
      },
      {
        "regionId": 2109,
        "regionCode": null,
        "regionName": "Bishkek"
      },
      {
        "regionId": 2110,
        "regionCode": null,
        "regionName": "Chui"
      },
      {
        "regionId": 2111,
        "regionCode": null,
        "regionName": "Issyk-Kul"
      },
      {
        "regionId": 2112,
        "regionCode": null,
        "regionName": "Jalal-Abad"
      },
      {
        "regionId": 2113,
        "regionCode": null,
        "regionName": "Naryn"
      },
      {
        "regionId": 2114,
        "regionCode": null,
        "regionName": "Osh"
      },
      {
        "regionId": 2115,
        "regionCode": null,
        "regionName": "Talas"
      }
    ]
  },
  {
    "countryId": 115,
    "countryCode": "LA",
    "countryName": "Lao People's Democratic Republic",
    "regions": [
      {
        "regionId": 2252,
        "regionCode": null,
        "regionName": "Attopu"
      },
      {
        "regionId": 2253,
        "regionCode": null,
        "regionName": "Bokeo"
      },
      {
        "regionId": 2254,
        "regionCode": null,
        "regionName": "Bolikhamsay"
      },
      {
        "regionId": 2255,
        "regionCode": null,
        "regionName": "Champasak"
      },
      {
        "regionId": 2256,
        "regionCode": null,
        "regionName": "Houaphanh"
      },
      {
        "regionId": 2257,
        "regionCode": null,
        "regionName": "Khammouane"
      },
      {
        "regionId": 2258,
        "regionCode": null,
        "regionName": "Luang Nam Tha"
      },
      {
        "regionId": 2259,
        "regionCode": null,
        "regionName": "Luang Prabang"
      },
      {
        "regionId": 2260,
        "regionCode": null,
        "regionName": "Oudomxay"
      },
      {
        "regionId": 2261,
        "regionCode": null,
        "regionName": "Phongsaly"
      },
      {
        "regionId": 2262,
        "regionCode": null,
        "regionName": "Saravan"
      },
      {
        "regionId": 2263,
        "regionCode": null,
        "regionName": "Savannakhet"
      },
      {
        "regionId": 2264,
        "regionCode": null,
        "regionName": "Sekong"
      },
      {
        "regionId": 2265,
        "regionCode": null,
        "regionName": "Viangchan Prefecture"
      },
      {
        "regionId": 2266,
        "regionCode": null,
        "regionName": "Viangchan Province"
      },
      {
        "regionId": 2267,
        "regionCode": null,
        "regionName": "Xaignabury"
      },
      {
        "regionId": 2268,
        "regionCode": null,
        "regionName": "Xiang Khuang"
      }
    ]
  },
  {
    "countryId": 116,
    "countryCode": "LV",
    "countryName": "Latvia",
    "regions": [
      {
        "regionId": 2379,
        "regionCode": null,
        "regionName": "Aizkraukles"
      },
      {
        "regionId": 2380,
        "regionCode": null,
        "regionName": "Aluksnes"
      },
      {
        "regionId": 2381,
        "regionCode": null,
        "regionName": "Balvu"
      },
      {
        "regionId": 2382,
        "regionCode": null,
        "regionName": "Bauskas"
      },
      {
        "regionId": 2383,
        "regionCode": null,
        "regionName": "Cesu"
      },
      {
        "regionId": 2384,
        "regionCode": null,
        "regionName": "Daugavpils"
      },
      {
        "regionId": 2385,
        "regionCode": null,
        "regionName": "Daugavpils City"
      },
      {
        "regionId": 2386,
        "regionCode": null,
        "regionName": "Dobeles"
      },
      {
        "regionId": 2387,
        "regionCode": null,
        "regionName": "Gulbenes"
      },
      {
        "regionId": 2388,
        "regionCode": null,
        "regionName": "Jekabspils"
      },
      {
        "regionId": 2389,
        "regionCode": null,
        "regionName": "Jelgava"
      },
      {
        "regionId": 2390,
        "regionCode": null,
        "regionName": "Jelgavas"
      },
      {
        "regionId": 2391,
        "regionCode": null,
        "regionName": "Jurmala City"
      },
      {
        "regionId": 2392,
        "regionCode": null,
        "regionName": "Kraslavas"
      },
      {
        "regionId": 2393,
        "regionCode": null,
        "regionName": "Kuldigas"
      },
      {
        "regionId": 2394,
        "regionCode": null,
        "regionName": "Liepaja"
      },
      {
        "regionId": 2395,
        "regionCode": null,
        "regionName": "Liepajas"
      },
      {
        "regionId": 2396,
        "regionCode": null,
        "regionName": "Limbazhu"
      },
      {
        "regionId": 2397,
        "regionCode": null,
        "regionName": "Ludzas"
      },
      {
        "regionId": 2398,
        "regionCode": null,
        "regionName": "Madonas"
      },
      {
        "regionId": 2399,
        "regionCode": null,
        "regionName": "Ogres"
      },
      {
        "regionId": 2400,
        "regionCode": null,
        "regionName": "Preilu"
      },
      {
        "regionId": 2401,
        "regionCode": null,
        "regionName": "Rezekne"
      },
      {
        "regionId": 2402,
        "regionCode": null,
        "regionName": "Rezeknes"
      },
      {
        "regionId": 2403,
        "regionCode": null,
        "regionName": "Riga"
      },
      {
        "regionId": 2404,
        "regionCode": null,
        "regionName": "Rigas"
      },
      {
        "regionId": 2405,
        "regionCode": null,
        "regionName": "Saldus"
      },
      {
        "regionId": 2406,
        "regionCode": null,
        "regionName": "Talsu"
      },
      {
        "regionId": 2407,
        "regionCode": null,
        "regionName": "Tukuma"
      },
      {
        "regionId": 2408,
        "regionCode": null,
        "regionName": "Valkas"
      },
      {
        "regionId": 2409,
        "regionCode": null,
        "regionName": "Valmieras"
      },
      {
        "regionId": 2410,
        "regionCode": null,
        "regionName": "Ventspils"
      },
      {
        "regionId": 2411,
        "regionCode": null,
        "regionName": "Ventspils City"
      }
    ]
  },
  {
    "countryId": 117,
    "countryCode": "LB",
    "countryName": "Lebanon",
    "regions": [
      {
        "regionId": 2269,
        "regionCode": null,
        "regionName": "al-Biqa"
      },
      {
        "regionId": 2270,
        "regionCode": null,
        "regionName": "al-Janub"
      },
      {
        "regionId": 2271,
        "regionCode": null,
        "regionName": "an-Nabatiyah"
      },
      {
        "regionId": 2272,
        "regionCode": null,
        "regionName": "ash-Shamal"
      },
      {
        "regionId": 2273,
        "regionCode": null,
        "regionName": "Beirut"
      },
      {
        "regionId": 2274,
        "regionCode": null,
        "regionName": "Jabal Lubnan"
      },
      {
        "regionId": 2275,
        "regionCode": null,
        "regionName": "Mohafazat Liban-Nord"
      },
      {
        "regionId": 2276,
        "regionCode": null,
        "regionName": "Mohafazat Mont-Liban"
      },
      {
        "regionId": 2277,
        "regionCode": null,
        "regionName": "Sidon"
      }
    ]
  },
  {
    "countryId": 118,
    "countryCode": "LS",
    "countryName": "Lesotho",
    "regions": [
      {
        "regionId": 2344,
        "regionCode": null,
        "regionName": "Berea"
      },
      {
        "regionId": 2345,
        "regionCode": null,
        "regionName": "Butha-Buthe"
      },
      {
        "regionId": 2346,
        "regionCode": null,
        "regionName": "Leribe"
      },
      {
        "regionId": 2347,
        "regionCode": null,
        "regionName": "Mafeteng"
      },
      {
        "regionId": 2348,
        "regionCode": null,
        "regionName": "Maseru"
      },
      {
        "regionId": 2349,
        "regionCode": null,
        "regionName": "Mohale's Hoek"
      },
      {
        "regionId": 2350,
        "regionCode": null,
        "regionName": "Mokhotlong"
      },
      {
        "regionId": 2351,
        "regionCode": null,
        "regionName": "Qacha's Nek"
      },
      {
        "regionId": 2352,
        "regionCode": null,
        "regionName": "Quthing"
      },
      {
        "regionId": 2353,
        "regionCode": null,
        "regionName": "Thaba-Tseka"
      }
    ]
  },
  {
    "countryId": 119,
    "countryCode": "LR",
    "countryName": "Liberia",
    "regions": [
      {
        "regionId": 2332,
        "regionCode": null,
        "regionName": "Bomi"
      },
      {
        "regionId": 2333,
        "regionCode": null,
        "regionName": "Bong"
      },
      {
        "regionId": 2334,
        "regionCode": null,
        "regionName": "Grand Bassa"
      },
      {
        "regionId": 2335,
        "regionCode": null,
        "regionName": "Grand Cape Mount"
      },
      {
        "regionId": 2336,
        "regionCode": null,
        "regionName": "Grand Gedeh"
      },
      {
        "regionId": 2337,
        "regionCode": null,
        "regionName": "Loffa"
      },
      {
        "regionId": 2338,
        "regionCode": null,
        "regionName": "Margibi"
      },
      {
        "regionId": 2339,
        "regionCode": null,
        "regionName": "Maryland and Grand Kru"
      },
      {
        "regionId": 2340,
        "regionCode": null,
        "regionName": "Montserrado"
      },
      {
        "regionId": 2341,
        "regionCode": null,
        "regionName": "Nimba"
      },
      {
        "regionId": 2342,
        "regionCode": null,
        "regionName": "Rivercess"
      },
      {
        "regionId": 2343,
        "regionCode": null,
        "regionName": "Sinoe"
      }
    ]
  },
  {
    "countryId": 120,
    "countryCode": "LY",
    "countryName": "Libya",
    "regions": [
      {
        "regionId": 2412,
        "regionCode": null,
        "regionName": "Ajdabiya"
      },
      {
        "regionId": 2413,
        "regionCode": null,
        "regionName": "al-'Aziziyah"
      },
      {
        "regionId": 2414,
        "regionCode": null,
        "regionName": "al-Fatih"
      },
      {
        "regionId": 2415,
        "regionCode": null,
        "regionName": "al-Jabal al Akhdar"
      },
      {
        "regionId": 2416,
        "regionCode": null,
        "regionName": "al-Jufrah"
      },
      {
        "regionId": 2417,
        "regionCode": null,
        "regionName": "al-Khums"
      },
      {
        "regionId": 2418,
        "regionCode": null,
        "regionName": "al-Kufrah"
      },
      {
        "regionId": 2419,
        "regionCode": null,
        "regionName": "an-Nuqat al-Khams"
      },
      {
        "regionId": 2420,
        "regionCode": null,
        "regionName": "ash-Shati'"
      },
      {
        "regionId": 2421,
        "regionCode": null,
        "regionName": "az-Zawiyah"
      },
      {
        "regionId": 2422,
        "regionCode": null,
        "regionName": "Banghazi"
      },
      {
        "regionId": 2423,
        "regionCode": null,
        "regionName": "Darnah"
      },
      {
        "regionId": 2424,
        "regionCode": null,
        "regionName": "Ghadamis"
      },
      {
        "regionId": 2425,
        "regionCode": null,
        "regionName": "Gharyan"
      },
      {
        "regionId": 2426,
        "regionCode": null,
        "regionName": "Misratah"
      },
      {
        "regionId": 2427,
        "regionCode": null,
        "regionName": "Murzuq"
      },
      {
        "regionId": 2428,
        "regionCode": null,
        "regionName": "Sabha"
      },
      {
        "regionId": 2429,
        "regionCode": null,
        "regionName": "Sawfajjin"
      },
      {
        "regionId": 2430,
        "regionCode": null,
        "regionName": "Surt"
      },
      {
        "regionId": 2431,
        "regionCode": null,
        "regionName": "Tarabulus"
      },
      {
        "regionId": 2432,
        "regionCode": null,
        "regionName": "Tarhunah"
      },
      {
        "regionId": 2433,
        "regionCode": null,
        "regionName": "Tripolitania"
      },
      {
        "regionId": 2434,
        "regionCode": null,
        "regionName": "Tubruq"
      },
      {
        "regionId": 2435,
        "regionCode": null,
        "regionName": "Yafran"
      },
      {
        "regionId": 2436,
        "regionCode": null,
        "regionName": "Zlitan"
      }
    ]
  },
  {
    "countryId": 121,
    "countryCode": "LI",
    "countryName": "Liechtenstein",
    "regions": [
      {
        "regionId": 2288,
        "regionCode": null,
        "regionName": "Balzers"
      },
      {
        "regionId": 2289,
        "regionCode": null,
        "regionName": "Eschen"
      },
      {
        "regionId": 2290,
        "regionCode": null,
        "regionName": "Gamprin"
      },
      {
        "regionId": 2291,
        "regionCode": null,
        "regionName": "Mauren"
      },
      {
        "regionId": 2292,
        "regionCode": null,
        "regionName": "Planken"
      },
      {
        "regionId": 2293,
        "regionCode": null,
        "regionName": "Ruggell"
      },
      {
        "regionId": 2294,
        "regionCode": null,
        "regionName": "Schaan"
      },
      {
        "regionId": 2295,
        "regionCode": null,
        "regionName": "Schellenberg"
      },
      {
        "regionId": 2296,
        "regionCode": null,
        "regionName": "Triesen"
      },
      {
        "regionId": 2297,
        "regionCode": null,
        "regionName": "Triesenberg"
      },
      {
        "regionId": 2298,
        "regionCode": null,
        "regionName": "Vaduz"
      }
    ]
  },
  {
    "countryId": 122,
    "countryCode": "LT",
    "countryName": "Lithuania",
    "regions": [
      {
        "regionId": 2354,
        "regionCode": null,
        "regionName": "Alytaus"
      },
      {
        "regionId": 2355,
        "regionCode": null,
        "regionName": "Anyksciai"
      },
      {
        "regionId": 2356,
        "regionCode": null,
        "regionName": "Kauno"
      },
      {
        "regionId": 2357,
        "regionCode": null,
        "regionName": "Klaipedos"
      },
      {
        "regionId": 2358,
        "regionCode": null,
        "regionName": "Marijampoles"
      },
      {
        "regionId": 2359,
        "regionCode": null,
        "regionName": "Panevezhio"
      },
      {
        "regionId": 2360,
        "regionCode": null,
        "regionName": "Panevezys"
      },
      {
        "regionId": 2361,
        "regionCode": null,
        "regionName": "Shiauliu"
      },
      {
        "regionId": 2362,
        "regionCode": null,
        "regionName": "Taurages"
      },
      {
        "regionId": 2363,
        "regionCode": null,
        "regionName": "Telshiu"
      },
      {
        "regionId": 2364,
        "regionCode": null,
        "regionName": "Telsiai"
      },
      {
        "regionId": 2365,
        "regionCode": null,
        "regionName": "Utenos"
      },
      {
        "regionId": 2366,
        "regionCode": null,
        "regionName": "Vilniaus"
      }
    ]
  },
  {
    "countryId": 123,
    "countryCode": "LU",
    "countryName": "Luxembourg",
    "regions": [
      {
        "regionId": 2367,
        "regionCode": null,
        "regionName": "Capellen"
      },
      {
        "regionId": 2368,
        "regionCode": null,
        "regionName": "Clervaux"
      },
      {
        "regionId": 2369,
        "regionCode": null,
        "regionName": "Diekirch"
      },
      {
        "regionId": 2370,
        "regionCode": null,
        "regionName": "Echternach"
      },
      {
        "regionId": 2371,
        "regionCode": null,
        "regionName": "Esch-sur-Alzette"
      },
      {
        "regionId": 2372,
        "regionCode": null,
        "regionName": "Grevenmacher"
      },
      {
        "regionId": 2373,
        "regionCode": null,
        "regionName": "Luxembourg"
      },
      {
        "regionId": 2374,
        "regionCode": null,
        "regionName": "Mersch"
      },
      {
        "regionId": 2375,
        "regionCode": null,
        "regionName": "Redange"
      },
      {
        "regionId": 2376,
        "regionCode": null,
        "regionName": "Remich"
      },
      {
        "regionId": 2377,
        "regionCode": null,
        "regionName": "Vianden"
      },
      {
        "regionId": 2378,
        "regionCode": null,
        "regionName": "Wiltz"
      }
    ]
  },
  {
    "countryId": 124,
    "countryCode": "MO",
    "countryName": "Macau",
    "regions": [
      {
        "regionId": 2583,
        "regionCode": null,
        "regionName": "Macau"
      }
    ]
  },
  {
    "countryId": 125,
    "countryCode": "MK",
    "countryName": "Macedonia, Republic of",
    "regions": [
      {
        "regionId": 2507,
        "regionCode": null,
        "regionName": "Berovo"
      },
      {
        "regionId": 2508,
        "regionCode": null,
        "regionName": "Bitola"
      },
      {
        "regionId": 2509,
        "regionCode": null,
        "regionName": "Brod"
      },
      {
        "regionId": 2510,
        "regionCode": null,
        "regionName": "Debar"
      },
      {
        "regionId": 2511,
        "regionCode": null,
        "regionName": "Delchevo"
      },
      {
        "regionId": 2512,
        "regionCode": null,
        "regionName": "Demir Hisar"
      },
      {
        "regionId": 2513,
        "regionCode": null,
        "regionName": "Gevgelija"
      },
      {
        "regionId": 2514,
        "regionCode": null,
        "regionName": "Gostivar"
      },
      {
        "regionId": 2515,
        "regionCode": null,
        "regionName": "Kavadarci"
      },
      {
        "regionId": 2516,
        "regionCode": null,
        "regionName": "Kichevo"
      },
      {
        "regionId": 2517,
        "regionCode": null,
        "regionName": "Kochani"
      },
      {
        "regionId": 2518,
        "regionCode": null,
        "regionName": "Kratovo"
      },
      {
        "regionId": 2519,
        "regionCode": null,
        "regionName": "Kriva Palanka"
      },
      {
        "regionId": 2520,
        "regionCode": null,
        "regionName": "Krushevo"
      },
      {
        "regionId": 2521,
        "regionCode": null,
        "regionName": "Kumanovo"
      },
      {
        "regionId": 2522,
        "regionCode": null,
        "regionName": "Negotino"
      },
      {
        "regionId": 2523,
        "regionCode": null,
        "regionName": "Ohrid"
      },
      {
        "regionId": 2524,
        "regionCode": null,
        "regionName": "Prilep"
      },
      {
        "regionId": 2525,
        "regionCode": null,
        "regionName": "Probishtip"
      },
      {
        "regionId": 2526,
        "regionCode": null,
        "regionName": "Radovish"
      },
      {
        "regionId": 2527,
        "regionCode": null,
        "regionName": "Resen"
      },
      {
        "regionId": 2528,
        "regionCode": null,
        "regionName": "Shtip"
      },
      {
        "regionId": 2529,
        "regionCode": null,
        "regionName": "Skopje"
      },
      {
        "regionId": 2530,
        "regionCode": null,
        "regionName": "Struga"
      },
      {
        "regionId": 2531,
        "regionCode": null,
        "regionName": "Strumica"
      },
      {
        "regionId": 2532,
        "regionCode": null,
        "regionName": "Sveti Nikole"
      },
      {
        "regionId": 2533,
        "regionCode": null,
        "regionName": "Tetovo"
      },
      {
        "regionId": 2534,
        "regionCode": null,
        "regionName": "Valandovo"
      },
      {
        "regionId": 2535,
        "regionCode": null,
        "regionName": "Veles"
      },
      {
        "regionId": 2536,
        "regionCode": null,
        "regionName": "Vinica"
      }
    ]
  },
  {
    "countryId": 126,
    "countryCode": "MG",
    "countryName": "Madagascar",
    "regions": [
      {
        "regionId": 2476,
        "regionCode": null,
        "regionName": "Antananarivo"
      },
      {
        "regionId": 2477,
        "regionCode": null,
        "regionName": "Antsiranana"
      },
      {
        "regionId": 2478,
        "regionCode": null,
        "regionName": "Fianarantsoa"
      },
      {
        "regionId": 2479,
        "regionCode": null,
        "regionName": "Mahajanga"
      },
      {
        "regionId": 2480,
        "regionCode": null,
        "regionName": "Toamasina"
      },
      {
        "regionId": 2481,
        "regionCode": null,
        "regionName": "Toliary"
      }
    ]
  },
  {
    "countryId": 127,
    "countryCode": "MW",
    "countryName": "Malawi",
    "regions": [
      {
        "regionId": 2643,
        "regionCode": null,
        "regionName": "Balaka"
      },
      {
        "regionId": 2644,
        "regionCode": null,
        "regionName": "Blantyre City"
      },
      {
        "regionId": 2645,
        "regionCode": null,
        "regionName": "Chikwawa"
      },
      {
        "regionId": 2646,
        "regionCode": null,
        "regionName": "Chiradzulu"
      },
      {
        "regionId": 2647,
        "regionCode": null,
        "regionName": "Chitipa"
      },
      {
        "regionId": 2648,
        "regionCode": null,
        "regionName": "Dedza"
      },
      {
        "regionId": 2649,
        "regionCode": null,
        "regionName": "Dowa"
      },
      {
        "regionId": 2650,
        "regionCode": null,
        "regionName": "Karonga"
      },
      {
        "regionId": 2651,
        "regionCode": null,
        "regionName": "Kasungu"
      },
      {
        "regionId": 2652,
        "regionCode": null,
        "regionName": "Lilongwe City"
      },
      {
        "regionId": 2653,
        "regionCode": null,
        "regionName": "Machinga"
      },
      {
        "regionId": 2654,
        "regionCode": null,
        "regionName": "Mangochi"
      },
      {
        "regionId": 2655,
        "regionCode": null,
        "regionName": "Mchinji"
      },
      {
        "regionId": 2656,
        "regionCode": null,
        "regionName": "Mulanje"
      },
      {
        "regionId": 2657,
        "regionCode": null,
        "regionName": "Mwanza"
      },
      {
        "regionId": 2658,
        "regionCode": null,
        "regionName": "Mzimba"
      },
      {
        "regionId": 2659,
        "regionCode": null,
        "regionName": "Mzuzu City"
      },
      {
        "regionId": 2660,
        "regionCode": null,
        "regionName": "Nkhata Bay"
      },
      {
        "regionId": 2661,
        "regionCode": null,
        "regionName": "Nkhotakota"
      },
      {
        "regionId": 2662,
        "regionCode": null,
        "regionName": "Nsanje"
      },
      {
        "regionId": 2663,
        "regionCode": null,
        "regionName": "Ntcheu"
      },
      {
        "regionId": 2664,
        "regionCode": null,
        "regionName": "Ntchisi"
      },
      {
        "regionId": 2665,
        "regionCode": null,
        "regionName": "Phalombe"
      },
      {
        "regionId": 2666,
        "regionCode": null,
        "regionName": "Rumphi"
      },
      {
        "regionId": 2667,
        "regionCode": null,
        "regionName": "Salima"
      },
      {
        "regionId": 2668,
        "regionCode": null,
        "regionName": "Thyolo"
      },
      {
        "regionId": 2669,
        "regionCode": null,
        "regionName": "Zomba Municipality"
      }
    ]
  },
  {
    "countryId": 128,
    "countryCode": "MY",
    "countryName": "Malaysia",
    "regions": [
      {
        "regionId": 2703,
        "regionCode": "JOH",
        "regionName": "Johor"
      },
      {
        "regionId": 2704,
        "regionCode": "KED",
        "regionName": "Kedah"
      },
      {
        "regionId": 2705,
        "regionCode": "KEL",
        "regionName": "Kelantan"
      },
      {
        "regionId": 2706,
        "regionCode": "KUL",
        "regionName": "Kuala Lumpur"
      },
      {
        "regionId": 2707,
        "regionCode": "LAB",
        "regionName": "Labuan"
      },
      {
        "regionId": 2708,
        "regionCode": "MEL",
        "regionName": "Melaka"
      },
      {
        "regionId": 2709,
        "regionCode": null,
        "regionName": "Negeri Johor"
      },
      {
        "regionId": 2710,
        "regionCode": "SER",
        "regionName": "Negeri Sembilan"
      },
      {
        "regionId": 2711,
        "regionCode": "PAH",
        "regionName": "Pahang"
      },
      {
        "regionId": 2712,
        "regionCode": null,
        "regionName": "Penang"
      },
      {
        "regionId": 2713,
        "regionCode": "PER",
        "regionName": "Perak"
      },
      {
        "regionId": 2714,
        "regionCode": "PEL",
        "regionName": "Perlis"
      },
      {
        "regionId": 2715,
        "regionCode": "PIN",
        "regionName": "Pulau Pinang"
      },
      {
        "regionId": 2716,
        "regionCode": "SAB",
        "regionName": "Sabah"
      },
      {
        "regionId": 2717,
        "regionCode": "SAR",
        "regionName": "Sarawak"
      },
      {
        "regionId": 2718,
        "regionCode": "SEL",
        "regionName": "Selangor"
      },
      {
        "regionId": 2719,
        "regionCode": null,
        "regionName": "Sembilan"
      },
      {
        "regionId": 2720,
        "regionCode": "11",
        "regionName": "Terengganu"
      }
    ]
  },
  {
    "countryId": 129,
    "countryCode": "MV",
    "countryName": "Maldives",
    "regions": [
      {
        "regionId": 2622,
        "regionCode": null,
        "regionName": "Alif Alif"
      },
      {
        "regionId": 2623,
        "regionCode": null,
        "regionName": "Alif Dhaal"
      },
      {
        "regionId": 2624,
        "regionCode": null,
        "regionName": "Baa"
      },
      {
        "regionId": 2625,
        "regionCode": null,
        "regionName": "Dhaal"
      },
      {
        "regionId": 2626,
        "regionCode": null,
        "regionName": "Faaf"
      },
      {
        "regionId": 2627,
        "regionCode": null,
        "regionName": "Gaaf Alif"
      },
      {
        "regionId": 2628,
        "regionCode": null,
        "regionName": "Gaaf Dhaal"
      },
      {
        "regionId": 2629,
        "regionCode": null,
        "regionName": "Ghaviyani"
      },
      {
        "regionId": 2630,
        "regionCode": null,
        "regionName": "Haa Alif"
      },
      {
        "regionId": 2631,
        "regionCode": null,
        "regionName": "Haa Dhaal"
      },
      {
        "regionId": 2632,
        "regionCode": null,
        "regionName": "Kaaf"
      },
      {
        "regionId": 2633,
        "regionCode": null,
        "regionName": "Laam"
      },
      {
        "regionId": 2634,
        "regionCode": null,
        "regionName": "Lhaviyani"
      },
      {
        "regionId": 2635,
        "regionCode": null,
        "regionName": "Male"
      },
      {
        "regionId": 2636,
        "regionCode": null,
        "regionName": "Miim"
      },
      {
        "regionId": 2637,
        "regionCode": null,
        "regionName": "Nuun"
      },
      {
        "regionId": 2638,
        "regionCode": null,
        "regionName": "Raa"
      },
      {
        "regionId": 2639,
        "regionCode": null,
        "regionName": "Shaviyani"
      },
      {
        "regionId": 2640,
        "regionCode": null,
        "regionName": "Siin"
      },
      {
        "regionId": 2641,
        "regionCode": null,
        "regionName": "Thaa"
      },
      {
        "regionId": 2642,
        "regionCode": null,
        "regionName": "Vaav"
      }
    ]
  },
  {
    "countryId": 130,
    "countryCode": "ML",
    "countryName": "Mali",
    "regions": [
      {
        "regionId": 2537,
        "regionCode": null,
        "regionName": "Bamako"
      },
      {
        "regionId": 2538,
        "regionCode": null,
        "regionName": "Gao"
      },
      {
        "regionId": 2539,
        "regionCode": null,
        "regionName": "Kayes"
      },
      {
        "regionId": 2540,
        "regionCode": null,
        "regionName": "Kidal"
      },
      {
        "regionId": 2541,
        "regionCode": null,
        "regionName": "Koulikoro"
      },
      {
        "regionId": 2542,
        "regionCode": null,
        "regionName": "Mopti"
      },
      {
        "regionId": 2543,
        "regionCode": null,
        "regionName": "Segou"
      },
      {
        "regionId": 2544,
        "regionCode": null,
        "regionName": "Sikasso"
      },
      {
        "regionId": 2545,
        "regionCode": null,
        "regionName": "Tombouctou"
      }
    ]
  },
  {
    "countryId": 131,
    "countryCode": "MT",
    "countryName": "Malta",
    "regions": [
      {
        "regionId": 2602,
        "regionCode": null,
        "regionName": "Gozo and Comino"
      },
      {
        "regionId": 2603,
        "regionCode": null,
        "regionName": "Inner Harbour"
      },
      {
        "regionId": 2604,
        "regionCode": null,
        "regionName": "Northern"
      },
      {
        "regionId": 2605,
        "regionCode": null,
        "regionName": "Outer Harbour"
      },
      {
        "regionId": 2606,
        "regionCode": null,
        "regionName": "South Eastern"
      },
      {
        "regionId": 2607,
        "regionCode": null,
        "regionName": "Valletta"
      },
      {
        "regionId": 2608,
        "regionCode": null,
        "regionName": "Western"
      }
    ]
  },
  {
    "countryId": 132,
    "countryCode": "MH",
    "countryName": "Marshall Islands",
    "regions": [
      {
        "regionId": 2482,
        "regionCode": null,
        "regionName": "Ailinlaplap"
      },
      {
        "regionId": 2483,
        "regionCode": null,
        "regionName": "Ailuk"
      },
      {
        "regionId": 2484,
        "regionCode": null,
        "regionName": "Arno"
      },
      {
        "regionId": 2485,
        "regionCode": null,
        "regionName": "Aur"
      },
      {
        "regionId": 2486,
        "regionCode": null,
        "regionName": "Bikini"
      },
      {
        "regionId": 2487,
        "regionCode": null,
        "regionName": "Ebon"
      },
      {
        "regionId": 2488,
        "regionCode": null,
        "regionName": "Enewetak"
      },
      {
        "regionId": 2489,
        "regionCode": null,
        "regionName": "Jabat"
      },
      {
        "regionId": 2490,
        "regionCode": null,
        "regionName": "Jaluit"
      },
      {
        "regionId": 2491,
        "regionCode": null,
        "regionName": "Kili"
      },
      {
        "regionId": 2492,
        "regionCode": null,
        "regionName": "Kwajalein"
      },
      {
        "regionId": 2493,
        "regionCode": null,
        "regionName": "Lae"
      },
      {
        "regionId": 2494,
        "regionCode": null,
        "regionName": "Lib"
      },
      {
        "regionId": 2495,
        "regionCode": null,
        "regionName": "Likiep"
      },
      {
        "regionId": 2496,
        "regionCode": null,
        "regionName": "Majuro"
      },
      {
        "regionId": 2497,
        "regionCode": null,
        "regionName": "Maloelap"
      },
      {
        "regionId": 2498,
        "regionCode": null,
        "regionName": "Mejit"
      },
      {
        "regionId": 2499,
        "regionCode": null,
        "regionName": "Mili"
      },
      {
        "regionId": 2500,
        "regionCode": null,
        "regionName": "Namorik"
      },
      {
        "regionId": 2501,
        "regionCode": null,
        "regionName": "Namu"
      },
      {
        "regionId": 2502,
        "regionCode": null,
        "regionName": "Rongelap"
      },
      {
        "regionId": 2503,
        "regionCode": null,
        "regionName": "Ujae"
      },
      {
        "regionId": 2504,
        "regionCode": null,
        "regionName": "Utrik"
      },
      {
        "regionId": 2505,
        "regionCode": null,
        "regionName": "Wotho"
      },
      {
        "regionId": 2506,
        "regionCode": null,
        "regionName": "Wotje"
      }
    ]
  },
  {
    "countryId": 133,
    "countryCode": "MQ",
    "countryName": "Martinique",
    "regions": [
      {
        "regionId": 2584,
        "regionCode": null,
        "regionName": "Fort-de-France"
      },
      {
        "regionId": 2585,
        "regionCode": null,
        "regionName": "La Trinite"
      },
      {
        "regionId": 2586,
        "regionCode": null,
        "regionName": "Le Marin"
      },
      {
        "regionId": 2587,
        "regionCode": null,
        "regionName": "Saint-Pierre"
      }
    ]
  },
  {
    "countryId": 134,
    "countryCode": "MR",
    "countryName": "Mauritania",
    "regions": [
      {
        "regionId": 2588,
        "regionCode": null,
        "regionName": "Adrar"
      },
      {
        "regionId": 2589,
        "regionCode": null,
        "regionName": "Assaba"
      },
      {
        "regionId": 2590,
        "regionCode": null,
        "regionName": "Brakna"
      },
      {
        "regionId": 2591,
        "regionCode": null,
        "regionName": "Dhakhlat Nawadibu"
      },
      {
        "regionId": 2592,
        "regionCode": null,
        "regionName": "Hudh-al-Gharbi"
      },
      {
        "regionId": 2593,
        "regionCode": null,
        "regionName": "Hudh-ash-Sharqi"
      },
      {
        "regionId": 2594,
        "regionCode": null,
        "regionName": "Inshiri"
      },
      {
        "regionId": 2595,
        "regionCode": null,
        "regionName": "Nawakshut"
      },
      {
        "regionId": 2596,
        "regionCode": null,
        "regionName": "Qidimagha"
      },
      {
        "regionId": 2597,
        "regionCode": null,
        "regionName": "Qurqul"
      },
      {
        "regionId": 2598,
        "regionCode": null,
        "regionName": "Taqant"
      },
      {
        "regionId": 2599,
        "regionCode": null,
        "regionName": "Tiris Zammur"
      },
      {
        "regionId": 2600,
        "regionCode": null,
        "regionName": "Trarza"
      }
    ]
  },
  {
    "countryId": 135,
    "countryCode": "MU",
    "countryName": "Mauritius",
    "regions": [
      {
        "regionId": 2609,
        "regionCode": null,
        "regionName": "Black River"
      },
      {
        "regionId": 2610,
        "regionCode": null,
        "regionName": "Eau Coulee"
      },
      {
        "regionId": 2611,
        "regionCode": null,
        "regionName": "Flacq"
      },
      {
        "regionId": 2612,
        "regionCode": null,
        "regionName": "Floreal"
      },
      {
        "regionId": 2613,
        "regionCode": null,
        "regionName": "Grand Port"
      },
      {
        "regionId": 2614,
        "regionCode": null,
        "regionName": "Moka"
      },
      {
        "regionId": 2615,
        "regionCode": null,
        "regionName": "Pamplempousses"
      },
      {
        "regionId": 2616,
        "regionCode": null,
        "regionName": "Plaines Wilhelm"
      },
      {
        "regionId": 2617,
        "regionCode": null,
        "regionName": "Port Louis"
      },
      {
        "regionId": 2618,
        "regionCode": null,
        "regionName": "Riviere du Rempart"
      },
      {
        "regionId": 2619,
        "regionCode": null,
        "regionName": "Rodrigues"
      },
      {
        "regionId": 2620,
        "regionCode": null,
        "regionName": "Rose Hill"
      },
      {
        "regionId": 2621,
        "regionCode": null,
        "regionName": "Savanne"
      }
    ]
  },
  {
    "countryId": 136,
    "countryCode": "YT",
    "countryName": "Mayotte",
    "regions": [
      {
        "regionId": 3968,
        "regionCode": null,
        "regionName": "Mayotte"
      },
      {
        "regionId": 3969,
        "regionCode": null,
        "regionName": "Pamanzi"
      }
    ]
  },
  {
    "countryId": 137,
    "countryCode": "MX",
    "countryName": "Mexico",
    "regions": [
      {
        "regionId": 4036,
        "regionCode": "AGS",
        "regionName": "Aguascalientes"
      },
      {
        "regionId": 4037,
        "regionCode": "BCN",
        "regionName": "Baja California (N)"
      },
      {
        "regionId": 4038,
        "regionCode": "BCS",
        "regionName": "Baja California Sur"
      },
      {
        "regionId": 4039,
        "regionCode": "CAM",
        "regionName": "Campeche"
      },
      {
        "regionId": 4040,
        "regionCode": "CHH",
        "regionName": "Chihuahua"
      },
      {
        "regionId": 4041,
        "regionCode": "CHP",
        "regionName": "Chiapas"
      },
      {
        "regionId": 4042,
        "regionCode": "COA",
        "regionName": "Coahuila"
      },
      {
        "regionId": 4043,
        "regionCode": "COL",
        "regionName": "Colima"
      },
      {
        "regionId": 4044,
        "regionCode": "DGO",
        "regionName": "Durango"
      },
      {
        "regionId": 4045,
        "regionCode": "DIF",
        "regionName": "Distrito Federal"
      },
      {
        "regionId": 4046,
        "regionCode": "GRO",
        "regionName": "Guerrero"
      },
      {
        "regionId": 4047,
        "regionCode": "GTO",
        "regionName": "Guanajuato"
      },
      {
        "regionId": 4048,
        "regionCode": "HGO",
        "regionName": "Hidalgo"
      },
      {
        "regionId": 4049,
        "regionCode": "JAL",
        "regionName": "Jalisco"
      },
      {
        "regionId": 4050,
        "regionCode": "MCH",
        "regionName": "Michoacán"
      },
      {
        "regionId": 4051,
        "regionCode": "MEX",
        "regionName": "Estado de México"
      },
      {
        "regionId": 4052,
        "regionCode": "MOR",
        "regionName": "Morelos"
      },
      {
        "regionId": 4053,
        "regionCode": "NAY",
        "regionName": "Nayarit"
      },
      {
        "regionId": 4054,
        "regionCode": "NLE",
        "regionName": "Nuevo Léon"
      },
      {
        "regionId": 4055,
        "regionCode": "OAX",
        "regionName": "Oaxaca"
      },
      {
        "regionId": 4056,
        "regionCode": "PUE",
        "regionName": "Puebla"
      },
      {
        "regionId": 4057,
        "regionCode": "QRO",
        "regionName": "Querétaro"
      },
      {
        "regionId": 4058,
        "regionCode": "ROO",
        "regionName": "Quintana Roo"
      },
      {
        "regionId": 4059,
        "regionCode": "SIN",
        "regionName": "Sinaloa"
      },
      {
        "regionId": 4060,
        "regionCode": "SLP",
        "regionName": "San Luis Potosí"
      },
      {
        "regionId": 4061,
        "regionCode": "SON",
        "regionName": "Sonora"
      },
      {
        "regionId": 4062,
        "regionCode": "TAB",
        "regionName": "Tabasco"
      },
      {
        "regionId": 4063,
        "regionCode": "TAM",
        "regionName": "Tamaulipas"
      },
      {
        "regionId": 4064,
        "regionCode": "TLA",
        "regionName": "Tlaxcala"
      },
      {
        "regionId": 4065,
        "regionCode": "VER",
        "regionName": "Veracruz"
      },
      {
        "regionId": 4066,
        "regionCode": "YUC",
        "regionName": "Yucatán"
      },
      {
        "regionId": 4067,
        "regionCode": "ZAC",
        "regionName": "Zacatecas"
      }
    ]
  },
  {
    "countryId": 138,
    "countryCode": "FM",
    "countryName": "Micronesia, Federated States of",
    "regions": [
      {
        "regionId": 1181,
        "regionCode": null,
        "regionName": "Chuuk"
      },
      {
        "regionId": 1182,
        "regionCode": null,
        "regionName": "Kusaie"
      },
      {
        "regionId": 1183,
        "regionCode": null,
        "regionName": "Pohnpei"
      },
      {
        "regionId": 1184,
        "regionCode": null,
        "regionName": "Yap"
      }
    ]
  },
  {
    "countryId": 139,
    "countryCode": "MD",
    "countryName": "Moldova, Republic of",
    "regions": [
      {
        "regionId": 2463,
        "regionCode": null,
        "regionName": "Balti"
      },
      {
        "regionId": 2464,
        "regionCode": null,
        "regionName": "Cahul"
      },
      {
        "regionId": 2465,
        "regionCode": null,
        "regionName": "Chisinau"
      },
      {
        "regionId": 2466,
        "regionCode": null,
        "regionName": "Chisinau Oras"
      },
      {
        "regionId": 2467,
        "regionCode": null,
        "regionName": "Edinet"
      },
      {
        "regionId": 2468,
        "regionCode": null,
        "regionName": "Gagauzia"
      },
      {
        "regionId": 2469,
        "regionCode": null,
        "regionName": "Lapusna"
      },
      {
        "regionId": 2470,
        "regionCode": null,
        "regionName": "Orhei"
      },
      {
        "regionId": 2471,
        "regionCode": null,
        "regionName": "Soroca"
      },
      {
        "regionId": 2472,
        "regionCode": null,
        "regionName": "Taraclia"
      },
      {
        "regionId": 2473,
        "regionCode": null,
        "regionName": "Tighina"
      },
      {
        "regionId": 2474,
        "regionCode": null,
        "regionName": "Transnistria"
      },
      {
        "regionId": 2475,
        "regionCode": null,
        "regionName": "Ungheni"
      }
    ]
  },
  {
    "countryId": 140,
    "countryCode": "MC",
    "countryName": "Monaco",
    "regions": [
      {
        "regionId": 2459,
        "regionCode": null,
        "regionName": "Fontvieille"
      },
      {
        "regionId": 2460,
        "regionCode": null,
        "regionName": "La Condamine"
      },
      {
        "regionId": 2461,
        "regionCode": null,
        "regionName": "Monaco-Ville"
      },
      {
        "regionId": 2462,
        "regionCode": null,
        "regionName": "Monte Carlo"
      }
    ]
  },
  {
    "countryId": 141,
    "countryCode": "MN",
    "countryName": "Mongolia",
    "regions": [
      {
        "regionId": 2561,
        "regionCode": null,
        "regionName": "Arhangaj"
      },
      {
        "regionId": 2562,
        "regionCode": null,
        "regionName": "Bajanhongor"
      },
      {
        "regionId": 2563,
        "regionCode": null,
        "regionName": "Bajan-Olgij"
      },
      {
        "regionId": 2564,
        "regionCode": null,
        "regionName": "Bulgan"
      },
      {
        "regionId": 2565,
        "regionCode": null,
        "regionName": "Darhan-Uul"
      },
      {
        "regionId": 2566,
        "regionCode": null,
        "regionName": "Dornod"
      },
      {
        "regionId": 2567,
        "regionCode": null,
        "regionName": "Dornogovi"
      },
      {
        "regionId": 2568,
        "regionCode": null,
        "regionName": "Dundgovi"
      },
      {
        "regionId": 2569,
        "regionCode": null,
        "regionName": "Govi-Altaj"
      },
      {
        "regionId": 2570,
        "regionCode": null,
        "regionName": "Govisumber"
      },
      {
        "regionId": 2571,
        "regionCode": null,
        "regionName": "Hentij"
      },
      {
        "regionId": 2572,
        "regionCode": null,
        "regionName": "Hovd"
      },
      {
        "regionId": 2573,
        "regionCode": null,
        "regionName": "Hovsgol"
      },
      {
        "regionId": 2574,
        "regionCode": null,
        "regionName": "Omnogovi"
      },
      {
        "regionId": 2575,
        "regionCode": null,
        "regionName": "Orhon"
      },
      {
        "regionId": 2576,
        "regionCode": null,
        "regionName": "Ovorhangaj"
      },
      {
        "regionId": 2577,
        "regionCode": null,
        "regionName": "Selenge"
      },
      {
        "regionId": 2578,
        "regionCode": null,
        "regionName": "Suhbaatar"
      },
      {
        "regionId": 2579,
        "regionCode": null,
        "regionName": "Tov"
      },
      {
        "regionId": 2580,
        "regionCode": null,
        "regionName": "Ulaanbaatar"
      },
      {
        "regionId": 2581,
        "regionCode": null,
        "regionName": "Uvs"
      },
      {
        "regionId": 2582,
        "regionCode": null,
        "regionName": "Zavhan"
      }
    ]
  },
  {
    "countryId": 142,
    "countryCode": "ME",
    "countryName": "Montenegro",
    "regions": []
  },
  {
    "countryId": 143,
    "countryCode": "MS",
    "countryName": "Montserrat",
    "regions": [
      {
        "regionId": 2601,
        "regionCode": null,
        "regionName": "Montserrat"
      }
    ]
  },
  {
    "countryId": 144,
    "countryCode": "MA",
    "countryName": "Morocco",
    "regions": [
      {
        "regionId": 2437,
        "regionCode": null,
        "regionName": "Agadir"
      },
      {
        "regionId": 2438,
        "regionCode": null,
        "regionName": "Casablanca"
      },
      {
        "regionId": 2439,
        "regionCode": null,
        "regionName": "Chaouia-Ouardigha"
      },
      {
        "regionId": 2440,
        "regionCode": null,
        "regionName": "Doukkala-Abda"
      },
      {
        "regionId": 2441,
        "regionCode": null,
        "regionName": "Fes-Boulemane"
      },
      {
        "regionId": 2442,
        "regionCode": null,
        "regionName": "Gharb-Chrarda-Beni Hssen"
      },
      {
        "regionId": 2443,
        "regionCode": null,
        "regionName": "Guelmim"
      },
      {
        "regionId": 2444,
        "regionCode": null,
        "regionName": "Kenitra"
      },
      {
        "regionId": 2445,
        "regionCode": null,
        "regionName": "Marrakech-Tensift-Al Haouz"
      },
      {
        "regionId": 2446,
        "regionCode": null,
        "regionName": "Meknes-Tafilalet"
      },
      {
        "regionId": 2447,
        "regionCode": null,
        "regionName": "Oriental"
      },
      {
        "regionId": 2448,
        "regionCode": null,
        "regionName": "Oujda"
      },
      {
        "regionId": 2449,
        "regionCode": null,
        "regionName": "Province de Tanger"
      },
      {
        "regionId": 2450,
        "regionCode": null,
        "regionName": "Rabat-Sale-Zammour-Zaer"
      },
      {
        "regionId": 2451,
        "regionCode": null,
        "regionName": "Sala Al Jadida"
      },
      {
        "regionId": 2452,
        "regionCode": null,
        "regionName": "Settat"
      },
      {
        "regionId": 2453,
        "regionCode": null,
        "regionName": "Souss Massa-Draa"
      },
      {
        "regionId": 2454,
        "regionCode": null,
        "regionName": "Tadla-Azilal"
      },
      {
        "regionId": 2455,
        "regionCode": null,
        "regionName": "Tangier-Tetouan"
      },
      {
        "regionId": 2456,
        "regionCode": null,
        "regionName": "Taza-Al Hoceima-Taounate"
      },
      {
        "regionId": 2457,
        "regionCode": null,
        "regionName": "Wilaya de Casablanca"
      },
      {
        "regionId": 2458,
        "regionCode": null,
        "regionName": "Wilaya de Rabat-Sale"
      }
    ]
  },
  {
    "countryId": 145,
    "countryCode": "MZ",
    "countryName": "Mozambique",
    "regions": [
      {
        "regionId": 2721,
        "regionCode": "P",
        "regionName": "Cabo Delgado"
      },
      {
        "regionId": 2722,
        "regionCode": "G",
        "regionName": "Gaza"
      },
      {
        "regionId": 2723,
        "regionCode": "I",
        "regionName": "Inhambane"
      },
      {
        "regionId": 2724,
        "regionCode": "B",
        "regionName": "Manica"
      },
      {
        "regionId": 2725,
        "regionCode": "L",
        "regionName": "Maputo"
      },
      {
        "regionId": 2726,
        "regionCode": null,
        "regionName": "Maputo Provincia"
      },
      {
        "regionId": 2727,
        "regionCode": "N",
        "regionName": "Nampula"
      },
      {
        "regionId": 2728,
        "regionCode": "A",
        "regionName": "Niassa"
      },
      {
        "regionId": 2729,
        "regionCode": "S",
        "regionName": "Sofala"
      },
      {
        "regionId": 2730,
        "regionCode": "T",
        "regionName": "Tete"
      },
      {
        "regionId": 2731,
        "regionCode": "Q",
        "regionName": "Zambezia"
      }
    ]
  },
  {
    "countryId": 146,
    "countryCode": "MM",
    "countryName": "Myanmar",
    "regions": [
      {
        "regionId": 2546,
        "regionCode": null,
        "regionName": "Ayeyarwady"
      },
      {
        "regionId": 2547,
        "regionCode": null,
        "regionName": "Bago"
      },
      {
        "regionId": 2548,
        "regionCode": null,
        "regionName": "Chin"
      },
      {
        "regionId": 2549,
        "regionCode": null,
        "regionName": "Kachin"
      },
      {
        "regionId": 2550,
        "regionCode": null,
        "regionName": "Kayah"
      },
      {
        "regionId": 2551,
        "regionCode": null,
        "regionName": "Kayin"
      },
      {
        "regionId": 2552,
        "regionCode": null,
        "regionName": "Magway"
      },
      {
        "regionId": 2553,
        "regionCode": null,
        "regionName": "Mandalay"
      },
      {
        "regionId": 2554,
        "regionCode": null,
        "regionName": "Mon"
      },
      {
        "regionId": 2555,
        "regionCode": null,
        "regionName": "Nay Pyi Taw"
      },
      {
        "regionId": 2556,
        "regionCode": null,
        "regionName": "Rakhine"
      },
      {
        "regionId": 2557,
        "regionCode": null,
        "regionName": "Sagaing"
      },
      {
        "regionId": 2558,
        "regionCode": null,
        "regionName": "Shan"
      },
      {
        "regionId": 2559,
        "regionCode": null,
        "regionName": "Tanintharyi"
      },
      {
        "regionId": 2560,
        "regionCode": null,
        "regionName": "Yangon"
      }
    ]
  },
  {
    "countryId": 147,
    "countryCode": "NA",
    "countryName": "Namibia",
    "regions": [
      {
        "regionId": 2732,
        "regionCode": null,
        "regionName": "Caprivi"
      },
      {
        "regionId": 2733,
        "regionCode": null,
        "regionName": "Erongo"
      },
      {
        "regionId": 2734,
        "regionCode": null,
        "regionName": "Hardap"
      },
      {
        "regionId": 2735,
        "regionCode": null,
        "regionName": "Karas"
      },
      {
        "regionId": 2736,
        "regionCode": null,
        "regionName": "Kavango"
      },
      {
        "regionId": 2737,
        "regionCode": null,
        "regionName": "Khomas"
      },
      {
        "regionId": 2738,
        "regionCode": null,
        "regionName": "Kunene"
      },
      {
        "regionId": 2739,
        "regionCode": null,
        "regionName": "Ohangwena"
      },
      {
        "regionId": 2740,
        "regionCode": null,
        "regionName": "Omaheke"
      },
      {
        "regionId": 2741,
        "regionCode": null,
        "regionName": "Omusati"
      },
      {
        "regionId": 2742,
        "regionCode": null,
        "regionName": "Oshana"
      },
      {
        "regionId": 2743,
        "regionCode": null,
        "regionName": "Oshikoto"
      },
      {
        "regionId": 2744,
        "regionCode": null,
        "regionName": "Otjozondjupa"
      }
    ]
  },
  {
    "countryId": 148,
    "countryCode": "NR",
    "countryName": "Nauru",
    "regions": [
      {
        "regionId": 2863,
        "regionCode": null,
        "regionName": "Yaren"
      }
    ]
  },
  {
    "countryId": 149,
    "countryCode": "NP",
    "countryName": "Nepal",
    "regions": [
      {
        "regionId": 2849,
        "regionCode": null,
        "regionName": "Bagmati"
      },
      {
        "regionId": 2850,
        "regionCode": null,
        "regionName": "Bheri"
      },
      {
        "regionId": 2851,
        "regionCode": null,
        "regionName": "Dhawalagiri"
      },
      {
        "regionId": 2852,
        "regionCode": null,
        "regionName": "Gandaki"
      },
      {
        "regionId": 2853,
        "regionCode": null,
        "regionName": "Janakpur"
      },
      {
        "regionId": 2854,
        "regionCode": null,
        "regionName": "Karnali"
      },
      {
        "regionId": 2855,
        "regionCode": null,
        "regionName": "Koshi"
      },
      {
        "regionId": 2856,
        "regionCode": null,
        "regionName": "Lumbini"
      },
      {
        "regionId": 2857,
        "regionCode": null,
        "regionName": "Mahakali"
      },
      {
        "regionId": 2858,
        "regionCode": null,
        "regionName": "Mechi"
      },
      {
        "regionId": 2859,
        "regionCode": null,
        "regionName": "Narayani"
      },
      {
        "regionId": 2860,
        "regionCode": null,
        "regionName": "Rapti"
      },
      {
        "regionId": 2861,
        "regionCode": null,
        "regionName": "Sagarmatha"
      },
      {
        "regionId": 2862,
        "regionCode": null,
        "regionName": "Seti"
      }
    ]
  },
  {
    "countryId": 150,
    "countryCode": "NL",
    "countryName": "Netherlands",
    "regions": [
      {
        "regionId": 2811,
        "regionCode": null,
        "regionName": "Amsterdam"
      },
      {
        "regionId": 2812,
        "regionCode": null,
        "regionName": "Benelux"
      },
      {
        "regionId": 2813,
        "regionCode": "01",
        "regionName": "Drenthe"
      },
      {
        "regionId": 2814,
        "regionCode": "02",
        "regionName": "Flevoland"
      },
      {
        "regionId": 2815,
        "regionCode": "03",
        "regionName": "Friesland"
      },
      {
        "regionId": 2816,
        "regionCode": "04",
        "regionName": "Gelderland"
      },
      {
        "regionId": 2817,
        "regionCode": "05",
        "regionName": "Groningen"
      },
      {
        "regionId": 2818,
        "regionCode": "06",
        "regionName": "Limburg"
      },
      {
        "regionId": 2819,
        "regionCode": "07",
        "regionName": "Noord-Brabant"
      },
      {
        "regionId": 2820,
        "regionCode": "08",
        "regionName": "Noord-Holland"
      },
      {
        "regionId": 2821,
        "regionCode": "09",
        "regionName": "Overijssel"
      },
      {
        "regionId": 2822,
        "regionCode": null,
        "regionName": "South Holland"
      },
      {
        "regionId": 2823,
        "regionCode": "10",
        "regionName": "Utrecht"
      },
      {
        "regionId": 2824,
        "regionCode": "11",
        "regionName": "Zeeland"
      },
      {
        "regionId": 2825,
        "regionCode": "12",
        "regionName": "Zuid-Holland"
      }
    ]
  },
  {
    "countryId": 151,
    "countryCode": "AN",
    "countryName": "Netherlands Antilles",
    "regions": [
      {
        "regionId": 105,
        "regionCode": null,
        "regionName": "Bonaire"
      },
      {
        "regionId": 106,
        "regionCode": null,
        "regionName": "Curacao"
      },
      {
        "regionId": 107,
        "regionCode": null,
        "regionName": "Saba"
      },
      {
        "regionId": 108,
        "regionCode": null,
        "regionName": "Sint Eustatius"
      },
      {
        "regionId": 109,
        "regionCode": null,
        "regionName": "Sint Maarten"
      }
    ]
  },
  {
    "countryId": 152,
    "countryCode": "NC",
    "countryName": "New Caledonia",
    "regions": [
      {
        "regionId": 2745,
        "regionCode": null,
        "regionName": "Iles"
      },
      {
        "regionId": 2746,
        "regionCode": null,
        "regionName": "Nord"
      },
      {
        "regionId": 2747,
        "regionCode": null,
        "regionName": "Sud"
      }
    ]
  },
  {
    "countryId": 153,
    "countryCode": "NZ",
    "countryName": "New Zealand",
    "regions": [
      {
        "regionId": 2865,
        "regionCode": null,
        "regionName": "Area Outside Region"
      },
      {
        "regionId": 2866,
        "regionCode": "NZ-AUK",
        "regionName": "Auckland"
      },
      {
        "regionId": 2867,
        "regionCode": "BOP",
        "regionName": "Bay of Plenty"
      },
      {
        "regionId": 2868,
        "regionCode": "CAN",
        "regionName": "Canterbury"
      },
      {
        "regionId": 2869,
        "regionCode": null,
        "regionName": "Christchurch"
      },
      {
        "regionId": 2870,
        "regionCode": null,
        "regionName": "Gisborne"
      },
      {
        "regionId": 2871,
        "regionCode": null,
        "regionName": "Hawke's Bay"
      },
      {
        "regionId": 2872,
        "regionCode": "MAN",
        "regionName": "Manawatu-Wanganui"
      },
      {
        "regionId": 2873,
        "regionCode": null,
        "regionName": "Marlborough"
      },
      {
        "regionId": 2874,
        "regionCode": null,
        "regionName": "Nelson"
      },
      {
        "regionId": 2875,
        "regionCode": "NTL",
        "regionName": "Northland"
      },
      {
        "regionId": 2876,
        "regionCode": "OTA",
        "regionName": "Otago"
      },
      {
        "regionId": 2877,
        "regionCode": null,
        "regionName": "Rodney"
      },
      {
        "regionId": 2878,
        "regionCode": "STL",
        "regionName": "Southland"
      },
      {
        "regionId": 2879,
        "regionCode": "TAR",
        "regionName": "Taranaki"
      },
      {
        "regionId": 2880,
        "regionCode": null,
        "regionName": "Tasman"
      },
      {
        "regionId": 2881,
        "regionCode": "WAI",
        "regionName": "Waikato"
      },
      {
        "regionId": 2882,
        "regionCode": "WLG",
        "regionName": "Wellington"
      },
      {
        "regionId": 2883,
        "regionCode": "WEC",
        "regionName": "West Coast"
      }
    ]
  },
  {
    "countryId": 154,
    "countryCode": "NI",
    "countryName": "Nicaragua",
    "regions": [
      {
        "regionId": 2794,
        "regionCode": null,
        "regionName": "Atlantico Norte"
      },
      {
        "regionId": 2795,
        "regionCode": null,
        "regionName": "Atlantico Sur"
      },
      {
        "regionId": 2796,
        "regionCode": "BO",
        "regionName": "Boaco"
      },
      {
        "regionId": 2797,
        "regionCode": "CA",
        "regionName": "Carazo"
      },
      {
        "regionId": 2798,
        "regionCode": "CI",
        "regionName": "Chinandega"
      },
      {
        "regionId": 2799,
        "regionCode": "CO",
        "regionName": "Chontales"
      },
      {
        "regionId": 2800,
        "regionCode": "ES",
        "regionName": "Esteli"
      },
      {
        "regionId": 2801,
        "regionCode": "GR",
        "regionName": "Granada"
      },
      {
        "regionId": 2802,
        "regionCode": "JI",
        "regionName": "Jinotega"
      },
      {
        "regionId": 2803,
        "regionCode": "LE",
        "regionName": "Leon"
      },
      {
        "regionId": 2804,
        "regionCode": "MD",
        "regionName": "Madriz"
      },
      {
        "regionId": 2805,
        "regionCode": "MN",
        "regionName": "Managua"
      },
      {
        "regionId": 2806,
        "regionCode": "MS",
        "regionName": "Masaya"
      },
      {
        "regionId": 2807,
        "regionCode": "MT",
        "regionName": "Matagalpa"
      },
      {
        "regionId": 2808,
        "regionCode": "NS",
        "regionName": "Nueva Segovia"
      },
      {
        "regionId": 2809,
        "regionCode": "SJ",
        "regionName": "Rio San Juan"
      },
      {
        "regionId": 2810,
        "regionCode": "RI",
        "regionName": "Rivas"
      }
    ]
  },
  {
    "countryId": 155,
    "countryCode": "NE",
    "countryName": "Niger",
    "regions": [
      {
        "regionId": 2748,
        "regionCode": null,
        "regionName": "Agadez"
      },
      {
        "regionId": 2749,
        "regionCode": null,
        "regionName": "Diffa"
      },
      {
        "regionId": 2750,
        "regionCode": null,
        "regionName": "Dosso"
      },
      {
        "regionId": 2751,
        "regionCode": null,
        "regionName": "Maradi"
      },
      {
        "regionId": 2752,
        "regionCode": null,
        "regionName": "Niamey"
      },
      {
        "regionId": 2753,
        "regionCode": null,
        "regionName": "Tahoua"
      },
      {
        "regionId": 2754,
        "regionCode": null,
        "regionName": "Tillabery"
      },
      {
        "regionId": 2755,
        "regionCode": null,
        "regionName": "Zinder"
      }
    ]
  },
  {
    "countryId": 156,
    "countryCode": "NG",
    "countryName": "Nigeria",
    "regions": [
      {
        "regionId": 2757,
        "regionCode": "AB",
        "regionName": "Abia"
      },
      {
        "regionId": 2758,
        "regionCode": null,
        "regionName": "Abuja Federal Capital Territor"
      },
      {
        "regionId": 2759,
        "regionCode": "AD",
        "regionName": "Adamawa"
      },
      {
        "regionId": 2760,
        "regionCode": "AK",
        "regionName": "Akwa Ibom"
      },
      {
        "regionId": 2761,
        "regionCode": "AN",
        "regionName": "Anambra"
      },
      {
        "regionId": 2762,
        "regionCode": "BA",
        "regionName": "Bauchi"
      },
      {
        "regionId": 2763,
        "regionCode": "BY",
        "regionName": "Bayelsa"
      },
      {
        "regionId": 2764,
        "regionCode": "BE",
        "regionName": "Benue"
      },
      {
        "regionId": 2765,
        "regionCode": "BO",
        "regionName": "Borno"
      },
      {
        "regionId": 2766,
        "regionCode": "CR",
        "regionName": "Cross River"
      },
      {
        "regionId": 2767,
        "regionCode": "DE",
        "regionName": "Delta"
      },
      {
        "regionId": 2768,
        "regionCode": "EB",
        "regionName": "Ebonyi"
      },
      {
        "regionId": 2769,
        "regionCode": "ED",
        "regionName": "Edo"
      },
      {
        "regionId": 2770,
        "regionCode": "EK",
        "regionName": "Ekiti"
      },
      {
        "regionId": 2771,
        "regionCode": "EN",
        "regionName": "Enugu"
      },
      {
        "regionId": 2772,
        "regionCode": "GO",
        "regionName": "Gombe"
      },
      {
        "regionId": 2773,
        "regionCode": "IM",
        "regionName": "Imo"
      },
      {
        "regionId": 2774,
        "regionCode": "JI",
        "regionName": "Jigawa"
      },
      {
        "regionId": 2775,
        "regionCode": "KD",
        "regionName": "Kaduna"
      },
      {
        "regionId": 2776,
        "regionCode": "KN",
        "regionName": "Kano"
      },
      {
        "regionId": 2777,
        "regionCode": "KT",
        "regionName": "Katsina"
      },
      {
        "regionId": 2778,
        "regionCode": "KE",
        "regionName": "Kebbi"
      },
      {
        "regionId": 2779,
        "regionCode": "KO",
        "regionName": "Kogi"
      },
      {
        "regionId": 2780,
        "regionCode": "KW",
        "regionName": "Kwara"
      },
      {
        "regionId": 2781,
        "regionCode": "LA",
        "regionName": "Lagos"
      },
      {
        "regionId": 2782,
        "regionCode": null,
        "regionName": "Nassarawa"
      },
      {
        "regionId": 2783,
        "regionCode": "NI",
        "regionName": "Niger"
      },
      {
        "regionId": 2784,
        "regionCode": null,
        "regionName": "Ogun"
      },
      {
        "regionId": 2785,
        "regionCode": "ON",
        "regionName": "Ondo"
      },
      {
        "regionId": 2786,
        "regionCode": "OS",
        "regionName": "Osun"
      },
      {
        "regionId": 2787,
        "regionCode": "OY",
        "regionName": "Oyo"
      },
      {
        "regionId": 2788,
        "regionCode": "PL",
        "regionName": "Plateau"
      },
      {
        "regionId": 2789,
        "regionCode": "RI",
        "regionName": "Rivers"
      },
      {
        "regionId": 2790,
        "regionCode": "SO",
        "regionName": "Sokoto"
      },
      {
        "regionId": 2791,
        "regionCode": "TA",
        "regionName": "Taraba"
      },
      {
        "regionId": 2792,
        "regionCode": "YO",
        "regionName": "Yobe"
      },
      {
        "regionId": 2793,
        "regionCode": "ZA",
        "regionName": "Zamfara"
      }
    ]
  },
  {
    "countryId": 157,
    "countryCode": "NU",
    "countryName": "Niue",
    "regions": [
      {
        "regionId": 2864,
        "regionCode": null,
        "regionName": "Niue"
      }
    ]
  },
  {
    "countryId": 158,
    "countryCode": "NF",
    "countryName": "Norfolk Island",
    "regions": [
      {
        "regionId": 2756,
        "regionCode": null,
        "regionName": "Norfolk Island"
      }
    ]
  },
  {
    "countryId": 159,
    "countryCode": "KP",
    "countryName": "North Korea",
    "regions": [
      {
        "regionId": 2180,
        "regionCode": null,
        "regionName": "Chagangdo"
      },
      {
        "regionId": 2181,
        "regionCode": null,
        "regionName": "Hamgyeongbukto"
      },
      {
        "regionId": 2182,
        "regionCode": null,
        "regionName": "Hamgyeongnamdo"
      },
      {
        "regionId": 2183,
        "regionCode": null,
        "regionName": "Hwanghaebukto"
      },
      {
        "regionId": 2184,
        "regionCode": null,
        "regionName": "Hwanghaenamdo"
      },
      {
        "regionId": 2185,
        "regionCode": null,
        "regionName": "Kaeseong"
      },
      {
        "regionId": 2186,
        "regionCode": null,
        "regionName": "Kangweon"
      },
      {
        "regionId": 2187,
        "regionCode": null,
        "regionName": "Nampo"
      },
      {
        "regionId": 2188,
        "regionCode": null,
        "regionName": "Pyeonganbukto"
      },
      {
        "regionId": 2189,
        "regionCode": null,
        "regionName": "Pyeongannamdo"
      },
      {
        "regionId": 2190,
        "regionCode": null,
        "regionName": "Pyeongyang"
      },
      {
        "regionId": 2191,
        "regionCode": null,
        "regionName": "Yanggang"
      }
    ]
  },
  {
    "countryId": 160,
    "countryCode": "NO",
    "countryName": "Norway",
    "regions": [
      {
        "regionId": 2826,
        "regionCode": null,
        "regionName": "Ã?stfold"
      },
      {
        "regionId": 2827,
        "regionCode": null,
        "regionName": "Akershus"
      },
      {
        "regionId": 2828,
        "regionCode": null,
        "regionName": "Aust Agder"
      },
      {
        "regionId": 2829,
        "regionCode": null,
        "regionName": "Bergen"
      },
      {
        "regionId": 2830,
        "regionCode": null,
        "regionName": "Buskerud"
      },
      {
        "regionId": 2831,
        "regionCode": null,
        "regionName": "Finnmark"
      },
      {
        "regionId": 2832,
        "regionCode": null,
        "regionName": "Hedmark"
      },
      {
        "regionId": 2833,
        "regionCode": null,
        "regionName": "Hordaland"
      },
      {
        "regionId": 2834,
        "regionCode": null,
        "regionName": "Moere og Romsdal"
      },
      {
        "regionId": 2835,
        "regionCode": null,
        "regionName": "Nord Trondelag"
      },
      {
        "regionId": 2836,
        "regionCode": null,
        "regionName": "Nordland"
      },
      {
        "regionId": 2837,
        "regionCode": null,
        "regionName": "Oestfold"
      },
      {
        "regionId": 2838,
        "regionCode": null,
        "regionName": "Oppland"
      },
      {
        "regionId": 2839,
        "regionCode": "03",
        "regionName": "Oslo"
      },
      {
        "regionId": 2840,
        "regionCode": null,
        "regionName": "Rogaland"
      },
      {
        "regionId": 2841,
        "regionCode": null,
        "regionName": "Soer Troendelag"
      },
      {
        "regionId": 2842,
        "regionCode": null,
        "regionName": "Sogn og Fjordane"
      },
      {
        "regionId": 2843,
        "regionCode": null,
        "regionName": "Stavern"
      },
      {
        "regionId": 2844,
        "regionCode": null,
        "regionName": "Sykkylven"
      },
      {
        "regionId": 2845,
        "regionCode": null,
        "regionName": "Telemark"
      },
      {
        "regionId": 2846,
        "regionCode": null,
        "regionName": "Troms"
      },
      {
        "regionId": 2847,
        "regionCode": null,
        "regionName": "Vest Agder"
      },
      {
        "regionId": 2848,
        "regionCode": null,
        "regionName": "Vestfold"
      }
    ]
  },
  {
    "countryId": 161,
    "countryCode": "OM",
    "countryName": "Oman",
    "regions": [
      {
        "regionId": 2884,
        "regionCode": null,
        "regionName": "ad-Dakhiliyah"
      },
      {
        "regionId": 2885,
        "regionCode": null,
        "regionName": "adh-Dhahirah"
      },
      {
        "regionId": 2886,
        "regionCode": null,
        "regionName": "Al Buraimi"
      },
      {
        "regionId": 2887,
        "regionCode": null,
        "regionName": "al-Batinah"
      },
      {
        "regionId": 2888,
        "regionCode": null,
        "regionName": "ash-Sharqiyah"
      },
      {
        "regionId": 2889,
        "regionCode": null,
        "regionName": "Dhufar"
      },
      {
        "regionId": 2890,
        "regionCode": null,
        "regionName": "Masqat"
      },
      {
        "regionId": 2891,
        "regionCode": null,
        "regionName": "Musandam"
      },
      {
        "regionId": 2892,
        "regionCode": null,
        "regionName": "Rusayl"
      },
      {
        "regionId": 2893,
        "regionCode": null,
        "regionName": "Wadi Kabir"
      }
    ]
  },
  {
    "countryId": 162,
    "countryCode": "PK",
    "countryName": "Pakistan",
    "regions": [
      {
        "regionId": 2977,
        "regionCode": null,
        "regionName": "Baluchistan"
      },
      {
        "regionId": 2978,
        "regionCode": null,
        "regionName": "Federal Capital Area"
      },
      {
        "regionId": 2979,
        "regionCode": null,
        "regionName": "Federally administered Tribal"
      },
      {
        "regionId": 2980,
        "regionCode": null,
        "regionName": "Northern Areas"
      },
      {
        "regionId": 2981,
        "regionCode": null,
        "regionName": "North-West Frontier"
      },
      {
        "regionId": 2982,
        "regionCode": null,
        "regionName": "Punjab"
      },
      {
        "regionId": 2983,
        "regionCode": null,
        "regionName": "Sind"
      }
    ]
  },
  {
    "countryId": 163,
    "countryCode": "PW",
    "countryName": "Palau",
    "regions": [
      {
        "regionId": 3062,
        "regionCode": null,
        "regionName": "Aimeliik"
      },
      {
        "regionId": 3063,
        "regionCode": null,
        "regionName": "Airai"
      },
      {
        "regionId": 3064,
        "regionCode": null,
        "regionName": "Angaur"
      },
      {
        "regionId": 3065,
        "regionCode": null,
        "regionName": "Hatobohei"
      },
      {
        "regionId": 3066,
        "regionCode": null,
        "regionName": "Kayangel"
      },
      {
        "regionId": 3067,
        "regionCode": null,
        "regionName": "Koror"
      },
      {
        "regionId": 3068,
        "regionCode": null,
        "regionName": "Melekeok"
      },
      {
        "regionId": 3069,
        "regionCode": null,
        "regionName": "Ngaraard"
      },
      {
        "regionId": 3070,
        "regionCode": null,
        "regionName": "Ngardmau"
      },
      {
        "regionId": 3071,
        "regionCode": null,
        "regionName": "Ngaremlengui"
      },
      {
        "regionId": 3072,
        "regionCode": null,
        "regionName": "Ngatpang"
      },
      {
        "regionId": 3073,
        "regionCode": null,
        "regionName": "Ngchesar"
      },
      {
        "regionId": 3074,
        "regionCode": null,
        "regionName": "Ngerchelong"
      },
      {
        "regionId": 3075,
        "regionCode": null,
        "regionName": "Ngiwal"
      },
      {
        "regionId": 3076,
        "regionCode": null,
        "regionName": "Peleliu"
      },
      {
        "regionId": 3077,
        "regionCode": null,
        "regionName": "Sonsorol"
      }
    ]
  },
  {
    "countryId": 164,
    "countryCode": "PS",
    "countryName": "Palestinian Territories",
    "regions": [
      {
        "regionId": 3031,
        "regionCode": null,
        "regionName": "al-Khalil"
      },
      {
        "regionId": 3032,
        "regionCode": null,
        "regionName": "al-Quds"
      },
      {
        "regionId": 3033,
        "regionCode": null,
        "regionName": "Ariha"
      },
      {
        "regionId": 3034,
        "regionCode": null,
        "regionName": "Bayt Lahm"
      },
      {
        "regionId": 3035,
        "regionCode": null,
        "regionName": "Bethlehem"
      },
      {
        "regionId": 3036,
        "regionCode": null,
        "regionName": "Dayr-al-Balah"
      },
      {
        "regionId": 3037,
        "regionCode": null,
        "regionName": "Ghazzah"
      },
      {
        "regionId": 3038,
        "regionCode": null,
        "regionName": "Ghazzah ash-Shamaliyah"
      },
      {
        "regionId": 3039,
        "regionCode": null,
        "regionName": "Janin"
      },
      {
        "regionId": 3040,
        "regionCode": null,
        "regionName": "Khan Yunis"
      },
      {
        "regionId": 3041,
        "regionCode": null,
        "regionName": "Nabulus"
      },
      {
        "regionId": 3042,
        "regionCode": null,
        "regionName": "Qalqilyah"
      },
      {
        "regionId": 3043,
        "regionCode": null,
        "regionName": "Rafah"
      },
      {
        "regionId": 3044,
        "regionCode": null,
        "regionName": "Ram Allah wal-Birah"
      },
      {
        "regionId": 3045,
        "regionCode": null,
        "regionName": "Salfit"
      },
      {
        "regionId": 3046,
        "regionCode": null,
        "regionName": "Tubas"
      },
      {
        "regionId": 3047,
        "regionCode": null,
        "regionName": "Tulkarm"
      }
    ]
  },
  {
    "countryId": 165,
    "countryCode": "PA",
    "countryName": "Panama",
    "regions": [
      {
        "regionId": 2894,
        "regionCode": null,
        "regionName": "Bocas del Toro"
      },
      {
        "regionId": 2895,
        "regionCode": null,
        "regionName": "Chiriqui"
      },
      {
        "regionId": 2896,
        "regionCode": null,
        "regionName": "Cocle"
      },
      {
        "regionId": 2897,
        "regionCode": null,
        "regionName": "Colon"
      },
      {
        "regionId": 2898,
        "regionCode": null,
        "regionName": "Darien"
      },
      {
        "regionId": 2899,
        "regionCode": null,
        "regionName": "Embera"
      },
      {
        "regionId": 2900,
        "regionCode": null,
        "regionName": "Herrera"
      },
      {
        "regionId": 2901,
        "regionCode": null,
        "regionName": "Kuna Yala"
      },
      {
        "regionId": 2902,
        "regionCode": null,
        "regionName": "Los Santos"
      },
      {
        "regionId": 2903,
        "regionCode": null,
        "regionName": "Ngobe Bugle"
      },
      {
        "regionId": 2904,
        "regionCode": null,
        "regionName": "Panama"
      },
      {
        "regionId": 2905,
        "regionCode": null,
        "regionName": "Veraguas"
      }
    ]
  },
  {
    "countryId": 166,
    "countryCode": "PG",
    "countryName": "Papua New Guinea",
    "regions": [
      {
        "regionId": 2935,
        "regionCode": null,
        "regionName": "East New Britain"
      },
      {
        "regionId": 2936,
        "regionCode": null,
        "regionName": "East Sepik"
      },
      {
        "regionId": 2937,
        "regionCode": null,
        "regionName": "Eastern Highlands"
      },
      {
        "regionId": 2938,
        "regionCode": null,
        "regionName": "Enga"
      },
      {
        "regionId": 2939,
        "regionCode": null,
        "regionName": "Fly River"
      },
      {
        "regionId": 2940,
        "regionCode": null,
        "regionName": "Gulf"
      },
      {
        "regionId": 2941,
        "regionCode": null,
        "regionName": "Madang"
      },
      {
        "regionId": 2942,
        "regionCode": null,
        "regionName": "Manus"
      },
      {
        "regionId": 2943,
        "regionCode": null,
        "regionName": "Milne Bay"
      },
      {
        "regionId": 2944,
        "regionCode": null,
        "regionName": "Morobe"
      },
      {
        "regionId": 2945,
        "regionCode": null,
        "regionName": "National Capital District"
      },
      {
        "regionId": 2946,
        "regionCode": null,
        "regionName": "New Ireland"
      },
      {
        "regionId": 2947,
        "regionCode": null,
        "regionName": "North Solomons"
      },
      {
        "regionId": 2948,
        "regionCode": null,
        "regionName": "Oro"
      },
      {
        "regionId": 2949,
        "regionCode": null,
        "regionName": "Sandaun"
      },
      {
        "regionId": 2950,
        "regionCode": null,
        "regionName": "Simbu"
      },
      {
        "regionId": 2951,
        "regionCode": null,
        "regionName": "Southern Highlands"
      },
      {
        "regionId": 2952,
        "regionCode": null,
        "regionName": "West New Britain"
      },
      {
        "regionId": 2953,
        "regionCode": null,
        "regionName": "Western Highlands"
      }
    ]
  },
  {
    "countryId": 167,
    "countryCode": "PY",
    "countryName": "Paraguay",
    "regions": [
      {
        "regionId": 3078,
        "regionCode": null,
        "regionName": "Alto Paraguay"
      },
      {
        "regionId": 3079,
        "regionCode": null,
        "regionName": "Alto Parana"
      },
      {
        "regionId": 3080,
        "regionCode": null,
        "regionName": "Amambay"
      },
      {
        "regionId": 3081,
        "regionCode": null,
        "regionName": "Asuncion"
      },
      {
        "regionId": 3082,
        "regionCode": null,
        "regionName": "Boqueron"
      },
      {
        "regionId": 3083,
        "regionCode": null,
        "regionName": "Caaguazu"
      },
      {
        "regionId": 3084,
        "regionCode": null,
        "regionName": "Caazapa"
      },
      {
        "regionId": 3085,
        "regionCode": null,
        "regionName": "Canendiyu"
      },
      {
        "regionId": 3086,
        "regionCode": null,
        "regionName": "Central"
      },
      {
        "regionId": 3087,
        "regionCode": null,
        "regionName": "Concepcion"
      },
      {
        "regionId": 3088,
        "regionCode": null,
        "regionName": "Cordillera"
      },
      {
        "regionId": 3089,
        "regionCode": null,
        "regionName": "Guaira"
      },
      {
        "regionId": 3090,
        "regionCode": null,
        "regionName": "Itapua"
      },
      {
        "regionId": 3091,
        "regionCode": null,
        "regionName": "Misiones"
      },
      {
        "regionId": 3092,
        "regionCode": null,
        "regionName": "Neembucu"
      },
      {
        "regionId": 3093,
        "regionCode": null,
        "regionName": "Paraguari"
      },
      {
        "regionId": 3094,
        "regionCode": null,
        "regionName": "Presidente Hayes"
      },
      {
        "regionId": 3095,
        "regionCode": null,
        "regionName": "San Pedro"
      }
    ]
  },
  {
    "countryId": 168,
    "countryCode": "PE",
    "countryName": "Peru",
    "regions": [
      {
        "regionId": 2906,
        "regionCode": "AMA",
        "regionName": "Amazonas"
      },
      {
        "regionId": 2907,
        "regionCode": "05",
        "regionName": "Ancash"
      },
      {
        "regionId": 2908,
        "regionCode": "19",
        "regionName": "Apurimac"
      },
      {
        "regionId": 2909,
        "regionCode": "08",
        "regionName": "Arequipa"
      },
      {
        "regionId": 2910,
        "regionCode": "18",
        "regionName": "Ayacucho"
      },
      {
        "regionId": 2911,
        "regionCode": "12",
        "regionName": "Cajamarca"
      },
      {
        "regionId": 2912,
        "regionCode": null,
        "regionName": "Cusco"
      },
      {
        "regionId": 2913,
        "regionCode": "17",
        "regionName": "Huancavelica"
      },
      {
        "regionId": 2914,
        "regionCode": "HUC",
        "regionName": "Huanuco"
      },
      {
        "regionId": 2915,
        "regionCode": "07",
        "regionName": "Ica"
      },
      {
        "regionId": 2916,
        "regionCode": "JUN",
        "regionName": "Junin"
      },
      {
        "regionId": 2917,
        "regionCode": "04",
        "regionName": "La Libertad"
      },
      {
        "regionId": 2918,
        "regionCode": "03",
        "regionName": "Lambayeque"
      },
      {
        "regionId": 2919,
        "regionCode": "06",
        "regionName": "Lima y Callao"
      },
      {
        "regionId": 2920,
        "regionCode": "22",
        "regionName": "Loreto"
      },
      {
        "regionId": 2921,
        "regionCode": "MDD",
        "regionName": "Madre de Dios"
      },
      {
        "regionId": 2922,
        "regionCode": "09",
        "regionName": "Moquegua"
      },
      {
        "regionId": 2923,
        "regionCode": "15",
        "regionName": "Pasco"
      },
      {
        "regionId": 2924,
        "regionCode": "02",
        "regionName": "Piura"
      },
      {
        "regionId": 2925,
        "regionCode": "21",
        "regionName": "Puno"
      },
      {
        "regionId": 2926,
        "regionCode": "SAM",
        "regionName": "San Martin"
      },
      {
        "regionId": 2927,
        "regionCode": "10",
        "regionName": "Tacna"
      },
      {
        "regionId": 2928,
        "regionCode": "01",
        "regionName": "Tumbes"
      },
      {
        "regionId": 2929,
        "regionCode": "23",
        "regionName": "Ucayali"
      }
    ]
  },
  {
    "countryId": 169,
    "countryCode": "PH",
    "countryName": "Philippines",
    "regions": [
      {
        "regionId": 2954,
        "regionCode": "BTG",
        "regionName": "Batangas"
      },
      {
        "regionId": 2955,
        "regionCode": "05",
        "regionName": "Bicol"
      },
      {
        "regionId": 2956,
        "regionCode": "BUL",
        "regionName": "Bulacan"
      },
      {
        "regionId": 2957,
        "regionCode": "CAG",
        "regionName": "Cagayan"
      },
      {
        "regionId": 2958,
        "regionCode": null,
        "regionName": "Caraga"
      },
      {
        "regionId": 2959,
        "regionCode": "03",
        "regionName": "Central Luzon"
      },
      {
        "regionId": 2960,
        "regionCode": "11",
        "regionName": "Central Mindanao"
      },
      {
        "regionId": 2961,
        "regionCode": "07",
        "regionName": "Central Visayas"
      },
      {
        "regionId": 2962,
        "regionCode": null,
        "regionName": "Cordillera"
      },
      {
        "regionId": 2963,
        "regionCode": null,
        "regionName": "Davao"
      },
      {
        "regionId": 2964,
        "regionCode": "08",
        "regionName": "Eastern Visayas"
      },
      {
        "regionId": 2965,
        "regionCode": null,
        "regionName": "Greater Metropolitan Area"
      },
      {
        "regionId": 2966,
        "regionCode": "01",
        "regionName": "Ilocos"
      },
      {
        "regionId": 2967,
        "regionCode": "LAG",
        "regionName": "Laguna"
      },
      {
        "regionId": 2968,
        "regionCode": null,
        "regionName": "Luzon"
      },
      {
        "regionId": 2969,
        "regionCode": null,
        "regionName": "Mactan"
      },
      {
        "regionId": 2970,
        "regionCode": null,
        "regionName": "Metropolitan Manila Area"
      },
      {
        "regionId": 2971,
        "regionCode": null,
        "regionName": "Muslim Mindanao"
      },
      {
        "regionId": 2972,
        "regionCode": "10",
        "regionName": "Northern Mindanao"
      },
      {
        "regionId": 2973,
        "regionCode": null,
        "regionName": "Southern Mindanao"
      },
      {
        "regionId": 2974,
        "regionCode": null,
        "regionName": "Southern Tagalog"
      },
      {
        "regionId": 2975,
        "regionCode": "09",
        "regionName": "Western Mindanao"
      },
      {
        "regionId": 2976,
        "regionCode": null,
        "regionName": "Western Visayas"
      }
    ]
  },
  {
    "countryId": 170,
    "countryCode": "PN",
    "countryName": "Pitcairn Islands",
    "regions": [
      {
        "regionId": 3020,
        "regionCode": null,
        "regionName": "Pitcairn Island"
      }
    ]
  },
  {
    "countryId": 171,
    "countryCode": "PL",
    "countryName": "Poland",
    "regions": [
      {
        "regionId": 2984,
        "regionCode": null,
        "regionName": "Biale Blota"
      },
      {
        "regionId": 2985,
        "regionCode": null,
        "regionName": "Dobroszyce"
      },
      {
        "regionId": 2986,
        "regionCode": null,
        "regionName": "Dolnoslaskie"
      },
      {
        "regionId": 2987,
        "regionCode": null,
        "regionName": "Dziekanow Lesny"
      },
      {
        "regionId": 2988,
        "regionCode": null,
        "regionName": "Hopowo"
      },
      {
        "regionId": 2989,
        "regionCode": null,
        "regionName": "Kartuzy"
      },
      {
        "regionId": 2990,
        "regionCode": null,
        "regionName": "Koscian"
      },
      {
        "regionId": 2991,
        "regionCode": "17",
        "regionName": "Krakow"
      },
      {
        "regionId": 2992,
        "regionCode": null,
        "regionName": "Kujawsko-Pomorskie"
      },
      {
        "regionId": 2993,
        "regionCode": null,
        "regionName": "Lodzkie"
      },
      {
        "regionId": 2994,
        "regionCode": null,
        "regionName": "Lubelskie"
      },
      {
        "regionId": 2995,
        "regionCode": null,
        "regionName": "Lubuskie"
      },
      {
        "regionId": 2996,
        "regionCode": null,
        "regionName": "Malomice"
      },
      {
        "regionId": 2997,
        "regionCode": null,
        "regionName": "Malopolskie"
      },
      {
        "regionId": 2998,
        "regionCode": null,
        "regionName": "Mazowieckie"
      },
      {
        "regionId": 2999,
        "regionCode": null,
        "regionName": "Mirkow"
      },
      {
        "regionId": 3000,
        "regionCode": null,
        "regionName": "Opolskie"
      },
      {
        "regionId": 3001,
        "regionCode": null,
        "regionName": "Ostrowiec"
      },
      {
        "regionId": 3002,
        "regionCode": null,
        "regionName": "Podkarpackie"
      },
      {
        "regionId": 3003,
        "regionCode": null,
        "regionName": "Podlaskie"
      },
      {
        "regionId": 3004,
        "regionCode": null,
        "regionName": "Polska"
      },
      {
        "regionId": 3005,
        "regionCode": null,
        "regionName": "Pomorskie"
      },
      {
        "regionId": 3006,
        "regionCode": "31",
        "regionName": "Poznan"
      },
      {
        "regionId": 3007,
        "regionCode": null,
        "regionName": "Pruszkow"
      },
      {
        "regionId": 3008,
        "regionCode": null,
        "regionName": "Rymanowska"
      },
      {
        "regionId": 3009,
        "regionCode": "34",
        "regionName": "Rzeszow"
      },
      {
        "regionId": 3010,
        "regionCode": null,
        "regionName": "Slaskie"
      },
      {
        "regionId": 3011,
        "regionCode": null,
        "regionName": "Stare Pole"
      },
      {
        "regionId": 3012,
        "regionCode": null,
        "regionName": "Swietokrzyskie"
      },
      {
        "regionId": 3013,
        "regionCode": null,
        "regionName": "Warminsko-Mazurskie"
      },
      {
        "regionId": 3014,
        "regionCode": null,
        "regionName": "Warsaw"
      },
      {
        "regionId": 3015,
        "regionCode": null,
        "regionName": "Wejherowo"
      },
      {
        "regionId": 3016,
        "regionCode": null,
        "regionName": "Wielkopolskie"
      },
      {
        "regionId": 3017,
        "regionCode": "47",
        "regionName": "Wroclaw"
      },
      {
        "regionId": 3018,
        "regionCode": null,
        "regionName": "Zachodnio-Pomorskie"
      },
      {
        "regionId": 3019,
        "regionCode": null,
        "regionName": "Zukowo"
      }
    ]
  },
  {
    "countryId": 172,
    "countryCode": "PT",
    "countryName": "Portugal",
    "regions": [
      {
        "regionId": 3048,
        "regionCode": null,
        "regionName": "Abrantes"
      },
      {
        "regionId": 3049,
        "regionCode": null,
        "regionName": "Acores"
      },
      {
        "regionId": 3050,
        "regionCode": null,
        "regionName": "Alentejo"
      },
      {
        "regionId": 3051,
        "regionCode": "50",
        "regionName": "Algarve"
      },
      {
        "regionId": 3052,
        "regionCode": null,
        "regionName": "Braga"
      },
      {
        "regionId": 3053,
        "regionCode": null,
        "regionName": "Centro"
      },
      {
        "regionId": 3054,
        "regionCode": null,
        "regionName": "Distrito de Leiria"
      },
      {
        "regionId": 3055,
        "regionCode": null,
        "regionName": "Distrito de Viana do Castelo"
      },
      {
        "regionId": 3056,
        "regionCode": null,
        "regionName": "Distrito de Vila Real"
      },
      {
        "regionId": 3057,
        "regionCode": null,
        "regionName": "Distrito do Porto"
      },
      {
        "regionId": 3058,
        "regionCode": null,
        "regionName": "Lisboa e Vale do Tejo"
      },
      {
        "regionId": 3059,
        "regionCode": null,
        "regionName": "Madeira"
      },
      {
        "regionId": 3060,
        "regionCode": null,
        "regionName": "Norte"
      },
      {
        "regionId": 3061,
        "regionCode": null,
        "regionName": "Paivas"
      }
    ]
  },
  {
    "countryId": 173,
    "countryCode": "PR",
    "countryName": "Puerto Rico",
    "regions": [
      {
        "regionId": 3021,
        "regionCode": null,
        "regionName": "Arecibo"
      },
      {
        "regionId": 3022,
        "regionCode": null,
        "regionName": "Bayamon"
      },
      {
        "regionId": 3023,
        "regionCode": null,
        "regionName": "Carolina"
      },
      {
        "regionId": 3024,
        "regionCode": null,
        "regionName": "Florida"
      },
      {
        "regionId": 3025,
        "regionCode": null,
        "regionName": "Guayama"
      },
      {
        "regionId": 3026,
        "regionCode": null,
        "regionName": "Humacao"
      },
      {
        "regionId": 3027,
        "regionCode": null,
        "regionName": "Mayaguez-Aguadilla"
      },
      {
        "regionId": 3028,
        "regionCode": null,
        "regionName": "Ponce"
      },
      {
        "regionId": 3029,
        "regionCode": null,
        "regionName": "Salinas"
      },
      {
        "regionId": 3030,
        "regionCode": null,
        "regionName": "San Juan"
      },
      {
        "regionId": 4075,
        "regionCode": null,
        "regionName": "Cayey"
      }
    ]
  },
  {
    "countryId": 174,
    "countryCode": "QA",
    "countryName": "Qatar",
    "regions": [
      {
        "regionId": 3096,
        "regionCode": null,
        "regionName": "ad-Dawhah"
      },
      {
        "regionId": 3097,
        "regionCode": null,
        "regionName": "al-Ghuwayriyah"
      },
      {
        "regionId": 3098,
        "regionCode": null,
        "regionName": "al-Jumayliyah"
      },
      {
        "regionId": 3099,
        "regionCode": null,
        "regionName": "al-Khawr"
      },
      {
        "regionId": 3100,
        "regionCode": null,
        "regionName": "al-Wakrah"
      },
      {
        "regionId": 3101,
        "regionCode": null,
        "regionName": "ar-Rayyan"
      },
      {
        "regionId": 3102,
        "regionCode": null,
        "regionName": "ash-Shamal"
      },
      {
        "regionId": 3103,
        "regionCode": null,
        "regionName": "Doha"
      },
      {
        "regionId": 3104,
        "regionCode": null,
        "regionName": "Jarian-al-Batnah"
      },
      {
        "regionId": 3105,
        "regionCode": null,
        "regionName": "Umm Salal"
      }
    ]
  },
  {
    "countryId": 175,
    "countryCode": "RE",
    "countryName": "Reunion",
    "regions": [
      {
        "regionId": 3106,
        "regionCode": null,
        "regionName": "Saint-Benoit"
      },
      {
        "regionId": 3107,
        "regionCode": null,
        "regionName": "Saint-Denis"
      },
      {
        "regionId": 3108,
        "regionCode": null,
        "regionName": "Saint-Paul"
      },
      {
        "regionId": 3109,
        "regionCode": null,
        "regionName": "Saint-Pierre"
      }
    ]
  },
  {
    "countryId": 176,
    "countryCode": "RO",
    "countryName": "Romania",
    "regions": [
      {
        "regionId": 3110,
        "regionCode": "01",
        "regionName": "Alba"
      },
      {
        "regionId": 3111,
        "regionCode": "02",
        "regionName": "Arad"
      },
      {
        "regionId": 3112,
        "regionCode": "03",
        "regionName": "Arges"
      },
      {
        "regionId": 3113,
        "regionCode": "04",
        "regionName": "Bacau"
      },
      {
        "regionId": 3114,
        "regionCode": "05",
        "regionName": "Bihor"
      },
      {
        "regionId": 3115,
        "regionCode": "06",
        "regionName": "Bistrita-Nasaud"
      },
      {
        "regionId": 3116,
        "regionCode": "07",
        "regionName": "Botosani"
      },
      {
        "regionId": 3117,
        "regionCode": "08",
        "regionName": "Braila"
      },
      {
        "regionId": 3118,
        "regionCode": "09",
        "regionName": "Brasov"
      },
      {
        "regionId": 3119,
        "regionCode": "10",
        "regionName": "Bucuresti"
      },
      {
        "regionId": 3120,
        "regionCode": "11",
        "regionName": "Buzau"
      },
      {
        "regionId": 3121,
        "regionCode": "12",
        "regionName": "Calarasi"
      },
      {
        "regionId": 3122,
        "regionCode": "13",
        "regionName": "Caras-Severin"
      },
      {
        "regionId": 3123,
        "regionCode": "14",
        "regionName": "Cluj"
      },
      {
        "regionId": 3124,
        "regionCode": "15",
        "regionName": "Constanta"
      },
      {
        "regionId": 3125,
        "regionCode": "16",
        "regionName": "Covasna"
      },
      {
        "regionId": 3126,
        "regionCode": null,
        "regionName": "Dambovita"
      },
      {
        "regionId": 3127,
        "regionCode": "18",
        "regionName": "Dolj"
      },
      {
        "regionId": 3128,
        "regionCode": "19",
        "regionName": "Galati"
      },
      {
        "regionId": 3129,
        "regionCode": "21",
        "regionName": "Giurgiu"
      },
      {
        "regionId": 3130,
        "regionCode": "20",
        "regionName": "Gorj"
      },
      {
        "regionId": 3131,
        "regionCode": "22",
        "regionName": "Harghita"
      },
      {
        "regionId": 3132,
        "regionCode": "23",
        "regionName": "Hunedoara"
      },
      {
        "regionId": 3133,
        "regionCode": "24",
        "regionName": "Ialomita"
      },
      {
        "regionId": 3134,
        "regionCode": "25",
        "regionName": "Iasi"
      },
      {
        "regionId": 3135,
        "regionCode": null,
        "regionName": "Ilfov"
      },
      {
        "regionId": 3136,
        "regionCode": "26",
        "regionName": "Maramures"
      },
      {
        "regionId": 3137,
        "regionCode": "27",
        "regionName": "Mehedinti"
      },
      {
        "regionId": 3138,
        "regionCode": "28",
        "regionName": "Mures"
      },
      {
        "regionId": 3139,
        "regionCode": "29",
        "regionName": "Neamt"
      },
      {
        "regionId": 3140,
        "regionCode": "30",
        "regionName": "Olt"
      },
      {
        "regionId": 3141,
        "regionCode": "31",
        "regionName": "Prahova"
      },
      {
        "regionId": 3142,
        "regionCode": "32",
        "regionName": "Salaj"
      },
      {
        "regionId": 3143,
        "regionCode": "33",
        "regionName": "Satu Mare"
      },
      {
        "regionId": 3144,
        "regionCode": "34",
        "regionName": "Sibiu"
      },
      {
        "regionId": 3145,
        "regionCode": null,
        "regionName": "Sondelor"
      },
      {
        "regionId": 3146,
        "regionCode": "35",
        "regionName": "Suceava"
      },
      {
        "regionId": 3147,
        "regionCode": "36",
        "regionName": "Teleorman"
      },
      {
        "regionId": 3148,
        "regionCode": "37",
        "regionName": "Timis"
      },
      {
        "regionId": 3149,
        "regionCode": "38",
        "regionName": "Tulcea"
      },
      {
        "regionId": 3150,
        "regionCode": null,
        "regionName": "Valcea"
      },
      {
        "regionId": 3151,
        "regionCode": "39",
        "regionName": "Vaslui"
      },
      {
        "regionId": 3152,
        "regionCode": "41",
        "regionName": "Vrancea"
      }
    ]
  },
  {
    "countryId": 177,
    "countryCode": "RU",
    "countryName": "Russian Federation",
    "regions": [
      {
        "regionId": 3156,
        "regionCode": null,
        "regionName": "Adygeja"
      },
      {
        "regionId": 3157,
        "regionCode": null,
        "regionName": "Aga"
      },
      {
        "regionId": 3158,
        "regionCode": null,
        "regionName": "Alanija"
      },
      {
        "regionId": 3159,
        "regionCode": null,
        "regionName": "Altaj"
      },
      {
        "regionId": 3160,
        "regionCode": null,
        "regionName": "Amur"
      },
      {
        "regionId": 3161,
        "regionCode": null,
        "regionName": "Arhangelsk"
      },
      {
        "regionId": 3162,
        "regionCode": null,
        "regionName": "Astrahan"
      },
      {
        "regionId": 3163,
        "regionCode": null,
        "regionName": "Bashkortostan"
      },
      {
        "regionId": 3164,
        "regionCode": null,
        "regionName": "Belgorod"
      },
      {
        "regionId": 3165,
        "regionCode": null,
        "regionName": "Brjansk"
      },
      {
        "regionId": 3166,
        "regionCode": null,
        "regionName": "Burjatija"
      },
      {
        "regionId": 3167,
        "regionCode": null,
        "regionName": "Chechenija"
      },
      {
        "regionId": 3168,
        "regionCode": null,
        "regionName": "Cheljabinsk"
      },
      {
        "regionId": 3169,
        "regionCode": null,
        "regionName": "Chita"
      },
      {
        "regionId": 3170,
        "regionCode": null,
        "regionName": "Chukotka"
      },
      {
        "regionId": 3171,
        "regionCode": null,
        "regionName": "Chuvashija"
      },
      {
        "regionId": 3172,
        "regionCode": null,
        "regionName": "Dagestan"
      },
      {
        "regionId": 3173,
        "regionCode": null,
        "regionName": "Evenkija"
      },
      {
        "regionId": 3174,
        "regionCode": null,
        "regionName": "Gorno-Altaj"
      },
      {
        "regionId": 3175,
        "regionCode": null,
        "regionName": "Habarovsk"
      },
      {
        "regionId": 3176,
        "regionCode": null,
        "regionName": "Hakasija"
      },
      {
        "regionId": 3177,
        "regionCode": null,
        "regionName": "Hanty-Mansija"
      },
      {
        "regionId": 3178,
        "regionCode": null,
        "regionName": "Ingusetija"
      },
      {
        "regionId": 3179,
        "regionCode": null,
        "regionName": "Irkutsk"
      },
      {
        "regionId": 3180,
        "regionCode": null,
        "regionName": "Ivanovo"
      },
      {
        "regionId": 3181,
        "regionCode": null,
        "regionName": "Jamalo-Nenets"
      },
      {
        "regionId": 3182,
        "regionCode": null,
        "regionName": "Jaroslavl"
      },
      {
        "regionId": 3183,
        "regionCode": null,
        "regionName": "Jevrej"
      },
      {
        "regionId": 3184,
        "regionCode": null,
        "regionName": "Kabardino-Balkarija"
      },
      {
        "regionId": 3185,
        "regionCode": null,
        "regionName": "Kaliningrad"
      },
      {
        "regionId": 3186,
        "regionCode": null,
        "regionName": "Kalmykija"
      },
      {
        "regionId": 3187,
        "regionCode": null,
        "regionName": "Kaluga"
      },
      {
        "regionId": 3188,
        "regionCode": null,
        "regionName": "Kamchatka"
      },
      {
        "regionId": 3189,
        "regionCode": null,
        "regionName": "Karachaj-Cherkessija"
      },
      {
        "regionId": 3190,
        "regionCode": null,
        "regionName": "Karelija"
      },
      {
        "regionId": 3191,
        "regionCode": null,
        "regionName": "Kemerovo"
      },
      {
        "regionId": 3192,
        "regionCode": "KHA",
        "regionName": "Khabarovskiy Kray"
      },
      {
        "regionId": 3193,
        "regionCode": null,
        "regionName": "Kirov"
      },
      {
        "regionId": 3194,
        "regionCode": null,
        "regionName": "Komi"
      },
      {
        "regionId": 3195,
        "regionCode": null,
        "regionName": "Komi-Permjakija"
      },
      {
        "regionId": 3196,
        "regionCode": null,
        "regionName": "Korjakija"
      },
      {
        "regionId": 3197,
        "regionCode": null,
        "regionName": "Kostroma"
      },
      {
        "regionId": 3198,
        "regionCode": null,
        "regionName": "Krasnodar"
      },
      {
        "regionId": 3199,
        "regionCode": null,
        "regionName": "Krasnojarsk"
      },
      {
        "regionId": 3200,
        "regionCode": "KYA",
        "regionName": "Krasnoyarskiy Kray"
      },
      {
        "regionId": 3201,
        "regionCode": null,
        "regionName": "Kurgan"
      },
      {
        "regionId": 3202,
        "regionCode": null,
        "regionName": "Kursk"
      },
      {
        "regionId": 3203,
        "regionCode": null,
        "regionName": "Leningrad"
      },
      {
        "regionId": 3204,
        "regionCode": null,
        "regionName": "Lipeck"
      },
      {
        "regionId": 3205,
        "regionCode": null,
        "regionName": "Magadan"
      },
      {
        "regionId": 3206,
        "regionCode": null,
        "regionName": "Marij El"
      },
      {
        "regionId": 3207,
        "regionCode": null,
        "regionName": "Mordovija"
      },
      {
        "regionId": 3208,
        "regionCode": null,
        "regionName": "Moscow"
      },
      {
        "regionId": 3209,
        "regionCode": null,
        "regionName": "Moskovskaja Oblast"
      },
      {
        "regionId": 3210,
        "regionCode": null,
        "regionName": "Moskovskaya Oblast"
      },
      {
        "regionId": 3211,
        "regionCode": "MOW",
        "regionName": "Moskva"
      },
      {
        "regionId": 3212,
        "regionCode": null,
        "regionName": "Murmansk"
      },
      {
        "regionId": 3213,
        "regionCode": null,
        "regionName": "Nenets"
      },
      {
        "regionId": 3214,
        "regionCode": null,
        "regionName": "Nizhnij Novgorod"
      },
      {
        "regionId": 3215,
        "regionCode": null,
        "regionName": "Novgorod"
      },
      {
        "regionId": 3216,
        "regionCode": null,
        "regionName": "Novokusnezk"
      },
      {
        "regionId": 3217,
        "regionCode": null,
        "regionName": "Novosibirsk"
      },
      {
        "regionId": 3218,
        "regionCode": null,
        "regionName": "Omsk"
      },
      {
        "regionId": 3219,
        "regionCode": null,
        "regionName": "Orenburg"
      },
      {
        "regionId": 3220,
        "regionCode": null,
        "regionName": "Orjol"
      },
      {
        "regionId": 3221,
        "regionCode": null,
        "regionName": "Penza"
      },
      {
        "regionId": 3222,
        "regionCode": null,
        "regionName": "Perm"
      },
      {
        "regionId": 3223,
        "regionCode": null,
        "regionName": "Primorje"
      },
      {
        "regionId": 3224,
        "regionCode": null,
        "regionName": "Pskov"
      },
      {
        "regionId": 3225,
        "regionCode": null,
        "regionName": "Pskovskaya Oblast"
      },
      {
        "regionId": 3226,
        "regionCode": null,
        "regionName": "Rjazan"
      },
      {
        "regionId": 3227,
        "regionCode": null,
        "regionName": "Rostov"
      },
      {
        "regionId": 3228,
        "regionCode": null,
        "regionName": "Saha"
      },
      {
        "regionId": 3229,
        "regionCode": null,
        "regionName": "Sahalin"
      },
      {
        "regionId": 3230,
        "regionCode": null,
        "regionName": "Samara"
      },
      {
        "regionId": 3231,
        "regionCode": null,
        "regionName": "Samarskaya"
      },
      {
        "regionId": 3232,
        "regionCode": "SPE",
        "regionName": "Sankt-Peterburg"
      },
      {
        "regionId": 3233,
        "regionCode": null,
        "regionName": "Saratov"
      },
      {
        "regionId": 3234,
        "regionCode": null,
        "regionName": "Smolensk"
      },
      {
        "regionId": 3235,
        "regionCode": null,
        "regionName": "Stavropol"
      },
      {
        "regionId": 3236,
        "regionCode": null,
        "regionName": "Sverdlovsk"
      },
      {
        "regionId": 3237,
        "regionCode": null,
        "regionName": "Tajmyrija"
      },
      {
        "regionId": 3238,
        "regionCode": null,
        "regionName": "Tambov"
      },
      {
        "regionId": 3239,
        "regionCode": null,
        "regionName": "Tatarstan"
      },
      {
        "regionId": 3240,
        "regionCode": null,
        "regionName": "Tjumen"
      },
      {
        "regionId": 3241,
        "regionCode": null,
        "regionName": "Tomsk"
      },
      {
        "regionId": 3242,
        "regionCode": null,
        "regionName": "Tula"
      },
      {
        "regionId": 3243,
        "regionCode": null,
        "regionName": "Tver"
      },
      {
        "regionId": 3244,
        "regionCode": null,
        "regionName": "Tyva"
      },
      {
        "regionId": 3245,
        "regionCode": null,
        "regionName": "Udmurtija"
      },
      {
        "regionId": 3246,
        "regionCode": null,
        "regionName": "Uljanovsk"
      },
      {
        "regionId": 3247,
        "regionCode": null,
        "regionName": "Ulyanovskaya Oblast"
      },
      {
        "regionId": 3248,
        "regionCode": null,
        "regionName": "Ust-Orda"
      },
      {
        "regionId": 3249,
        "regionCode": null,
        "regionName": "Vladimir"
      },
      {
        "regionId": 3250,
        "regionCode": null,
        "regionName": "Volgograd"
      },
      {
        "regionId": 3251,
        "regionCode": null,
        "regionName": "Vologda"
      },
      {
        "regionId": 3252,
        "regionCode": null,
        "regionName": "Voronezh"
      }
    ]
  },
  {
    "countryId": 178,
    "countryCode": "RW",
    "countryName": "Rwanda",
    "regions": [
      {
        "regionId": 3253,
        "regionCode": null,
        "regionName": "Butare"
      },
      {
        "regionId": 3254,
        "regionCode": null,
        "regionName": "Byumba"
      },
      {
        "regionId": 3255,
        "regionCode": null,
        "regionName": "Cyangugu"
      },
      {
        "regionId": 3256,
        "regionCode": null,
        "regionName": "Gikongoro"
      },
      {
        "regionId": 3257,
        "regionCode": null,
        "regionName": "Gisenyi"
      },
      {
        "regionId": 3258,
        "regionCode": null,
        "regionName": "Gitarama"
      },
      {
        "regionId": 3259,
        "regionCode": null,
        "regionName": "Kibungo"
      },
      {
        "regionId": 3260,
        "regionCode": null,
        "regionName": "Kibuye"
      },
      {
        "regionId": 3261,
        "regionCode": null,
        "regionName": "Kigali-ngali"
      },
      {
        "regionId": 3262,
        "regionCode": null,
        "regionName": "Ruhengeri"
      }
    ]
  },
  {
    "countryId": 179,
    "countryCode": "SH",
    "countryName": "Saint Helena",
    "regions": [
      {
        "regionId": 3353,
        "regionCode": null,
        "regionName": "Ascension"
      },
      {
        "regionId": 3354,
        "regionCode": null,
        "regionName": "Gough Island"
      },
      {
        "regionId": 3355,
        "regionCode": null,
        "regionName": "Saint Helena"
      },
      {
        "regionId": 3356,
        "regionCode": null,
        "regionName": "Tristan da Cunha"
      }
    ]
  },
  {
    "countryId": 180,
    "countryCode": "KN",
    "countryName": "Saint Kitts and Nevis",
    "regions": [
      {
        "regionId": 2166,
        "regionCode": null,
        "regionName": "Christ Church Nichola Town"
      },
      {
        "regionId": 2167,
        "regionCode": null,
        "regionName": "Saint Anne Sandy Point"
      },
      {
        "regionId": 2168,
        "regionCode": null,
        "regionName": "Saint George Basseterre"
      },
      {
        "regionId": 2169,
        "regionCode": null,
        "regionName": "Saint George Gingerland"
      },
      {
        "regionId": 2170,
        "regionCode": null,
        "regionName": "Saint James Windward"
      },
      {
        "regionId": 2171,
        "regionCode": null,
        "regionName": "Saint John Capesterre"
      },
      {
        "regionId": 2172,
        "regionCode": null,
        "regionName": "Saint John Figtree"
      },
      {
        "regionId": 2173,
        "regionCode": null,
        "regionName": "Saint Mary Cayon"
      },
      {
        "regionId": 2174,
        "regionCode": null,
        "regionName": "Saint Paul Capesterre"
      },
      {
        "regionId": 2175,
        "regionCode": null,
        "regionName": "Saint Paul Charlestown"
      },
      {
        "regionId": 2176,
        "regionCode": null,
        "regionName": "Saint Peter Basseterre"
      },
      {
        "regionId": 2177,
        "regionCode": null,
        "regionName": "Saint Thomas Lowland"
      },
      {
        "regionId": 2178,
        "regionCode": null,
        "regionName": "Saint Thomas Middle Island"
      },
      {
        "regionId": 2179,
        "regionCode": null,
        "regionName": "Trinity Palmetto Point"
      }
    ]
  },
  {
    "countryId": 181,
    "countryCode": "LC",
    "countryName": "Saint Lucia",
    "regions": [
      {
        "regionId": 2278,
        "regionCode": null,
        "regionName": "Anse-la-Raye"
      },
      {
        "regionId": 2279,
        "regionCode": null,
        "regionName": "Canaries"
      },
      {
        "regionId": 2280,
        "regionCode": null,
        "regionName": "Castries"
      },
      {
        "regionId": 2281,
        "regionCode": null,
        "regionName": "Choiseul"
      },
      {
        "regionId": 2282,
        "regionCode": null,
        "regionName": "Dennery"
      },
      {
        "regionId": 2283,
        "regionCode": null,
        "regionName": "Gros Inlet"
      },
      {
        "regionId": 2284,
        "regionCode": null,
        "regionName": "Laborie"
      },
      {
        "regionId": 2285,
        "regionCode": null,
        "regionName": "Micoud"
      },
      {
        "regionId": 2286,
        "regionCode": null,
        "regionName": "Soufriere"
      },
      {
        "regionId": 2287,
        "regionCode": null,
        "regionName": "Vieux Fort"
      }
    ]
  },
  {
    "countryId": 182,
    "countryCode": "WS",
    "countryName": "Samoa",
    "regions": [
      {
        "regionId": 3938,
        "regionCode": null,
        "regionName": "A'ana"
      },
      {
        "regionId": 3939,
        "regionCode": null,
        "regionName": "Aiga-i-le-Tai"
      },
      {
        "regionId": 3940,
        "regionCode": null,
        "regionName": "Atua"
      },
      {
        "regionId": 3941,
        "regionCode": null,
        "regionName": "Fa'asaleleaga"
      },
      {
        "regionId": 3942,
        "regionCode": null,
        "regionName": "Gaga'emauga"
      },
      {
        "regionId": 3943,
        "regionCode": null,
        "regionName": "Gagaifomauga"
      },
      {
        "regionId": 3944,
        "regionCode": null,
        "regionName": "Palauli"
      },
      {
        "regionId": 3945,
        "regionCode": null,
        "regionName": "Satupa'itea"
      },
      {
        "regionId": 3946,
        "regionCode": null,
        "regionName": "Tuamasaga"
      },
      {
        "regionId": 3947,
        "regionCode": null,
        "regionName": "Va'a-o-Fonoti"
      },
      {
        "regionId": 3948,
        "regionCode": null,
        "regionName": "Vaisigano"
      }
    ]
  },
  {
    "countryId": 183,
    "countryCode": "SM",
    "countryName": "San Marino",
    "regions": [
      {
        "regionId": 3386,
        "regionCode": null,
        "regionName": "Acquaviva"
      },
      {
        "regionId": 3387,
        "regionCode": null,
        "regionName": "Borgo Maggiore"
      },
      {
        "regionId": 3388,
        "regionCode": null,
        "regionName": "Chiesanuova"
      },
      {
        "regionId": 3389,
        "regionCode": null,
        "regionName": "Domagnano"
      },
      {
        "regionId": 3390,
        "regionCode": null,
        "regionName": "Faetano"
      },
      {
        "regionId": 3391,
        "regionCode": null,
        "regionName": "Fiorentino"
      },
      {
        "regionId": 3392,
        "regionCode": null,
        "regionName": "Montegiardino"
      },
      {
        "regionId": 3393,
        "regionCode": null,
        "regionName": "San Marino"
      },
      {
        "regionId": 3394,
        "regionCode": null,
        "regionName": "Serravalle"
      }
    ]
  },
  {
    "countryId": 184,
    "countryCode": "SA",
    "countryName": "Saudi Arabia",
    "regions": [
      {
        "regionId": 3263,
        "regionCode": null,
        "regionName": "Al Khobar"
      },
      {
        "regionId": 3264,
        "regionCode": null,
        "regionName": "al-Bahah"
      },
      {
        "regionId": 3265,
        "regionCode": null,
        "regionName": "al-Hudud-ash-Shamaliyah"
      },
      {
        "regionId": 3266,
        "regionCode": null,
        "regionName": "al-Madinah"
      },
      {
        "regionId": 3267,
        "regionCode": null,
        "regionName": "ar-Riyad"
      },
      {
        "regionId": 3268,
        "regionCode": null,
        "regionName": "Aseer"
      },
      {
        "regionId": 3269,
        "regionCode": null,
        "regionName": "Ash Sharqiyah"
      },
      {
        "regionId": 3270,
        "regionCode": null,
        "regionName": "Asir"
      },
      {
        "regionId": 3271,
        "regionCode": null,
        "regionName": "Central Province"
      },
      {
        "regionId": 3272,
        "regionCode": null,
        "regionName": "Eastern Province"
      },
      {
        "regionId": 3273,
        "regionCode": null,
        "regionName": "Ha'il"
      },
      {
        "regionId": 3274,
        "regionCode": null,
        "regionName": "Jawf"
      },
      {
        "regionId": 3275,
        "regionCode": null,
        "regionName": "Jizan"
      },
      {
        "regionId": 3276,
        "regionCode": null,
        "regionName": "Makkah"
      },
      {
        "regionId": 3277,
        "regionCode": null,
        "regionName": "Najran"
      },
      {
        "regionId": 3278,
        "regionCode": null,
        "regionName": "Qasim"
      },
      {
        "regionId": 3279,
        "regionCode": null,
        "regionName": "Tabuk"
      },
      {
        "regionId": 3280,
        "regionCode": null,
        "regionName": "Western Province"
      }
    ]
  },
  {
    "countryId": 185,
    "countryCode": "SN",
    "countryName": "Senegal",
    "regions": [
      {
        "regionId": 3395,
        "regionCode": null,
        "regionName": "Dakar"
      },
      {
        "regionId": 3396,
        "regionCode": null,
        "regionName": "Diourbel"
      },
      {
        "regionId": 3397,
        "regionCode": null,
        "regionName": "Fatick"
      },
      {
        "regionId": 3398,
        "regionCode": null,
        "regionName": "Kaolack"
      },
      {
        "regionId": 3399,
        "regionCode": null,
        "regionName": "Kolda"
      },
      {
        "regionId": 3400,
        "regionCode": null,
        "regionName": "Louga"
      },
      {
        "regionId": 3401,
        "regionCode": null,
        "regionName": "Saint-Louis"
      },
      {
        "regionId": 3402,
        "regionCode": null,
        "regionName": "Tambacounda"
      },
      {
        "regionId": 3403,
        "regionCode": null,
        "regionName": "Thies"
      },
      {
        "regionId": 3404,
        "regionCode": null,
        "regionName": "Ziguinchor"
      }
    ]
  },
  {
    "countryId": 186,
    "countryCode": "RS",
    "countryName": "Serbia",
    "regions": [
      {
        "regionId": 3153,
        "regionCode": null,
        "regionName": "Central Serbia"
      },
      {
        "regionId": 3154,
        "regionCode": null,
        "regionName": "Kosovo and Metohija"
      },
      {
        "regionId": 3155,
        "regionCode": null,
        "regionName": "Vojvodina"
      }
    ]
  },
  {
    "countryId": 187,
    "countryCode": "SC",
    "countryName": "Seychelles",
    "regions": [
      {
        "regionId": 3290,
        "regionCode": null,
        "regionName": "Anse Boileau"
      },
      {
        "regionId": 3291,
        "regionCode": null,
        "regionName": "Anse Royale"
      },
      {
        "regionId": 3292,
        "regionCode": null,
        "regionName": "Cascade"
      },
      {
        "regionId": 3293,
        "regionCode": null,
        "regionName": "Takamaka"
      },
      {
        "regionId": 3294,
        "regionCode": null,
        "regionName": "Victoria"
      }
    ]
  },
  {
    "countryId": 188,
    "countryCode": "SL",
    "countryName": "Sierra Leone",
    "regions": [
      {
        "regionId": 3382,
        "regionCode": null,
        "regionName": "Eastern"
      },
      {
        "regionId": 3383,
        "regionCode": null,
        "regionName": "Northern"
      },
      {
        "regionId": 3384,
        "regionCode": null,
        "regionName": "Southern"
      },
      {
        "regionId": 3385,
        "regionCode": null,
        "regionName": "Western"
      }
    ]
  },
  {
    "countryId": 189,
    "countryCode": "SG",
    "countryName": "Singapore",
    "regions": [
      {
        "regionId": 3352,
        "regionCode": "SG",
        "regionName": "Singapore"
      }
    ]
  },
  {
    "countryId": 190,
    "countryCode": "SK",
    "countryName": "Slovakia",
    "regions": [
      {
        "regionId": 3374,
        "regionCode": null,
        "regionName": "Banskobystricky"
      },
      {
        "regionId": 3375,
        "regionCode": null,
        "regionName": "Bratislavsky"
      },
      {
        "regionId": 3376,
        "regionCode": null,
        "regionName": "Kosicky"
      },
      {
        "regionId": 3377,
        "regionCode": null,
        "regionName": "Nitriansky"
      },
      {
        "regionId": 3378,
        "regionCode": null,
        "regionName": "Presovsky"
      },
      {
        "regionId": 3379,
        "regionCode": null,
        "regionName": "Trenciansky"
      },
      {
        "regionId": 3380,
        "regionCode": null,
        "regionName": "Trnavsky"
      },
      {
        "regionId": 3381,
        "regionCode": null,
        "regionName": "Zilinsky"
      }
    ]
  },
  {
    "countryId": 191,
    "countryCode": "SI",
    "countryName": "Slovenia",
    "regions": [
      {
        "regionId": 3357,
        "regionCode": null,
        "regionName": "Benedikt"
      },
      {
        "regionId": 3358,
        "regionCode": null,
        "regionName": "Gorenjska"
      },
      {
        "regionId": 3359,
        "regionCode": null,
        "regionName": "Gorishka"
      },
      {
        "regionId": 3360,
        "regionCode": null,
        "regionName": "Jugovzhodna Slovenija"
      },
      {
        "regionId": 3361,
        "regionCode": null,
        "regionName": "Koroshka"
      },
      {
        "regionId": 3362,
        "regionCode": null,
        "regionName": "Notranjsko-krashka"
      },
      {
        "regionId": 3363,
        "regionCode": null,
        "regionName": "Obalno-krashka"
      },
      {
        "regionId": 3364,
        "regionCode": null,
        "regionName": "Obcina Domzale"
      },
      {
        "regionId": 3365,
        "regionCode": null,
        "regionName": "Obcina Vitanje"
      },
      {
        "regionId": 3366,
        "regionCode": null,
        "regionName": "Osrednjeslovenska"
      },
      {
        "regionId": 3367,
        "regionCode": null,
        "regionName": "Podravska"
      },
      {
        "regionId": 3368,
        "regionCode": null,
        "regionName": "Pomurska"
      },
      {
        "regionId": 3369,
        "regionCode": null,
        "regionName": "Savinjska"
      },
      {
        "regionId": 3370,
        "regionCode": null,
        "regionName": "Slovenian Littoral"
      },
      {
        "regionId": 3371,
        "regionCode": null,
        "regionName": "Spodnjeposavska"
      },
      {
        "regionId": 3372,
        "regionCode": null,
        "regionName": "Zasavska"
      }
    ]
  },
  {
    "countryId": 192,
    "countryCode": "SB",
    "countryName": "Solomon Islands",
    "regions": [
      {
        "regionId": 3281,
        "regionCode": null,
        "regionName": "Central"
      },
      {
        "regionId": 3282,
        "regionCode": null,
        "regionName": "Choiseul"
      },
      {
        "regionId": 3283,
        "regionCode": null,
        "regionName": "Guadalcanal"
      },
      {
        "regionId": 3284,
        "regionCode": null,
        "regionName": "Isabel"
      },
      {
        "regionId": 3285,
        "regionCode": null,
        "regionName": "Makira and Ulawa"
      },
      {
        "regionId": 3286,
        "regionCode": null,
        "regionName": "Malaita"
      },
      {
        "regionId": 3287,
        "regionCode": null,
        "regionName": "Rennell and Bellona"
      },
      {
        "regionId": 3288,
        "regionCode": null,
        "regionName": "Temotu"
      },
      {
        "regionId": 3289,
        "regionCode": null,
        "regionName": "Western"
      }
    ]
  },
  {
    "countryId": 193,
    "countryCode": "SO",
    "countryName": "Somalia",
    "regions": [
      {
        "regionId": 3405,
        "regionCode": "AW",
        "regionName": "Awdal"
      },
      {
        "regionId": 3406,
        "regionCode": null,
        "regionName": "Bakol"
      },
      {
        "regionId": 3407,
        "regionCode": null,
        "regionName": "Banadir"
      },
      {
        "regionId": 3408,
        "regionCode": "BR",
        "regionName": "Bari"
      },
      {
        "regionId": 3409,
        "regionCode": "BY",
        "regionName": "Bay"
      },
      {
        "regionId": 3410,
        "regionCode": null,
        "regionName": "Galgudug"
      },
      {
        "regionId": 3411,
        "regionCode": "GE",
        "regionName": "Gedo"
      },
      {
        "regionId": 3412,
        "regionCode": null,
        "regionName": "Hiran"
      },
      {
        "regionId": 3413,
        "regionCode": null,
        "regionName": "Jubbada Hose"
      },
      {
        "regionId": 3414,
        "regionCode": null,
        "regionName": "Jubbadha Dexe"
      },
      {
        "regionId": 3415,
        "regionCode": "MU",
        "regionName": "Mudug"
      },
      {
        "regionId": 3416,
        "regionCode": null,
        "regionName": "Nugal"
      },
      {
        "regionId": 3417,
        "regionCode": null,
        "regionName": "Sanag"
      },
      {
        "regionId": 3418,
        "regionCode": null,
        "regionName": "Shabellaha Dhexe"
      },
      {
        "regionId": 3419,
        "regionCode": null,
        "regionName": "Shabellaha Hose"
      },
      {
        "regionId": 3420,
        "regionCode": null,
        "regionName": "Togdher"
      },
      {
        "regionId": 3421,
        "regionCode": null,
        "regionName": "Woqoyi Galbed"
      }
    ]
  },
  {
    "countryId": 194,
    "countryCode": "ZA",
    "countryName": "South Africa",
    "regions": [
      {
        "regionId": 3970,
        "regionCode": "EC",
        "regionName": "Eastern Cape"
      },
      {
        "regionId": 3971,
        "regionCode": null,
        "regionName": "Free State"
      },
      {
        "regionId": 3972,
        "regionCode": "GP",
        "regionName": "Gauteng"
      },
      {
        "regionId": 3973,
        "regionCode": null,
        "regionName": "Kempton Park"
      },
      {
        "regionId": 3974,
        "regionCode": null,
        "regionName": "Kramerville"
      },
      {
        "regionId": 3975,
        "regionCode": null,
        "regionName": "KwaZulu Natal"
      },
      {
        "regionId": 3976,
        "regionCode": null,
        "regionName": "Limpopo"
      },
      {
        "regionId": 3977,
        "regionCode": "MP",
        "regionName": "Mpumalanga"
      },
      {
        "regionId": 3978,
        "regionCode": null,
        "regionName": "North West"
      },
      {
        "regionId": 3979,
        "regionCode": "NC",
        "regionName": "Northern Cape"
      },
      {
        "regionId": 3980,
        "regionCode": null,
        "regionName": "Parow"
      },
      {
        "regionId": 3981,
        "regionCode": null,
        "regionName": "Table View"
      },
      {
        "regionId": 3982,
        "regionCode": null,
        "regionName": "Umtentweni"
      },
      {
        "regionId": 3983,
        "regionCode": "WC",
        "regionName": "Western Cape"
      }
    ]
  },
  {
    "countryId": 195,
    "countryCode": "ES",
    "countryName": "Spain",
    "regions": [
      {
        "regionId": 1065,
        "regionCode": null,
        "regionName": "A Coruna"
      },
      {
        "regionId": 1066,
        "regionCode": null,
        "regionName": "Alacant"
      },
      {
        "regionId": 1067,
        "regionCode": "01",
        "regionName": "Alava"
      },
      {
        "regionId": 1068,
        "regionCode": "02",
        "regionName": "Albacete"
      },
      {
        "regionId": 1069,
        "regionCode": "04",
        "regionName": "Almeria"
      },
      {
        "regionId": 1070,
        "regionCode": null,
        "regionName": "Andalucia"
      },
      {
        "regionId": 1071,
        "regionCode": "33",
        "regionName": "Asturias"
      },
      {
        "regionId": 1072,
        "regionCode": "05",
        "regionName": "Avila"
      },
      {
        "regionId": 1073,
        "regionCode": "06",
        "regionName": "Badajoz"
      },
      {
        "regionId": 1074,
        "regionCode": null,
        "regionName": "Balears"
      },
      {
        "regionId": 1075,
        "regionCode": "08",
        "regionName": "Barcelona"
      },
      {
        "regionId": 1076,
        "regionCode": null,
        "regionName": "Bertamirans"
      },
      {
        "regionId": 1077,
        "regionCode": null,
        "regionName": "Biscay"
      },
      {
        "regionId": 1078,
        "regionCode": "09",
        "regionName": "Burgos"
      },
      {
        "regionId": 1079,
        "regionCode": "10",
        "regionName": "Caceres"
      },
      {
        "regionId": 1080,
        "regionCode": "11",
        "regionName": "Cadiz"
      },
      {
        "regionId": 1081,
        "regionCode": "39",
        "regionName": "Cantabria"
      },
      {
        "regionId": 1082,
        "regionCode": null,
        "regionName": "Castello"
      },
      {
        "regionId": 1083,
        "regionCode": null,
        "regionName": "Catalunya"
      },
      {
        "regionId": 1084,
        "regionCode": null,
        "regionName": "Ceuta"
      },
      {
        "regionId": 1085,
        "regionCode": "13",
        "regionName": "Ciudad Real"
      },
      {
        "regionId": 1086,
        "regionCode": null,
        "regionName": "Comunidad Autonoma de Canarias"
      },
      {
        "regionId": 1087,
        "regionCode": null,
        "regionName": "Comunidad Autonoma de Cataluna"
      },
      {
        "regionId": 1088,
        "regionCode": null,
        "regionName": "Comunidad Autonoma de Galicia"
      },
      {
        "regionId": 1089,
        "regionCode": null,
        "regionName": "Comunidad Autonoma de las Isla"
      },
      {
        "regionId": 1090,
        "regionCode": null,
        "regionName": "Comunidad Autonoma del Princip"
      },
      {
        "regionId": 1091,
        "regionCode": null,
        "regionName": "Comunidad Valenciana"
      },
      {
        "regionId": 1092,
        "regionCode": null,
        "regionName": "Cordoba"
      },
      {
        "regionId": 1093,
        "regionCode": "16",
        "regionName": "Cuenca"
      },
      {
        "regionId": 1094,
        "regionCode": null,
        "regionName": "Gipuzkoa"
      },
      {
        "regionId": 1095,
        "regionCode": null,
        "regionName": "Girona"
      },
      {
        "regionId": 1096,
        "regionCode": "18",
        "regionName": "Granada"
      },
      {
        "regionId": 1097,
        "regionCode": "19",
        "regionName": "Guadalajara"
      },
      {
        "regionId": 1098,
        "regionCode": "20",
        "regionName": "Guipuzcoa"
      },
      {
        "regionId": 1099,
        "regionCode": "21",
        "regionName": "Huelva"
      },
      {
        "regionId": 1100,
        "regionCode": "22",
        "regionName": "Huesca"
      },
      {
        "regionId": 1101,
        "regionCode": "23",
        "regionName": "Jaen"
      },
      {
        "regionId": 1102,
        "regionCode": "26",
        "regionName": "La Rioja"
      },
      {
        "regionId": 1103,
        "regionCode": "35",
        "regionName": "Las Palmas"
      },
      {
        "regionId": 1104,
        "regionCode": "24",
        "regionName": "Leon"
      },
      {
        "regionId": 1105,
        "regionCode": "25",
        "regionName": "Lerida"
      },
      {
        "regionId": 1106,
        "regionCode": null,
        "regionName": "Lleida"
      },
      {
        "regionId": 1107,
        "regionCode": "27",
        "regionName": "Lugo"
      },
      {
        "regionId": 1108,
        "regionCode": "28",
        "regionName": "Madrid"
      },
      {
        "regionId": 1109,
        "regionCode": "29",
        "regionName": "Malaga"
      },
      {
        "regionId": 1110,
        "regionCode": null,
        "regionName": "Melilla"
      },
      {
        "regionId": 1111,
        "regionCode": "30",
        "regionName": "Murcia"
      },
      {
        "regionId": 1112,
        "regionCode": "31",
        "regionName": "Navarra"
      },
      {
        "regionId": 1113,
        "regionCode": null,
        "regionName": "Ourense"
      },
      {
        "regionId": 1114,
        "regionCode": null,
        "regionName": "Pais Vasco"
      },
      {
        "regionId": 1115,
        "regionCode": "34",
        "regionName": "Palencia"
      },
      {
        "regionId": 1116,
        "regionCode": "36",
        "regionName": "Pontevedra"
      },
      {
        "regionId": 1117,
        "regionCode": "37",
        "regionName": "Salamanca"
      },
      {
        "regionId": 1118,
        "regionCode": null,
        "regionName": "Santa Cruz de Tenerife"
      },
      {
        "regionId": 1119,
        "regionCode": "40",
        "regionName": "Segovia"
      },
      {
        "regionId": 1120,
        "regionCode": "41",
        "regionName": "Sevilla"
      },
      {
        "regionId": 1121,
        "regionCode": "42",
        "regionName": "Soria"
      },
      {
        "regionId": 1122,
        "regionCode": "43",
        "regionName": "Tarragona"
      },
      {
        "regionId": 1123,
        "regionCode": null,
        "regionName": "Tenerife"
      },
      {
        "regionId": 1124,
        "regionCode": "44",
        "regionName": "Teruel"
      },
      {
        "regionId": 1125,
        "regionCode": "45",
        "regionName": "Toledo"
      },
      {
        "regionId": 1126,
        "regionCode": "46",
        "regionName": "Valencia"
      },
      {
        "regionId": 1127,
        "regionCode": "47",
        "regionName": "Valladolid"
      },
      {
        "regionId": 1128,
        "regionCode": "48",
        "regionName": "Vizcaya"
      },
      {
        "regionId": 1129,
        "regionCode": "49",
        "regionName": "Zamora"
      },
      {
        "regionId": 1130,
        "regionCode": "50",
        "regionName": "Zaragoza"
      }
    ]
  },
  {
    "countryId": 196,
    "countryCode": "LK",
    "countryName": "Sri Lanka",
    "regions": [
      {
        "regionId": 2299,
        "regionCode": null,
        "regionName": "Amparai"
      },
      {
        "regionId": 2300,
        "regionCode": null,
        "regionName": "Anuradhapuraya"
      },
      {
        "regionId": 2301,
        "regionCode": null,
        "regionName": "Badulla"
      },
      {
        "regionId": 2302,
        "regionCode": null,
        "regionName": "Boralesgamuwa"
      },
      {
        "regionId": 2303,
        "regionCode": null,
        "regionName": "Colombo"
      },
      {
        "regionId": 2304,
        "regionCode": null,
        "regionName": "Galla"
      },
      {
        "regionId": 2305,
        "regionCode": null,
        "regionName": "Gampaha"
      },
      {
        "regionId": 2306,
        "regionCode": null,
        "regionName": "Hambantota"
      },
      {
        "regionId": 2307,
        "regionCode": null,
        "regionName": "kadawatha"
      },
      {
        "regionId": 2308,
        "regionCode": null,
        "regionName": "Kalatura"
      },
      {
        "regionId": 2309,
        "regionCode": null,
        "regionName": "Kegalla"
      },
      {
        "regionId": 2310,
        "regionCode": null,
        "regionName": "Kilinochchi"
      },
      {
        "regionId": 2311,
        "regionCode": null,
        "regionName": "Kurunegala"
      },
      {
        "regionId": 2312,
        "regionCode": null,
        "regionName": "Madakalpuwa"
      },
      {
        "regionId": 2313,
        "regionCode": null,
        "regionName": "Maha Nuwara"
      },
      {
        "regionId": 2314,
        "regionCode": null,
        "regionName": "Malwana"
      },
      {
        "regionId": 2315,
        "regionCode": null,
        "regionName": "Mannarama"
      },
      {
        "regionId": 2316,
        "regionCode": null,
        "regionName": "Matale"
      },
      {
        "regionId": 2317,
        "regionCode": null,
        "regionName": "Matara"
      },
      {
        "regionId": 2318,
        "regionCode": null,
        "regionName": "Monaragala"
      },
      {
        "regionId": 2319,
        "regionCode": null,
        "regionName": "Mullaitivu"
      },
      {
        "regionId": 2320,
        "regionCode": null,
        "regionName": "North Eastern Province"
      },
      {
        "regionId": 2321,
        "regionCode": null,
        "regionName": "North Western Province"
      },
      {
        "regionId": 2322,
        "regionCode": null,
        "regionName": "Nuwara Eliya"
      },
      {
        "regionId": 2323,
        "regionCode": null,
        "regionName": "Polonnaruwa"
      },
      {
        "regionId": 2324,
        "regionCode": null,
        "regionName": "Puttalama"
      },
      {
        "regionId": 2325,
        "regionCode": null,
        "regionName": "Ratnapuraya"
      },
      {
        "regionId": 2326,
        "regionCode": null,
        "regionName": "Southern Province"
      },
      {
        "regionId": 2327,
        "regionCode": null,
        "regionName": "Tirikunamalaya"
      },
      {
        "regionId": 2328,
        "regionCode": null,
        "regionName": "Tuscany"
      },
      {
        "regionId": 2329,
        "regionCode": null,
        "regionName": "Vavuniyawa"
      },
      {
        "regionId": 2330,
        "regionCode": null,
        "regionName": "Western Province"
      },
      {
        "regionId": 2331,
        "regionCode": null,
        "regionName": "Yapanaya"
      }
    ]
  },
  {
    "countryId": 197,
    "countryCode": "SD",
    "countryName": "Sudan",
    "regions": [
      {
        "regionId": 3295,
        "regionCode": null,
        "regionName": "A'ali-an-Nil"
      },
      {
        "regionId": 3296,
        "regionCode": null,
        "regionName": "al-Bahr-al-Ahmar"
      },
      {
        "regionId": 3297,
        "regionCode": null,
        "regionName": "al-Buhayrat"
      },
      {
        "regionId": 3298,
        "regionCode": null,
        "regionName": "al-Jazirah"
      },
      {
        "regionId": 3299,
        "regionCode": null,
        "regionName": "al-Khartum"
      },
      {
        "regionId": 3300,
        "regionCode": null,
        "regionName": "al-Qadarif"
      },
      {
        "regionId": 3301,
        "regionCode": null,
        "regionName": "al-Wahdah"
      },
      {
        "regionId": 3302,
        "regionCode": null,
        "regionName": "an-Nil-al-Abyad"
      },
      {
        "regionId": 3303,
        "regionCode": null,
        "regionName": "an-Nil-al-Azraq"
      },
      {
        "regionId": 3304,
        "regionCode": null,
        "regionName": "ash-Shamaliyah"
      },
      {
        "regionId": 3305,
        "regionCode": null,
        "regionName": "Bahr-al-Jabal"
      },
      {
        "regionId": 3306,
        "regionCode": null,
        "regionName": "Central Equatoria"
      },
      {
        "regionId": 3307,
        "regionCode": null,
        "regionName": "Gharb Bahr-al-Ghazal"
      },
      {
        "regionId": 3308,
        "regionCode": null,
        "regionName": "Gharb Darfur"
      },
      {
        "regionId": 3309,
        "regionCode": null,
        "regionName": "Gharb Kurdufan"
      },
      {
        "regionId": 3310,
        "regionCode": null,
        "regionName": "Gharb-al-Istiwa'iyah"
      },
      {
        "regionId": 3311,
        "regionCode": null,
        "regionName": "Janub Darfur"
      },
      {
        "regionId": 3312,
        "regionCode": null,
        "regionName": "Janub Kurdufan"
      },
      {
        "regionId": 3313,
        "regionCode": null,
        "regionName": "Junqali"
      },
      {
        "regionId": 3314,
        "regionCode": null,
        "regionName": "Kassala"
      },
      {
        "regionId": 3315,
        "regionCode": null,
        "regionName": "Nahr-an-Nil"
      },
      {
        "regionId": 3316,
        "regionCode": null,
        "regionName": "Shamal Bahr-al-Ghazal"
      },
      {
        "regionId": 3317,
        "regionCode": null,
        "regionName": "Shamal Darfur"
      },
      {
        "regionId": 3318,
        "regionCode": null,
        "regionName": "Shamal Kurdufan"
      },
      {
        "regionId": 3319,
        "regionCode": null,
        "regionName": "Sharq-al-Istiwa'iyah"
      },
      {
        "regionId": 3320,
        "regionCode": null,
        "regionName": "Sinnar"
      },
      {
        "regionId": 3321,
        "regionCode": null,
        "regionName": "Warab"
      },
      {
        "regionId": 3322,
        "regionCode": null,
        "regionName": "Wilayat al Khartum"
      }
    ]
  },
  {
    "countryId": 198,
    "countryCode": "SR",
    "countryName": "Suriname",
    "regions": [
      {
        "regionId": 3422,
        "regionCode": "BR",
        "regionName": "Brokopondo"
      },
      {
        "regionId": 3423,
        "regionCode": "CM",
        "regionName": "Commewijne"
      },
      {
        "regionId": 3424,
        "regionCode": "CR",
        "regionName": "Coronie"
      },
      {
        "regionId": 3425,
        "regionCode": "MA",
        "regionName": "Marowijne"
      },
      {
        "regionId": 3426,
        "regionCode": "NI",
        "regionName": "Nickerie"
      },
      {
        "regionId": 3427,
        "regionCode": "PR",
        "regionName": "Para"
      },
      {
        "regionId": 3428,
        "regionCode": "PM",
        "regionName": "Paramaribo"
      },
      {
        "regionId": 3429,
        "regionCode": "SA",
        "regionName": "Saramacca"
      },
      {
        "regionId": 3430,
        "regionCode": "WA",
        "regionName": "Wanica"
      }
    ]
  },
  {
    "countryId": 199,
    "countryCode": "SJ",
    "countryName": "Svalbard",
    "regions": [
      {
        "regionId": 3373,
        "regionCode": null,
        "regionName": "Svalbard"
      }
    ]
  },
  {
    "countryId": 200,
    "countryCode": "SZ",
    "countryName": "Swaziland",
    "regions": [
      {
        "regionId": 3460,
        "regionCode": null,
        "regionName": "Hhohho"
      },
      {
        "regionId": 3461,
        "regionCode": null,
        "regionName": "Lubombo"
      },
      {
        "regionId": 3462,
        "regionCode": null,
        "regionName": "Manzini"
      },
      {
        "regionId": 3463,
        "regionCode": null,
        "regionName": "Shiselweni"
      }
    ]
  },
  {
    "countryId": 201,
    "countryCode": "SE",
    "countryName": "Sweden",
    "regions": [
      {
        "regionId": 3323,
        "regionCode": null,
        "regionName": "Alvsborgs Lan"
      },
      {
        "regionId": 3324,
        "regionCode": null,
        "regionName": "Angermanland"
      },
      {
        "regionId": 3325,
        "regionCode": null,
        "regionName": "Blekinge"
      },
      {
        "regionId": 3326,
        "regionCode": null,
        "regionName": "Bohuslan"
      },
      {
        "regionId": 3327,
        "regionCode": null,
        "regionName": "Dalarna"
      },
      {
        "regionId": 3328,
        "regionCode": null,
        "regionName": "Gavleborg"
      },
      {
        "regionId": 3329,
        "regionCode": null,
        "regionName": "Gaza"
      },
      {
        "regionId": 3330,
        "regionCode": null,
        "regionName": "Gotland"
      },
      {
        "regionId": 3331,
        "regionCode": null,
        "regionName": "Halland"
      },
      {
        "regionId": 3332,
        "regionCode": null,
        "regionName": "Jamtland"
      },
      {
        "regionId": 3333,
        "regionCode": null,
        "regionName": "Jonkoping"
      },
      {
        "regionId": 3334,
        "regionCode": null,
        "regionName": "Kalmar"
      },
      {
        "regionId": 3335,
        "regionCode": null,
        "regionName": "Kristianstads"
      },
      {
        "regionId": 3336,
        "regionCode": null,
        "regionName": "Kronoberg"
      },
      {
        "regionId": 3337,
        "regionCode": null,
        "regionName": "Norrbotten"
      },
      {
        "regionId": 3338,
        "regionCode": null,
        "regionName": "Orebro"
      },
      {
        "regionId": 3339,
        "regionCode": null,
        "regionName": "Ostergotland"
      },
      {
        "regionId": 3340,
        "regionCode": null,
        "regionName": "Saltsjo-Boo"
      },
      {
        "regionId": 3341,
        "regionCode": null,
        "regionName": "Skane"
      },
      {
        "regionId": 3342,
        "regionCode": null,
        "regionName": "Smaland"
      },
      {
        "regionId": 3343,
        "regionCode": null,
        "regionName": "Sodermanland"
      },
      {
        "regionId": 3344,
        "regionCode": null,
        "regionName": "Stockholm"
      },
      {
        "regionId": 3345,
        "regionCode": null,
        "regionName": "Uppsala"
      },
      {
        "regionId": 3346,
        "regionCode": null,
        "regionName": "Varmland"
      },
      {
        "regionId": 3347,
        "regionCode": null,
        "regionName": "Vasterbotten"
      },
      {
        "regionId": 3348,
        "regionCode": null,
        "regionName": "Vastergotland"
      },
      {
        "regionId": 3349,
        "regionCode": null,
        "regionName": "Vasternorrland"
      },
      {
        "regionId": 3350,
        "regionCode": null,
        "regionName": "Vastmanland"
      },
      {
        "regionId": 3351,
        "regionCode": null,
        "regionName": "Vastra Gotaland"
      }
    ]
  },
  {
    "countryId": 202,
    "countryCode": "CH",
    "countryName": "Switzerland",
    "regions": [
      {
        "regionId": 598,
        "regionCode": "AG",
        "regionName": "Aargau"
      },
      {
        "regionId": 599,
        "regionCode": null,
        "regionName": "Appenzell Inner-Rhoden"
      },
      {
        "regionId": 600,
        "regionCode": null,
        "regionName": "Appenzell-Ausser Rhoden"
      },
      {
        "regionId": 601,
        "regionCode": null,
        "regionName": "Basel-Landschaft"
      },
      {
        "regionId": 602,
        "regionCode": null,
        "regionName": "Basel-Stadt"
      },
      {
        "regionId": 603,
        "regionCode": "BE",
        "regionName": "Bern"
      },
      {
        "regionId": 604,
        "regionCode": null,
        "regionName": "Canton Ticino"
      },
      {
        "regionId": 605,
        "regionCode": "FR",
        "regionName": "Fribourg"
      },
      {
        "regionId": 606,
        "regionCode": null,
        "regionName": "Geneve"
      },
      {
        "regionId": 607,
        "regionCode": "GL",
        "regionName": "Glarus"
      },
      {
        "regionId": 608,
        "regionCode": null,
        "regionName": "Graubunden"
      },
      {
        "regionId": 609,
        "regionCode": null,
        "regionName": "Heerbrugg"
      },
      {
        "regionId": 610,
        "regionCode": "JU",
        "regionName": "Jura"
      },
      {
        "regionId": 611,
        "regionCode": null,
        "regionName": "Kanton Aargau"
      },
      {
        "regionId": 612,
        "regionCode": null,
        "regionName": "Luzern"
      },
      {
        "regionId": 613,
        "regionCode": null,
        "regionName": "Morbio Inferiore"
      },
      {
        "regionId": 614,
        "regionCode": null,
        "regionName": "Muhen"
      },
      {
        "regionId": 615,
        "regionCode": "NE",
        "regionName": "Neuchatel"
      },
      {
        "regionId": 616,
        "regionCode": "NW",
        "regionName": "Nidwalden"
      },
      {
        "regionId": 617,
        "regionCode": "OW",
        "regionName": "Obwalden"
      },
      {
        "regionId": 618,
        "regionCode": null,
        "regionName": "Sankt Gallen"
      },
      {
        "regionId": 619,
        "regionCode": "SH",
        "regionName": "Schaffhausen"
      },
      {
        "regionId": 620,
        "regionCode": "SZ",
        "regionName": "Schwyz"
      },
      {
        "regionId": 621,
        "regionCode": "SO",
        "regionName": "Solothurn"
      },
      {
        "regionId": 622,
        "regionCode": "TG",
        "regionName": "Thurgau"
      },
      {
        "regionId": 623,
        "regionCode": "TI",
        "regionName": "Ticino"
      },
      {
        "regionId": 624,
        "regionCode": "UR",
        "regionName": "Uri"
      },
      {
        "regionId": 625,
        "regionCode": "VS",
        "regionName": "Valais"
      },
      {
        "regionId": 626,
        "regionCode": "VD",
        "regionName": "Vaud"
      },
      {
        "regionId": 627,
        "regionCode": null,
        "regionName": "Vauffelin"
      },
      {
        "regionId": 628,
        "regionCode": "ZG",
        "regionName": "Zug"
      },
      {
        "regionId": 629,
        "regionCode": "ZH",
        "regionName": "Zurich"
      }
    ]
  },
  {
    "countryId": 203,
    "countryCode": "SY",
    "countryName": "Syrian Arab Republic",
    "regions": [
      {
        "regionId": 3445,
        "regionCode": null,
        "regionName": "Aleppo"
      },
      {
        "regionId": 3446,
        "regionCode": null,
        "regionName": "al-Hasakah"
      },
      {
        "regionId": 3447,
        "regionCode": null,
        "regionName": "al-Ladhiqiyah"
      },
      {
        "regionId": 3448,
        "regionCode": null,
        "regionName": "al-Qunaytirah"
      },
      {
        "regionId": 3449,
        "regionCode": null,
        "regionName": "ar-Raqqah"
      },
      {
        "regionId": 3450,
        "regionCode": null,
        "regionName": "as-Suwayda"
      },
      {
        "regionId": 3451,
        "regionCode": null,
        "regionName": "Dar'a"
      },
      {
        "regionId": 3452,
        "regionCode": null,
        "regionName": "Dayr-az-Zawr"
      },
      {
        "regionId": 3453,
        "regionCode": null,
        "regionName": "Dimashq"
      },
      {
        "regionId": 3454,
        "regionCode": null,
        "regionName": "Halab"
      },
      {
        "regionId": 3455,
        "regionCode": null,
        "regionName": "Hamah"
      },
      {
        "regionId": 3456,
        "regionCode": null,
        "regionName": "Hims"
      },
      {
        "regionId": 3457,
        "regionCode": null,
        "regionName": "Idlib"
      },
      {
        "regionId": 3458,
        "regionCode": null,
        "regionName": "Madinat Dimashq"
      },
      {
        "regionId": 3459,
        "regionCode": null,
        "regionName": "Tartus"
      }
    ]
  },
  {
    "countryId": 204,
    "countryCode": "TW",
    "countryName": "Taiwan",
    "regions": [
      {
        "regionId": 3719,
        "regionCode": null,
        "regionName": "Changhwa"
      },
      {
        "regionId": 3720,
        "regionCode": null,
        "regionName": "Chiayi Hsien"
      },
      {
        "regionId": 3721,
        "regionCode": null,
        "regionName": "Chiayi Shih"
      },
      {
        "regionId": 3722,
        "regionCode": null,
        "regionName": "Eastern Taipei"
      },
      {
        "regionId": 3723,
        "regionCode": null,
        "regionName": "Hsinchu Hsien"
      },
      {
        "regionId": 3724,
        "regionCode": null,
        "regionName": "Hsinchu Shih"
      },
      {
        "regionId": 3725,
        "regionCode": null,
        "regionName": "Hualien"
      },
      {
        "regionId": 3726,
        "regionCode": null,
        "regionName": "Ilan"
      },
      {
        "regionId": 3727,
        "regionCode": null,
        "regionName": "Kaohsiung Hsien"
      },
      {
        "regionId": 3728,
        "regionCode": null,
        "regionName": "Kaohsiung Shih"
      },
      {
        "regionId": 3729,
        "regionCode": null,
        "regionName": "Keelung Shih"
      },
      {
        "regionId": 3730,
        "regionCode": null,
        "regionName": "Kinmen"
      },
      {
        "regionId": 3731,
        "regionCode": null,
        "regionName": "Miaoli"
      },
      {
        "regionId": 3732,
        "regionCode": null,
        "regionName": "Nantou"
      },
      {
        "regionId": 3733,
        "regionCode": null,
        "regionName": "Northern Taiwan"
      },
      {
        "regionId": 3734,
        "regionCode": null,
        "regionName": "Penghu"
      },
      {
        "regionId": 3735,
        "regionCode": null,
        "regionName": "Pingtung"
      },
      {
        "regionId": 3736,
        "regionCode": null,
        "regionName": "Taichung"
      },
      {
        "regionId": 3737,
        "regionCode": null,
        "regionName": "Taichung Hsien"
      },
      {
        "regionId": 3738,
        "regionCode": null,
        "regionName": "Taichung Shih"
      },
      {
        "regionId": 3739,
        "regionCode": null,
        "regionName": "Tainan Hsien"
      },
      {
        "regionId": 3740,
        "regionCode": null,
        "regionName": "Tainan Shih"
      },
      {
        "regionId": 3741,
        "regionCode": null,
        "regionName": "Taipei Hsien"
      },
      {
        "regionId": 3742,
        "regionCode": null,
        "regionName": "Taipei Shih / Taipei Hsien"
      },
      {
        "regionId": 3743,
        "regionCode": null,
        "regionName": "Taitung"
      },
      {
        "regionId": 3744,
        "regionCode": null,
        "regionName": "Taoyuan"
      },
      {
        "regionId": 3745,
        "regionCode": null,
        "regionName": "Yilan"
      },
      {
        "regionId": 3746,
        "regionCode": null,
        "regionName": "Yunlin"
      },
      {
        "regionId": 3747,
        "regionCode": null,
        "regionName": "Yun-Lin Hsien"
      }
    ]
  },
  {
    "countryId": 205,
    "countryCode": "TJ",
    "countryName": "Tajikistan",
    "regions": [
      {
        "regionId": 3563,
        "regionCode": null,
        "regionName": "Dushanbe"
      },
      {
        "regionId": 3564,
        "regionCode": null,
        "regionName": "Gorno-Badakhshan"
      },
      {
        "regionId": 3565,
        "regionCode": null,
        "regionName": "Karotegin"
      },
      {
        "regionId": 3566,
        "regionCode": null,
        "regionName": "Khatlon"
      },
      {
        "regionId": 3567,
        "regionCode": null,
        "regionName": "Sughd"
      }
    ]
  },
  {
    "countryId": 206,
    "countryCode": "TZ",
    "countryName": "Tanzania, United Republic of",
    "regions": [
      {
        "regionId": 3748,
        "regionCode": null,
        "regionName": "Arusha"
      },
      {
        "regionId": 3749,
        "regionCode": null,
        "regionName": "Dar es Salaam"
      },
      {
        "regionId": 3750,
        "regionCode": null,
        "regionName": "Dodoma"
      },
      {
        "regionId": 3751,
        "regionCode": null,
        "regionName": "Iringa"
      },
      {
        "regionId": 3752,
        "regionCode": null,
        "regionName": "Kagera"
      },
      {
        "regionId": 3753,
        "regionCode": null,
        "regionName": "Kigoma"
      },
      {
        "regionId": 3754,
        "regionCode": null,
        "regionName": "Kilimanjaro"
      },
      {
        "regionId": 3755,
        "regionCode": null,
        "regionName": "Lindi"
      },
      {
        "regionId": 3756,
        "regionCode": null,
        "regionName": "Mara"
      },
      {
        "regionId": 3757,
        "regionCode": null,
        "regionName": "Mbeya"
      },
      {
        "regionId": 3758,
        "regionCode": null,
        "regionName": "Morogoro"
      },
      {
        "regionId": 3759,
        "regionCode": null,
        "regionName": "Mtwara"
      },
      {
        "regionId": 3760,
        "regionCode": null,
        "regionName": "Mwanza"
      },
      {
        "regionId": 3761,
        "regionCode": null,
        "regionName": "Pwani"
      },
      {
        "regionId": 3762,
        "regionCode": null,
        "regionName": "Rukwa"
      },
      {
        "regionId": 3763,
        "regionCode": null,
        "regionName": "Ruvuma"
      },
      {
        "regionId": 3764,
        "regionCode": null,
        "regionName": "Shinyanga"
      },
      {
        "regionId": 3765,
        "regionCode": null,
        "regionName": "Singida"
      },
      {
        "regionId": 3766,
        "regionCode": null,
        "regionName": "Tabora"
      },
      {
        "regionId": 3767,
        "regionCode": null,
        "regionName": "Tanga"
      },
      {
        "regionId": 3768,
        "regionCode": null,
        "regionName": "Zanzibar and Pemba"
      }
    ]
  },
  {
    "countryId": 207,
    "countryCode": "TH",
    "countryName": "Thailand",
    "regions": [
      {
        "regionId": 3485,
        "regionCode": "01",
        "regionName": "Amnat Charoen"
      },
      {
        "regionId": 3486,
        "regionCode": "02",
        "regionName": "Ang Thong"
      },
      {
        "regionId": 3487,
        "regionCode": "10",
        "regionName": "Bangkok"
      },
      {
        "regionId": 3488,
        "regionCode": "31",
        "regionName": "Buri Ram"
      },
      {
        "regionId": 3489,
        "regionCode": "04",
        "regionName": "Chachoengsao"
      },
      {
        "regionId": 3490,
        "regionCode": "05",
        "regionName": "Chai Nat"
      },
      {
        "regionId": 3491,
        "regionCode": "06",
        "regionName": "Chaiyaphum"
      },
      {
        "regionId": 3492,
        "regionCode": null,
        "regionName": "Changwat Chaiyaphum"
      },
      {
        "regionId": 3493,
        "regionCode": "07",
        "regionName": "Chanthaburi"
      },
      {
        "regionId": 3494,
        "regionCode": "08",
        "regionName": "Chiang Mai"
      },
      {
        "regionId": 3495,
        "regionCode": "09",
        "regionName": "Chiang Rai"
      },
      {
        "regionId": 3496,
        "regionCode": "10",
        "regionName": "Chon Buri"
      },
      {
        "regionId": 3497,
        "regionCode": "11",
        "regionName": "Chumphon"
      },
      {
        "regionId": 3498,
        "regionCode": "12",
        "regionName": "Kalasin"
      },
      {
        "regionId": 3499,
        "regionCode": "13",
        "regionName": "Kamphaeng Phet"
      },
      {
        "regionId": 3500,
        "regionCode": "14",
        "regionName": "Kanchanaburi"
      },
      {
        "regionId": 3501,
        "regionCode": "15",
        "regionName": "Khon Kaen"
      },
      {
        "regionId": 3502,
        "regionCode": "16",
        "regionName": "Krabi"
      },
      {
        "regionId": 3503,
        "regionCode": "17",
        "regionName": "Krung Thep"
      },
      {
        "regionId": 3504,
        "regionCode": "19",
        "regionName": "Lampang"
      },
      {
        "regionId": 3505,
        "regionCode": "20",
        "regionName": "Lamphun"
      },
      {
        "regionId": 3506,
        "regionCode": "21",
        "regionName": "Loei"
      },
      {
        "regionId": 3507,
        "regionCode": "22",
        "regionName": "Lop Buri"
      },
      {
        "regionId": 3508,
        "regionCode": "23",
        "regionName": "Mae Hong Son"
      },
      {
        "regionId": 3509,
        "regionCode": "24",
        "regionName": "Maha Sarakham"
      },
      {
        "regionId": 3510,
        "regionCode": "25",
        "regionName": "Mukdahan"
      },
      {
        "regionId": 3511,
        "regionCode": "26",
        "regionName": "Nakhon Nayok"
      },
      {
        "regionId": 3512,
        "regionCode": "27",
        "regionName": "Nakhon Pathom"
      },
      {
        "regionId": 3513,
        "regionCode": "28",
        "regionName": "Nakhon Phanom"
      },
      {
        "regionId": 3514,
        "regionCode": "29",
        "regionName": "Nakhon Ratchasima"
      },
      {
        "regionId": 3515,
        "regionCode": "30",
        "regionName": "Nakhon Sawan"
      },
      {
        "regionId": 3516,
        "regionCode": "31",
        "regionName": "Nakhon Si Thammarat"
      },
      {
        "regionId": 3517,
        "regionCode": "32",
        "regionName": "Nan"
      },
      {
        "regionId": 3518,
        "regionCode": "33",
        "regionName": "Narathiwat"
      },
      {
        "regionId": 3519,
        "regionCode": "39",
        "regionName": "Nong Bua Lam Phu"
      },
      {
        "regionId": 3520,
        "regionCode": "35",
        "regionName": "Nong Khai"
      },
      {
        "regionId": 3521,
        "regionCode": "36",
        "regionName": "Nonthaburi"
      },
      {
        "regionId": 3522,
        "regionCode": "37",
        "regionName": "Pathum Thani"
      },
      {
        "regionId": 3523,
        "regionCode": "38",
        "regionName": "Pattani"
      },
      {
        "regionId": 3524,
        "regionCode": "39",
        "regionName": "Phangnga"
      },
      {
        "regionId": 3525,
        "regionCode": "40",
        "regionName": "Phatthalung"
      },
      {
        "regionId": 3526,
        "regionCode": "41",
        "regionName": "Phayao"
      },
      {
        "regionId": 3527,
        "regionCode": "42",
        "regionName": "Phetchabun"
      },
      {
        "regionId": 3528,
        "regionCode": "43",
        "regionName": "Phetchaburi"
      },
      {
        "regionId": 3529,
        "regionCode": "44",
        "regionName": "Phichit"
      },
      {
        "regionId": 3530,
        "regionCode": "45",
        "regionName": "Phitsanulok"
      },
      {
        "regionId": 3531,
        "regionCode": "14",
        "regionName": "Phra Nakhon Si Ayutthaya"
      },
      {
        "regionId": 3532,
        "regionCode": "47",
        "regionName": "Phrae"
      },
      {
        "regionId": 3533,
        "regionCode": "48",
        "regionName": "Phuket"
      },
      {
        "regionId": 3534,
        "regionCode": "49",
        "regionName": "Prachin Buri"
      },
      {
        "regionId": 3535,
        "regionCode": "77",
        "regionName": "Prachuap Khiri Khan"
      },
      {
        "regionId": 3536,
        "regionCode": "85",
        "regionName": "Ranong"
      },
      {
        "regionId": 3537,
        "regionCode": "70",
        "regionName": "Ratchaburi"
      },
      {
        "regionId": 3538,
        "regionCode": "21",
        "regionName": "Rayong"
      },
      {
        "regionId": 3539,
        "regionCode": "45",
        "regionName": "Roi Et"
      },
      {
        "regionId": 3540,
        "regionCode": "27",
        "regionName": "Sa Kaeo"
      },
      {
        "regionId": 3541,
        "regionCode": "47",
        "regionName": "Sakon Nakhon"
      },
      {
        "regionId": 3542,
        "regionCode": "11",
        "regionName": "Samut Prakan"
      },
      {
        "regionId": 3543,
        "regionCode": "74",
        "regionName": "Samut Sakhon"
      },
      {
        "regionId": 3544,
        "regionCode": null,
        "regionName": "Samut Songkhran"
      },
      {
        "regionId": 3545,
        "regionCode": "19",
        "regionName": "Saraburi"
      },
      {
        "regionId": 3546,
        "regionCode": "91",
        "regionName": "Satun"
      },
      {
        "regionId": 3547,
        "regionCode": "33",
        "regionName": "Si Sa Ket"
      },
      {
        "regionId": 3548,
        "regionCode": "17",
        "regionName": "Sing Buri"
      },
      {
        "regionId": 3549,
        "regionCode": "90",
        "regionName": "Songkhla"
      },
      {
        "regionId": 3550,
        "regionCode": "64",
        "regionName": "Sukhothai"
      },
      {
        "regionId": 3551,
        "regionCode": null,
        "regionName": "Suphan Buri"
      },
      {
        "regionId": 3552,
        "regionCode": "84",
        "regionName": "Surat Thani"
      },
      {
        "regionId": 3553,
        "regionCode": "32",
        "regionName": "Surin"
      },
      {
        "regionId": 3554,
        "regionCode": "63",
        "regionName": "Tak"
      },
      {
        "regionId": 3555,
        "regionCode": "92",
        "regionName": "Trang"
      },
      {
        "regionId": 3556,
        "regionCode": "23",
        "regionName": "Trat"
      },
      {
        "regionId": 3557,
        "regionCode": "34",
        "regionName": "Ubon Ratchathani"
      },
      {
        "regionId": 3558,
        "regionCode": "41",
        "regionName": "Udon Thani"
      },
      {
        "regionId": 3559,
        "regionCode": "61",
        "regionName": "Uthai Thani"
      },
      {
        "regionId": 3560,
        "regionCode": "53",
        "regionName": "Uttaradit"
      },
      {
        "regionId": 3561,
        "regionCode": "95",
        "regionName": "Yala"
      },
      {
        "regionId": 3562,
        "regionCode": "35",
        "regionName": "Yasothon"
      }
    ]
  },
  {
    "countryId": 208,
    "countryCode": "TL",
    "countryName": "Timor-Leste (East Timor)",
    "regions": []
  },
  {
    "countryId": 209,
    "countryCode": "TG",
    "countryName": "Togo",
    "regions": [
      {
        "regionId": 3480,
        "regionCode": null,
        "regionName": "Centre"
      },
      {
        "regionId": 3481,
        "regionCode": null,
        "regionName": "Kara"
      },
      {
        "regionId": 3482,
        "regionCode": null,
        "regionName": "Maritime"
      },
      {
        "regionId": 3483,
        "regionCode": null,
        "regionName": "Plateaux"
      },
      {
        "regionId": 3484,
        "regionCode": null,
        "regionName": "Savanes"
      }
    ]
  },
  {
    "countryId": 210,
    "countryCode": "TK",
    "countryName": "Tokelau",
    "regions": [
      {
        "regionId": 3568,
        "regionCode": null,
        "regionName": "Atafu"
      },
      {
        "regionId": 3569,
        "regionCode": null,
        "regionName": "Fakaofo"
      },
      {
        "regionId": 3570,
        "regionCode": null,
        "regionName": "Nukunonu"
      }
    ]
  },
  {
    "countryId": 211,
    "countryCode": "TO",
    "countryName": "Tonga",
    "regions": [
      {
        "regionId": 3607,
        "regionCode": null,
        "regionName": "Eua"
      },
      {
        "regionId": 3608,
        "regionCode": null,
        "regionName": "Ha'apai"
      },
      {
        "regionId": 3609,
        "regionCode": null,
        "regionName": "Niuas"
      },
      {
        "regionId": 3610,
        "regionCode": null,
        "regionName": "Tongatapu"
      },
      {
        "regionId": 3611,
        "regionCode": null,
        "regionName": "Vava'u"
      }
    ]
  },
  {
    "countryId": 212,
    "countryCode": "TT",
    "countryName": "Trinidad and Tobago",
    "regions": [
      {
        "regionId": 3695,
        "regionCode": null,
        "regionName": "Arima-Tunapuna-Piarco"
      },
      {
        "regionId": 3696,
        "regionCode": null,
        "regionName": "Caroni"
      },
      {
        "regionId": 3697,
        "regionCode": null,
        "regionName": "Chaguanas"
      },
      {
        "regionId": 3698,
        "regionCode": null,
        "regionName": "Couva-Tabaquite-Talparo"
      },
      {
        "regionId": 3699,
        "regionCode": null,
        "regionName": "Diego Martin"
      },
      {
        "regionId": 3700,
        "regionCode": null,
        "regionName": "Glencoe"
      },
      {
        "regionId": 3701,
        "regionCode": null,
        "regionName": "Penal Debe"
      },
      {
        "regionId": 3702,
        "regionCode": null,
        "regionName": "Point Fortin"
      },
      {
        "regionId": 3703,
        "regionCode": null,
        "regionName": "Port of Spain"
      },
      {
        "regionId": 3704,
        "regionCode": null,
        "regionName": "Princes Town"
      },
      {
        "regionId": 3705,
        "regionCode": null,
        "regionName": "Saint George"
      },
      {
        "regionId": 3706,
        "regionCode": null,
        "regionName": "San Fernando"
      },
      {
        "regionId": 3707,
        "regionCode": null,
        "regionName": "San Juan"
      },
      {
        "regionId": 3708,
        "regionCode": null,
        "regionName": "Sangre Grande"
      },
      {
        "regionId": 3709,
        "regionCode": null,
        "regionName": "Siparia"
      },
      {
        "regionId": 3710,
        "regionCode": null,
        "regionName": "Tobago"
      }
    ]
  },
  {
    "countryId": 213,
    "countryCode": "TA",
    "countryName": "Tristan da Cunha",
    "regions": []
  },
  {
    "countryId": 214,
    "countryCode": "TN",
    "countryName": "Tunisia",
    "regions": [
      {
        "regionId": 3577,
        "regionCode": null,
        "regionName": "al-Kaf"
      },
      {
        "regionId": 3578,
        "regionCode": null,
        "regionName": "al-Mahdiyah"
      },
      {
        "regionId": 3579,
        "regionCode": null,
        "regionName": "al-Munastir"
      },
      {
        "regionId": 3580,
        "regionCode": null,
        "regionName": "al-Qasrayn"
      },
      {
        "regionId": 3581,
        "regionCode": null,
        "regionName": "al-Qayrawan"
      },
      {
        "regionId": 3582,
        "regionCode": null,
        "regionName": "Aryanah"
      },
      {
        "regionId": 3583,
        "regionCode": null,
        "regionName": "Bajah"
      },
      {
        "regionId": 3584,
        "regionCode": null,
        "regionName": "Bin 'Arus"
      },
      {
        "regionId": 3585,
        "regionCode": null,
        "regionName": "Binzart"
      },
      {
        "regionId": 3586,
        "regionCode": null,
        "regionName": "Gouvernorat de Ariana"
      },
      {
        "regionId": 3587,
        "regionCode": null,
        "regionName": "Gouvernorat de Nabeul"
      },
      {
        "regionId": 3588,
        "regionCode": null,
        "regionName": "Gouvernorat de Sousse"
      },
      {
        "regionId": 3589,
        "regionCode": null,
        "regionName": "Hammamet Yasmine"
      },
      {
        "regionId": 3590,
        "regionCode": null,
        "regionName": "Jundubah"
      },
      {
        "regionId": 3591,
        "regionCode": null,
        "regionName": "Madaniyin"
      },
      {
        "regionId": 3592,
        "regionCode": null,
        "regionName": "Manubah"
      },
      {
        "regionId": 3593,
        "regionCode": null,
        "regionName": "Monastir"
      },
      {
        "regionId": 3594,
        "regionCode": null,
        "regionName": "Nabul"
      },
      {
        "regionId": 3595,
        "regionCode": null,
        "regionName": "Qabis"
      },
      {
        "regionId": 3596,
        "regionCode": null,
        "regionName": "Qafsah"
      },
      {
        "regionId": 3597,
        "regionCode": null,
        "regionName": "Qibili"
      },
      {
        "regionId": 3598,
        "regionCode": null,
        "regionName": "Safaqis"
      },
      {
        "regionId": 3599,
        "regionCode": null,
        "regionName": "Sfax"
      },
      {
        "regionId": 3600,
        "regionCode": null,
        "regionName": "Sidi Bu Zayd"
      },
      {
        "regionId": 3601,
        "regionCode": null,
        "regionName": "Silyanah"
      },
      {
        "regionId": 3602,
        "regionCode": null,
        "regionName": "Susah"
      },
      {
        "regionId": 3603,
        "regionCode": null,
        "regionName": "Tatawin"
      },
      {
        "regionId": 3604,
        "regionCode": null,
        "regionName": "Tawzar"
      },
      {
        "regionId": 3605,
        "regionCode": null,
        "regionName": "Tunis"
      },
      {
        "regionId": 3606,
        "regionCode": null,
        "regionName": "Zaghwan"
      }
    ]
  },
  {
    "countryId": 215,
    "countryCode": "TR",
    "countryName": "Turkey",
    "regions": [
      {
        "regionId": 3612,
        "regionCode": "01",
        "regionName": "Adana"
      },
      {
        "regionId": 3613,
        "regionCode": "02",
        "regionName": "Adiyaman"
      },
      {
        "regionId": 3614,
        "regionCode": "03",
        "regionName": "Afyon"
      },
      {
        "regionId": 3615,
        "regionCode": "04",
        "regionName": "Agri"
      },
      {
        "regionId": 3616,
        "regionCode": "68",
        "regionName": "Aksaray"
      },
      {
        "regionId": 3617,
        "regionCode": "05",
        "regionName": "Amasya"
      },
      {
        "regionId": 3618,
        "regionCode": "06",
        "regionName": "Ankara"
      },
      {
        "regionId": 3619,
        "regionCode": "07",
        "regionName": "Antalya"
      },
      {
        "regionId": 3620,
        "regionCode": "75",
        "regionName": "Ardahan"
      },
      {
        "regionId": 3621,
        "regionCode": "08",
        "regionName": "Artvin"
      },
      {
        "regionId": 3622,
        "regionCode": "09",
        "regionName": "Aydin"
      },
      {
        "regionId": 3623,
        "regionCode": "10",
        "regionName": "Balikesir"
      },
      {
        "regionId": 3624,
        "regionCode": "74",
        "regionName": "Bartin"
      },
      {
        "regionId": 3625,
        "regionCode": "72",
        "regionName": "Batman"
      },
      {
        "regionId": 3626,
        "regionCode": "69",
        "regionName": "Bayburt"
      },
      {
        "regionId": 3627,
        "regionCode": "11",
        "regionName": "Bilecik"
      },
      {
        "regionId": 3628,
        "regionCode": "12",
        "regionName": "Bingol"
      },
      {
        "regionId": 3629,
        "regionCode": "13",
        "regionName": "Bitlis"
      },
      {
        "regionId": 3630,
        "regionCode": "14",
        "regionName": "Bolu"
      },
      {
        "regionId": 3631,
        "regionCode": "15",
        "regionName": "Burdur"
      },
      {
        "regionId": 3632,
        "regionCode": "16",
        "regionName": "Bursa"
      },
      {
        "regionId": 3633,
        "regionCode": "17",
        "regionName": "Canakkale"
      },
      {
        "regionId": 3634,
        "regionCode": "18",
        "regionName": "Cankiri"
      },
      {
        "regionId": 3635,
        "regionCode": "19",
        "regionName": "Corum"
      },
      {
        "regionId": 3636,
        "regionCode": "20",
        "regionName": "Denizli"
      },
      {
        "regionId": 3637,
        "regionCode": "21",
        "regionName": "Diyarbakir"
      },
      {
        "regionId": 3638,
        "regionCode": "81",
        "regionName": "Duzce"
      },
      {
        "regionId": 3639,
        "regionCode": "22",
        "regionName": "Edirne"
      },
      {
        "regionId": 3640,
        "regionCode": "23",
        "regionName": "Elazig"
      },
      {
        "regionId": 3641,
        "regionCode": "24",
        "regionName": "Erzincan"
      },
      {
        "regionId": 3642,
        "regionCode": "25",
        "regionName": "Erzurum"
      },
      {
        "regionId": 3643,
        "regionCode": "26",
        "regionName": "Eskisehir"
      },
      {
        "regionId": 3644,
        "regionCode": "27",
        "regionName": "Gaziantep"
      },
      {
        "regionId": 3645,
        "regionCode": "28",
        "regionName": "Giresun"
      },
      {
        "regionId": 3646,
        "regionCode": "29",
        "regionName": "Gumushane"
      },
      {
        "regionId": 3647,
        "regionCode": "30",
        "regionName": "Hakkari"
      },
      {
        "regionId": 3648,
        "regionCode": "31",
        "regionName": "Hatay"
      },
      {
        "regionId": 3649,
        "regionCode": "33",
        "regionName": "Icel"
      },
      {
        "regionId": 3650,
        "regionCode": "76",
        "regionName": "Igdir"
      },
      {
        "regionId": 3651,
        "regionCode": "32",
        "regionName": "Isparta"
      },
      {
        "regionId": 3652,
        "regionCode": "34",
        "regionName": "Istanbul"
      },
      {
        "regionId": 3653,
        "regionCode": "35",
        "regionName": "Izmir"
      },
      {
        "regionId": 3654,
        "regionCode": "46",
        "regionName": "Kahramanmaras"
      },
      {
        "regionId": 3655,
        "regionCode": "78",
        "regionName": "Karabuk"
      },
      {
        "regionId": 3656,
        "regionCode": "70",
        "regionName": "Karaman"
      },
      {
        "regionId": 3657,
        "regionCode": "36",
        "regionName": "Kars"
      },
      {
        "regionId": 3658,
        "regionCode": null,
        "regionName": "Karsiyaka"
      },
      {
        "regionId": 3659,
        "regionCode": "37",
        "regionName": "Kastamonu"
      },
      {
        "regionId": 3660,
        "regionCode": "38",
        "regionName": "Kayseri"
      },
      {
        "regionId": 3661,
        "regionCode": "79",
        "regionName": "Kilis"
      },
      {
        "regionId": 3662,
        "regionCode": "71",
        "regionName": "Kirikkale"
      },
      {
        "regionId": 3663,
        "regionCode": "39",
        "regionName": "Kirklareli"
      },
      {
        "regionId": 3664,
        "regionCode": "40",
        "regionName": "Kirsehir"
      },
      {
        "regionId": 3665,
        "regionCode": "41",
        "regionName": "Kocaeli"
      },
      {
        "regionId": 3666,
        "regionCode": "42",
        "regionName": "Konya"
      },
      {
        "regionId": 3667,
        "regionCode": "43",
        "regionName": "Kutahya"
      },
      {
        "regionId": 3668,
        "regionCode": null,
        "regionName": "Lefkosa"
      },
      {
        "regionId": 3669,
        "regionCode": "44",
        "regionName": "Malatya"
      },
      {
        "regionId": 3670,
        "regionCode": "45",
        "regionName": "Manisa"
      },
      {
        "regionId": 3671,
        "regionCode": "47",
        "regionName": "Mardin"
      },
      {
        "regionId": 3672,
        "regionCode": "48",
        "regionName": "Mugla"
      },
      {
        "regionId": 3673,
        "regionCode": "49",
        "regionName": "Mus"
      },
      {
        "regionId": 3674,
        "regionCode": "50",
        "regionName": "Nevsehir"
      },
      {
        "regionId": 3675,
        "regionCode": "51",
        "regionName": "Nigde"
      },
      {
        "regionId": 3676,
        "regionCode": "52",
        "regionName": "Ordu"
      },
      {
        "regionId": 3677,
        "regionCode": "80",
        "regionName": "Osmaniye"
      },
      {
        "regionId": 3678,
        "regionCode": "53",
        "regionName": "Rize"
      },
      {
        "regionId": 3679,
        "regionCode": "54",
        "regionName": "Sakarya"
      },
      {
        "regionId": 3680,
        "regionCode": "55",
        "regionName": "Samsun"
      },
      {
        "regionId": 3681,
        "regionCode": "63",
        "regionName": "Sanliurfa"
      },
      {
        "regionId": 3682,
        "regionCode": "56",
        "regionName": "Siirt"
      },
      {
        "regionId": 3683,
        "regionCode": "57",
        "regionName": "Sinop"
      },
      {
        "regionId": 3684,
        "regionCode": "73",
        "regionName": "Sirnak"
      },
      {
        "regionId": 3685,
        "regionCode": "58",
        "regionName": "Sivas"
      },
      {
        "regionId": 3686,
        "regionCode": "59",
        "regionName": "Tekirdag"
      },
      {
        "regionId": 3687,
        "regionCode": "60",
        "regionName": "Tokat"
      },
      {
        "regionId": 3688,
        "regionCode": "61",
        "regionName": "Trabzon"
      },
      {
        "regionId": 3689,
        "regionCode": "62",
        "regionName": "Tunceli"
      },
      {
        "regionId": 3690,
        "regionCode": "64",
        "regionName": "Usak"
      },
      {
        "regionId": 3691,
        "regionCode": "65",
        "regionName": "Van"
      },
      {
        "regionId": 3692,
        "regionCode": "77",
        "regionName": "Yalova"
      },
      {
        "regionId": 3693,
        "regionCode": "66",
        "regionName": "Yozgat"
      },
      {
        "regionId": 3694,
        "regionCode": "67",
        "regionName": "Zonguldak"
      }
    ]
  },
  {
    "countryId": 216,
    "countryCode": "TM",
    "countryName": "Turkmenistan",
    "regions": [
      {
        "regionId": 3571,
        "regionCode": null,
        "regionName": "Ahal"
      },
      {
        "regionId": 3572,
        "regionCode": null,
        "regionName": "Asgabat"
      },
      {
        "regionId": 3573,
        "regionCode": null,
        "regionName": "Balkan"
      },
      {
        "regionId": 3574,
        "regionCode": null,
        "regionName": "Dasoguz"
      },
      {
        "regionId": 3575,
        "regionCode": null,
        "regionName": "Lebap"
      },
      {
        "regionId": 3576,
        "regionCode": null,
        "regionName": "Mari"
      }
    ]
  },
  {
    "countryId": 217,
    "countryCode": "TC",
    "countryName": "Turks and Caicos Islands",
    "regions": [
      {
        "regionId": 3464,
        "regionCode": null,
        "regionName": "Grand Turk"
      },
      {
        "regionId": 3465,
        "regionCode": null,
        "regionName": "South Caicos and East Caicos"
      }
    ]
  },
  {
    "countryId": 218,
    "countryCode": "TV",
    "countryName": "Tuvalu",
    "regions": [
      {
        "regionId": 3711,
        "regionCode": "FUN",
        "regionName": "Funafuti"
      },
      {
        "regionId": 3712,
        "regionCode": "NMG",
        "regionName": "Nanumanga"
      },
      {
        "regionId": 3713,
        "regionCode": "NMA",
        "regionName": "Nanumea"
      },
      {
        "regionId": 3714,
        "regionCode": "NIT",
        "regionName": "Niutao"
      },
      {
        "regionId": 3715,
        "regionCode": "NUI",
        "regionName": "Nui"
      },
      {
        "regionId": 3716,
        "regionCode": "NKF",
        "regionName": "Nukufetau"
      },
      {
        "regionId": 3717,
        "regionCode": "NKL",
        "regionName": "Nukulaelae"
      },
      {
        "regionId": 3718,
        "regionCode": "VAI",
        "regionName": "Vaitupu"
      }
    ]
  },
  {
    "countryId": 219,
    "countryCode": "UG",
    "countryName": "Uganda",
    "regions": [
      {
        "regionId": 3799,
        "regionCode": null,
        "regionName": "Central"
      },
      {
        "regionId": 3800,
        "regionCode": null,
        "regionName": "Eastern"
      },
      {
        "regionId": 3801,
        "regionCode": null,
        "regionName": "Northern"
      },
      {
        "regionId": 3802,
        "regionCode": null,
        "regionName": "Western"
      }
    ]
  },
  {
    "countryId": 220,
    "countryCode": "UA",
    "countryName": "Ukraine",
    "regions": [
      {
        "regionId": 3769,
        "regionCode": "CHR",
        "regionName": "Cherkas'ka"
      },
      {
        "regionId": 3770,
        "regionCode": null,
        "regionName": "Chernihivs'ka"
      },
      {
        "regionId": 3771,
        "regionCode": null,
        "regionName": "Chernivets'ka"
      },
      {
        "regionId": 3772,
        "regionCode": "43",
        "regionName": "Crimea"
      },
      {
        "regionId": 3773,
        "regionCode": null,
        "regionName": "Dnipropetrovska"
      },
      {
        "regionId": 3774,
        "regionCode": "DON",
        "regionName": "Donets'ka"
      },
      {
        "regionId": 3775,
        "regionCode": "IVF",
        "regionName": "Ivano-Frankivs'ka"
      },
      {
        "regionId": 3776,
        "regionCode": null,
        "regionName": "Kharkiv"
      },
      {
        "regionId": 3777,
        "regionCode": null,
        "regionName": "Kharkov"
      },
      {
        "regionId": 3778,
        "regionCode": null,
        "regionName": "Khersonska"
      },
      {
        "regionId": 3779,
        "regionCode": null,
        "regionName": "Khmel'nyts'ka"
      },
      {
        "regionId": 3780,
        "regionCode": null,
        "regionName": "Kirovohrad"
      },
      {
        "regionId": 3781,
        "regionCode": null,
        "regionName": "Krym"
      },
      {
        "regionId": 3782,
        "regionCode": null,
        "regionName": "Kyyiv"
      },
      {
        "regionId": 3783,
        "regionCode": null,
        "regionName": "Kyyivs'ka"
      },
      {
        "regionId": 3784,
        "regionCode": null,
        "regionName": "Luhans'ka"
      },
      {
        "regionId": 3785,
        "regionCode": null,
        "regionName": "L'vivs'ka"
      },
      {
        "regionId": 3786,
        "regionCode": null,
        "regionName": "Mykolayivs'ka"
      },
      {
        "regionId": 3787,
        "regionCode": "ODS",
        "regionName": "Odes'ka"
      },
      {
        "regionId": 3788,
        "regionCode": null,
        "regionName": "Odessa"
      },
      {
        "regionId": 3789,
        "regionCode": "POL",
        "regionName": "Poltavs'ka"
      },
      {
        "regionId": 3790,
        "regionCode": "RIV",
        "regionName": "Rivnens'ka"
      },
      {
        "regionId": 3791,
        "regionCode": null,
        "regionName": "Sevastopol'"
      },
      {
        "regionId": 3792,
        "regionCode": "SUM",
        "regionName": "Sums'ka"
      },
      {
        "regionId": 3793,
        "regionCode": "TER",
        "regionName": "Ternopil's'ka"
      },
      {
        "regionId": 3794,
        "regionCode": null,
        "regionName": "Volyns'ka"
      },
      {
        "regionId": 3795,
        "regionCode": null,
        "regionName": "Vynnyts'ka"
      },
      {
        "regionId": 3796,
        "regionCode": "ZAK",
        "regionName": "Zakarpats'ka"
      },
      {
        "regionId": 3797,
        "regionCode": null,
        "regionName": "Zaporizhia"
      },
      {
        "regionId": 3798,
        "regionCode": null,
        "regionName": "Zhytomyrs'ka"
      }
    ]
  },
  {
    "countryId": 221,
    "countryCode": "AE",
    "countryName": "United Arab Emirates",
    "regions": [
      {
        "regionId": 8,
        "regionCode": null,
        "regionName": "Abu Zabi"
      },
      {
        "regionId": 9,
        "regionCode": "AJ",
        "regionName": "Ajman"
      },
      {
        "regionId": 10,
        "regionCode": null,
        "regionName": "al-Fujayrah"
      },
      {
        "regionId": 11,
        "regionCode": null,
        "regionName": "ash-Shariqah"
      },
      {
        "regionId": 12,
        "regionCode": "DU",
        "regionName": "Dubai"
      },
      {
        "regionId": 13,
        "regionCode": null,
        "regionName": "Ras al-Khaymah"
      },
      {
        "regionId": 14,
        "regionCode": "SH",
        "regionName": "Sharjah"
      },
      {
        "regionId": 15,
        "regionCode": null,
        "regionName": "Sharjha"
      },
      {
        "regionId": 16,
        "regionCode": null,
        "regionName": "Umm al Qaywayn"
      }
    ]
  },
  {
    "countryId": 222,
    "countryCode": "UK",
    "countryName": "United Kingdom",
    "regions": [
      {
        "regionId": 1337,
        "regionCode": "AB",
        "regionName": "Aberdeen"
      },
      {
        "regionId": 1338,
        "regionCode": null,
        "regionName": "Aberdeenshire"
      },
      {
        "regionId": 1339,
        "regionCode": null,
        "regionName": "Argyll"
      },
      {
        "regionId": 1340,
        "regionCode": "AM",
        "regionName": "Armagh"
      },
      {
        "regionId": 1341,
        "regionCode": "BE",
        "regionName": "Bedfordshire"
      },
      {
        "regionId": 1342,
        "regionCode": "BL",
        "regionName": "Belfast"
      },
      {
        "regionId": 1343,
        "regionCode": "BK",
        "regionName": "Berkshire"
      },
      {
        "regionId": 1344,
        "regionCode": "B",
        "regionName": "Birmingham"
      },
      {
        "regionId": 1345,
        "regionCode": null,
        "regionName": "Brechin"
      },
      {
        "regionId": 1346,
        "regionCode": null,
        "regionName": "Bridgnorth"
      },
      {
        "regionId": 1347,
        "regionCode": "BR",
        "regionName": "Bristol"
      },
      {
        "regionId": 1348,
        "regionCode": "BU",
        "regionName": "Buckinghamshire"
      },
      {
        "regionId": 1349,
        "regionCode": "CB",
        "regionName": "Cambridge"
      },
      {
        "regionId": 1350,
        "regionCode": "CA",
        "regionName": "Cambridgeshire"
      },
      {
        "regionId": 1351,
        "regionCode": null,
        "regionName": "Channel Islands"
      },
      {
        "regionId": 1352,
        "regionCode": "CH",
        "regionName": "Cheshire"
      },
      {
        "regionId": 1353,
        "regionCode": "CV",
        "regionName": "Cleveland"
      },
      {
        "regionId": 1355,
        "regionCode": null,
        "regionName": "Conwy"
      },
      {
        "regionId": 1356,
        "regionCode": "CO",
        "regionName": "Cornwall"
      },
      {
        "regionId": 1357,
        "regionCode": "CV",
        "regionName": "Coventry"
      },
      {
        "regionId": 1358,
        "regionCode": null,
        "regionName": "Craven Arms"
      },
      {
        "regionId": 1359,
        "regionCode": "CU",
        "regionName": "Cumbria"
      },
      {
        "regionId": 1360,
        "regionCode": null,
        "regionName": "Denbighshire"
      },
      {
        "regionId": 1361,
        "regionCode": "DE",
        "regionName": "Derby"
      },
      {
        "regionId": 1362,
        "regionCode": "DB",
        "regionName": "Derbyshire"
      },
      {
        "regionId": 1363,
        "regionCode": "DV",
        "regionName": "Devon"
      },
      {
        "regionId": 1364,
        "regionCode": null,
        "regionName": "Dial Code Dungannon"
      },
      {
        "regionId": 1365,
        "regionCode": null,
        "regionName": "Didcot"
      },
      {
        "regionId": 1366,
        "regionCode": "DO",
        "regionName": "Dorset"
      },
      {
        "regionId": 1367,
        "regionCode": null,
        "regionName": "Dunbartonshire"
      },
      {
        "regionId": 1368,
        "regionCode": "DU",
        "regionName": "Durham"
      },
      {
        "regionId": 1369,
        "regionCode": null,
        "regionName": "East Dunbartonshire"
      },
      {
        "regionId": 1370,
        "regionCode": null,
        "regionName": "East Lothian"
      },
      {
        "regionId": 1371,
        "regionCode": null,
        "regionName": "East Midlands"
      },
      {
        "regionId": 1372,
        "regionCode": "SE",
        "regionName": "East Sussex"
      },
      {
        "regionId": 1373,
        "regionCode": null,
        "regionName": "East Yorkshire"
      },
      {
        "regionId": 1374,
        "regionCode": null,
        "regionName": "England"
      },
      {
        "regionId": 1375,
        "regionCode": "ES",
        "regionName": "Essex"
      },
      {
        "regionId": 1376,
        "regionCode": "FM",
        "regionName": "Fermanagh"
      },
      {
        "regionId": 1377,
        "regionCode": "FI",
        "regionName": "Fife"
      },
      {
        "regionId": 1378,
        "regionCode": null,
        "regionName": "Flintshire"
      },
      {
        "regionId": 1379,
        "regionCode": null,
        "regionName": "Fulham"
      },
      {
        "regionId": 1380,
        "regionCode": null,
        "regionName": "Gainsborough"
      },
      {
        "regionId": 1381,
        "regionCode": null,
        "regionName": "Glocestershire"
      },
      {
        "regionId": 1382,
        "regionCode": "GW",
        "regionName": "Gwent"
      },
      {
        "regionId": 1383,
        "regionCode": "HA",
        "regionName": "Hampshire"
      },
      {
        "regionId": 1384,
        "regionCode": null,
        "regionName": "Hants"
      },
      {
        "regionId": 1385,
        "regionCode": null,
        "regionName": "Herefordshire"
      },
      {
        "regionId": 1386,
        "regionCode": "HT",
        "regionName": "Hertfordshire"
      },
      {
        "regionId": 1387,
        "regionCode": null,
        "regionName": "Ireland"
      },
      {
        "regionId": 1388,
        "regionCode": null,
        "regionName": "Isle Of Man"
      },
      {
        "regionId": 1389,
        "regionCode": "IW",
        "regionName": "Isle of Wight"
      },
      {
        "regionId": 1390,
        "regionCode": null,
        "regionName": "Kenford"
      },
      {
        "regionId": 1391,
        "regionCode": "KE",
        "regionName": "Kent"
      },
      {
        "regionId": 1392,
        "regionCode": "KA",
        "regionName": "Kilmarnock"
      },
      {
        "regionId": 1393,
        "regionCode": null,
        "regionName": "Lanarkshire"
      },
      {
        "regionId": 1394,
        "regionCode": "LA",
        "regionName": "Lancashire"
      },
      {
        "regionId": 1395,
        "regionCode": "LE",
        "regionName": "Leicestershire"
      },
      {
        "regionId": 1396,
        "regionCode": "LI",
        "regionName": "Lincolnshire"
      },
      {
        "regionId": 1397,
        "regionCode": null,
        "regionName": "Llanymynech"
      },
      {
        "regionId": 1398,
        "regionCode": null,
        "regionName": "London"
      },
      {
        "regionId": 1399,
        "regionCode": null,
        "regionName": "Ludlow"
      },
      {
        "regionId": 1400,
        "regionCode": "M",
        "regionName": "Manchester"
      },
      {
        "regionId": 1401,
        "regionCode": null,
        "regionName": "Mayfair"
      },
      {
        "regionId": 1402,
        "regionCode": "MY",
        "regionName": "Merseyside"
      },
      {
        "regionId": 1403,
        "regionCode": "MG",
        "regionName": "Mid Glamorgan"
      },
      {
        "regionId": 1404,
        "regionCode": null,
        "regionName": "Middlesex"
      },
      {
        "regionId": 1405,
        "regionCode": null,
        "regionName": "Mildenhall"
      },
      {
        "regionId": 1406,
        "regionCode": null,
        "regionName": "Monmouthshire"
      },
      {
        "regionId": 1407,
        "regionCode": null,
        "regionName": "Newton Stewart"
      },
      {
        "regionId": 1408,
        "regionCode": "NK",
        "regionName": "Norfolk"
      },
      {
        "regionId": 1409,
        "regionCode": null,
        "regionName": "North Humberside"
      },
      {
        "regionId": 1410,
        "regionCode": "YN",
        "regionName": "North Yorkshire"
      },
      {
        "regionId": 1411,
        "regionCode": "NH",
        "regionName": "Northamptonshire"
      },
      {
        "regionId": 1412,
        "regionCode": null,
        "regionName": "Northants"
      },
      {
        "regionId": 1413,
        "regionCode": "BT",
        "regionName": "Northern Ireland"
      },
      {
        "regionId": 1414,
        "regionCode": "NU",
        "regionName": "Northumberland"
      },
      {
        "regionId": 1415,
        "regionCode": "NT",
        "regionName": "Nottinghamshire"
      },
      {
        "regionId": 1416,
        "regionCode": "OX",
        "regionName": "Oxford"
      },
      {
        "regionId": 1417,
        "regionCode": "PO",
        "regionName": "Powys"
      },
      {
        "regionId": 1418,
        "regionCode": null,
        "regionName": "Roos-shire"
      },
      {
        "regionId": 1419,
        "regionCode": null,
        "regionName": "Sark"
      },
      {
        "regionId": 1420,
        "regionCode": null,
        "regionName": "Scotland"
      },
      {
        "regionId": 1421,
        "regionCode": null,
        "regionName": "Scottish Borders"
      },
      {
        "regionId": 1422,
        "regionCode": "SH",
        "regionName": "Shropshire"
      },
      {
        "regionId": 1423,
        "regionCode": "SO",
        "regionName": "Somerset"
      },
      {
        "regionId": 1424,
        "regionCode": "SG",
        "regionName": "South Glamorgan"
      },
      {
        "regionId": 1425,
        "regionCode": null,
        "regionName": "South Wales"
      },
      {
        "regionId": 1426,
        "regionCode": "YS",
        "regionName": "South Yorkshire"
      },
      {
        "regionId": 1427,
        "regionCode": null,
        "regionName": "Southwell"
      },
      {
        "regionId": 1428,
        "regionCode": "ST",
        "regionName": "Staffordshire"
      },
      {
        "regionId": 1429,
        "regionCode": "SR",
        "regionName": "Strabane"
      },
      {
        "regionId": 1430,
        "regionCode": "SK",
        "regionName": "Suffolk"
      },
      {
        "regionId": 1431,
        "regionCode": "SY",
        "regionName": "Surrey"
      },
      {
        "regionId": 1432,
        "regionCode": null,
        "regionName": "Sussex"
      },
      {
        "regionId": 1433,
        "regionCode": "TW",
        "regionName": "Twickenham"
      },
      {
        "regionId": 1434,
        "regionCode": "TW",
        "regionName": "Tyne and Wear"
      },
      {
        "regionId": 1435,
        "regionCode": null,
        "regionName": "Tyrone"
      },
      {
        "regionId": 1437,
        "regionCode": null,
        "regionName": "Wales"
      },
      {
        "regionId": 1438,
        "regionCode": "WA",
        "regionName": "Warwickshire"
      },
      {
        "regionId": 1439,
        "regionCode": null,
        "regionName": "West Lothian"
      },
      {
        "regionId": 1440,
        "regionCode": "WM",
        "regionName": "West Midlands"
      },
      {
        "regionId": 1441,
        "regionCode": "SW",
        "regionName": "West Sussex"
      },
      {
        "regionId": 1442,
        "regionCode": "YW",
        "regionName": "West Yorkshire"
      },
      {
        "regionId": 1443,
        "regionCode": null,
        "regionName": "Whissendine"
      },
      {
        "regionId": 1444,
        "regionCode": "WI",
        "regionName": "Wiltshire"
      },
      {
        "regionId": 1445,
        "regionCode": "WO",
        "regionName": "Wokingham"
      },
      {
        "regionId": 1446,
        "regionCode": null,
        "regionName": "Worcestershire"
      },
      {
        "regionId": 1447,
        "regionCode": null,
        "regionName": "Wrexham"
      },
      {
        "regionId": 1448,
        "regionCode": null,
        "regionName": "Wurttemberg"
      },
      {
        "regionId": 1449,
        "regionCode": null,
        "regionName": "Yorkshire"
      },
      {
        "regionId": 4109,
        "regionCode": null,
        "regionName": "Antrim"
      },
      {
        "regionId": 4110,
        "regionCode": null,
        "regionName": "Down"
      },
      {
        "regionId": 4111,
        "regionCode": null,
        "regionName": "Londonderry"
      }
    ]
  },
  {
    "countryId": 223,
    "countryCode": "US",
    "countryName": "United States",
    "regions": [
      {
        "regionId": 4082,
        "regionCode": "PR",
        "regionName": "American Samoa"
      },
      {
        "regionId": 4083,
        "regionCode": "GU",
        "regionName": "Guam"
      },
      {
        "regionId": 4084,
        "regionCode": "MH",
        "regionName": "Marshall Islands"
      },
      {
        "regionId": 4085,
        "regionCode": "MP",
        "regionName": "Northern Mariana Islands"
      },
      {
        "regionId": 4086,
        "regionCode": "FM",
        "regionName": "Federated States of Micronesia"
      },
      {
        "regionId": 4087,
        "regionCode": "PR",
        "regionName": "Puerto Rico"
      },
      {
        "regionId": 4088,
        "regionCode": "PW",
        "regionName": "Palau"
      },
      {
        "regionId": 4089,
        "regionCode": "VI",
        "regionName": "U.S. Virgin Islands"
      },
      {
        "regionId": 3803,
        "regionCode": "AL",
        "regionName": "Alabama"
      },
      {
        "regionId": 3804,
        "regionCode": "AK",
        "regionName": "Alaska"
      },
      {
        "regionId": 3805,
        "regionCode": "AZ",
        "regionName": "Arizona"
      },
      {
        "regionId": 3806,
        "regionCode": "AR",
        "regionName": "Arkansas"
      },
      {
        "regionId": 3807,
        "regionCode": "CA",
        "regionName": "California"
      },
      {
        "regionId": 3808,
        "regionCode": "CO",
        "regionName": "Colorado"
      },
      {
        "regionId": 3809,
        "regionCode": "CT",
        "regionName": "Connecticut"
      },
      {
        "regionId": 3810,
        "regionCode": "DE",
        "regionName": "Delaware"
      },
      {
        "regionId": 3811,
        "regionCode": "DC",
        "regionName": "District of Columbia"
      },
      {
        "regionId": 3812,
        "regionCode": "FL",
        "regionName": "Florida"
      },
      {
        "regionId": 3813,
        "regionCode": "GA",
        "regionName": "Georgia"
      },
      {
        "regionId": 3814,
        "regionCode": "HI",
        "regionName": "Hawaii"
      },
      {
        "regionId": 3815,
        "regionCode": "ID",
        "regionName": "Idaho"
      },
      {
        "regionId": 3816,
        "regionCode": "IL",
        "regionName": "Illinois"
      },
      {
        "regionId": 3817,
        "regionCode": "IN",
        "regionName": "Indiana"
      },
      {
        "regionId": 3818,
        "regionCode": "IA",
        "regionName": "Iowa"
      },
      {
        "regionId": 3819,
        "regionCode": "KS",
        "regionName": "Kansas"
      },
      {
        "regionId": 3820,
        "regionCode": "KY",
        "regionName": "Kentucky"
      },
      {
        "regionId": 3821,
        "regionCode": "LA",
        "regionName": "Louisiana"
      },
      {
        "regionId": 3822,
        "regionCode": "ME",
        "regionName": "Maine"
      },
      {
        "regionId": 3823,
        "regionCode": "MD",
        "regionName": "Maryland"
      },
      {
        "regionId": 3824,
        "regionCode": "MA",
        "regionName": "Massachusetts"
      },
      {
        "regionId": 3825,
        "regionCode": "MI",
        "regionName": "Michigan"
      },
      {
        "regionId": 3826,
        "regionCode": "MN",
        "regionName": "Minnesota"
      },
      {
        "regionId": 3827,
        "regionCode": "MS",
        "regionName": "Mississippi"
      },
      {
        "regionId": 3828,
        "regionCode": "MO",
        "regionName": "Missouri"
      },
      {
        "regionId": 3829,
        "regionCode": "MT",
        "regionName": "Montana"
      },
      {
        "regionId": 3830,
        "regionCode": "NE",
        "regionName": "Nebraska"
      },
      {
        "regionId": 3831,
        "regionCode": "NV",
        "regionName": "Nevada"
      },
      {
        "regionId": 3832,
        "regionCode": "NH",
        "regionName": "New Hampshire"
      },
      {
        "regionId": 3833,
        "regionCode": "NJ",
        "regionName": "New Jersey"
      },
      {
        "regionId": 3834,
        "regionCode": "NM",
        "regionName": "New Mexico"
      },
      {
        "regionId": 3835,
        "regionCode": "NY",
        "regionName": "New York"
      },
      {
        "regionId": 3836,
        "regionCode": "NC",
        "regionName": "North Carolina"
      },
      {
        "regionId": 3837,
        "regionCode": "ND",
        "regionName": "North Dakota"
      },
      {
        "regionId": 3838,
        "regionCode": "OH",
        "regionName": "Ohio"
      },
      {
        "regionId": 3839,
        "regionCode": "OK",
        "regionName": "Oklahoma"
      },
      {
        "regionId": 3840,
        "regionCode": "OR",
        "regionName": "Oregon"
      },
      {
        "regionId": 3841,
        "regionCode": "PA",
        "regionName": "Pennsylvania"
      },
      {
        "regionId": 3842,
        "regionCode": "RI",
        "regionName": "Rhode Island"
      },
      {
        "regionId": 3843,
        "regionCode": "SC",
        "regionName": "South Carolina"
      },
      {
        "regionId": 3844,
        "regionCode": "SD",
        "regionName": "South Dakota"
      },
      {
        "regionId": 3845,
        "regionCode": "TN",
        "regionName": "Tennessee"
      },
      {
        "regionId": 3846,
        "regionCode": "TX",
        "regionName": "Texas"
      },
      {
        "regionId": 3847,
        "regionCode": "UT",
        "regionName": "Utah"
      },
      {
        "regionId": 3848,
        "regionCode": "VT",
        "regionName": "Vermont"
      },
      {
        "regionId": 3849,
        "regionCode": "VA",
        "regionName": "Virginia"
      },
      {
        "regionId": 3850,
        "regionCode": "WA",
        "regionName": "Washington"
      },
      {
        "regionId": 3851,
        "regionCode": "WV",
        "regionName": "West Virginia"
      },
      {
        "regionId": 3852,
        "regionCode": "WI",
        "regionName": "Wisconsin"
      },
      {
        "regionId": 3853,
        "regionCode": "WY",
        "regionName": "Wyoming"
      }
    ]
  },
  {
    "countryId": 224,
    "countryCode": "UY",
    "countryName": "Uruguay",
    "regions": [
      {
        "regionId": 3854,
        "regionCode": "AR",
        "regionName": "Artigas"
      },
      {
        "regionId": 3855,
        "regionCode": "CA",
        "regionName": "Canelones"
      },
      {
        "regionId": 3856,
        "regionCode": "CL",
        "regionName": "Cerro Largo"
      },
      {
        "regionId": 3857,
        "regionCode": "CO",
        "regionName": "Colonia"
      },
      {
        "regionId": 3858,
        "regionCode": "DU",
        "regionName": "Durazno"
      },
      {
        "regionId": 3859,
        "regionCode": "FS",
        "regionName": "Flores"
      },
      {
        "regionId": 3860,
        "regionCode": "FD",
        "regionName": "Florida"
      },
      {
        "regionId": 3861,
        "regionCode": "LA",
        "regionName": "Lavalleja"
      },
      {
        "regionId": 3862,
        "regionCode": "MA",
        "regionName": "Maldonado"
      },
      {
        "regionId": 3863,
        "regionCode": "MO",
        "regionName": "Montevideo"
      },
      {
        "regionId": 3864,
        "regionCode": "PA",
        "regionName": "Paysandu"
      },
      {
        "regionId": 3865,
        "regionCode": "RN",
        "regionName": "Rio Negro"
      },
      {
        "regionId": 3866,
        "regionCode": "RV",
        "regionName": "Rivera"
      },
      {
        "regionId": 3867,
        "regionCode": "RO",
        "regionName": "Rocha"
      },
      {
        "regionId": 3868,
        "regionCode": "SA",
        "regionName": "Salto"
      },
      {
        "regionId": 3869,
        "regionCode": "SJ",
        "regionName": "San Jose"
      },
      {
        "regionId": 3870,
        "regionCode": "SO",
        "regionName": "Soriano"
      },
      {
        "regionId": 3871,
        "regionCode": "TA",
        "regionName": "Tacuarembo"
      },
      {
        "regionId": 3872,
        "regionCode": "TT",
        "regionName": "Treinta y Tres"
      }
    ]
  },
  {
    "countryId": 225,
    "countryCode": "UZ",
    "countryName": "Uzbekistan",
    "regions": [
      {
        "regionId": 3873,
        "regionCode": null,
        "regionName": "Andijon"
      },
      {
        "regionId": 3874,
        "regionCode": null,
        "regionName": "Buhoro"
      },
      {
        "regionId": 3875,
        "regionCode": null,
        "regionName": "Buxoro Viloyati"
      },
      {
        "regionId": 3876,
        "regionCode": null,
        "regionName": "Cizah"
      },
      {
        "regionId": 3877,
        "regionCode": null,
        "regionName": "Fargona"
      },
      {
        "regionId": 3878,
        "regionCode": null,
        "regionName": "Horazm"
      },
      {
        "regionId": 3879,
        "regionCode": null,
        "regionName": "Kaskadar"
      },
      {
        "regionId": 3880,
        "regionCode": null,
        "regionName": "Korakalpogiston"
      },
      {
        "regionId": 3881,
        "regionCode": null,
        "regionName": "Namangan"
      },
      {
        "regionId": 3882,
        "regionCode": null,
        "regionName": "Navoi"
      },
      {
        "regionId": 3883,
        "regionCode": null,
        "regionName": "Samarkand"
      },
      {
        "regionId": 3884,
        "regionCode": null,
        "regionName": "Sirdare"
      },
      {
        "regionId": 3885,
        "regionCode": null,
        "regionName": "Surhondar"
      },
      {
        "regionId": 3886,
        "regionCode": null,
        "regionName": "Toskent"
      }
    ]
  },
  {
    "countryId": 226,
    "countryCode": "VA",
    "countryName": "Vatican City",
    "regions": [
      {
        "regionId": 3887,
        "regionCode": null,
        "regionName": "Vatican City State UNION ALL SELECT Holy See)"
      }
    ]
  },
  {
    "countryId": 227,
    "countryCode": "VE",
    "countryName": "Venezuela",
    "regions": [
      {
        "regionId": 3888,
        "regionCode": "Z",
        "regionName": "Amazonas"
      },
      {
        "regionId": 3889,
        "regionCode": "ANZ",
        "regionName": "Anzoategui"
      },
      {
        "regionId": 3890,
        "regionCode": "APU",
        "regionName": "Apure"
      },
      {
        "regionId": 3891,
        "regionCode": "ARA",
        "regionName": "Aragua"
      },
      {
        "regionId": 3892,
        "regionCode": "BAR",
        "regionName": "Barinas"
      },
      {
        "regionId": 3893,
        "regionCode": "BOL",
        "regionName": "Bolivar"
      },
      {
        "regionId": 3894,
        "regionCode": "CAR",
        "regionName": "Carabobo"
      },
      {
        "regionId": 3895,
        "regionCode": "COJ",
        "regionName": "Cojedes"
      },
      {
        "regionId": 3896,
        "regionCode": "DA",
        "regionName": "Delta Amacuro"
      },
      {
        "regionId": 3897,
        "regionCode": "DF",
        "regionName": "Distrito Federal"
      },
      {
        "regionId": 3898,
        "regionCode": "FAL",
        "regionName": "Falcon"
      },
      {
        "regionId": 3899,
        "regionCode": "GUA",
        "regionName": "Guarico"
      },
      {
        "regionId": 3900,
        "regionCode": "LAR",
        "regionName": "Lara"
      },
      {
        "regionId": 3901,
        "regionCode": "MER",
        "regionName": "Merida"
      },
      {
        "regionId": 3902,
        "regionCode": "MIR",
        "regionName": "Miranda"
      },
      {
        "regionId": 3903,
        "regionCode": "MON",
        "regionName": "Monagas"
      },
      {
        "regionId": 3904,
        "regionCode": "NE",
        "regionName": "Nueva Esparta"
      },
      {
        "regionId": 3905,
        "regionCode": "POR",
        "regionName": "Portuguesa"
      },
      {
        "regionId": 3906,
        "regionCode": "SUC",
        "regionName": "Sucre"
      },
      {
        "regionId": 3907,
        "regionCode": "TAC",
        "regionName": "Tachira"
      },
      {
        "regionId": 3908,
        "regionCode": "TRU",
        "regionName": "Trujillo"
      },
      {
        "regionId": 3909,
        "regionCode": "VAR",
        "regionName": "Vargas"
      },
      {
        "regionId": 3910,
        "regionCode": "YAR",
        "regionName": "Yaracuy"
      },
      {
        "regionId": 3911,
        "regionCode": "ZUL",
        "regionName": "Zulia"
      }
    ]
  },
  {
    "countryId": 228,
    "countryCode": "VN",
    "countryName": "Vietnam",
    "regions": [
      {
        "regionId": 3918,
        "regionCode": "54",
        "regionName": "Bac Giang"
      },
      {
        "regionId": 3919,
        "regionCode": "31",
        "regionName": "Binh Dinh"
      },
      {
        "regionId": 3920,
        "regionCode": "57",
        "regionName": "Binh Duong"
      },
      {
        "regionId": 3921,
        "regionCode": "DN",
        "regionName": "Da Nang"
      },
      {
        "regionId": 3922,
        "regionCode": null,
        "regionName": "Dong Bang Song Cuu Long"
      },
      {
        "regionId": 3923,
        "regionCode": null,
        "regionName": "Dong Bang Song Hong"
      },
      {
        "regionId": 3924,
        "regionCode": "39",
        "regionName": "Dong Nai"
      },
      {
        "regionId": 3925,
        "regionCode": null,
        "regionName": "Dong Nam Bo"
      },
      {
        "regionId": 3926,
        "regionCode": null,
        "regionName": "Duyen Hai Mien Trung"
      },
      {
        "regionId": 3927,
        "regionCode": null,
        "regionName": "Hanoi"
      },
      {
        "regionId": 3928,
        "regionCode": "66",
        "regionName": "Hung Yen"
      },
      {
        "regionId": 3929,
        "regionCode": null,
        "regionName": "Khu Bon Cu"
      },
      {
        "regionId": 3930,
        "regionCode": "41",
        "regionName": "Long An"
      },
      {
        "regionId": 3931,
        "regionCode": null,
        "regionName": "Mien Nui Va Trung Du"
      },
      {
        "regionId": 3932,
        "regionCode": "69",
        "regionName": "Thai Nguyen"
      },
      {
        "regionId": 3933,
        "regionCode": "SG",
        "regionName": "Thanh Pho Ho Chi Minh"
      },
      {
        "regionId": 3934,
        "regionCode": null,
        "regionName": "Thu Do Ha Noi"
      },
      {
        "regionId": 3935,
        "regionCode": null,
        "regionName": "Tinh Can Tho"
      },
      {
        "regionId": 3936,
        "regionCode": null,
        "regionName": "Tinh Da Nang"
      },
      {
        "regionId": 3937,
        "regionCode": null,
        "regionName": "Tinh Gia Lai"
      }
    ]
  },
  {
    "countryId": 229,
    "countryCode": "VI",
    "countryName": "Virgin Islands",
    "regions": [
      {
        "regionId": 3915,
        "regionCode": null,
        "regionName": "Saint Croix"
      },
      {
        "regionId": 3916,
        "regionCode": null,
        "regionName": "Saint John"
      },
      {
        "regionId": 3917,
        "regionCode": null,
        "regionName": "Saint Thomas"
      }
    ]
  },
  {
    "countryId": 230,
    "countryCode": "EH",
    "countryName": "Western Sahara",
    "regions": [
      {
        "regionId": 1055,
        "regionCode": null,
        "regionName": "al-'Ayun"
      },
      {
        "regionId": 1056,
        "regionCode": null,
        "regionName": "as-Samarah"
      },
      {
        "regionId": 1057,
        "regionCode": null,
        "regionName": "Bu Jaydur"
      },
      {
        "regionId": 1058,
        "regionCode": null,
        "regionName": "Wad-adh-Dhahab"
      }
    ]
  },
  {
    "countryId": 231,
    "countryCode": "YE",
    "countryName": "Yemen",
    "regions": [
      {
        "regionId": 3949,
        "regionCode": null,
        "regionName": "Abyan"
      },
      {
        "regionId": 3950,
        "regionCode": null,
        "regionName": "'Adan"
      },
      {
        "regionId": 3951,
        "regionCode": null,
        "regionName": "al-Bayda"
      },
      {
        "regionId": 3952,
        "regionCode": null,
        "regionName": "al-Hudaydah"
      },
      {
        "regionId": 3953,
        "regionCode": null,
        "regionName": "al-Jawf"
      },
      {
        "regionId": 3954,
        "regionCode": null,
        "regionName": "al-Mahrah"
      },
      {
        "regionId": 3955,
        "regionCode": null,
        "regionName": "al-Mahwit"
      },
      {
        "regionId": 3956,
        "regionCode": null,
        "regionName": "Dhamar"
      },
      {
        "regionId": 3957,
        "regionCode": null,
        "regionName": "Hadramaut"
      },
      {
        "regionId": 3958,
        "regionCode": null,
        "regionName": "Hajjah"
      },
      {
        "regionId": 3959,
        "regionCode": null,
        "regionName": "Hudaydah"
      },
      {
        "regionId": 3960,
        "regionCode": null,
        "regionName": "Ibb"
      },
      {
        "regionId": 3961,
        "regionCode": null,
        "regionName": "Lahij"
      },
      {
        "regionId": 3962,
        "regionCode": null,
        "regionName": "Madinat San'a"
      },
      {
        "regionId": 3963,
        "regionCode": null,
        "regionName": "Ma'rib"
      },
      {
        "regionId": 3964,
        "regionCode": null,
        "regionName": "Sa'dah"
      },
      {
        "regionId": 3965,
        "regionCode": null,
        "regionName": "Sana"
      },
      {
        "regionId": 3966,
        "regionCode": null,
        "regionName": "Shabwah"
      },
      {
        "regionId": 3967,
        "regionCode": null,
        "regionName": "Ta'izz"
      }
    ]
  },
  {
    "countryId": 232,
    "countryCode": "ZM",
    "countryName": "Zambia",
    "regions": [
      {
        "regionId": 3984,
        "regionCode": null,
        "regionName": "Central"
      },
      {
        "regionId": 3985,
        "regionCode": null,
        "regionName": "Copperbelt"
      },
      {
        "regionId": 3986,
        "regionCode": null,
        "regionName": "Eastern"
      },
      {
        "regionId": 3987,
        "regionCode": null,
        "regionName": "Luapala"
      },
      {
        "regionId": 3988,
        "regionCode": null,
        "regionName": "Lusaka"
      },
      {
        "regionId": 3989,
        "regionCode": null,
        "regionName": "Northern"
      },
      {
        "regionId": 3990,
        "regionCode": null,
        "regionName": "North-Western"
      },
      {
        "regionId": 3991,
        "regionCode": null,
        "regionName": "Southern"
      },
      {
        "regionId": 3992,
        "regionCode": null,
        "regionName": "Western"
      }
    ]
  },
  {
    "countryId": 233,
    "countryCode": "ZW",
    "countryName": "Zimbabwe",
    "regions": [
      {
        "regionId": 3993,
        "regionCode": null,
        "regionName": "Bulawayo"
      },
      {
        "regionId": 3994,
        "regionCode": null,
        "regionName": "Harare"
      },
      {
        "regionId": 3995,
        "regionCode": null,
        "regionName": "Manicaland"
      },
      {
        "regionId": 3996,
        "regionCode": null,
        "regionName": "Mashonaland Central"
      },
      {
        "regionId": 3997,
        "regionCode": null,
        "regionName": "Mashonaland East"
      },
      {
        "regionId": 3998,
        "regionCode": null,
        "regionName": "Mashonaland West"
      },
      {
        "regionId": 3999,
        "regionCode": null,
        "regionName": "Masvingo"
      },
      {
        "regionId": 4000,
        "regionCode": null,
        "regionName": "Matabeleland North"
      },
      {
        "regionId": 4001,
        "regionCode": null,
        "regionName": "Matabeleland South"
      },
      {
        "regionId": 4002,
        "regionCode": null,
        "regionName": "Midlands"
      }
    ]
  },
  {
    "countryId": 234,
    "countryCode": "MP",
    "countryName": "Northern Mariana Islands",
    "regions": []
  },
  {
    "countryId": 235,
    "countryCode": "VC",
    "countryName": "Saint Vincent and the Grenadines",
    "regions": []
  },
  {
    "countryId": 238,
    "countryCode": "VU",
    "countryName": "Vanuatu",
    "regions": [
      {
        "regionId": 4102,
        "regionCode": "MAP",
        "regionName": "Malampa"
      },
      {
        "regionId": 4103,
        "regionCode": "PAM",
        "regionName": "Pénama"
      },
      {
        "regionId": 4104,
        "regionCode": "SAM",
        "regionName": "Sanma"
      },
      {
        "regionId": 4105,
        "regionCode": "SEE",
        "regionName": "Shéfa"
      },
      {
        "regionId": 4106,
        "regionCode": "TAE",
        "regionName": "Taféa"
      },
      {
        "regionId": 4107,
        "regionCode": "TOB",
        "regionName": "Torba"
      }
    ]
  }
]